/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be9ec4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be9ec4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"af99dbaf-168b-40c7-8487-2b6610349c4c","title":"Cronologia delle modifiche","link":"change-history.html","desc":"Gennaio 2023 Aggiunte informazioni sulla","descFull":"Gennaio 2023 Aggiunte informazioni sulla configurazione di  Markvision  Enterprise (MVE) e sul flusso di lavoro per ADFS. Aggiornate le informazioni relative all'accesso al dashboard di protezione. Aggiunto il capitolo Accesso al database. Agosto 2022 Aggiunte informazioni sui seguenti argomenti: Protocollo Enrollment over Secure Transport (EST) come definito in RFC 7030 Dashboard di protezione Assegnazione automatica delle parole chiave durante il rilevamento Supporto per e‑mail tramite SSL/TLS Supporto per Windows Server 2022 Aggiornate le informazioni relative ai seguenti argomenti: Modelli di stampante supportati Gestione dei certificati con l'autorità di certificazione Microsoft tramite i servizi Web di registrazione certificati di Microsoft (MSCEWS) Configurazione del server OpenXPKI CA Gestione delle configurazioni MVE Marzo 2022 Aggiornate le informazioni sui modelli di stampante supportati. Aggiunte informazioni sulla creazione di un certificato client. Maggio 2021 Aggiornate le informazioni relative ai seguenti argomenti: Modelli di stampante supportati Gestione dell'autorità di certificazione (CA) Microsoft Configurazione di MVE per la gestione automatica dei certificati Configurazione dell'autorità di certificazione Microsoft Enterprise con il servizio Registrazione dispositivi di rete (NDES) Aggiunte informazioni sui seguenti argomenti: Gestione dei certificati con l'autorità di certificazione Microsoft tramite i servizi Web di registrazione certificati di Microsoft (MSCEWS) Creazione del certificato SSL per i server del servizio Web di informazioni sulle registrazioni di certificati (CEP) e del servizio Web di registrazione certificati (CES) Metodi di autenticazione per CEP e CES Certificato periferica con nome Novembre 2020 Aggiornate le informazioni relative ai seguenti argomenti: Modelli di stampante supportati Database supportati Aggiunte informazioni sui seguenti argomenti: Gestione e implementazione delle configurazioni Backup e ripristino del database Gestione dei certificati tramite autorità di certificazione OpenXPKI e Microsoft Aggiunto il supporto per le seguenti operazioni: Gestione e implementazione delle configurazioni in un gruppo di modelli di stampante Creazione di nomi di database personalizzati Febbraio 2020 Aggiornate le informazioni relative ai seguenti argomenti: Modelli di stampante supportati Server supportati Database supportati Percorso di aggiornamento di MVE valido Aggiunte informazioni sui seguenti argomenti: Istruzioni per le best practice Istruzioni sulla gestione dei certificati automatici Componenti di protezione avanzata predefiniti e relative impostazioni Altri modi per proteggere le stampanti Scenari di esempio Giugno 2019 Aggiornate le informazioni relative ai seguenti argomenti: Note a piè pagina aggiunte ai modelli di stampante che richiedono l'uso di certificati Assegnazione di diritti dbo durante la configurazione del database Percorso di aggiornamento valido quando si esegue l'aggiornamento alla versione 3.4 File necessari per il backup e il ripristino del database Impostazioni per l'autenticazione tramite server LDAP Parametri relativi a stato di validità del certificato, data e fuso orario aggiunti alle impostazioni delle regole di ricerca Configurazione delle autorizzazioni e dei controlli di accesso alle funzioni nelle impostazioni di protezione della stampante Selezione di un file del firmware dalla libreria delle risorse durante l'aggiornamento del firmware della stampante Selezione della data di inizio, dell'ora di inizio e di pausa e dei giorni della settimana per l'aggiornamento del firmware della stampante Gestione delle configurazioni Aggiunte informazioni sui seguenti argomenti: Informazioni sugli stati di protezione della stampante Configurazione dei componenti di protezione avanzata Creazione di un componente di protezione avanzata da una stampante Generazione di una versione stampabile delle impostazioni di configurazione Caricamento dell'autorità di certificazione di un parco stampanti Rimozione di informazioni e riferimenti dell'utente Informazioni sulle autorizzazioni e sui controlli di accesso alle funzioni Operazioni di risoluzione dei problemi quando l'applicazione di configurazioni con più applicazioni non riesce Operazioni di risoluzione dei problemi quando un utente  Amministratore  dimentica la password Agosto 2018 Aggiornate le informazioni relative ai seguenti argomenti: Modelli di stampante supportati Configurazione del database Aggiornamento a MVE 3.3 Domande frequenti Creazione di un'azione Creazione di un programma Aggiunte informazioni sui seguenti argomenti: Configurazione di un account utente di dominio RunAs Esportazione dei registri Operazioni per la risoluzione dei problemi quando MVE non riconosce stampanti protette Luglio 2018 Aggiornate le informazioni sull'aggiornamento a MVE 3.2. Aprile 2018 Aggiornate le informazioni relative ai seguenti argomenti: Modelli di stampante supportati Configurazione del database Backup e ripristino dei file del database URL di accesso a MVE Informazioni sulle impostazioni delle variabili Aggiunte informazioni sui seguenti argomenti: Configurazione dei certificati delle stampanti Interruzione delle attività Aggiornamento del firmware delle stampanti Settembre 2017 Aggiornate le informazioni relative ai seguenti argomenti: Requisiti di sistema Comunicazione tra MVE e i modelli  Lexmark  Forms Printer 2580, 2581, 2590 e 2591 Rimozione manuale dei database di Microsoft SQL Server Backup e ripristino dei file del database Impostazioni di protezione richieste per i controlli di accesso alle funzioni durante la distribuzione dei file del firmware e delle soluzioni alle stampanti Supporto per le licenze durante la distribuzione delle applicazioni Avvisi della stampante e azioni associate Ripristino automatico dello stato della stampante Assegnazione di eventi e parole chiave Giugno 2017 Versione iniziale del documento per MVE 3.0. cronologia delle modifiche"},{"UUID":"462cdbb8-deec-4f95-97cf-404e0a6e7787","title":"Panoramica","link":"overview-chapter.html","desc":"Informazioni su  Markvision ","descFull":"Informazioni su  Markvision  Enterprise Markvision  Enterprise (MVE) è un software di utilità per la gestione delle stampanti basato su Web e destinato a professionisti IT. Con MVE, è possibile gestire un ampio parco stampanti in un ambiente aziendale in modo efficiente, effettuando le seguenti operazioni: Rilevare, organizzare e tracciare un parco stampanti. È possibile controllare una stampante per raccogliere i dati ad essa relativi, ad esempio lo stato, le impostazioni e i materiali di consumo. Creare configurazioni e assegnarle alle stampanti. Implementare il firmware, i certificati della stampante, le autorità di certificazione (CA, Certificate Authority) e le applicazioni sulle stampanti. Controllare gli avvisi e gli eventi della stampante. Questo documento fornisce informazioni su configurazione, utilizzo e risoluzione dei problemi relativi all'applicazione. Questo documento è destinato agli amministratori. panoramica Markvision Enterprise Markvision Enterprise informazioni"},{"UUID":"390d0f0f-18ac-4e11-87f9-b5e29895000a","title":"Introduzione","link":"best-practices-topic.html","desc":"Best practice Questo argomento descrive","descFull":"Best practice Questo argomento descrive le procedure consigliate per utilizzare MVE per la gestione efficace del parco stampanti. Installare MVE nell'ambiente. Creare un server utilizzando l'ambiente Windows Server più recente. Contenuto correlato: Requisiti del server Web Creare un account utente di dominio che non disponga di accesso amministratore. Contenuto correlato: Impostazione di Esegui come utente Creare un database Microsoft SQL Server, configurare la crittografia e quindi concedere al nuovo account utente l'accesso ai database. Contenuto correlato: Requisiti del database Configurazione del database Installare MVE utilizzando l'account utente di dominio e SQL Server con autenticazione Windows. Contenuto correlato: Installazione di MVE Configurare MVE, quindi rilevare e organizzare il parco stampanti. Firmare il certificato del server. Contenuto correlato: Firma del certificato MVE Configurazione di MVE per la gestione automatica dei certificati Configurare le impostazioni LDAP. Contenuto correlato: Abilitazione dell'autenticazione tramite server LDAP Installazione dei certificati LDAP Eseguire la connessione a un server e-mail. Contenuto correlato: Configurazione delle impostazioni e-mail Rilevare il parco stampanti. Contenuto correlato: Rilevamento delle stampanti Programmare i controlli e gli aggiornamenti dello stato. Contenuto correlato: Controllo delle stampanti Aggiornamento dello stato della stampante Configurare le impostazioni di base, ad esempio nomi di contatti, posizioni, etichette risorsa e fusi orari. Organizzare il parco stampanti. Utilizzare parole chiave, ad esempio le posizioni, per categorizzare le stampanti. Contenuto correlato: Assegnazione di parole chiave alle stampanti Creazione di una ricerca salvata Proteggete il parco stampanti. Proteggere l'accesso alla stampante utilizzando i componenti di protezione avanzata predefiniti. Contenuto correlato: Protezione delle stampanti mediante le configurazioni predefinite Informazioni sulle autorizzazioni e i controlli di accesso alle funzioni Altri modi per proteggere le stampanti Creare una configurazione protetta che includa i certificati. Contenuto correlato: Creazione di una configurazione Importazione di file nella libreria delle risorse Applicare la configurazione al parco stampanti corrente. Contenuto correlato: Assegnazione di configurazioni alle stampanti Applicazione delle configurazioni Programmare le applicazioni e le verifiche di conformità. Contenuto correlato: Creazione di un programma Aggiungere configurazioni ai profili di ricerca per proteggere le nuove stampanti. Contenuto correlato: Creazione di un profilo di ricerca Firmare i certificati delle stampanti. Contenuto correlato: Firma del certificato MVE Mantenere aggiornato il firmware. Contenuto correlato: Aggiornamento del firmware delle stampanti Installare e configurare le applicazioni. Contenuto correlato: Creazione di una configurazione Importazione di file nella libreria delle risorse Monitorare il parco stampanti. Contenuto correlato: Creazione di una ricerca salvata best practice"},{"UUID":"7cfda879-910a-4f5e-aa95-16f86ea1f51e","title":"Introduzione","link":"system-requirements-topic.html","desc":"Requisiti di sistema È installato","descFull":"Requisiti di sistema È installato MVE come server Web ed è possibile accedervi da un browser Web su qualsiasi computer collegato alla rete. MVE utilizza inoltre un database per memorizzare le informazioni relative al parco stampanti. Di seguito vengono indicati i requisiti per server Web, database e sistema utente: Requisiti del server Web Requisiti di sistema Processore Processore dual-core da almeno 2 GHz che utilizza HTT (Hyper‑Threading Technology) RAM Almeno 4 GB Unità disco fisso Almeno 60 GB MVE, Lexmark Document Distributor (LDD) e Utilità di distribuzione delle periferiche non possono essere eseguiti sullo stesso server. Server supportati Windows Server 2022 Standard Edition Windows Server 2019 Windows Server 2016 Standard Edition Windows Server 2012 Standard Edition Windows Server 2012 R2 MVE supporta la virtualizzazione per i server supportati in un ambiente locale. Requisiti del database Database supportati Firebird  (database integrato) Microsoft SQL Server 2019 Microsoft SQL Server 2017 Microsoft SQL Server 2016 Microsoft SQL Server 2014 Microsoft SQL Server 2012 la dimensione minima consigliata del database è 60 GB per allocare 20 MB per FRAMEWORK e 4,5 MB per MONITOR e QUARTZ. Per ulteriori informazioni, vedere  . Requisiti del sistema utente Browser Web supportati Microsoft Edge Mozilla Firefox (versione più recente) Google Chrome  (versione più recente) Apple Safari (versione più recente) Risoluzione schermo Almeno 1280 x 768 pixel requisiti del server Web server Web requisiti requisiti del database database requisiti requisiti di sistema dell'utente sistema utente requisiti sistemi operativi supportati browser Web supportati database supportati server supportati"},{"UUID":"bcda9c9b-2808-443d-a3b0-ce4c99dcd56e","title":"Introduzione","link":"supported-languages-topic.html","desc":"Lingue supportate Portoghese brasiliano Inglese","descFull":"Lingue supportate Portoghese brasiliano Inglese Francese Tedesco Italiano Cinese semplificato Spagnolo lingue supportate lingue supportate"},{"UUID":"33ddc0c4-4796-4bea-ad7b-fd644b7eded8","title":"Introduzione","link":"supported-printer-models-topic.html","desc":"Modelli di stampante supportati Lexmark","descFull":"Modelli di stampante supportati Lexmark 6500 Lexmark B2236 2 Lexmark B2338 2 , B2442 2 , B2546 2 , B2650 2 , B2865 1 Lexmark B3440 2 , B3442 2 Lexmark C2132 Lexmark C2240 2 , C2325 2 , C2425 2 , C2535 2 Lexmark C2335 2 Lexmark C3224 2 Lexmark C3326 2 Lexmark C3426 2 Lexmark C4150 2 , C6160 2 , C9235 2 Lexmark C4342 2 , C4352 2 Lexmark C746, C748 Lexmark C792 Lexmark C925 1 , C950 Lexmark CS310, CS410, CS510 Lexmark CS317, CS417, CS517 Lexmark CS331 2 Lexmark CS421 2 , CS521 2 , CS622 2 Lexmark CS431 2 Lexmark CS531 2 , CS632 2 Lexmark CS720 2 , CS725 2 Lexmark CS727 2 , CS728 2 Lexmark CS730 2 Lexmark CS735 2 Lexmark CS820 2 , CS827 2 Lexmark CS921 2 , CS923 2 , CS927 2 Lexmark CS943 2 Lexmark CX310, CX410, CX510 Lexmark CX317, CX417, CX517 Lexmark CX331 2 Lexmark CX421 2 , CX522 2 , CX622 2 , CX625 2 Lexmark CX431 2 Lexmark CX532 2 Lexmark CX625 2 Lexmark CX635 2 Lexmark CX725 2 Lexmark CX728 2 Lexmark CX730 2 Lexmark CX735 2 Lexmark CX820 2 , CX825 2 , CX827 2 , CX860 2 Lexmark CX920 2 , CX921 2 , CX922 2 , CX923 2 , CX924 2 , CX927 2 Lexmark CX930 2 , CX931 2 Lexmark CX942 2 , CX943 2 , CX944 2 Lexmark Forms Printer 2580 4 , 2581 4 , 2590 4 , 2591 4 Lexmark M1140, M1145, M3150 Lexmark M1242 2 , M1246 2 , M3250 2 , M5255 2 , M5265 2 , M5270 2 Lexmark M3350 2 Lexmark M5155, M5163, M5170 Lexmark M5255 2 , M5265 2 , M5270 2 Lexmark MB2236 2 Lexmark MB2338 2 , MB2442 2 , MB2546 2 , MB2650 2 , MB2770 2 Lexmark MB3442 2 Lexmark MC2325 2 , MC2425 2 , MC2535 2 , MC2640 2 Lexmark MC3224 2 Lexmark MC3326 2 Lexmark MC3426 2 Lexmark MS310, MS312, MS315, MS410, MS415, MS510, MS610 Lexmark MS317, MS417, MS517 Lexmark MS321 2 , MS421 2 , MS521 2 , MS621 2 , MS622 2 Lexmark MS331 2 , MS431 2 Lexmark MS531 2 , MS631 2 , MS632 2 Lexmark MS617, MS817, MS818 Lexmark MS710, MS711, MS810, MS811, MS812 Lexmark MS725 2 , MS821 2 , MS822 2 , MS823 2 , MS824 2 , MS825 2 , MS826 2 Lexmark MS911 Lexmark MX310, MX410, MX510, MX511, MX610, MX611 Lexmark MX317, MX417, MX517 Lexmark MX321 2 , MX421 2 , MX521 2 , MX522 2 , MX622 2 Lexmark MX331 2 , MX431 2 Lexmark MX432 2 Lexmark MX532 2 , MX632 2 Lexmark MX617, MX717, MX718 Lexmark MX6500 Lexmark MX710, MX711, MX810, MX811, MX812 Lexmark MX721 2 , MX722 2 , MX725 2 , MX822 2 , MX824 2 , MX826 2 Lexmark MX910, MX911, MX912 Lexmark MX931 2 Lexmark T650 1 , T652 1 , T654 1 , T656 1 Lexmark X651 1 , X652 1 , X654 1 , X656 1 , X658 1 , XS651 1 , XS652 1 , XS654 1 , XS658 1 Lexmark X746, X748, X792 Lexmark X850 1 , X852 1 , X854 1 , X860 1 , X862 1 , X864 1 , XS864 1 Lexmark X925, X950, X952, X954 Lexmark XC2130, XC2132 Lexmark XC2235 2 , XC2240 2 , XC4240 2 Lexmark XC2335 2 Lexmark XC4140 2 , XC4150 2 , XC6152 2 , XC8155 2 , XC8160 2 Lexmark XC9225 2 , XC9235 2 , XC9245 2 , XC9255 2 , XC9265 2 Lexmark XC9325 2 , XC9335 2 Lexmark XC9445 2 , XC9455 2 , XC9465 2 Lexmark XM1135, XM1140, XM1145, XM3150 Lexmark XM1242 2 , XM1246 2 , XM3250 2 Lexmark XM3142 2 Lexmark XM3350 2 Lexmark XM5163, XM5170, XM5263, XM5270 Lexmark XM5365 2 , XM5370 2 Lexmark XM7155, XM7163, XM7170, XM7263, XM7270 Lexmark XM7355 2 , MX7365 2 , MX7370 2 Lexmark XM9145, XM9155, XM9165 Lexmark XM9335 2 Lexmark XC2326 Lexmark XC2326 Lexmark XC4342 2 , XC4352 2 1  È richiesto un aggiornamento del certificato della stampante. In questa versione, l'aggiornamento delle prestazioni e della protezione della piattaforma Java rimuove il supporto di alcuni algoritmi di firma del certificato, quali MD5 e SHA1. Questa modifica impedisce a MVE di funzionare su alcune stampanti. Per ulteriori informazioni, consultare la  relativa guida . 2  È necessario attivare il supporto di SNMPv3 sulla stampante. 3  Se sulla stampante è impostata una password di protezione avanzata, MVE non è in grado di supportare la stampante. 4  MVE non può comunicare con i modelli Lexmark Forms Printer 2580, 2581, 2590 e 2591 con stato Non pronta. La comunicazione avviene solo se MVE ha comunicato in precedenza con la stampante in stato Pronta. La stampante potrebbe essere nello stato Non pronta quando si ricevono errori o avvertenze, ad esempio di materiali di consumo esauriti. Per modificare lo stato, risolvere l'errore o l'avvertenza, quindi premere  Pronta . modelli di stampante supportati modelli di stampante supportati"},{"UUID":"48d5a279-3b82-4c0a-91f3-2063689fb88c","title":"Introduzione","link":"setting-up-database-topic.html","desc":"Configurazione del database È possibile","descFull":"Configurazione del database È possibile utilizzare Firebird o Microsoft SQL Server come database back-end. La tabella seguente può aiutare a scegliere il database da utilizzare. Firebird Microsoft SQL Server Installazione del server Deve essere installato sullo stesso server di MVE. Può essere eseguito da qualsiasi server. Comunicazione Bloccato a soli localhost. Comunica tramite una porta statica o un'istanza dinamica denominata. È supportata la comunicazione SSL/TLS con un server Microsoft SQL protetto. Prestazioni Problemi di prestazioni con grandi parchi stampanti. Migliori prestazioni per grandi parchi stampanti. Dimensioni del database Le dimensioni predefinite per i database sono 6 MB per FRAMEWORK e 1 MB per MONITOR e QUARTZ. La tabella FRAMEWORK aumenta di 1 KB per ogni record di stampante aggiunto. Le dimensioni predefinite per i database sono 20 MB per FRAMEWORK e 4,5 MB per MONITOR e QUARTZ. La tabella FRAMEWORK aumenta di 1 KB per ogni record di stampante aggiunto. Configurazione Configurato automaticamente durante il processo di installazione. Richiede configurazione di pre-installazione. Se si utilizza Firebird, il programma di installazione MVE installa e configura Firebird senza richiedere altre configurazioni. Se si utilizza Microsoft SQL Server, prima di installare MVE attenersi alla seguente procedura: Consentire l'esecuzione automatica dell'applicazione. Impostare le librerie di rete per l'utilizzo dei socket TCP/IP. Creare i seguenti database: i seguenti sono i nomi di database predefiniti. È anche possibile fornire nomi di database personalizzati. FRAMEWORK MONITOR QUARTZ Se si utilizza un'istanza denominata, impostare l'avvio automatico del servizio Microsoft SQL Server Browser. In alternativa, impostare una porta statica sui socket TCP/IP. Creare un account utente con diritti dbowner per tutti e tre i database utilizzati da MVE per connettersi al database e per configurarlo. Se l'utente corrisponde a un account Microsoft SQL Server, attivare Microsoft SQL Server e le modalità Autenticazione di Windows su Microsoft SQL Server. la disinstallazione di MVE configurato per l'uso di Microsoft SQL Server non comporta la rimozione dei database o delle tabelle create. Dopo la disinstallazione, i database FRAMEWORK, MONITOR e QUARTZ devono essere rimossi manualmente. Assegnare i diritti dbo all'utente del database, quindi impostare lo schema dbo come lo schema predefinito. configurazione del database database impostazione database Firebird Microsoft SQL Server"},{"UUID":"17669458-1e3e-443e-b5e8-c3c9f95e80e9","title":"Introduzione","link":"setting-mve-run-as-user-topic.html","desc":"Impostazione di Esegui come utente","descFull":"Impostazione di Esegui come utente Durante l'installazione, è possibile specificare l'esecuzione di MVE come un account di sistema locale o come un account utente di dominio. L'esecuzione di MVE come account Esegui come utente di dominio fornisce un'installazione più sicura. L'account utente del dominio dispone di privilegi limitati rispetto a un account di sistema locale. Esegui come utente di dominio Esegui come sistema locale Autorizzazioni di sistema locale Accesso per tutti i file a quanto segue: $MVE_INSTALL /tomcat/logs $MVE_INSTALL /tomcat/temp $MVE_INSTALL /tomcat/work $MVE_INSTALL /apps/library $MVE_INSTALL /apps/dm-mve/picture $MVE_INSTALL /../mve_truststore* $MVE_INSTALL /jre/lib/security/cacerts $MVE_INSTALL /apps/dm-mve/WEB-INF/ldap $MVE_INSTALL /apps/dm-mve/download Dove  $MVE_INSTALL  è la directory di installazione. Privilegi di Windows: LOGON_AS_A_SERVICE Autorizzazioni di amministratore Autenticazione della connessione database Autenticazione di Windows con Microsoft SQL Server Autenticazione SQL Autenticazione SQL Configurazione Un utente del dominio deve essere configurato prima dell'installazione. Configurato automaticamente durante il processo di installazione Se si utilizza l'impostazione MVE come Esegui come account utente di dominio, creare l'utente sullo stesso dominio del server MVE. esegui come utente impostazione impostazione MVE come Esegui come utente"},{"UUID":"4e174080-da8e-4c3f-b3a5-a2af0cf71f98","title":"Introduzione","link":"installing-markvision-topic.html","desc":"Installazione di MVE Trasferire il","descFull":"Installazione di MVE Trasferire il file eseguibile in un percorso il cui nome non contenga spazi. Eseguire il file come amministratore, quindi seguire le istruzioni visualizzate sullo schermo del computer. Le password sono autenticate tramite hash e memorizzate in modo sicuro. Assicurarsi di memorizzare le password o di conservarle in una posizione sicura in quanto non possono essere decrittografate una volta archiviate. Se ci si connette a Microsoft SQL Server utilizzando l'autenticazione di Windows, non viene effettuata alcuna verifica della connessione durante l'installazione. Assicurarsi che l'utente designato per eseguire il servizio MVE di Windows abbia un account corrispondente nell'istanza di Microsoft SQL Server. L'utente designato deve avere i diritti dbowner per i database FRAMEWORK, MONITOR e QUARTZ. MVE installazione installazione di MVE"},{"UUID":"0ed75960-d706-4050-ad99-8512e3ecdfb5","title":"Introduzione","link":"installing-mve-silently-topic.html","desc":"Installazione di MVE invisibile all'utente","descFull":"Installazione di MVE invisibile all'utente Impostazioni del database per l'installazione invisibile all'utente Impostazione Descrizione Valore --help Mostra l'elenco delle opzioni valide. --version Mostra le informazioni sul prodotto. --unattendedmodeui <unattendedmodeui> L'interfaccia utente per la modalità automatica. Predefinito:  none Consentito: none minimal minimalWithDialogs --optionfile <optionfile> Il file delle opzioni di installazione. Predefinito: --debuglevel <debuglevel> Il livello di dettaglio delle informazioni di debug. Predefinito:  2 Consentito: 0 1 2 3 4 --mode <mode> La modalità di installazione. Predefinito:  win32 Consentito: win32 unattended --debugtrace <debugtrace> Il nome file di debug. Predefinito: --installer-language <installer-language> La selezione della lingua. Predefinito:  en Consentito: en es de fr it pt_BR zh_CN --encryptionKey <encryptionKey> La chiave di crittografia. Chiave di crittografia: Predefinito: --prefix <prefix> La directory di installazione. Predefinito:  C:\\Programmi --mveLexmark_runas <mveLexmark_runas> Le opzioni di utente utilizzato per l'esecuzione. Predefinito:  LOCAL_SYSTEM Consentito: LOCAL_SYSTEM SPECIFIC_USER --serviceRunAsUsername <serviceRunAsUsername> Il nome utente utilizzato per l'esecuzione. Nome utente: Predefinito: --serviceRunAsPassword <serviceRunAsPassword> La password utente utilizzata per l'esecuzione. Password: Predefinito: --mveLexmark_database <mveLexmark_database> Il tipo di database. Predefinito: Consentito: FIREBIRD SQL_SERVER --firebirdUsername <firebirdUsername> Il nome utente del database Firebird. Nome utente: Predefinito: --firebirdPassword <firebirdPassword> La password del database Firebird. Password: Predefinito: --firebirdFWDbName <firebirdFWDbName> Il nome del database Firebird per FRAMEWORK. Nomi database: Predefinito:  FRAMEWORK --firebirdMNDbName <firebirdMNDbName> Il nome del database Firebird per MONITOR. Predefinito:  MONITOR --firebirdQZDbName <firebirdQZDbName> Nome del database Firebird per QUARTZ. Predefinito:  QUARTZ --databaseIPAddress <databaseIPAddress> L'indirizzo IP o il nome host del database. Indirizzo IP o nome host: Predefinito: --databasePort <databasePort> Il numero della porta del database. Numero porta: Predefinito: --instanceName <instanceName> Il nome dell'istanza. Nome istanza: Predefinito: --instanceIdentifier <instanceIdentifier> L'istanza. Predefinito:  databasePort Consentito: databasePort instanceName --databaseUsername <databaseUsername> Il nome utente del database. Nome utente: Predefinito: --databasePassword <databasePassword> La password del database. Password: Predefinito: --sqlServerAuthenticationMethod <sqlServerAuthenticationMethod> Il metodo di autenticazione di Microsoft SQL Server. Predefinito:  sqlServerDbAuthentication Consentito: sqlServerDbAuthentication sqlServerWindowsAuthentication --fWDbName <fWDbName> Il nome del database per FRAMEWORK. Nomi database: Predefinito:  FRAMEWORK --mNDbName <mNDbName> Il nome del database per MONITOR. Predefinito:  MONITOR --qZDbName <qZDbName> Nome del database per QUARTZ. Predefinito:  QUARTZ --mveAdminUsername <mveAdminUsername> Il nome utente dell'amministratore. Nome utente: Predefinito:  admin --mveAdminPassword <mveAdminPassword> La password dell'amministratore. Password: Predefinito: installazione di MVE invisibile all'utente MVE, installazione invisibile all'utente installazione invisibile all'utente MVE"},{"UUID":"19641bcf-7c66-46bf-914a-33cedca91f47","title":"Introduzione","link":"accessing-mve-topic.html","desc":"Accesso a MVE Per accedere","descFull":"Accesso a MVE Per accedere a MVE, utilizzare le credenziali di accesso create durante l'installazione. È anche possibile configurare altri metodi di accesso, come LDAP, Kerberos o altri account locali. Per ulteriori informazioni, vedere  . Aprire un browser web e digitare  https:// MVE_SERVER /mve/ , in cui  MVE_SERVER  corrisponde al nome host o all'indirizzo IP del server che ospita MVE. Se necessario, accettare la declinazione di responsabilità. Immettere le proprie credenziali. Fare clic su  Accedi . Dopo aver effettuato l'accesso, assicurarsi di modificare la password predefinita dell'amministratore utilizzata durante l'installazione. Per ulteriori informazioni, vedere  . Se MVE è inattivo per più di 30 minuti, l'utente viene disconnesso automaticamente. MVE accesso accesso a MVE"},{"UUID":"8b18a3b7-b37f-4ecb-b145-10e7328e3c11","title":"Introduzione","link":"changing-language-topic.html","desc":"Modifica della lingua Aprire un","descFull":"Modifica della lingua Aprire un browser web e digitare  https:// MVE_SERVER /mve/ , in cui  MVE_SERVER  corrisponde al nome host o all'indirizzo IP del server che ospita MVE. Se necessario, accettare la declinazione di responsabilità. Nell'angolo superiore destro della pagina, selezionare una lingua. modifica della lingua lingua modifica"},{"UUID":"7131d6af-957e-41c8-83dc-4fc5a363fb02","title":"Introduzione","link":"changing-your-password-topic.html","desc":"Modifica della password Aprire un","descFull":"Modifica della password Aprire un browser web e digitare  https:// MVE_SERVER /mve/ , in cui  MVE_SERVER  corrisponde al nome host o all'indirizzo IP del server che ospita MVE. Se necessario, accettare la declinazione di responsabilità. Immettere le proprie credenziali. Fare clic su  Accedi . Nell'angolo superiore destro della pagina, fare clic sul nome utente, quindi su  Modifica password . Modificare la password. password modifica modifica della password"},{"UUID":"4269d5db-ac0e-4e8b-9f61-dbaf42e6ac98","title":"Manutenzione dell'applicazione","link":"upgrading-to-latest-version-topic.html","desc":"Aggiornamento a MVE 4.3 Prima","descFull":"Aggiornamento a MVE 4.3 Prima di iniziare l'aggiornamento, effettuare le seguenti operazioni: Eseguire il backup dei file del database, dell'applicazione e delle proprietà. Per ulteriori informazioni, vedere  . Se necessario, fornire i nomi di database personalizzati. In caso di aggiornamento dalla versione 1.x, è necessario passare alla versione 2.0, quindi alla versione 3.3 e alla versione 4.0 prima di effettuare l'aggiornamento alla versione 4.3. Il processo di migrazione dei criteri viene eseguito solo quando si esegue l'aggiornamento a MVE 2.0. Esempio Percorso di aggiornamento valido Da  3.3  a  4.0  a  4.3 Percorso di aggiornamento non valido Da  1.6.x  a  4.3 Da  2.0  a  4.3 Eseguire il backup dei file del database e dell'applicazione. Qualsiasi aggiornamento o disinstallazione determina un rischio di perdita irreversibile dei dati. Sarà possibile utilizzare i file di backup per ripristinare lo stato precedente dell'applicazione nel caso in cui l'aggiornamento non riesca. quando si esegue l'aggiornamento di MVE, il database subisce delle modifiche. Non ripristinare un backup del database creato da una versione precedente. Per ulteriori informazioni, vedere  . Scaricare il file eseguibile in un percorso temporaneo. Eseguire il programma di installazione come amministratore, quindi seguire le istruzioni visualizzate sullo schermo del computer. Quando si esegue l'aggiornamento a MVE 2.0, i criteri assegnati alle stampanti vengono trasferiti in una singola configurazione per ciascun modello di stampante. Ad esempio, se i criteri relativi a fax, copia, carta e stampa sono assegnati a una stampante X792, tali criteri vengono consolidati in una configurazione X792. Questa procedura non riguarda i criteri che non sono assegnati alle stampanti. MVE genera un file di registro che conferma l'avvenuta migrazione dei criteri a una configurazione. Per ulteriori informazioni, vedere  . Dopo aver eseguito l'aggiornamento, accertarsi di cancellare la cache del browser prima di accedere nuovamente all'applicazione. Quando si esegue l'aggiornamento di MVE alla versione 3.5 o successiva, i componenti di protezione avanzata vengono esclusi dalle configurazioni a cui appartengono. Se due o più componenti di protezione avanzata sono identici, questi vengono combinati in un unico componente. Il componente di protezione avanzata creato viene aggiunto automaticamente alla libreria dei componenti di protezione avanzata. aggiornamento alla versione più recente di MVE MVE aggiornamento"},{"UUID":"6eaef465-6f15-4e9e-89f5-40ec2775b568","title":"Manutenzione dell'applicazione","link":"backing-up-and-restoring-database-topic.html","desc":"Backup e ripristino del database","descFull":"Backup e ripristino del database è possibile che si verifichi una perdita di dati durante l'esecuzione delle procedure di backup e ripristino. Assicurarsi di eseguirle correttamente. Backup dei file del database e dell'applicazione Si consiglia di eseguire regolarmente il backup del database. Arrestare il servizio Firebird e il servizio Markvision Enterprise. Aprire la finestra di dialogo  Esegui , quindi digitare  services.msc . Fare clic con il pulsante destro del mouse su  Firebird Guardian - DefaultInstance , quindi fare clic su  Arresta . Fare clic con il pulsante destro del mouse su  Markvision Enterprise , quindi fare clic su  Arresta . Selezionare la cartella in cui è installato Markvision Enterprise. Ad esempio,  C:\\Programmi\\ Eseguire il backup dei file dell'applicazione e del database. Backup dei file dell'applicazione Copiare i seguenti file in un repository sicuro. Lexmark\\mve_encryption.jceks Lexmark\\mve_truststore.p12 Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\platform.properties Lexmark\\Markvision Enterprise\\apps\\library Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\jre\\lib\\security\\cacerts Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml assicurarsi che questi file siano memorizzati correttamente. Senza le chiavi di crittografia nel file mve_encryption.jceks, i dati memorizzati in un formato crittografato nel database e nel file system non possono essere recuperati. Backup dei file del database Effettuare una delle seguenti operazioni: i seguenti file utilizzano i nomi di database predefiniti. Queste istruzioni si applicano anche ai nomi di database personalizzati. Se si utilizza un database Firebird, copiare i seguenti file in un repository sicuro. Per evitare perdite di dati, è necessario eseguire regolarmente il backup di questi file. Lexmark\\Markvision Enterprise\\firebird\\security2.fdb Se si utilizzano nomi di database personalizzati, aggiornare quanto segue: Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service/WEB-INF\\classes\\application.yml Lexmark\\Markvision Enterprise\\firebird\\aliases.conf Lexmark\\Markvision Enterprise\\firebird\\data\\QUARTZ.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\MONITOR.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\FRAMEWORK.FDB Se si utilizza Microsoft SQL Server, creare un backup per FRAMEWORK, MONITOR e QUARTZ. Per ulteriori informazioni, contattare l'amministratore di Microsoft SQL Server. Riavviare il servizio Firebird e il servizio Markvision Enterprise. Aprire la finestra di dialogo  Esegui , quindi digitare  services.msc . Fare clic con il pulsante destro del mouse su  Firebird Guardian - DefaultInstance , quindi fare clic su  Riavvia . Fare clic con il pulsante destro del mouse su  Markvision Enterprise , quindi fare clic su  Riavvia . Ripristino dei file del database e dell'applicazione quando si esegue l'aggiornamento di MVE, il database può subire delle modifiche. Non ripristinare un backup del database creato da una versione precedente. Arrestare il servizio Markvision Enterprise. Per ulteriori informazioni, vedere   di  . Selezionare la cartella in cui è installato Markvision Enterprise. Ad esempio,  C:\\Programmi\\ Ripristinare i file dell'applicazione. Sostituire i seguenti file con i file salvati durante il processo di backup: Lexmark\\mve_encryption.jceks Lexmark\\mve_truststore.p12 Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\platform.properties Lexmark\\Markvision Enterprise\\apps\\library Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\jre\\lib\\security\\cacerts Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml è possibile ripristinare un backup del database in una nuova installazione MVE solo se la versione di tale installazione è la stessa. Ripristinare i file del database. Effettuare una delle seguenti operazioni: Se si usa un database Firebird, sostituire i seguenti file salvati durante il processo di backup: i seguenti file utilizzano i nomi di database predefiniti. Questa istruzione si applica anche ai nomi di database personalizzati. Lexmark\\Markvision Enterprise\\firebird\\security2.fdb Se si utilizzano nomi di database personalizzati, vengono ripristinati anche i seguenti file: Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service/WEB-INF\\classes\\application.yml Lexmark\\Markvision Enterprise\\firebird\\aliases.conf Lexmark\\Markvision Enterprise\\firebird\\data\\QUARTZ.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\MONITOR.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\FRAMEWORK.FDB Se si usa un database Microsoft SQL Server, contattare l'amministratore di Microsoft SQL Server. Riavviare il servizio Markvision Enterprise. Per ulteriori informazioni, vedere   di  . database backup database ripristino backup e ripristino del database"},{"UUID":"3b5b9bd5-103e-4dd8-a4be-bf836c9acede","title":"Manutenzione dell'applicazione","link":"changing-installer-settings-topic.html","desc":"Aggiornamento delle impostazioni del programma","descFull":"Aggiornamento delle impostazioni del programma di installazione dopo l'installazione L'utility password di Markvision Enterprise consente di aggiornare le impostazioni di Microsoft SQL Server configurate durante l'installazione senza dover reinstallare MVE. L'utility consente inoltre di aggiornare le credenziali dell'account di dominio Esegui come utente, ad esempio il nome utente e la password. È inoltre possibile utilizzare la utility per creare un altro utente amministratore se vengono dimenticate le credenziali dell'utente amministratore precedente. Selezionare la cartella in cui è installato Markvision Enterprise. Ad esempio,  C:\\Programmi\\ Avviare il file  mvepwdutility-windows.exe  nella cartella Lexmark\\Markvision Enterprise\\. Selezionare una lingua, quindi fare clic su  OK Avanti . Seguire le istruzioni visualizzate sullo schermo del computer. modifica delle impostazioni del programma di installazione dopo l'installazione impostazioni del programma di installazione modifica"},{"UUID":"9b0049cc-6f6a-463b-a9c0-76091afa68d6","title":"Configurazione dell'accesso utente","link":"setting-up-user-access-overview-topic.html","desc":"Panoramica MVE consente di aggiungere","descFull":"Panoramica MVE consente di aggiungere utenti interni direttamente al server MVE o di utilizzare gli account utente registrati in un server LDAP. Per ulteriori informazioni sull'aggiunta di utenti interni, vedere  . Per ulteriori informazioni sull'utilizzo di account utente LDAP, vedere  . Quando si aggiungono utenti, devono essere assegnati dei ruoli. Per ulteriori informazioni, vedere  . Durante l'autenticazione, il sistema verifica le credenziali degli utenti interni presenti nel server MVE. Se MVE non è in grado di eseguire l'autenticazione dell'utente, prova ad autenticarlo sul server LDAP. Se il nome dell'utente esiste sia sul server MVE che sul server LDAP, viene utilizzata la password del server MVE. configurazione dell'accesso utente, panoramica panoramica configurazione dell'accesso utente"},{"UUID":"f38f1d75-d3ae-40c6-ac85-84fa8a62c463","title":"Configurazione dell'accesso utente","link":"understanding-user-roles-topic.html","desc":"Informazioni sui ruoli utente Gli","descFull":"Informazioni sui ruoli utente Gli utenti MVE possono essere assegnati a uno o più ruoli. A seconda del ruolo, gli utenti possono effettuare le seguenti attività: Amministratore : accedere ed eseguire le attività di tutti i menu. Essi dispongono inoltre di privilegi amministrativi che consentono, ad esempio, di aggiungere utenti al sistema o di configurare le impostazioni del sistema. Solo gli utenti con il ruolo di amministratore possono interrompere le attività in esecuzione indipendentemente dal tipo di utente che le ha avviate. Stampanti Gestire i profili di ricerca. Impostare gli stati della stampante. Eseguire un controllo. Gestire categorie e parole chiave. Programmare un controllo, un'esportazione dati e la ricerca della stampante. Configurazioni Gestire le configurazioni, comprese l'importazione e l'esportazione dei file di configurazione. Caricare i file nella libreria delle risorse. Assegnare e applicare le configurazioni alle stampanti. Programmare un controllo di conformità e l'applicazione delle configurazioni. Distribuire i file alle stampanti. Aggiornare il firmware della stampante. Generare le richieste di firma per il certificato della stampante. Scaricare le richieste di firma per il certificato della stampante. Gestione degli eventi Gestire azioni ed eventi. Assegnare eventi alle stampanti. Effettuare il test delle azioni. Assistenza Aggiornare lo stato della stampante. Riavviare le stampanti. Eseguire un controllo di conformità. Applicare le configurazioni alle stampanti. Tutti gli utenti di MVE possono visualizzare la pagina delle informazioni della stampante e gestire viste e ricerche salvate. Per ulteriori informazioni sull'assegnazione dei ruoli utente, vedere  . ruoli utente informazioni informazioni sui ruoli utente"},{"UUID":"0cb8cca6-f68b-4bb0-864f-ca9fe2150e8b","title":"Configurazione dell'accesso utente","link":"managing-users-topic.html","desc":"Gestione degli utenti Fare clic","descFull":"Gestione degli utenti Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  Utente , quindi effettuare una delle seguenti operazioni: Aggiungere un utente Fare clic su  Crea . Digitare il nome utente, l'ID utente e la password. Selezionare i ruoli. Per ulteriori informazioni, vedere  . Fare clic su  Crea utente . Modificare un utente Selezionare un ID utente. Configurare le impostazioni. Fare clic su  Salva modifiche . Eliminare utenti Selezionare uno o più utenti. Fare clic su  Elimina , quindi confermare l'eliminazione. Un account utente è bloccato dopo tre tentativi consecutivi di accesso non riusciti. Solo un utente Amministratore può riattivare l'account utente. Se l'utente Amministratore è bloccato, il sistema lo riattiva automaticamente dopo cinque minuti. gestione degli utenti utenti gestione utenti aggiunta utenti modifica utenti eliminazione"},{"UUID":"c7c6994d-03f0-4c9a-8052-012fb96d8fbd","title":"Configurazione dell'accesso utente","link":"enabling-ldap-server-authentication-topic.html","desc":"Abilitazione dell'autenticazione tramite server LDAP","descFull":"Abilitazione dell'autenticazione tramite server LDAP LDAP è un protocollo estendibile tra più piattaforme, basato su standard, che viene eseguito direttamente su TCP/IP e utilizzato per accedere a database specializzati denominati directory. Per evitare di gestire più credenziali utente, è possibile utilizzare il server LDAP della società per autenticare gli ID utente e le password. Come prerequisito, il server LDAP deve contenere gruppi utenti corrispondenti ai ruoli utente richiesti. Per ulteriori informazioni, vedere  . Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  LDAP , quindi selezionare  Abilita LDAP per autenticazione . Nel campo  Nome host server LDAP  digitare l'indirizzo IP o il nome host del server LDAP in cui viene eseguita l'autenticazione. se si desidera utilizzare la comunicazione crittografata tra il server MVE e il server LDAP, utilizzare il nome di dominio completo (FQDN). Specificare il numero di porta del server in base al protocollo di crittografia selezionato. Selezionare il protocollo di crittografia. Nessuna TLS : un protocollo di sicurezza che utilizza la crittografia dei dati e l'autenticazione del certificato per proteggere la comunicazione tra un server e un client. Se si seleziona questa opzione, viene inviato un comando START_TLS al server LDAP una volta stabilita la connessione. Utilizzare questa impostazione se si desidera una comunicazione protetta tramite la porta 389. SSL/TLS : un protocollo di sicurezza che utilizza la crittografia a chiave pubblica per autenticare la comunicazione tra un server e un client. Utilizzare questa opzione se si desidera una comunicazione protetta dall'inizio del binding LDAP. Questa opzione viene generalmente utilizzata per la porta 636 o altre porte LDAP protette. Selezionare il tipo di binding. Semplice : il server MVE produce le credenziali specificate al server LDAP al fine di utilizzare la funzione di ricerca del server LDAP. Digitare il nome utente di binding. Digitare la password di binding, quindi confermarla. Kerberos : per configurare le impostazioni, effettuare le seguenti operazioni: Digitare il nome utente di binding. Digitare la password di binding, quindi confermarla. Fare clic su  Scegli file , quindi selezionare il file krb5.conf. SPNEGO : per configurare le impostazioni, effettuare le seguenti operazioni: Digitare il nome principale del servizio. Fare clic su  Scegli file , quindi selezionare il file krb5.conf. Fare clic su  Scegli file , quindi selezionare il file keytab Kerberos. Questa opzione viene utilizzata solo per configurare il meccanismo SPNEGO (Simple and Protected GSSAPI Negotiation Mechanism) per supportare la funzionalità Single Sign-On. Nella sezione  Opzioni avanzate  effettuare le seguenti operazioni: Base di ricerca : il nome distinto di base (DN) del nodo radice. Nella gerarchia del server community LDAP, questo nodo deve essere il predecessore del nodo utente e del nodo gruppo. Ad esempio,  dc=mvetest,dc=com . quando si specifica il DN radice, accertarsi che solo  dc  e  o  facciano parte del DN radice. Se  ou  o  cn  è il predecessore dei nodi utente e gruppo, utilizzare  ou  o  cn  nelle basi di ricerca utenti o gruppi. Base di ricerca utenti : il nodo nel server community LDAP in cui è presente l'oggetto utente. Questo nodo si trova nel DN radice in cui sono elencati tutti i nodi utente. Ad esempio,  ou=people . Filtro di ricerca utenti : il parametro per individuare un oggetto utente nel server community LDAP. Ad esempio,  (uid={0}) . Esempi di più condizioni ed espressioni complesse consentite Accesso con Nel campo  Filtro di ricerca utenti  digitare Nome comune (CN={0}) Nome di accesso (sAMAccountName={0}) Nome principale utente (userPrincipalName={0}) Numero di telefono (telephoneNumber={0}) Nome di accesso o nome comune (|(sAMAccountName={0})(CN={0})) possono essere utilizzati solo i modelli  {0}  e  {1} . Se si utilizza  {0} , MVE cerca il DN utente LDAP. Se si utilizza  {1} , MVE cerca il nome di accesso utente MVE. Cerca oggetto base utenti e sottoalbero intero : il sistema ricerca tutti i nodi nella base di ricerca utenti. Base di ricerca gruppi : il nodo nel server community LDAP che contiene i gruppi utenti corrispondenti ai ruoli MVE. Questo nodo si trova nel DN radice in cui sono elencati tutti i nodi gruppo. Ad esempio,  ou=group . Filtro di ricerca gruppi : il parametro per individuare un utente all'interno di un gruppo che corrisponde a un ruolo MVE. l'unico modello valido è  {0} , che indica che MVE cerca il nome di accesso utente MVE. Attributo ruolo gruppo : digitare l'attributo LDAP per il nome completo del gruppo. Un attributo LDAP ha un significato specifico e definisce un mapping tra l'attributo e il nome di un campo. Ad esempio, l'attributo LDAP  cn  viene associato al campo  Nome . Anche l'attributo LDAP  commonname  viene associato al campo  Nome . In genere, questo attributo deve essere lasciato impostato sul valore predefinito di  cn . Cerca oggetto base utenti e sottoalbero intero : il sistema ricerca tutti i nodi nella base di ricerca gruppi. Nella sezione  Mapping gruppi LDAP a ruoli MVE  immettere i nomi dei gruppi LDAP che corrispondono ai ruoli MVE. Per ulteriori informazioni, vedere  . È possibile assegnare un gruppo LDAP a più ruoli MVE. È inoltre possibile immettere più di un gruppo LDAP in un campo di ruolo, utilizzando il carattere barra verticale ( | ) per separare i gruppi. Ad esempio, per includere i gruppi  admin  e  assets  per il ruolo  Amministratore , digitare  admin|assets  nel campo  Gruppi LDAP per amministratore . Se si desidera utilizzare solo il ruolo  Amministratore  e non gli altri ruoli MVE, lasciare i campi vuoti. Fare clic su  Salva modifiche . server LDAP abilitazione dell'autenticazione abilitazione dell'autenticazione tramite server LDAP"},{"UUID":"11ac48dc-7425-4b2e-b0d1-11b422ca76cc","title":"Configurazione dell'accesso utente","link":"installing-ldap-server-certificates-topic.html","desc":"Installazione dei certificati del server","descFull":"Installazione dei certificati del server LDAP Per stabilire una comunicazione crittografata tra il server MVE e il server LDAP, MVE deve considerare attendibile il certificato del server LDAP. Nell'architettura MVE, quando MVE si autentica con un server LDAP, MVE è il client e il server LDAP è il peer. Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  LDAP , quindi configurare le impostazioni LDAP. Per ulteriori informazioni, vedere  . Fare clic su  Prova LDAP . Immettere un nome utente LDAP e una password validi, quindi fare clic su  Avvia prova . Esaminare la validità del certificato, quindi accettarlo. installazione dei certificati del server LDAP certificati server LDAP installazione"},{"UUID":"f4532584-f151-48b0-984c-aed154368f76","title":"Configurazione dell'accesso utente","link":"adding-root-ca-certificate-java-truststore-topic.html","desc":"Aggiunta di un certificato CA","descFull":"Aggiunta di un certificato CA radice al truststore Java Alcune configurazioni LDAP per MVE utilizzano un servizio di bilanciamento del carico o un IP virtuale (VIP) per reindirizzare le richieste LDAPS. In questi casi, il certificato CA radice del dominio deve essere installato e attendibile nel truststore Java di MVE. Importare il certificato CA radice e verificare che sia attendibile. Eseguire il backup dei file del database e dell'applicazione. Arrestare il servizio MVE. Eseguire il prompt dei comandi come amministratore, quindi digitare quanto segue: \"C:\\Program Files\\Lexmark\\Markvision Enterprise\\jre\\bin\\keytool.exe\" -import -trustcacerts -alias EnterpriseRootCA -file C:\\temp\\EnterpriseRootCA.cer -keystore \"C:\\Program Files\\Lexmark\\Markvision Enterprise\\jre\\lib\\security\\cacerts\" Alla richiesta di immettere la password del keystore, digitare  changeit . Quando viene richiesto se si desidera considerare attendibile il certificato, digitare  sì . Se il processo viene completato, appare il messaggio  Il certificato è stato aggiunto al keystore . Se le autorizzazioni a livello di file per il file cacerts non consentono di aggiornare il file, viene visualizzato il messaggio Accesso negato. È possibile aggiornare le autorizzazioni per il file o eseguire il prompt dei comandi come amministratore con autorizzazione di aggiornamento del file. Riavviare il servizio MVE. aggiunta di un certificato CA radice truststore Java"},{"UUID":"fb5744ba-7528-400a-bfd8-a600eeb3ab5c","title":"Rilevamento delle stampanti","link":"creating-discovery-profile-topic.html","desc":"Creazione di un profilo di","descFull":"Creazione di un profilo di ricerca Utilizzare un profilo di ricerca per trovare le stampanti in rete e aggiungerle al sistema. In un profilo di ricerca, effettuare una delle seguenti operazioni per includere o escludere un elenco di indirizzi IP o nomi host: Aggiunta di singole voci Importazione di voci da un file TXT o CSV Inoltre, è possibile assegnare e applicare automaticamente una configurazione a un modello di stampante compatibile. Una configurazione deve contenere impostazioni della stampante, applicazioni, licenze, firmware e certificati CA che possono essere distribuiti sulle stampanti. Nel menu  Stampanti  fare clic su  Profili di ricerca Crea . Nella sezione  Impostazioni generali  digitare un nome univoco e una descrizione per il profilo di ricerca, quindi configurare le seguenti opzioni: Timeout : l'intervallo di tempo per cui il sistema deve attendere la risposta di una stampante. Tentativi : il numero di tentativi di comunicazione del sistema con una stampante. Gestisci automaticamente stampanti rilevate : le nuove stampanti rilevate vengono impostate automaticamente sullo stato Gestito e lo stato Nuovo viene ignorato durante la ricerca. Nella sezione  Indirizzi  effettuare una delle seguenti operazioni: Aggiungere gli indirizzi Selezionare  Includi  o  Escludi . Digitare l'indirizzo IP, il nome host, la subnet o l'intervallo di indirizzi IP. Aggiungere una sola voce per volta. Utilizzare i seguenti formati per gli indirizzi: 10.195.10.1  (indirizzo IPv4 singolo) myprinter.example.com  (nome host singolo) 10.195.10.3-10.195.10.255  (intervallo di indirizzi IPv4) 10.195.*.*  (caratteri jolly) 10.195.10.1/22  (notazione IPv4 CIDR (Classless Inter‑Domain Routing) 2001:db8:0:0:0:0:2:1  (indirizzo IPv6 completo) 2001:db8::2:1  (indirizzo IPv6 compresso) se vengono creati profili di ricerca separati per l'indirizzo IPv6 e l'indirizzo IPv4 per la stessa stampante, viene visualizzato l'ultimo indirizzo rilevato. Ad esempio, se una stampante viene rilevata tramite IPv6, quindi viene nuovamente rilevata tramite IPv4, nell'elenco delle stampanti viene visualizzato solo l'indirizzo IPv4. Fare clic su  Aggiungi . Importare gli indirizzi Fare clic su  Importa . Scegliere se includere o escludere degli indirizzi IP durante la ricerca. Selezionare il file di testo contenente l'elenco di indirizzi. Ciascuna voce di indirizzo deve trovarsi su una riga separata. File di testo di esempio 10.195.10.1\nmyprinter.example.com\n10.195.10.3-10.195.10.255\n10.195.*.*\n10.195.10.1/22\n2001:db8:0:0:0:0:2:1\n2001:db8::2:1 Fare clic su  Importa . Nella sezione  SNMP  selezionare  Versione 1 ,  Versione 2c  o  Versione 3 , quindi impostare le autorizzazioni di accesso. per eseguire la ricerca delle stampanti che utilizzano SNMP versione 3, creare un nome utente e una password in Embedded Web Server della stampante, quindi riavviare la stampante. Se non è possibile stabilire una connessione, rilevare nuovamente le stampanti. Per ulteriori informazioni, consultare la  Guida dell'amministratore di Embedded Web Server . Se necessario, nella sezione  Immetti le credenziali , selezionare il metodo di autenticazione utilizzato per le stampanti, quindi immettere le credenziali. questa funzione consente di stabilire la comunicazione con le stampanti protette durante il rilevamento. È necessario fornire le credenziali corrette per eseguire attività sulle stampanti protette, come controllo, aggiornamento dello stato e aggiornamento del firmware. Se necessario, nella sezione  Assegna configurazioni , associare una configurazione a un modello di stampante. Per informazioni sulla creazione di una configurazione, vedere  . Se necessario, nella sezione  Assegna parole chiave , associare una parola chiave a un modello di stampante durante il rilevamento. Per informazioni sull'assegnazione delle parole chiave alle stampanti, vedere  . A tutte le stampanti rilevate tramite questo profilo vengono assegnate le nuove parole chiave. Le nuove parole chiave vengono aggiunte all'elenco esistente di parole chiave già assegnate a una stampante. Fare clic su  Salva profilo  o su  Salva ed esegui profilo . è possibile programmare l'esecuzione periodica di una ricerca. Per ulteriori informazioni, vedere  . creazione di un profilo di ricerca profilo di ricerca creazione"},{"UUID":"2dc9ea02-b27d-4d04-a282-75b21f57d274","title":"Rilevamento delle stampanti","link":"managing-discovery-profiles-topic.html","desc":"Gestione dei profili di ricerca","descFull":"Gestione dei profili di ricerca Dalla scheda Stampanti, fare clic su  Profili di ricerca . Effettuare una delle seguenti operazioni: Modificare un profilo Selezionare un profilo, quindi fare clic su  Modifica . Configurare le impostazioni. Fare clic su  Salva profilo  o su  Salva ed esegui profilo . Copiare un profilo Selezionare un profilo, quindi fare clic su  Copia . Configurare le impostazioni. Aggiungere gli indirizzi IP. Per ulteriori informazioni, vedere  . Fare clic su  Salva profilo  o su  Salva ed esegui profilo . Eliminare un profilo Selezionare uno o più profili. Fare clic su  Elimina , quindi confermare l'eliminazione. Eseguire un profilo Selezionare uno o più profili. Fare clic su  Esegui . Controllare lo stato di ricerca dal menu Attività. gestione dei profili di ricerca profili di ricerca gestione modifica dei profili di ricerca eliminazione dei profili di ricerca copia dei profili di ricerca esecuzione dei profili di ricerca profili di ricerca modifica profili di ricerca eliminazione profili di ricerca copia profili di ricerca esecuzione"},{"UUID":"51a22bbd-a2af-4b60-8058-fae0f717c920","title":"Rilevamento delle stampanti","link":"sample-scenario-discovering-printers-topic.html","desc":"Scenario di esempio: rilevamento delle","descFull":"Scenario di esempio: rilevamento delle stampanti La società ABC è una grande azienda di produzione che occupa un edificio di nove piani. La società ha appena acquistato 30 nuove stampanti Lexmark, distribuite sui nove piani. Il personale IT deve aggiungere queste nuove stampanti a MVE. Le stampanti sono già collegate alla rete, ma non si conoscono tutti gli indirizzi IP. Si desidera proteggere le seguenti nuove stampanti situate nel reparto contabilità. 10.194.55.60 10.194.56.77 10.194.55.71 10.194.63.27 10.194.63.10 Esempio di implementazione Creare un profilo di ricerca per le stampanti situate nel reparto contabilità. Aggiungere i cinque indirizzi IP. Creare una configurazione che protegga le stampanti specificate. Includere le configurazioni nel profilo di ricerca. Salvare ed eseguire il profilo. Creare un altro profilo di ricerca per le rimanenti stampanti. Includere gli indirizzi IP utilizzando un carattere jolly. Utilizzare il seguente formato:  10.194.*.* Escludere i cinque indirizzi IP delle stampanti situate nel reparto contabilità. Salvare e quindi eseguire il profilo. rilevamento delle stampanti stampanti rilevamento"},{"UUID":"a33e16dc-4e53-42fb-ad0e-ff98dd64b521","title":"Gestione della dashboard di protezione","link":"overview-security-dashboard-topic.html","desc":"Panoramica Il dashboard di protezione","descFull":"Panoramica Il dashboard di protezione consente di visualizzare lo stato delle impostazioni di protezione delle periferiche attraverso una rappresentazione visiva di varie impostazioni di protezione, quali porte, protocolli, stato di crittografia disco, account di amministratore periferica e stato del certificato predefinito. Fornisce visibilità sul livello di sicurezza del parco dispositivi, aiutando gli amministratori a identificare e correggere le impostazioni che non sono conformi. panoramica dashboard di protezione"},{"UUID":"f78a895d-da23-4313-a3f4-b3689a515ccc","title":"Gestione della dashboard di protezione","link":"accessing-dashboard-topic.html","desc":"Accesso al dashboard di protezione","descFull":"Accesso al dashboard di protezione Nel portale Web MVE, fare clic su  Dashboard . Il dashboard di protezione è la pagina di destinazione predefinita per gli utenti Admin. Fare clic su uno dei seguenti widget: Informazioni sulla protezione della periferica Controllo conformità periferica Come mostrare o nascondere il dashboard di protezione Modificare il parametro  dashboard.display  nel file platform.properties per nascondere o mostrare il dashboard di protezione. Il file platform.properties si trova in  \\ Installation Location \\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes , dove  Installation Location  è la cartella di installazione di MVE. Il valore predefinito di questo parametro è  True . Se si immette un valore errato o si lascia il campo di questo parametro vuoto, viene visualizzato il dashboard. Per disabilitare il dashboard, impostare il parametro  dashboard.display  su  False . Dopo aver modificato il parametro, riavviare il servizio MVE. dashboard accesso"},{"UUID":"a52df133-b4e6-465b-b2db-59f3c3017cca","title":"Gestione della dashboard di protezione","link":"managing-device-security-information-topic.html","desc":"Gestione di  Informazioni sulla","descFull":"Gestione di  Informazioni sulla protezione della periferica Questo widget riepiloga la vista della protezione del parco dispositivi. Fare clic su una barra qualsiasi del grafico per accedere  alla finestra  Informazioni sulla protezione della periferica . Passare il mouse sulle barre per visualizzare i seguenti dettagli: Numero porta Numero di stampanti associate Se le impostazioni della stampante sono aperte/abilitate Fare clic su  Stampa  per ottenere un formato stampabile della vista dettagliata. La finestra Informazioni sulla protezione della periferica dispone di una funzione di drill‑down. Facendo clic su un elemento della barra nel grafico, l'utente può accedere a una vista filtrata della pagina di elenco delle stampanti. Per ulteriori informazioni, vedere  . Informazioni sulla protezione della periferica gestione"},{"UUID":"e389957c-022c-450e-b7d9-fda6862009df","title":"Gestione della dashboard di protezione","link":"managing-device-conformance-check-topic.html","desc":"Gestione di  Controllo conformità","descFull":"Gestione di  Controllo conformità periferica Questo widget riepiloga la vista dettagliata del controllo di conformità del parco dispositivi. Fare clic su una sezione qualsiasi del grafico a torta per passare alla finestra  Controllo conformità periferica . Nel riquadro a sinistra, applicare il filtro  Intervallo date . l'intervallo predefinito è 7 giorni. Fare clic su  Stampa  per ottenere un formato stampabile della vista dettagliata. La finestra Controllo conformità periferica dispone di una funzione di drill‑down. Facendo clic su una sezione del grafico a torta, l'utente può accedere a una vista filtrata della pagina di elenco delle stampanti. Per ulteriori informazioni, vedere  . Controllo conformità periferica gestione"},{"UUID":"b3458db7-a5a3-4af6-a63d-0fb25ccd18fb","title":"Visualizzazione delle stampanti","link":"viewing-printer-list-topic.html","desc":"Visualizzazione dell'elenco stampanti La pagina","descFull":"Visualizzazione dell'elenco stampanti La pagina Elenco stampanti è la pagina iniziale predefinita quando si accede a MVE. La tabella mostra l'elenco delle stampanti aggiunte in MVE. Nel menu  Stampanti  fare clic su  Elenco stampanti . Nella pagina  Elenco stampanti  effettuare una delle seguenti operazioni: Per cercare determinate stampanti, effettuare una delle seguenti operazioni: Utilizzare la casella di ricerca per cercare indirizzo IP, nome host, nome del sistema o numero di serie. Modificare la visualizzazione dell'elenco stampanti. Per ulteriori informazioni, vedere  . se si sta utilizzando la casella di ricerca, l'applicazione cerca tutte le stampanti presenti nel sistema. I filtri selezionati e le ricerche salvate vengono ignorati. Se si esegue una ricerca salvata, vengono utilizzati i criteri specificati nella ricerca salvata. I filtri selezionati e l'indirizzo IP o il nome host immesso nella casella di ricerca vengono ignorati. È anche possibile utilizzare i filtri per restringere i risultati di ricerca correnti. Utilizzare i filtri. Eseguire una ricerca salvata. Per ulteriori informazioni, vedere  . Per ordinare le stampanti, dalla tabella con l'elenco delle stampanti, fare clic su qualsiasi intestazione di colonna. Le stampanti sono ordinate in base all'intestazione della colonna selezionata. Per visualizzare ulteriori informazioni sulle stampanti, ridimensionare le colonne. Posizionare il cursore sul bordo verticale dell'intestazione della colonna, quindi trascinare il bordo a sinistra o a destra. visualizzazione dell'elenco stampanti elenco delle stampanti visualizzazione"},{"UUID":"9fa1b478-6aba-49fb-8d17-1c94e797c710","title":"Visualizzazione delle stampanti","link":"viewing-device-information-topic.html","desc":"Visualizzazione delle informazioni della stampante","descFull":"Visualizzazione delle informazioni della stampante Per vedere l'elenco completo delle informazioni, assicurarsi che il controllo sia eseguito sulla stampante. Per ulteriori informazioni, vedere  . Nel menu  Stampanti  fare clic su  Elenco stampanti . Fare clic sull'indirizzo IP della stampante. Visualizzare le seguenti informazioni: Stato : stato della stampante. Materiali di consumo : dettagli sui materiali di consumo e percentuale dei materiali rimanenti. Identificazione : informazioni di identificazione della rete della stampante. le informazioni sul fuso orario sono disponibili solo in determinati modelli di stampante. Date : la data in cui la stampante viene aggiunta al sistema, la data di ricerca e la data del controllo più recente. Firmware : proprietà e livelli del codice del firmware della stampante. Funzionalità : funzioni della stampante. Opzioni di memoria : dimensione del disco fisso e spazio libero sulla memoria flash dell'utente. Opzioni di alimentazione : impostazioni per i vassoi disponibili. Opzioni di uscita : impostazioni per i raccoglitori disponibili. Applicazioni eSF : informazioni relative alle applicazioni eSF (Embedded Solutions Framework) installate sulla stampante. Statistiche stampante : valori specifici di ciascuna proprietà della stampante. Modifica dettagli : informazioni relative alle modifiche della stampante. queste informazioni sono disponibili solo nelle stampanti con stato Gestito (modificato). Per ulteriori informazioni, vedere  . Credenziali stampante : credenziali utilizzate per la configurazione assegnata alla stampante. Certificato della stampante  : proprietà dei seguenti certificati della stampante: Predefinito HTTPS 802.1x IPSec Queste informazioni sono disponibili solo su alcuni modelli di stampante. Uno stato di validità  Scadenza imminente  indica la data di scadenza, come impostato nella sezione  Autorità di certificazione  in  Configurazione di sistema . Proprietà di configurazione : proprietà della configurazione assegnata alla stampante. Avvisi attivi : gli avvisi della stampante in attesa di essere cancellati. Eventi assegnati : eventi assegnati alla stampante. visualizzazione delle informazioni della stampante informazioni sulla stampante visualizzazione"},{"UUID":"755146c1-1a1f-435b-842c-25bbfce02bfd","title":"Visualizzazione delle stampanti","link":"exporting-data-topic.html","desc":"Esportazione dei dati della stampante","descFull":"Esportazione dei dati della stampante MVE consente di esportare le informazioni relative alla stampante che è disponibile nella visualizzazione corrente. Nella cartella  Stampanti  , fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Stampante Esporta i dati . I dati esportati vengono salvati in un file CSV. È possibile programmare l'esecuzione periodica di un'esportazione dati. Per ulteriori informazioni, vedere  . esportazione di dati della stampante dati della stampante esportazione"},{"UUID":"5271246d-57e7-4bac-96c2-720cbd9d7ab4","title":"Visualizzazione delle stampanti","link":"managing-views-topic.html","desc":"Gestione delle visualizzazioni La funzione","descFull":"Gestione delle visualizzazioni La funzione  Visualizzazioni  consente di personalizzare le informazioni contenute nella pagina dell'elenco stampanti. Nel menu  Stampanti  fare clic su  Visualizzazioni . Effettuare una delle seguenti operazioni: Creare una visualizzazione Fare clic su  Crea . Digitare un nome univoco per la visualizzazione e la relativa descrizione. Nella scheda  Visualizza colonne , nel menu  Colonna 1 , selezionare la colonna dell'identificativo. Nella sezione  Colonne possibili  espandere una categoria e selezionare le informazioni che si desidera mostrare sotto forma di colonna, quindi fare clic su  > . Funzionalità : indica se le funzionalità selezionate sono supportate sulla stampante. Certificato : mostra la data di creazione del certificato della stampante, lo stato di registrazione, la data di scadenza, la data di rinnovo, il numero di revisione, l'oggetto del certificato, la validità e lo stato della firma. Informazioni sulla configurazione : mostra le informazioni associate alla configurazione della stampante, come conformità, nome della configurazione e stato. Date : consente di visualizzare l'ultimo controllo, l'ultima verifica di conformità, l'ultima ricerca e la data in cui la stampante è stata aggiunta al sistema. Eventi : mostra le informazioni relative agli eventi della stampante. Firmware : mostra le informazioni relative al firmware, ad esempio la versione del firmware. Identificazione : mostra le informazioni relative alla stampante, ad esempio l'indirizzo IP, il nome host e il numero di serie. Opzioni di alimentazione : mostra le informazioni sulle opzioni di input, ad esempio le dimensioni del vassoio e il tipo di supporto. Opzioni : mostra informazioni sulle opzioni della stampante, ad esempio disco fisso e unità flash. Statistiche stampante : mostra informazioni sull'utilizzo della stampante, ad esempio il numero di pagine stampate o acquisite tramite scansione, e il numero totale di lavori inviati via fax. Soluzioni : mostra le applicazioni eSF installate sulla stampante e i numeri delle relative versioni. Stato : mostra lo stato della stampante e dei materiali di consumo. Materiali di consumo : mostra le informazioni relative ai materiali di consumo. Porte della stampante : mostra le informazioni correlate alle porte. Un'opzione  Sconosciuto  nel valore della porta significa che la porta non esiste sulla stampante o che MVE non è in grado di recuperare la porta. Opzioni di protezione della stampante : mostra le informazioni TLS e di crittografia. Fare clic su  Crea visualizzazione . Modificare una visualizzazione Selezionare una visualizzazione. Fare clic su  Modifica , quindi modificare le impostazioni. Fare clic su  Salva modifiche . Copiare una visualizzazione Selezionare una visualizzazione. Fare clic su  Copia , quindi configurare le impostazioni. Fare clic su  Crea visualizzazione . Eliminare visualizzazioni Selezionare una o più visualizzazioni. Fare clic su  Elimina , quindi confermare l'eliminazione. Impostare una visualizzazione predefinita Selezionare una visualizzazione. Fare clic su  Imposta come predefinito . Le seguenti visualizzazioni sono generate dal sistema e non possono essere modificate o eliminate: Configurazione Elenco stampanti Evento Protezione Service Desk Vassoio standard gestione delle visualizzazioni modifica di visualizzazioni copia di visualizzazioni eliminazione di visualizzazioni impostazione di una visualizzazione predefinita visualizzazioni gestione visualizzazioni modifica visualizzazioni copia visualizzazioni eliminazione"},{"UUID":"1b0c75dc-73e7-44ff-98bb-0767edefecad","title":"Visualizzazione delle stampanti","link":"changing-printer-listing-view-topic.html","desc":"Modifica della visualizzazione dell'elenco stampanti","descFull":"Modifica della visualizzazione dell'elenco stampanti Per ulteriori informazioni, vedere  . Nel menu Stampante, fare clic su  Elenco stampanti . Fare clic su  Visualizzazioni , quindi selezionare una visualizzazione. modifica della visualizzazione dell'elenco stampanti visualizzazione dell'elenco stampanti modifica"},{"UUID":"f9a75ea5-8161-4cf6-9b4f-d274ae260612","title":"Visualizzazione delle stampanti","link":"filtering-printers-using-search-bar-topic.html","desc":"Filtraggio delle stampanti dalla barra","descFull":"Filtraggio delle stampanti dalla barra di ricerca Per cercare le stampanti dalla barra di ricerca, tenere presente quanto segue. Per cercare un indirizzo IP, assicurarsi di digitare l'intervallo o l'indirizzo IP completo. Ad esempio: 10.195.10.1 10.195.10.3-10.195.10.255 10.195.*.* 2001:db8:0:0:0:0:2:1 Se la stringa di ricerca non è un indirizzo IP completo, le stampanti vengono cercate in base al nome host, al nome del sistema o al numero di serie. Il carattere di sottolineatura (  _  ) può essere utilizzato come carattere jolly. filtraggio delle stampanti dalla barra di ricerca barra di ricerca filtraggio delle stampanti stampanti filtraggio"},{"UUID":"5d65f88b-21bb-4e18-b358-d43155f11874","title":"Visualizzazione delle stampanti","link":"managing-keywords-topic.html","desc":"Gestione delle parole chiave Le","descFull":"Gestione delle parole chiave Le parole chiave consentono di creare etichette personalizzate e di assegnarle alle stampanti. Nel menu  Stampanti  fare clic su  Parole chiave . Effettuare una delle seguenti operazioni: Aggiungere, modificare o eliminare una categoria. le categorie raggruppano insieme le parole chiave. Aggiungere, modificare o eliminare una parola chiave. Per informazioni sull'assegnazione delle parole chiave alle stampanti, vedere  . gestione delle parole chiave parole chiave gestione creazione di parole chiave modifica di parole chiave eliminazione di parole chiave parole chiave creazione parole chiave modifica parole chiave eliminazione"},{"UUID":"57e1e752-0067-475a-9ce2-8d0e6fc9b571","title":"Uso delle ricerche salvate","link":"understanding-device-life-cycle-states-topic.html","desc":"Informazioni sugli stati del ciclo","descFull":"Informazioni sugli stati del ciclo di vita della stampante Le ricerche salvate generate dal sistema mostrano le stampanti con i seguenti stati del ciclo di vita della stampante: Tutte le stampanti : tutte le stampanti nel sistema. Stampanti gestite : le stampanti visualizzate possono essere in uno dei seguenti stati: Gestito (normale) Gestito (modificato) Gestito (mancante) Gestito (trovato) Stampanti gestite (modificate) : stampanti del sistema le cui proprietà seguenti sono cambiate dall'ultimo controllo: Etichetta proprietà Nome host Nome contatto Posizione contatto Dimensione memoria Fronte/retro Materiali di consumo (livelli esclusi) Opzioni di input Opzioni di stampa Applicazioni eSF Certificato della stampante predefinita Stampanti gestite (trovate) : stampanti segnalate come mancanti, ma che ora sono state trovate. Stampanti gestite (mancanti) : stampanti con le quali il sistema non è in grado di comunicare. Stampanti gestite (normali) : stampanti del sistema, le cui proprietà sono rimaste invariate dall'ultimo controllo. Nuove stampanti : stampanti appena rilevate che non sono state impostate automaticamente sullo stato Gestito. Stampanti ritirate : stampanti non più attive nel sistema. Stampanti non gestite : stampanti contrassegnate per l'esclusione dalle attività eseguite nel sistema. Stato iniziale Stato finale Transizione 1  L'impostazione \" Gestisci automaticamente stampanti rilevate \" è attivata nel profilo di ricerca. 2 L'impostazione \" Gestisci automaticamente stampanti rilevate \" è disattivata nel profilo di ricerca. Avvia Normale Rilevata. 1 Avvia Nuovo Rilevata. 2 Qualsiasi Normale, Non gestito o Ritirato Manuale (Mancante non viene modificato in Normale). Ritirato Normale Rilevata. 1 Ritirato Nuovo Rilevata. 2 Normale, Mancante o Trovato Modificato Nuovo indirizzo rilevato. Normale Modificato Le proprietà di controllo non corrispondono alle proprietà del database. Normale, Modificato o Trovato Mancante Stato non trovato su controllo o di aggiornamento. Modificato Normale Le proprietà di controllo corrispondono alle proprietà del database. Mancante Trovato Stato rilevato, di controllo o di aggiornamento. Trovato Normale Stato rilevato, di controllo o di aggiornamento. stati del ciclo di vita della stampante informazioni informazioni sugli stati del ciclo di vita della stampante"},{"UUID":"9ce29d65-2b50-4fd2-8c52-38edef5b2a84","title":"Uso delle ricerche salvate","link":"understanding-device-life-cycle-states-topic.html","desc":"Esecuzione di una ricerca salvata","descFull":"Esecuzione di una ricerca salvata Una ricerca salvata è un insieme di parametri salvato che restituisce le informazioni più recenti sulle stampanti in base a tali parametri. È possibile creare ed eseguire una ricerca salvata personalizzata oppure eseguire le ricerche salvate predefinite generate dal sistema. Le ricerche salvate generate dal sistema mostrano le stampanti nei relativi stati del ciclo di vita. Per ulteriori informazioni, vedere  . Nel menu  Stampanti  fare clic su  Elenco stampanti . Nel menu a discesa, selezionare una ricerca salvata. esecuzione di una ricerca salvata ricerche salvate esecuzione"},{"UUID":"4571bbb3-ee33-4838-aa9b-771386a3cdc3","title":"Uso delle ricerche salvate","link":"understanding-device-life-cycle-states-topic.html","desc":"Creazione di una ricerca salvata","descFull":"Creazione di una ricerca salvata Uso dei filtri Nel menu  Stampanti  fare clic su  Elenco stampanti . Sul lato sinistro della pagina, selezionare i filtri. i filtri selezionati sono elencati sopra l'intestazione dei risultati di ricerca. Fare clic su  Salva , quindi digitare un nome univoco per la ricerca salvata e la relativa descrizione. Fare clic su  Crea ricerca salvata . Uso della pagina Ricerca salvata Nel menu  Stampanti  fare clic su  Ricerche salvate Crea . Nella sezione  Impostazioni generali  digitare un nome univoco per la ricerca salvata e la relativa descrizione. Nella sezione  Regole e gruppi di regole , nel menu  Corrispondenza , specificare se i risultati della ricerca devono corrispondere a tutte o ad alcune regole. Effettuare una delle seguenti operazioni: Aggiungere una regola Fare clic su  Aggiungi regola . Specificare il parametro, l'operazione e il valore della regola di ricerca. Per ulteriori informazioni, vedere  . Aggiungere un gruppo di regole Un gruppo di regole può contenere una combinazione di regole. Se il menu  Corrispondenza  è impostato su  QUALSIASI regola e gruppi di regole , il sistema esegue la ricerca delle stampanti che corrispondono a tutte le regole nel gruppo di regole. Se il menu  Corrispondenza  è impostato su  TUTTE le regole e gruppi di regole , il sistema esegue la ricerca delle stampanti che corrispondono a qualsiasi regola nel gruppo di regole. Fare clic su  Aggiungi gruppo di regole . Specificare il parametro, l'operazione e il valore della regola di ricerca. Per ulteriori informazioni, vedere  . Per aggiungere un'altra regola, fare clic su  Aggiungi regola . Fare clic su  Crea ricerca salvata  o  Crea ed esegui ricerca salvata . creazione di una ricerca salvata personalizzata ricerca salvata personalizzata creazione"},{"UUID":"a4d5d538-e3ca-4339-b3d7-fda8c0893375","title":"Uso delle ricerche salvate","link":"understanding-device-life-cycle-states-topic.html","desc":"Informazioni sulle impostazioni delle regole","descFull":"Informazioni sulle impostazioni delle regole di ricerca Cercare le stampanti utilizzando uno o più dei seguenti parametri: Parametro Descrizione Etichetta risorsa Il valore dell'impostazione dell'etichetta risorsa sulla stampante. Data creazione del certificato 1 La data in cui il certificato è stato creato. Stato di registrazione del certificato 1 Lo stato di registrazione del certificato. Data di scadenza certificato 1 La data di scadenza del certificato. Data di rinnovo certificato 1 La data in cui il certificato viene rinnovato. Numero di revisione certificato 1 Il numero di revisione del certificato. Stato di firma del certificato 1 Lo stato del certificato. Stato di validità del certificato 1 La validità del certificato. lo stato  Scadenza imminente  indica che il certificato scade entro 30 giorni. Funzionalità Colore La stampante stampa a colori o in bianco e nero. Configurazione Il nome della configurazione assegnato alla stampante. Conformità configurazione Lo stato di conformità della stampante a fronte della configurazione assegnata. Posizione contatto Il valore dell'impostazione della posizione di contatto sulla stampante. Nome contatto Il valore dell'impostazione del nome di contatto sulla stampante. Copia La stampante supporta la funzione Copia. Data: Aggiunta al sistema La data in cui la stampante è stata aggiunta al sistema. Data: Ultimo controllo La data in cui è stato eseguito l'ultimo controllo della stampante. Data: Ultimo controllo conformità La data in cui è stato eseguito l'ultimo controllo della conformità alla configurazione della stampante. Data: Ultima rilevazione La data in cui la stampante è stata rilevata l'ultima volta. Codifica disco La stampante è configurata per la crittografia del disco. Pulizia disco La stampante è configurata per la pulizia del disco. Fronte/retro La stampante supporta la stampa su due lati. Funzionalità eSF La stampante supporta la gestione delle applicazioni eSF. Informazioni eSF Le informazioni sull'applicazione eSF installata sulla stampante, ad esempio il nome, lo stato e la versione. Nome evento Il nome degli eventi assegnati. Nome fax Il valore dell'impostazione del nome fax sulla stampante. Numero fax Il valore dell'impostazione del numero fax sulla stampante. Ricezione fax La stampante supporta la ricezione dei fax. Informazioni firmware Le informazioni sul firmware installato sulla stampante. Nome : il nome del firmware. Ad esempio,  Base  o  Kernel . Versione : la versione del firmware della stampante. Nome host Il nome host della stampante. Indirizzo IP L'indirizzo IP della stampante. è possibile utilizzare un asterisco negli ultimi tre ottetti per cercare più voci. Ad esempio,  123.123.123.* ,  123.123.*.* ,  123.*.*.* ,  2001:db8::2:1  e  2001:db8:0:0:0:0:2:1 . Parola chiave Le parole chiave assegnate. Conteggio pagine complessive Il conteggio totale delle pagine della stampante. Indirizzo MAC L'indirizzo MAC della stampante. Contatore manutenzione Il valore del contatore di manutenzione della stampante. Produttore Il nome del produttore della stampante. Tecnologia contrassegno La tecnologia di contrassegno supportata dalla stampante. Funzionalità MFP La stampante è un prodotto multifunzione (MFP). Modello Il nome del modello di stampante. Numero di serie modulare Il numero di serie modulare. Stato stampante Lo stato della stampante. Ad esempio,  Pronta ,  Inceppamento carta ,  Vassoio 1 mancante . Gravità stato stampante Il valore dello stato più grave sulla stampante. Ad esempio,  Sconosciuto ,  Pronta ,  Avvertenza  o  Errore . Profilo La stampante supporta i profili. Scan to E-mail La stampante supporta la funzione di acquisizione su e-mail Scan to Fax La stampante supporta la funzione di acquisizione su fax. Acquisisci su rete La stampante supporta l'acquisizione su rete. Stato comunicazioni protette Lo stato di autenticazione o di protezione della stampante. Numero di serie Il numero di serie della stampante. Stato Lo stato attuale della stampante nel database. Stato materiale di consumo Lo stato dei materiali di consumo della stampante. Gravità dello stato dei materiali di consumo Il valore dello stato dei materiali di consumo più grave sulla stampante. Ad esempio,  Sconosciuto ,  OK ,  Avvertenza  o  Errore . Nome sistema Il nome di sistema della stampante. Fuso orario Il fuso orario dell'area in cui si trova la stampante. TLI Il valore dell'impostazione TLI sulla stampante. 1 I parametri relativi al certificato sono applicabili ai seguenti certificati periferica: Predefinito HTTPS 802.1x IPSec Utilizzare i seguenti operatori durante la ricerca delle stampanti: Corrisponde esattamente : un parametro è uguale a un valore specificato. È diverso da : un parametro è diverso da un valore specificato. Contiene : un parametro contiene un valore specificato. Non contiene : un parametro non contiene un valore specificato. Inizia con : un parametro inizia con un valore specificato. Termina con : un parametro termina con un valore specificato. Data Meno recente di : parametro che consente di eseguire la ricerca nei giorni precedenti a quelli specificati. Ultimo periodo specificato : parametro che consente di eseguire la ricerca nei giorni specificati prima di oggi. Entro i prossimi : parametro che consente di eseguire la ricerca entro i giorni specificati dopo oggi. per cercare stampanti che presentano parametri con valori vuoti, utilizzare  _EMPTY_OR_NULL_ . Ad esempio, per cercare stampanti con  Nome fax  non specificato, nel campo  Valore , digitare  _EMPTY_OR_NULL_ . impostazioni delle regole di ricerca informazioni regole di ricerca parametri regole di ricerca operatori"},{"UUID":"f60c453d-b330-4a7c-9145-fd23f1ed654f","title":"Uso delle ricerche salvate","link":"understanding-device-life-cycle-states-topic.html","desc":"Gestione delle ricerche salvate Nel","descFull":"Gestione delle ricerche salvate Nel menu Stampanti, fare clic su  Ricerche salvate . Effettuare una delle seguenti operazioni: Modificare una ricerca salvata Selezionare una ricerca salvata, quindi fare clic su  Modifica . Le ricerche salvate generate dal sistema non possono essere modificate. Per ulteriori informazioni, vedere  . Configurare le impostazioni. Fare clic su  Salva modifiche  o su  Salva ed esegui . Copiare una ricerca salvata Selezionare una ricerca salvata, quindi fare clic su  Copia . Configurare le impostazioni. Fare clic su  Crea ricerca salvata  o  Crea ed esegui ricerca salvata . Eliminare le ricerche salvate Selezionare una o più ricerche salvate. Le ricerche salvate generate dal sistema non possono essere eliminate. Per ulteriori informazioni, vedere  . Fare clic su  Elimina , quindi confermare l'eliminazione. gestione delle ricerche salvate ricerche salvate gestione modifica delle ricerche salvate copia delle ricerche salvate eliminazione delle ricerche salvate ricerche salvate modifica ricerche salvate copia ricerche salvate eliminazione"},{"UUID":"bd3aa1d0-3aa8-40cb-81b0-ec580f3467c6","title":"Visualizzazione delle stampanti","link":"sample-scenario-monitor-fleet-topic.html","desc":"Scenario di esempio: monitoraggio dei","descFull":"Scenario di esempio: monitoraggio dei livelli di toner del parco stampanti Il personale IT della società ABC deve organizzare il parco stampanti al fine di monitorarlo con facilità e desidera monitorare l'utilizzo del toner delle stampanti per determinare se i materiali di consumo devono essere sostituiti. Esempio di implementazione Creare una ricerca salvata che recupera le stampanti i cui materiali di consumo presentano errori o avvertenze. Regola di esempio per la ricerca salvata Parametro:  Gravità dello stato dei materiali di consumo Operazione:  Non è Valore:  Materiali di consumo OK Creare una visualizzazione che mostri lo stato, la capacità e il livello dei materiali di consumo per ciascuna stampante. Colonne di esempio da mostrare nella visualizzazione dei materiali di consumo Stato materiale di consumo Funzionalità Cartuccia nero Livello cartuccia nero Funzionalità Cartuccia ciano Livello cartuccia ciano Funzionalità Cartuccia magenta Livello cartuccia magenta Funzionalità Cartuccia giallo Livello cartuccia giallo Eseguire la ricerca salvata mentre si utilizza la visualizzazione. le informazioni visualizzate nella visualizzazione dell'elenco stampanti si basano sull'ultimo controllo. Eseguire un controllo e un aggiornamento dello stato per ottenere lo stato corrente della stampante. monitoraggio delle stampanti"},{"UUID":"c24a8d85-5468-47fd-951b-37ad154d90f1","title":"Protezione delle comunicazioni della stampante","link":"understanding-security-status-topic.html","desc":"Informazioni sugli stati di protezione","descFull":"Informazioni sugli stati di protezione della stampante Durante la ricerca, la stampante può trovarsi in uno dei seguenti stati: Non protetto : MVE non necessita di credenziali per comunicare con il dispositivo. Protetto : MVE necessita di credenziali che sono state fornite. Credenziali mancanti : MVE necessita di credenziali che non sono state fornite. Credenziali non valide : MVE necessita di credenziali, ma sono state fornite credenziali non corrette. La stampante è in stato  Credenziali non valide  quando durante la ricerca, il controllo, l'aggiornamento dello stato, la verifica della conformità o l'applicazione della configurazione le credenziali fornite non vengono ritenute valide. La stampante è in stato  Non protetto  solo quando non richiede credenziali durante la ricerca. Per modificare lo stato da  Non protetto  a  Protetto , applicare una configurazione protetta. Per modificare lo stato  Credenziali mancanti  o  Credenziali non valide  di una stampante, immettere manualmente le credenziali in MVE oppure creare una configurazione dalla stampante. stati di protezione della stampante informazioni"},{"UUID":"f3fa3657-ac4b-4efc-a41f-b0914b97857d","title":"Protezione delle comunicazioni della stampante","link":"securing-printers-using-default-config-topic.html","desc":"Protezione delle stampanti mediante le","descFull":"Protezione delle stampanti mediante le configurazioni predefinite Su alcuni modelli di stampante non esiste un utente amministratore predefinito. L'utente guest può entrare liberamente senza bisogno di eseguire l'accesso. Questa impostazione consente all'utente di accedere a tutte le autorizzazioni e ai controlli di accesso della stampante. MVE gestisce questo rischio tramite le configurazioni predefinite. Dopo una nuova installazione, vengono creati automaticamente due componenti di protezione avanzata, ognuno dei quali contiene le impostazioni di protezione predefinite e l'account amministratore locale preconfigurato. È possibile utilizzare questi componenti di protezione durante la creazione di una configurazione e quindi distribuire e applicare la configurazione alle nuove stampanti. Nel menu  Configurazioni  fare clic su  Tutti i componenti di protezione avanzata . Autenticazione semplice basata sull'account Questo componente di protezione contiene un  account locale nome utente/password  chiamato  amministratore . L'account  amministratore  è un membro del gruppo Amministratore, le cui autorizzazioni includono le autorizzazioni e i controlli di accesso alle funzioni per proteggere la stampante e limitare l'accesso pubblico. Per ulteriori informazioni, vedere  . Prima di aggiungere questo componente a una configurazione, assicurarsi di impostare la password per  amministratore  e le credenziali stampante. Autenticazione semplice basata sul modello Questo componente di protezione contiene un modello di protezione denominato  Con protezione password amministratore  configurato con un  Account locale password . Questo modello di protezione viene applicato ai seguenti controlli di accesso: Aggiornamenti firmware Gestione remota Menu Protezione da remoto Gli altri controlli di accesso sono impostati su  Nessuna protezione . Tuttavia, è sempre possibile impostare gli altri menu amministrativi in modo da utilizzare il modello di protezione per maggiore sicurezza. Per ulteriori informazioni sui controlli di accesso, vedere  . Prima di aggiungere questo componente a una configurazione, assicurarsi di impostare la password e le credenziali stampante. protezione delle stampanti mediante le configurazioni predefinite stampanti protezione configurazioni predefinite"},{"UUID":"37a43b99-6c62-4ea6-a72b-931b67528508","title":"Protezione delle comunicazioni della stampante","link":"understanding-fac-permissions-topic.html","desc":"Informazioni sulle autorizzazioni e i","descFull":"Informazioni sulle autorizzazioni e i controlli di accesso alle funzioni È possibile configurare le stampanti in modo da limitare l'accesso pubblico ai menu amministrativi e alle funzioni di gestione periferiche. Nei modelli più nuovi le autorizzazioni per accedere alle funzioni della stampante si possono proteggere con diversi metodi di autenticazione. Nei modelli meno recenti è possibile applicare un modello di protezione a un controllo di accesso alle funzioni (FAC). Per comunicare con e gestire le stampanti protette, MVE richiede alcune autorizzazioni o FAC, a seconda del modello della stampante. Nella tabella riportata di seguito sono illustrate le funzioni della stampante che si possono essere gestire in MVE e le autorizzazioni o FAC necessari. MVE richiede le credenziali di autenticazione quando la funzione  Gestione remota  è protetta. Se altri menu amministrativi e autorizzazioni di gestione periferiche o FAC sono protetti, è necessario proteggere anche  Gestione remota . In caso contrario, MVE non potrà eseguire le funzioni. Tali autorizzazioni e controlli di accesso alle funzioni sono predefiniti in MVE come componenti di protezione avanzata predefiniti e possono essere immediatamente utilizzati in una configurazione. Per ulteriori informazioni, vedere  . Se non si utilizzano i componenti di protezione avanzata predefiniti, assicurarsi che tali autorizzazioni e controlli di accesso alle funzioni siano configurati manualmente nella stampante. Per ulteriori informazioni, vedere  . Autorizzazioni o FAC Descrizione Gestione remota La possibilità di leggere e scrivere le impostazioni da remoto. Se una qualsiasi altra autorizzazione o FAC riportato in questa tabella è protetto, è necessario proteggere anche  Gestione remota . Aggiornamenti firmware La possibilità di aggiornare il firmware con qualsiasi metodo. Configurazione applicazioni La possibilità di installare o rimuovere applicazioni dalla stampante e inviare i file di impostazione delle applicazioni alla stampante. Importa/Esporta tutte le impostazioni o Importazione/esportazione file di configurazione La possibilità di inviare file di configurazione alla stampante. Menu Protezione o Menu Protezione da remoto La possibilità di gestire i metodi di accesso e configurare le opzioni di protezione della stampante. Per proteggere i modelli di stampante più recenti in MVE, disabilitare l'accesso pubblico per le autorizzazioni di  Gestione remota  e  Menu Protezione . Per i modelli meno recenti, applicare un modello di protezione al FAC di  Gestione remota . controlli di accesso alle funzioni informazioni autorizzazioni informazioni"},{"UUID":"8c9bdaf4-f995-43e6-a1c7-9ccb07951c12","title":"Protezione delle comunicazioni della stampante","link":"configuring-device-security-topic.html","desc":"Configurazione della protezione della stampante","descFull":"Configurazione della protezione della stampante Nel menu  Stampanti  fare clic su  Elenco stampanti . Fare clic sull'indirizzo IP della stampante, quindi fare clic su  Apri server Web incorporato . Fare clic su  Impostazioni  o  Configurazione . A seconda del modello di stampante, svolgere una delle seguenti operazioni: Fare clic su  Protezione Metodi di accesso , quindi effettuare le seguenti operazioni: Per i modelli di stampante più recenti Nella sezione  Protezione  creare un metodo di accesso. Fare clic su  Gestisci gruppi/autorizzazioni  o  Gestisci autorizzazioni  accanto al metodo di accesso. Espandere  Menu amministrativi , quindi selezionare  Menu Protezione . Espandere  Gestione periferiche , quindi selezionare le seguenti opzioni: Gestione remota Aggiornamenti firmware Configurazione applicazioni Importa/Esporta tutte le impostazioni Fare clic su  Salva . Dalla sezione  Pubblico , fare clic su  Gestisci autorizzazioni . Espandere  Menu amministrativi , quindi deselezionare  Menu Protezione . Espandere  Gestione periferiche , quindi deselezionare  Gestione remota . Fare clic su  Salva . Fare clic su  Protezione Impostazione di protezione  o  Modifica impostazioni di protezione , quindi effettuare le seguenti operazioni: Per i modelli meno recenti Nella sezione  Impostazione di protezione avanzata  creare un blocco e un modello di protezione. Fare clic su  Controlli accesso , quindi espandere  Menu amministrativi . Nel menu  Menu Protezione da remoto  selezionare il modello di protezione. Espandere  Gestione , quindi selezionare il modello di protezione per le seguenti controlli di accesso alle funzioni: Configurazione applicazioni Gestione remota Aggiornamenti firmware Importazione/esportazione file di configurazione Fare clic su  Invia . configurazione della protezione della stampante protezione della stampante configurazione"},{"UUID":"8770ef94-5a36-416b-970a-87a19c33931c","title":"Protezione delle comunicazioni della stampante","link":"securing-printer-communications-on-your-fleet-topic.html","desc":"Protezione delle comunicazioni della stampante","descFull":"Protezione delle comunicazioni della stampante nel parco stampanti Rilevare una stampante protetta. Per ulteriori informazioni, vedere  . Una stampante è protetta quando accanto al nome è visualizzata l'icona  . Per informazioni sulla protezione di una stampante, vedere il  documento della Guida . Per ulteriori informazioni sugli stati di protezione della stampante, vedere  . Creare una configurazione da una stampante. Per ulteriori informazioni, vedere  . Assegnare la configurazione al parco periferiche. Per ulteriori informazioni, vedere  . Applicare la configurazione. Per ulteriori informazioni, vedere  . Il simbolo del lucchetto viene visualizzato accanto alla stampante protetta. protezione delle comunicazioni della stampante nel parco stampanti comunicazioni della stampante protezione"},{"UUID":"3c765db0-bedf-48e6-9a28-bddaf7a5a65f","title":"Protezione delle comunicazioni della stampante","link":"securing-printers-topic.html","desc":"Altri modi per proteggere le","descFull":"Altri modi per proteggere le stampanti Per ulteriori informazioni sulle impostazioni di protezione della stampante, consultare la  Guida dell'amministratore di Embedded Web Server  per la stampante in uso. Verificare le seguenti impostazioni delle stampanti: La crittografia disco è abilitata. Le seguenti porte sono limitate: TCP 79 (Finger) TCP 21 (FTP) UDP 69 (TFTP) TCP 5001 (IPDS) TCP 9600 (IPDS) TCP 10000 (Telnet) L'elenco crittografie predefinito è la stringa di crittografia OWASP \"B\". protezione delle stampanti stampanti protezione"},{"UUID":"ee73ddb3-c600-4f6a-b830-af49f87e2340","title":"Gestione delle stampanti","link":"restarting-printer-topic.html","desc":"Riavvio della stampante Nella cartella","descFull":"Riavvio della stampante Nella cartella  Stampanti  , fare clic su  Elenco stampanti . Selezionare l'indirizzo IP della stampante. Fare clic su  Riavvia stampante . riavvio della stampante stampante riavvio"},{"UUID":"03cc0986-5568-45c7-b1a1-26a513a0bb50","title":"Gestione delle stampanti","link":"viewing-ews-topic.html","desc":"Visualizzazione di Embedded Web Server","descFull":"Visualizzazione di Embedded Web Server della stampante Embedded Web Server è un software incorporato in una stampante che fornisce un pannello di controllo per la configurazione della stampante da qualsiasi browser Web. Nella cartella  Stampanti  , fare clic su  Elenco stampanti . Selezionare l'indirizzo IP della stampante. Fare clic su  ApriEmbedded Web Server visualizzazione di Embedded Web Server della stampante Embedded Web Server visualizzazione"},{"UUID":"4d78cd2f-5ff9-425b-83be-fbb7c29c8657","title":"Gestione delle stampanti","link":"auditing-devices-topic.html","desc":"Controllo delle stampanti Un controllo","descFull":"Controllo delle stampanti Un controllo raccoglie le informazioni relative alle stampanti con stato Gestito e salva tali informazioni nel sistema. Per assicurarsi che le informazioni nel sistema siano aggiornate, eseguire periodicamente un controllo. Nel menu Stampante, fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Stampante Controllo . È possibile programmare l'esecuzione periodica di un controllo. Per ulteriori informazioni, vedere  . controllo delle stampanti stampanti controllo"},{"UUID":"ca99106f-7ced-492a-ac6b-49820f1f4757","title":"Gestione delle stampanti","link":"updating-printer-status-topic.html","desc":"Aggiornamento dello stato della stampante","descFull":"Aggiornamento dello stato della stampante La funzione Aggiorna stato consente di aggiornare lo stato della stampante e le informazioni sui materiali di consumo. Per assicurarsi che lo stato della stampante e le informazioni sui materiali di consumo siano aggiornate, aggiornare regolarmente lo stato. Nel menu  Stampanti  fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Stampante Aggiorna stato . è possibile programmare l'esecuzione periodica di un aggiornamento di stato. Per ulteriori informazioni, vedere  . aggiornamento dello stato della stampante stato della stampante aggiornamento"},{"UUID":"23f75358-9f98-4cc4-b23b-9f83ba4c5058","title":"Gestione delle stampanti","link":"setting-device-state-topic.html","desc":"Impostazione dello stato della stampante","descFull":"Impostazione dello stato della stampante Per ulteriori informazioni sugli stati della stampante, vedere  . Nel menu Stampante, fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Stampante , quindi selezionare una delle seguenti opzioni: Imposta stato su Gestito : la stampante viene inclusa in tutte le attività che è possibile eseguire sul sistema. Imposta stato su Non gestito : la stampante viene esclusa da tutte le attività che è possibile eseguire sul sistema. Imposta stato su Ritirato : la stampante viene rimossa dalla rete. Il sistema conserva le informazioni della stampante, ma non prevede di rilevare nuovamente la stampante sulla rete. stato della stampante impostazione impostazione dello stato della stampante"},{"UUID":"4a81e81a-d47a-465d-92b8-e7b54bc0cda4","title":"Gestione delle stampanti","link":"assigning-configurations-to-devices-topic.html","desc":"Assegnazione di configurazioni alle stampanti","descFull":"Assegnazione di configurazioni alle stampanti Prima di iniziare, assicurarsi che sia stata creata una configurazione per la stampante. L'assegnazione di una configurazione a una stampante consente al sistema di eseguire controlli di conformità e applicazioni. Per ulteriori informazioni, vedere  . Nel menu  Stampanti  fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Configura Assegna configurazioni . Nella sezione  Configurazione  selezionare una configurazione. se il sistema è impostato su  Utilizzare Markvision per gestire i certificati della periferica , selezionare  Periferiche selezionate attendibili . Questa conferma consente all'utente di verificare che le stampanti siano periferiche reali e non falsificate. Fare clic su  Assegna configurazioni . assegnazione di configurazioni alle stampanti configurazioni assegnazione"},{"UUID":"b938ffec-d86b-44d7-b25a-f2cd9ac6cfb6","title":"Gestione delle stampanti","link":"unassigning-configurations-topic.html","desc":"Annullamento dell'assegnazione delle configurazioni Nel","descFull":"Annullamento dell'assegnazione delle configurazioni Nel menu Stampante, fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Configura Annulla assegnazione configurazioni . Fare clic su  Annulla assegnazione configurazioni . annullamento dell'assegnazione delle configurazioni configurazioni annullamento dell'assegnazione"},{"UUID":"c7aea794-7bd7-4880-867d-dd269163c383","title":"Gestione delle stampanti","link":"enforcing-configurations-topic.html","desc":"Applicazione delle configurazioni MVE esegue","descFull":"Applicazione delle configurazioni MVE esegue un controllo di conformità sulla stampante. Se alcune impostazioni risultano non conformi, MVE le modifica sulla stampante. MVE esegue un controllo di conformità finale dopo aver modificato le impostazioni. Il completamento degli aggiornamenti che prevedono il riavvio della stampante, ad esempio gli aggiornamenti del firmware, potrebbe richiedere una seconda applicazione. Prima di iniziare, assicurarsi alla stampante sia stata assegnata una configurazione. Per ulteriori informazioni, vedere  . Nella cartella  Stampanti  , fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Configura Applica configurazioni . Se la stampante è in stato di errore, alcune impostazioni potrebbero non essere aggiornate. Affinché MVE distribuisca i file del firmware e delle soluzioni su una stampante, il controllo di accesso alla funzione Aggiornamenti firmware deve essere impostato su  Nessuna protezione . Se la protezione è applicata, il controllo di accesso alla funzione Aggiornamenti firmware deve utilizzare lo stesso modello di protezione del controllo di accesso Gestione remota. Per ulteriori informazioni, vedere  . È possibile programmare l'esecuzione periodica di un'applicazione. Per ulteriori informazioni, vedere  . applicazione delle configurazioni configurazioni applicazione"},{"UUID":"ad999b1a-7405-4019-ab01-2555b360cb2a","title":"Gestione delle stampanti","link":"checking-device-conformance-topic.html","desc":"Controllo della conformità di una","descFull":"Controllo della conformità di una stampante con una configurazione Durante un controllo di conformità, MVE controlla le impostazioni della stampante e verifica se corrispondono alla configurazione assegnata. MVE non apporta alcuna modifica alla stampante durante questa operazione. Prima di iniziare, assicurarsi alla stampante sia stata assegnata una configurazione. Per ulteriori informazioni, vedere  . Nella cartella  Stampanti  , fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Configura Controllo di conformità . È possibile visualizzare i risultati nella pagina di stato dell'attività. È possibile programmare l'esecuzione periodica di un controllo di conformità. Per ulteriori informazioni, vedere  . controllo della conformità della stampante con una configurazione conformità verifica stampante conformità con perforazione conformità"},{"UUID":"53dff284-d680-4576-aa08-e8816db14f5f","title":"Gestione delle stampanti","link":"deploying-files-to-printers-topic.html","desc":"Distribuzione dei file alle stampanti","descFull":"Distribuzione dei file alle stampanti È possibile implementare i seguenti file alla stampante: Certificati CA : i file  .cer  o  .pem  aggiunti all'archivio attendibile della stampante. Configurazione bundle : i file  .zip  che vengono esportati da una stampante supportata o ottenuti direttamente da Lexmark. Aggiornamento del firmware : un file  .fls  che viene caricato nella stampante. File generici : tutti i file che si desidera inviare alla stampante. Socket di tipo raw : inviati tramite la porta 9100. La stampante li considera come qualsiasi altro tipo di dati di stampa. FTP : consente di inviare file tramite FTP. Questo metodo di distribuzione non è supportato su stampanti protette. Certificato stampante : un certificato firmato che è installato sulla stampante come il certificato predefinito. UCF (Universal Configuration File) : un file di configurazione esportato da una stampante. Servizio Web : il servizio Web HTTPS viene utilizzato quando il modello di stampante lo supporta. In caso contrario, la stampante utilizza il servizio Web HTTP. FTP : consente di inviare file tramite FTP. Questo metodo di distribuzione non è supportato su stampanti protette. Nella cartella  Stampanti  , fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Configura Distribuisci file a stampanti . Fare clic su  Scegli file , quindi selezionare il file. Selezionare un tipo di file, quindi selezionare un metodo di distribuzione. Fare clic su  Distribuisci file . Affinché MVE distribuisca i file del firmware e delle soluzioni su una stampante, il controllo di accesso alla funzione Aggiornamenti firmware deve essere impostato su  Nessuna protezione . Se la protezione è applicata, il controllo di accesso alla funzione Aggiornamenti firmware deve utilizzare lo stesso modello di protezione del controllo di accesso Gestione remota. È possibile programmare l'esecuzione periodica di una distribuzione. Per ulteriori informazioni, vedere  . distribuzione dei file alle stampanti file distribuzione stampanti distribuzione dei file"},{"UUID":"72f36899-b447-4336-a203-baa17e272567","title":"Gestione delle stampanti","link":"updating-printer-firmware-topic.html","desc":"Aggiornamento del firmware delle stampanti","descFull":"Aggiornamento del firmware delle stampanti Nel menu  Stampanti  fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Configura Aggiorna firmware su stampanti . Selezionare un file del firmware dalla libreria delle risorse oppure fare clic su  Scegli file , quindi cercare il file del firmware. per ulteriori informazioni sull'aggiunta di file del firmware alla libreria, vedere  . Se necessario, per pianificare l'aggiornamento, selezionare  Definisci intervallo di tempo di aggiornamento , quindi selezionare la data di inizio, l'ora di inizio e di interruzione e i giorni della settimana. Il firmware viene inviato alle stampanti nell'intervallo tra l'ora di inizio specificata e il tempo di pausa. L'attività viene messa in pausa dopo il tempo di pausa, quindi riprende all'ora di inizio successiva finché non viene completata. Fare clic su  Aggiorna firmware . Affinché MVE aggiorni il firmware della stampante, il controllo di accesso alla funzione Aggiornamenti firmware deve essere impostato su  Nessuna protezione . Se la protezione è applicata, il controllo di accesso alla funzione  Aggiornamenti firmware  deve utilizzare lo stesso modello di protezione del controllo di accesso  Gestione remota . In questo caso, MVE deve gestire la stampante nella modalità protetta. Per ulteriori informazioni, vedere  . aggiornamento del firmware delle stampanti firmware delle stampanti aggiornamento"},{"UUID":"43df76ee-370d-46c8-a671-de9f92219a1a","title":"Gestione delle stampanti","link":"uninstalling-applications-from-devices-topic.html","desc":"Disinstallazione delle applicazioni dalle stampanti","descFull":"Disinstallazione delle applicazioni dalle stampanti MVE può disinstallare solo applicazioni aggiunte al sistema nel formato Package Builder. Per ulteriori informazioni sul caricamento delle applicazioni nel sistema, vedere  . Nel menu  Stampanti  fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Configura Disinstalla app dalle stampanti . Selezionare le applicazioni. Fare clic su  Disinstalla app . disinstallazione delle applicazioni dalle stampanti applicazioni disinstallazione"},{"UUID":"7a593417-5cc0-4c95-9f51-c927d636f57a","title":"Gestione delle stampanti","link":"assigning-events-to-device-topic.html","desc":"Assegnazione di eventi alle stampanti","descFull":"Assegnazione di eventi alle stampanti L'assegnazione degli eventi alle stampanti consente a MVE di eseguire l'azione associata ogni volta che si verifica uno degli avvisi associati sulla stampante assegnata. Per ulteriori informazioni sulla creazione di eventi, vedere  . Gli eventi possono essere assegnati solo alle stampanti non protette. Nel menu Stampante, fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Assegna gli Eventi . Selezionare uno o più eventi. Se l'evento è già assegnato ad alcune delle stampanti selezionate, nella casella di controllo è visualizzato un trattino. Se si lascia il trattino, l'evento non viene modificato Se si seleziona la casella di controllo, l'evento viene assegnato a tutte le stampanti selezionate. Se si deseleziona la casella di controllo, l'evento viene rimosso dalle stampanti a cui era precedentemente assegnato Fare clic su  Assegna eventi . assegnazione di eventi alle stampanti eventi assegnazione stampanti eventi"},{"UUID":"c9921cf2-cf40-47de-8d7b-c570821306f4","title":"Gestione delle stampanti","link":"assigning-keyword-topic.html","desc":"Assegnazione di parole chiave alle","descFull":"Assegnazione di parole chiave alle stampanti L'assegnazione di parole chiave alle stampanti permette di organizzare le stampanti. Per ulteriori informazioni sulla creazione di parole chiave, vedere  . Nel menu Stampante, fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Assegna Parole chiave . Se necessario, nel menu Visualizza, selezionare una categoria. Selezionare una o più parole chiave. Le parole chiave sono elencate seguendo una categoria. Se la parola chiave è già assegnata ad alcune delle stampanti selezionate, nella casella di controllo è visualizzato un trattino. Se si lascia il trattino, la parola chiave non viene assegnata o rimossa dalle stampanti selezionate. Se si seleziona la casella di controllo, la parola chiave viene assegnata a tutte le stampanti selezionate. Se si deseleziona la casella di controllo, la parola chiave viene rimossa dalle stampanti a cui era precedentemente assegnata. Fare clic su  Assegna parole chiave . assegnazione di una parola chiave parola chiave assegnazione"},{"UUID":"b418163e-f8e1-45eb-89db-54094825980a","title":"Gestione delle stampanti","link":"entering-credentials-secured-printers-topic.html","desc":"Immissione delle credenziali per le","descFull":"Immissione delle credenziali per le stampanti protette È possibile individuare e registrare le stampanti protette. Per comunicare con tali stampanti, è possibile applicare una configurazione o immettere le credenziali direttamente in MVE. Una stampante è protetta quando accanto al nome è visualizzata l'icona  . Per immettere le credenziali, effettuare una delle seguenti operazioni: Nel menu  Stampanti  fare clic su  Elenco stampanti . Selezionare una o più stampanti protette. Fare clic su  Protezione Immetti le credenziali . Selezionare il metodo di autenticazione, quindi immettere le credenziali. Fare clic su  Immetti le credenziali . Le stampanti registrate e protette che non hanno però le credenziali corrette salvate in MVE sono contrassegnate come  Credenziali mancanti  sotto il filtro  Comunicazioni . Dopo l'immissione delle credenziali corrette, le stampanti vengono contrassegnate con lo stato  Protetto . immissione delle credenziali per le stampanti protette credenziali immissione stampanti protette autenticazione"},{"UUID":"229ccfd3-6602-4b08-9e29-83c50babdf5b","title":"Gestione delle stampanti","link":"configuring-printer-certificates-manually-topic.html","desc":"Configurazione manuale dei certificati predefiniti","descFull":"Configurazione manuale dei certificati predefiniti delle stampanti Quando non si utilizza la funzione di gestione automatica dei certificati, MVE può facilitare il processo di firma del certificato predefinito della stampante su un parco stampanti. MVE raccoglie le richieste di firma dei certificati dal parco dispositivi, quindi distribuisce i certificati firmati sulle stampanti appropriate dopo la firma. Un amministratore di sistema deve effettuare le seguenti operazioni: Generare le richieste di firma del certificato della stampante. Nel menu  Stampanti  fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Protezione Genera richieste di firma certificato stampante . è possibile selezionare una o più stampanti quando si generano richieste di firma dei certificati, ma può essere presente un solo gruppo di richieste per volta. Per evitare la sovrascrittura di eventuali richieste di firma dei certificati esistenti, è necessario scaricare le richieste di firma dei certificati prima di generare un altro gruppo. Attendere il completamento dell'attività, quindi scaricare le richieste di firma dei certificati della stampante. Nel menu  Stampanti  fare clic su  Elenco stampanti . Fare clic su  Protezione Scarica richieste di firma certificato stampante . Utilizzare un'autorità di certificazione (CA) attendibile per firmare le richieste di firma del certificato. Salvare i certificati firmati in un file ZIP. tutti i certificati firmati devono trovarsi nella posizione radice del file ZIP. In caso contrario, MVE non potrà analizzare il file. Nel menu  Stampanti  fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Configura Distribuisci file a stampanti . Fare clic su  Scegli file , quindi selezionare il file ZIP. Nel menu  Tipo file  selezionare  Certificati della stampante . Fare clic su  Distribuisci file . configurazione manuale dei certificati delle stampanti certificati della stampante configurazione manuale"},{"UUID":"fa91a5b8-27e0-4779-a3af-045b7dd75c39","title":"Gestione delle stampanti","link":"removing-printers-topic.html","desc":"Rimozione di stampanti Nel menu","descFull":"Rimozione di stampanti Nel menu  Stampanti  fare clic su  Elenco stampanti . Selezionare una o più stampanti. Fare clic su  Stampante . Se necessario, per rimuovere il certificato della stampante, selezionare  Elimina certificati periferica associati . se MVE gestisce i certificati della periferica, la rimozione del certificato della stampante comporta l'eliminazione del certificato predefinito dalla stampante. La stampante genera quindi un nuovo certificato autofirmato. Effettuare una delle seguenti operazioni: Per conservare le informazioni sulla stampante, fare clic su  Ritira stampante . Per rimuovere la stampante dal sistema, fare clic su  Elimina stampante . rimozione di stampanti stampanti rimozione"},{"UUID":"6ec11b72-3ce5-4dfd-9957-1bdd45715bf4","title":"Gestione delle configurazioni","link":"managing-configurations-overview-topic.html","desc":"Panoramica MVE utilizza le configurazioni","descFull":"Panoramica MVE utilizza le configurazioni per gestire le stampanti del parco. Una configurazione è un insieme di impostazioni che possono essere assegnate e applicate a una stampante o a un gruppo di modelli di stampante. All'interno di una configurazione, è possibile modificare le impostazioni della stampante e distribuire le applicazioni, le licenze, il firmware e i certificati delle stampanti. È possibile creare una configurazione composta da: Impostazioni di base della stampante Impostazioni di protezione avanzate Autorizzazioni stampa a colori questa impostazione è disponibile solo nelle configurazioni per le stampanti a colori supportate. Firmware delle stampanti Applicazioni Certificati CA File di risorse Utilizzando le configurazioni, è possibile eseguire le seguenti operazioni per gestire le stampanti: Assegnare una configurazione alle stampanti. Applicare la configurazione alle stampanti. Le impostazioni specificate nella configurazione vengono applicate alle stampanti. Il firmware, le applicazioni, il certificato della stampante, i file dell'applicazione (.fls) e i certificati CA vengono installati. Controllare se le stampanti sono conformi a una configurazione. Se una stampante non è conforme, è possibile applicare la configurazione alla stampante. l'applicazione della configurazione e il controllo della conformità possono essere programmati in modo che vengano eseguiti regolarmente. Se la stampante supporta le impostazioni di configurazione ma i valori non sono applicabili, viene visualizzata come non conforme. gestione delle configurazioni panoramica gestione delle configurazioni configurazioni gestione"},{"UUID":"981c5a78-e8e6-4e62-bad5-4fd842a876e4","title":"Gestione delle configurazioni","link":"creating-configuration-topic.html","desc":"Creazione di una configurazione Una","descFull":"Creazione di una configurazione Una configurazione è un insieme di impostazioni che possono essere assegnate e applicate a una stampante o a un gruppo di stampanti. All'interno di una configurazione, è possibile modificare le impostazioni della stampante e distribuire le applicazioni, le licenze, il firmware e i certificati CA alle stampanti. Nel menu  Configurazioni  fare clic su  Tutte le configurazioni Crea . Digitare un nome univoco per la configurazione e la relativa descrizione. Nell'elenco  Impostazioni , effettuare una o più delle seguenti operazioni: Nella scheda  Di base , selezionare una o più impostazioni, quindi specificare i valori. Se il valore è un'impostazione variabile, racchiudere l'intestazione con i simboli  ${} . Ad esempio,  ${Contact_Name} . Per utilizzare un file delle impostazioni variabili, selezionarlo dal menu  Usa file dati delle impostazioni variabili  oppure importare il file. Per ulteriori informazioni, vedere  . Selezionare una o più impostazioni, quindi specificare i valori. Se il valore è un'impostazione variabile, racchiudere l'intestazione con i simboli  ${} . Ad esempio,  ${Contact_Name} . Per utilizzare un file delle impostazioni variabili, selezionarlo dal menu  Usa file dati delle impostazioni variabili  oppure importare il file. Per ulteriori informazioni, vedere  . Se si aggiungono uno o più certificati a questa configurazione, è possibile selezionare uno dei certificati del menu a discesa  Valore . Nella scheda  Protezione avanzata  selezionare un componente di protezione avanzata. Per creare un componente di protezione avanzata, vedere  . È possibile gestire le impostazioni di protezione avanzata solo durante la creazione di una configurazione da una stampante selezionata. Per ulteriori informazioni, vedere  . Nella scheda  Autorizzazioni stampa a colori  configurare le impostazioni. Per ulteriori informazioni, vedere  . questa impostazione è disponibile solo nelle configurazioni per le stampanti a colori supportate. Nella scheda  Firmware  selezionare un file di firmware. Se in una configurazione sono presenti più versioni dello stesso firmware, durante la conformità e l'applicazione viene presa in considerazione solo la versione del firmware superiore. Per importare un file di firmware, vedere  . Nella scheda  App  selezionare una o più applicazioni da distribuire. Per ulteriori informazioni, vedere  . MVE non supporta la distribuzione di applicazioni con licenze di prova. È possibile distribuire solo applicazioni gratuite o applicazioni con licenze di produzione. Nella scheda  Certificati  selezionare uno o più certificati da distribuire. Per importare un file di certificato, vedere  . selezionare  Utilizzare Markvision per gestire i certificati della periferica  affinché MVE valuti i certificati mancanti, non validi, revocati e scaduti e quindi li sostituisca automaticamente. Selezionare una delle seguenti opzioni: Certificato periferica predefinito Certificato periferica con nome per impostazione predefinita, l'utente può aggiungere 10 certificati con nome per ogni installazione MVE e 5 certificati con nome per ogni configurazione MVE. Per ulteriori informazioni, vedere  . Nella scheda  File di risorse , selezionare uno dei seguenti tipi di file da distribuire: File dell'applicazione (.fls) Pacchetto di configurazione (.zip) File di configurazione universale (.ucf) Le opzioni nella scheda risorse non sono sottoposte a controllo di conformità. Non è consigliabile utilizzare più file UCF e pacchetti di configurazione in una singola configurazione. Questo metodo non è applicabile ai file UCF durante la configurazione di Acquisisci su rete sulle stampanti legacy. I file UCF devono essere distribuiti utilizzando l'azione  Distribuisci file a stampante . Fare clic su  Crea configurazione . l'elenco seguente mostra la sequenza di distribuzione in una configurazione: Certificati CA File dell'applicazione Pacchetti di soluzioni Protezione avanzata Certificati periferica Impostazioni di base UCF e pacchetto di configurazione Firmware creazione di una configurazione configurazione creazione"},{"UUID":"be4ae3a2-932f-476d-82d9-d0db3ee0e36a","title":"Gestione delle configurazioni","link":"creating-configuration-from-printer-topic.html","desc":"Creazione di una configurazione da","descFull":"Creazione di una configurazione da una stampante I seguenti componenti non sono inclusi: Firmware delle stampanti Applicazioni Certificati Per aggiungere il firmware, le applicazioni e i certificati, modificare la configurazione in MVE. Nel menu  Stampanti  fare clic su  Elenco stampanti . Selezionare la stampante, quindi fare clic su  Configura Crea configurazione da stampante . Se necessario, selezionare  Includi impostazioni di protezione avanzata  per creare un componente di protezione avanzata dalla stampante selezionata. Se la stampante è protetta, selezionare il metodo di autenticazione, quindi immettere le credenziali. Digitare un nome univoco per la configurazione e la relativa descrizione, quindi fare clic su  Crea configurazione . Nel menu  Configurazioni  fare clic su  Tutte le configurazioni . Selezionare la configurazione, quindi fare clic su  Modifica . Se necessario, modificare le impostazioni. Fare clic su  Salva modifiche . creazione di una configurazione da una stampante configurazione creazione"},{"UUID":"3e0e48aa-d1d6-4e90-bb02-377d658c7f06","title":"Gestione delle configurazioni","link":"sample-scenario-cloning-configurations-topic.html","desc":"Scenario di esempio: clonazione di","descFull":"Scenario di esempio: clonazione di una configurazione Quindici stampanti Lexmark MX812 sono state aggiunte al sistema dopo il rilevamento. Il personale IT deve applicare le impostazioni delle stampanti esistenti alle nuove stampanti rilevate. è anche possibile clonare una configurazione da una stampante, quindi applicarla a un gruppo di modelli di stampante. Esempio di implementazione Nell'elenco delle stampanti esistenti selezionare una stampante Lexmark MX812. Creare una configurazione dalla stampante. per proteggere le stampanti, includere le impostazioni di protezione avanzata. Assegnare e quindi applicare la configurazione alle nuove stampanti rilevate. clonazione di configurazioni scenario di esempio scenario di esempio per la clonazione di configurazioni"},{"UUID":"b8e50c81-fe96-4c6a-91af-f881ab3e91f0","title":"Gestione delle configurazioni","link":"creating-advanced-security-component-topic.html","desc":"Creazione di un componente di","descFull":"Creazione di un componente di protezione avanzata da una stampante Creare un componente di protezione avanzata da una stampante per gestire le impostazioni di protezione avanzata. MVE legge tutte le impostazioni da tale stampante, quindi crea un componente che include le impostazioni. Il componente può essere associato a più configurazioni per i modelli di stampante che hanno il medesimo framework di protezione. Nel menu  Stampanti  fare clic su  Elenco stampanti . Selezionare la stampante, quindi fare clic su  Configura Crea componente di protezione avanzata dalla stampante . Digitare un nome univoco per il componente e la relativa descrizione. Se la stampante è protetta, selezionare il metodo di autenticazione, quindi immettere le credenziali. Fare clic su  Crea componente . quando si crea e si applica una configurazione con un componente di protezione avanzata che contiene account locali, gli account locali vengono aggiunti alle stampanti. Tutti gli account locali esistenti preconfigurati nella stampante vengono conservati. creazione di un componente di protezione avanzata da una stampante componente di protezione avanzata creazione"},{"UUID":"318cf730-ef6f-4d7b-9356-ca2989172876","title":"Gestione delle configurazioni","link":"generating-printable-version-topic.html","desc":"Generazione di una versione stampabile","descFull":"Generazione di una versione stampabile delle impostazioni di configurazione Modificare una configurazione o un componente di protezione avanzata. Fare clic su  Versione stampabile . impostazioni di configurazione versione stampabile"},{"UUID":"b71a17eb-3eb8-45d1-9d27-fa0e7198a9e4","title":"Gestione delle configurazioni","link":"understanding-dynamic-settings-topic.html","desc":"Informazioni sulle impostazioni dinamiche Queste","descFull":"Informazioni sulle impostazioni dinamiche Queste impostazioni includono Certificato periferica 802.1x, Certificato periferica HTTPS e Certificato periferica IPSec elencate nella scheda  Di base  di una configurazione. Le opzioni per ciascuna di queste impostazioni vengono popolate con i certificati selezionati nella scheda  Certificato . Quando si clona, esporta o importa una configurazione, i valori preselezionati di queste impostazioni vengono cancellati ed è necessario selezionare i valori manualmente. impostazioni dinamiche informazioni"},{"UUID":"6e6e5173-c661-43c0-aaf1-0043e0673857","title":"Gestione delle configurazioni","link":"understanding-variable-settings-topic.html","desc":"Informazioni sulle impostazioni delle variabili","descFull":"Informazioni sulle impostazioni delle variabili Le impostazioni delle variabili consentono di gestire le impostazioni sul parco periferiche che sono esclusive per ciascuna stampante, ad esempio nome host o etichetta risorsa. Durante la creazione o la modifica di una configurazione, è possibile selezionare un file CSV da associare alla configurazione. Formato CSV di esempio: \nIP_ADDRESS,Contact_Name,Address,Disp_Info\n1.2.3.4,John Doe,1600 Penn. Ave., Blue\n4.3.2.1,Jane Doe,1601 Penn. Ave., Red\n2.3.6.5,\"Joe, Jane and Douglas\",1601 Penn. Ave.,Yellow\n2.3.6.7,\"Joe, Jane and Douglas\",1600 Penn. Ave.,He is 6’7” tall Nella riga dell'intestazione del file delle variabili, la prima colonna è un token identificativo della stampante univoco. Il token deve includere una delle seguenti opzioni: HOSTNAME IP_ADDRESS SYSTEM_NAME SERIAL_NUMBER Ciascuna colonna successiva nella riga dell'intestazione del file delle variabili è un token di sostituzione definito dall'utente. Il token deve essere indicato all'interno della configurazione con il formato ${HEADER}. Esso viene sostituito con i valori nelle righe successive quando si applica la configurazione. Verificare che i token non contengano spazi. È possibile importare il file CSV contenente le impostazioni delle variabili durante la creazione o la modifica di una configurazione. Per ulteriori informazioni, vedere  . impostazioni di variabile informazioni importazione di CSV impostazioni di variabile esportazione di CSV impostazioni di variabile CSV impostazioni di variabile"},{"UUID":"920ecac6-c9f9-4780-a349-19f664fe43c6","title":"Gestione delle configurazioni","link":"configuring-color-permissions-topic.html","desc":"Configurazione delle autorizzazioni per la","descFull":"Configurazione delle autorizzazioni per la stampa a colori MVE consente di limitare la stampa a colori per computer host e utenti specifici. Questa impostazione è disponibile solo nelle configurazioni per le stampanti a colori supportate. Nel menu Configurazioni, fare clic su  Tutte le configurazioni . Creare o modificare una configurazione. Nella scheda Autorizzazioni stampa a colori, effettuare una delle seguenti operazioni: Configura autorizzazioni stampa a colori per i computer host Nel menu Visualizza, selezionare  Computer host , quindi  Includi autorizzazioni stampa a colori per i computer host . Fare clic su  Aggiungi , quindi digitare il nome del computer host. Per consentire la stampa a colori sul computer host, selezionare  Consenti stampa a colori . Per consentire la stampa a colori agli utenti che accedono al computer host, selezionare  Ignora autorizzazione utente . Fare clic su  Salva e aggiungi  o su  Salva . Configura autorizzazioni stampa a colori per gli utenti Nel menu Visualizza, selezionare  Utenti , quindi  Includi autorizzazioni stampa a colori per gli utenti . Fare clic su  Aggiungi , quindi digitare il nome utente. Selezionare  Consenti stampa a colori . Fare clic su  Salva e aggiungi  o su  Salva . configurazione delle autorizzazioni per la stampa a colori autorizzazioni stampa a colori configurazione"},{"UUID":"fe3b5480-b609-48c3-b31f-7884bf4c7a2c","title":"Gestione delle configurazioni","link":"creating-applications-package-topic.html","desc":"Creazione di un pacchetto di","descFull":"Creazione di un pacchetto di applicazioni Accedere a Package Builder su  iss.lexmark.com/cdp/package-builder . Nella pagina  Pacchetti , fare clic su  Crea pacchetto . Nella pagina  Crea pacchetto , immettere il nome del pacchetto. Fare clic su  Aggiungi prodotto , selezionare un prodotto, quindi fare clic su  Aggiungi prodotto . Se necessario, selezionare  Riscatta un codice di attivazione per il prodotto in licenza . Fare clic su  Crea pacchetto . Scaricare il pacchetto effettuando una delle seguenti operazioni: Fare clic sul nome del pacchetto, quindi su  Scarica . Nella colonna  Scarica pacchetto , fare clic su  Scarica . MVE non supporta la distribuzione di applicazioni con licenze di prova. È possibile distribuire solo applicazioni gratuite o applicazioni con licenze di produzione. Per i codici di attivazione, contattare il rappresentante Lexmark. Per aggiungere le applicazioni a una configurazione, importare il pacchetto di applicazioni nella libreria delle risorse. Per ulteriori informazioni, vedere  . creazione di un pacchetto di applicazioni pacchetto applicazioni creazione"},{"UUID":"964a78c7-fcf5-477c-bfde-395f0108d6e0","title":"Gestione delle configurazioni","link":"importing-exporting-configuration-file-topic.html","desc":"Importazione o esportazione di una","descFull":"Importazione o esportazione di una configurazione Prima di iniziare a importare un file di configurazione, accertarsi che venga esportato dalla stessa versione del MVE. Nel menu  Configurazioni  fare clic su  Tutte le configurazioni . Effettuare una delle seguenti operazioni: Per importare un file di configurazione, fare clic su  Importa , selezionare il file di configurazione e fare clic su  Importa . Per esportare un file di configurazione, selezionare una configurazione, quindi fare clic su  Esporta . Durante l'esportazione di una configurazione, le password sono escluse.  I file UCF, i pacchetti di configurazione e i file dell'applicazione non fanno parte di una configurazione esportata. importazione o esportazione di una configurazione configurazione importazione configurazione esportazione"},{"UUID":"6b901ca8-880e-459b-8862-f4cdd6934e87","title":"Gestione delle configurazioni","link":"importing-files-to-resource-library-topic.html","desc":"Importazione di file nella libreria","descFull":"Importazione di file nella libreria delle risorse La libreria delle risorse è una raccolta di file di firmware, certificati CA e pacchetti di applicazioni che vengono importati in MVE. Questi file possono essere associati a una o più configurazioni. Nel menu  Configurazioni  fare clic su  Libreria risorse . Fare clic su  Importa Scegli file , quindi selezionare il file. È possibile importare solo file del firmware (.fls), file dell'applicazione (.fls), pacchetti di applicazioni o bundle di configurazione (.zip), certificati CA (.pem) e file di configurazione universale (.ucf). Fare clic su  Importa risorsa . importazione di file nella libreria delle risorse libreria delle risorse importazione di file importazione di file nella libreria delle risorse"},{"UUID":"ef2522b4-4039-4be1-ab05-a432e887f905","title":"Configurazione di MVE per la gestione automatica dei certificati","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Informazioni sulla funzione di gestione","descFull":"Informazioni sulla funzione di gestione automatica dei certificati È possibile configurare MVE per gestire automaticamente i certificati delle stampanti e installarli sulle stampanti tramite applicazione della configurazione. Il seguente diagramma illustra il processo end-to-end della funzione di gestione automatica dei certificati. Gli endpoint dell'autorità di certificazione, ad esempio il server CA e l'indirizzo del server, devono essere definiti in MVE. Sono supportati i seguenti server CA: OpenXPKI CA : gli utenti possono utilizzare uno dei seguenti protocolli: SCEP (Secure Certificate Encryption Protocol) Connettore EST EST è il metodo consigliato per la connessione al server OpenXPKI. Per ulteriori informazioni sulla configurazione di OpenXPKI CA tramite il protocollo EST, vedere  Per ulteriori informazioni sulla configurazione di OpenXPKI CA tramite il protocollo SCEP, vedere  CA Microsoft - Enterprise : gli utenti possono utilizzare uno dei seguenti protocolli SCEP (Secure Certificate Encryption Protocol) Servizi Web di registrazione certificati Microsoft (MSCEWS) MSCEWS è il metodo consigliato per la connessione al server CA Microsoft - Enterprise. Per ulteriori informazioni sulla configurazione di CA Microsoft tramite il protocollo MSCEWS, vedere  Per ulteriori informazioni sulla configurazione di CA Microsoft tramite il protocollo SCEP, vedere  La connessione tra MVE e i server CA deve essere convalidata. Durante la convalida, MVE comunica con il server CA per scaricare la catena di certificati e l'elenco di revoche di certificati (CRL). Viene generato anche il certificato agente o il certificato di test di registrazione. Questo certificato consente al server CA di considerare attendibile MVE. Per ulteriori informazioni sulla definizione degli endpoint e la convalida, vedere  . È necessario che una configurazione impostata su  Utilizzare Markvision per gestire i certificati della periferica  sia assegnata e applicata alla stampante. Per ulteriori informazioni, vedere i seguenti argomenti:: Durante l'applicazione, MVE verifica la conformità della stampante. Per  Certificato periferica predefinito Il certificato viene convalidato rispetto alla catena di certificati scaricata dal server CA. Se la stampante non è conforme, viene richiesta una CSR, ovvero una richiesta di firma certificato, per la stampante. Per  Certificato periferica con nome Il certificato viene convalidato rispetto alla catena di certificati scaricata dal server CA. MVE crea un certificato periferica con nome autofirmato sul dispositivo. Se la stampante non è conforme, viene richiesta una CSR per la stampante. MVE comunica con il server CA tramite i protocolli configurati. Il server CA genera il nuovo certificato, quindi MVE invia il certificato alla stampante. Se nella stampante esiste un certificato con nome, non viene creato un nuovo certificato con nome, ma viene generata una CSR per la stampante. funzione di gestione automatica dei certificati gestione certificati"},{"UUID":"dbb88ab0-fc45-48b4-a31f-58f8aee1f6a5","title":"Configurazione di MVE per la gestione automatica dei certificati","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Configurazione di MVE per la","descFull":"Configurazione di MVE per la gestione automatica dei certificati Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  Autorità di certificazione Utilizza server dell'autorità di certificazione . il pulsante  Utilizza server dell'autorità di certificazione  viene visualizzato solo quando si configura l'autorità di certificazione per la prima volta o quando il certificato viene eliminato. Configurare gli endpoint del server. Server CA : il server CA che genera i certificati della stampante. È possibile selezionare una delle opzioni seguenti: OpenXPKI CA CA Microsoft - Enterprise l'utente può anche configurare un server CA che supporta il protocollo  Enrollment over Secure Transport (EST) . Il server CA deve implementare il protocollo EST come definito in RFC 7030. qualsiasi deviazione dalla specifica può causare un'impostazione non valida. EST è il protocollo consigliato per la connessione al server OpenXPKI CA. il server CA Microsoft - Enterprise non supporta il protocollo EST. Indirizzo del server CA : l'indirizzo IP o il nome host del server CA. Questo campo è applicabile solo per i protocolli SCEP ed EST. digitare una delle seguenti opzioni: Per il server MSCA (tramite SCEP): <Indirizzo IP o nome host del server>/certsrv/mscep/mscep.dll Per il server OpenXPKI (tramite SCEP): <Indirizzo IP o nome host del server>/scep/scep Per EST, digitare una delle seguenti opzioni: https://172.87.95.240 https://estserver.com estserver.com Etichetta server CA (opzionale) : se l'utente crea una nuova area di autenticazione, è necessario inserire in questo campo lo stesso nome dell'area di autenticazione. Indirizzo server CEP : questo campo è applicabile solo per il protocollo MSCEWS. digitare una delle seguenti opzioni: Per l'autenticazione tramite nome utente e password: https://democep.com/ADPolicyProvider_CEP_UsernamePassword/service.svc/CEP Per l'autenticazione integrata di Windows: https://democep.com/ADPolicyProvider_CEP_Kerberos/service.svc/CEP Per l'autenticazione con certificato client: https://democep.com/ADPolicyProvider_CEP_Certificate/service.svc/CEP Nome host server CA : il nome host del server CA. ad esempio, per il protocollo MSCEWS l'utente può selezionare  democa.lexmark.com Nome host server CES : il nome host del server CES. ad esempio, per il protocollo MSCEWS l'utente può selezionare  democes.lexmark.com Password di verifica : password di verifica necessaria per l'asserzione dell'identità di MVE al server CA. Questa password è necessaria solo per OpenXPKI CA. Non è supportata in CA Microsoft - Enterprise. a seconda del server CA in uso, è necessario configurare la modalità di autenticazione del server. Effettuare una delle seguenti operazioni: Se si seleziona il protocollo  EST , nel menu  Modalità di autenticazione del server CA  selezionare una delle seguenti opzioni: Autenticazione tramite nome utente e password Autenticazione certificato client Se si seleziona il protocollo  MSCEWS , nel menu  Modalità di autenticazione del server CA  selezionare una delle seguenti opzioni: Autenticazione tramite nome utente e password Autenticazione certificato client Autenticazione integrata di Windows Il protocollo  SCEP  supporta solo la modalità di autenticazione  Password di verifica . a seconda del server CA in uso, vedere una delle seguenti sezioni: Fare clic su  Salva le modifiche e convalida OK . L'opzione  Rifiuta modifiche  funziona solo se le modifiche non sono ancora state salvate o salvate e convalidate. L'utente non può recuperare i dati da una configurazione non valida, in quanto MVE non memorizza l'ultimo stato valido di alcuna configurazione. MVE memorizza una sola configurazione di certificato alla volta, che potrebbe essere valida o non valida. La connessione tra MVE e i server CA deve essere convalidata. Durante la convalida, MVE comunica con il server CA per scaricare la catena di certificati e l'elenco di revoche di certificati (CRL). Viene generato anche il certificato agente o il certificato di test di registrazione. Questo certificato consente al server CA di considerare attendibile MVE. Quando si utilizza il protocollo MSCEWS, è possibile selezionare uno o più modelli CEP. Attenersi alla seguente procedura: Dopo aver fatto clic su  Salva le modifiche e convalida , viene visualizzata la finestra Selezione del modello CEP. Selezionare uno o più modelli tra quelli disponibili. La finestra di dialogo Utilizza server dell'autorità di certificazione recupera l'elenco di revoche di certificati. Una finestra di dialogo conferma che la convalida del certificato ha avuto esito positivo. È possibile visualizzare i modelli CEP selezionati nella pagina di configurazione del server CA. quando si applica questa configurazione a qualsiasi dispositivo, viene creato un certificato sulla base del modello selezionato. Tornare alla pagina  Configurazione di sistema , quindi esaminare il certificato CA. è anche possibile scaricare o eliminare il certificato CA. configurazione di MVE per la gestione automatica dei certificati gestione automatica dei certificati configurazione"},{"UUID":"7794e55a-b997-4446-9a2d-e8f9bc740183","title":"Configurazione della CA Microsoft Enterprise con NDES","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Panoramica Nel seguente scenario di","descFull":"Panoramica Nel seguente scenario di distribuzione, tutte le autorizzazioni si basano sulle autorizzazioni impostate nei modelli di certificato pubblicati nel controller di dominio. Le richieste di certificato inviate alla CA si basano sui modelli di certificato. Per questa impostazione, assicurarsi di disporre di quanto segue: Un computer che ospita l'autorità di certificazione subordinata Un computer che ospita il servizio NDES Un controller di dominio Utenti richiesti Creare i seguenti utenti nel controller di dominio: Amministratore del servizio Denominato  SCEPAdmin Deve essere un membro dei gruppi  local admin  ed  Enterprise Admin Deve aver effettuato l'accesso localmente quando si attiva il ruolo NDES Dispone di  autorizzazione alla registrazione  per i modelli di certificato Dispone di  autorizzazione all'aggiunta di modelli  per la CA Account di servizio Denominato  SCEPSvc Deve essere un membro del gruppo  IIS_IUSRS Deve essere un utente di dominio e disporre di autorizzazioni alla  lettura  e alla  registrazione  per i modelli configurati Dispone di autorizzazione alla  richiesta  per la CA Amministratore CA Enterprise Denominato  CAAdmin Membro del gruppo  Enterprise Admin Deve far parte del gruppo di  amministrazione locale configurazione della CA Microsoft Enterprise con NDES panoramica CA Microsoft Enterprise con NDES configurazione"},{"UUID":"1e0f2e41-fed0-434b-b33e-bf5d27fd16e8","title":"Gestione dei certificati con l'autorità di certificazione Microsoft tramite SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Panoramica Il server CA radice","descFull":"Panoramica Il server CA radice è il server CA principale in qualsiasi organizzazione ed è al vertice dell'infrastruttura PKI. La CA radice autentica il server CA subordinata. Questo server viene generalmente mantenuto in modalità offline per evitare eventuali intrusioni e per proteggere la chiave privata. Per configurare il server CA radice, procedere come segue: Verificare che il server CA radice sia installato. Per ulteriori informazioni, vedere  . Configurare le impostazioni Punto di distribuzione CRL e Accesso alle informazioni dell'autorità. Per ulteriori informazioni, vedere  . Configurare l'accessibilità al CRL. Per ulteriori informazioni, vedere  . panoramica configurazione del server CA radice configurazione del server CA radice, panoramica"},{"UUID":"1a3e8e68-26b6-44e6-aa6c-00ad1e323345","title":"Gestione dei certificati con l'autorità di certificazione Microsoft tramite SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Installazione del server CA radice","descFull":"Installazione del server CA radice In Server Manager, fare clic su  Gestisci  Aggiungi ruoli e funzionalità . Fare clic su  Ruoli server , selezionare  Servizi certificati Active Directory  e tutte le relative funzioni, quindi fare clic su  Avanti . Nella sezione  Servizi del ruolo Servizi certificati Active Directory  selezionare  Autorità di certificazione , quindi fare clic su  Avanti  Installa . Dopo l'installazione, fare clic su  Configurare Servizi certificati Active Directory nel server di destinazione . Nella sezione  Servizi ruolo  selezionare  Autorità di certificazione  Avanti . Nella sezione  Tipo di installazione  selezionare  CA autonoma , quindi fare clic su  Avanti . Nella sezione  Tipo CA  selezionare  CA radice , quindi fare clic su  Avanti . Selezionare  Crea una nuova chiave privata , quindi fare clic su  Avanti . Nel menu  Selezionare un provider di crittografia  selezionare  RSA#Microsoft Software Key Storage Provider . Nel menu  Lunghezza chiave  selezionare  4096 . Nell'elenco degli algoritmi hash selezionare  SHA512 , quindi fare clic su  Avanti . Nel campo  Nome comune per questo CA  immettere il nome del server di hosting. Nel campo  Suffisso nome distinto  digitare il componente del dominio. Configurazione del nome CA di esempio Nome di dominio completo (FQDN) del computer:  test.dev.lexmark.com Nome comune (CN):  TEST Suffisso nome distinto:  DC=DEV,DC=LEXMARK,DC=COM Fare clic su  Avanti . Specificare il periodo di validità, quindi fare clic su  Avanti . in genere il periodo di validità è di 10 anni. Non modificare nulla nella finestra delle posizioni di database. Completare l'installazione. installazione di server CA radice server CA radice installazione"},{"UUID":"43a274ff-43f6-4503-b470-0288fcc524dd","title":"Configurazione della CA Microsoft Enterprise con NDES","link":"managing-certificates-using-SCEP-group.html","desc":"Panoramica Nel seguente scenario di","descFull":"Panoramica Nel seguente scenario di distribuzione, tutte le autorizzazioni si basano sulle autorizzazioni impostate nei modelli di certificato pubblicati nel controller di dominio. Le richieste di certificato inviate alla CA si basano sui modelli di certificato. Per questa impostazione, assicurarsi di disporre di quanto segue: Un computer che ospita l'autorità di certificazione subordinata Un computer che ospita il servizio NDES Un controller di dominio Utenti richiesti Creare i seguenti utenti nel controller di dominio: Amministratore del servizio Denominato  SCEPAdmin Deve essere un membro dei gruppi  local admin  ed  Enterprise Admin Deve aver effettuato l'accesso localmente quando si attiva il ruolo NDES Dispone di  autorizzazione alla registrazione  per i modelli di certificato Dispone di  autorizzazione all'aggiunta di modelli  per la CA Account di servizio Denominato  SCEPSvc Deve essere un membro del gruppo  IIS_IUSRS Deve essere un utente di dominio e disporre di autorizzazioni alla  lettura  e alla  registrazione  per i modelli configurati Dispone di autorizzazione alla  richiesta  per la CA configurazione della CA Microsoft Enterprise con NDES panoramica CA Microsoft Enterprise con NDES configurazione"},{"UUID":"5ac0c397-6c1a-46a2-b6ce-9677ebb3d2a6","title":"Configurazione del server CA subordinata","link":"managing-certificates-using-SCEP-group.html","desc":"Panoramica Il server CA subordinata","descFull":"Panoramica Il server CA subordinata è il server CA intermedia ed è sempre online. Si occupa in generale della gestione dei certificati. Per configurare il server CA subordinata, procedere come segue: Verificare che il server CA subordinata sia installato. Per ulteriori informazioni, vedere  . Configurare le impostazioni Punto di distribuzione CRL e Accesso alle informazioni dell'autorità. Per ulteriori informazioni, vedere  . Configurare l'accessibilità al CRL. Per ulteriori informazioni, vedere  . panoramica configurazione del server CA subordinata configurazione del server CA subordinata, panoramica"},{"UUID":"8dff10d9-1111-4288-928e-5eed3a638e4e","title":"Configurazione del server CA subordinata","link":"managing-certificates-using-SCEP-group.html","desc":"Installazione del server CA subordinata","descFull":"Installazione del server CA subordinata Sul server, accedere come utente di dominio  CAAdmin . In Server Manager, fare clic su  Gestisci  Aggiungi ruoli e funzionalità . Fare clic su  Ruoli server , selezionare  Servizi certificati Active Directory  e tutte le relative funzioni, quindi fare clic su  Avanti . Nella sezione  Servizi del ruolo Servizi certificati Active Directory  selezionare  Autorità di certificazione  e  Registrazione Web autorità di certificazione , quindi fare clic su  Avanti . assicurarsi che siano aggiunte tutte le funzioni di  Registrazione Web autorità di certificazione . Nella sezione  Servizi ruolo server Web (IIS)  conservare le impostazioni predefinite. Dopo l'installazione, fare clic su  Configurare Servizi certificati Active Directory nel server di destinazione . Nella sezione  Servizi ruolo  selezionare  Autorità di certificazione  e  Registrazione Web autorità di certificazione , quindi fare clic su  Avanti . Nella sezione  Tipo di installazione  selezionare  CA Enterprise , quindi fare clic su  Avanti . Nella sezione  Tipo CA  selezionare  CA subordinata , quindi fare clic su  Avanti . Selezionare  Crea una nuova chiave privata , quindi fare clic su  Avanti . Nel menu  Selezionare un provider di crittografia  selezionare  RSA#Microsoft Software Key Storage Provider . Nel menu  Lunghezza chiave  selezionare  4096 . Nell'elenco degli algoritmi hash selezionare  SHA512 , quindi fare clic su  Avanti . Nel campo  Nome comune per questo CA  immettere il nome del server host. Nel campo  Suffisso nome distinto  digitare il componente del dominio. Configurazione del nome CA di esempio Nome di dominio completo (FQDN) del computer:  test.dev.lexmark.com Nome comune (CN):  TEST Suffisso nome distinto:  DC=DEV,DC=LEXMARK,DC=COM Nella finestra di dialogo  Richiesta certificato  salvare il file di richiesta, quindi fare clic su  Avanti . Non modificare nulla nella finestra delle posizioni di database. Completare l'installazione. Firmare la richiesta CA della CA radice, quindi esportare il certificato autofirmato in formato PKCS7. Sul server CA subordinata, aprire  Autorità di certificazione . Nel pannello di sinistra, fare clic con il pulsante destro del mouse sulla CA, quindi scegliere  Tutte le attività  Installa certificato CA . Selezionare il certificato autofirmato, quindi avviare il servizio CA. installazione di server CA subordinata server CA subordinata installazione"},{"UUID":"eedcdffc-b996-414c-ae7d-4e05e78fdc87","title":"Gestione dei certificati con l'autorità di certificazione Microsoft tramite SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Configurazione delle impostazioni Punto di","descFull":"Configurazione delle impostazioni Punto di distribuzione CRL e Accesso alle informazioni dell'autorità configurare le impostazioni Punto di distribuzione CRL (CDP) e Accesso alle informazioni dell'autorità (AIA) per l'elenco di revoche di certificati (CRL). In Server Manager fare clic su  Strumenti  Autorità di certificazione . Nel pannello di sinistra, fare clic con il pulsante destro del mouse sulla CA, quindi scegliere  Proprietà  Estensioni . Nel menu  Seleziona estensione   selezionare  Punto di distribuzione CRL) . Nell'elenco di revoche di certificati, selezionare la voce  C:\\Windows\\system32\\ , quindi effettuare le seguenti operazioni: Selezionare  Pubblica CRL nel percorso specificato . Deselezionare  Pubblica Delta CRL in questa posizione . Eliminare tutte le altre voci tranne  C:\\Windows\\system32\\ . Fare clic su  Aggiungi . Nel campo  Posizione  aggiungere  http:// serverIP /CertEnroll/<CAName><CRLNameSuffix><DeltaCRLAllowed>.crl , dove  serverIP  è l'indirizzo IP del server. Se il server è raggiungibile tramite il nome di dominio completo (FQDN), utilizzare  <ServerDNSName>  anziché l'indirizzo IP del server. Fare clic su  OK . Selezionare  Includi nell'estensione dei punti di distribuzione dei certificati emessi  per la voce creata. Nel menu  Seleziona estensione  selezionare  Accesso alle informazioni dell'autorità (AIA) . Eliminare tutte le altre voci tranne  C:\\Windows\\system32\\ . Fare clic su  Aggiungi . Nel campo  Posizione  aggiungere  http:// serverIP /CertEnroll/<ServerDNSName>_<CAName><CertificateName>.crt , dove  serverIP  è l'indirizzo IP del server. Se il server è raggiungibile tramite il nome di dominio completo (FQDN), utilizzare  <ServerDNSName>  anziché l'indirizzo IP del server. Fare clic su  OK . Selezionare  Includi nell'estensione AIA dei certificati emessi  per la voce creata. Fare clic su  Applica OK . se necessario, riavviare il servizio di certificazione. Nel pannello di sinistra, espandere la CA, fare clic con il pulsante destro del mouse su  Certificati revocati , quindi scegliere  Proprietà . Specificare il valore per  l'intervallo di pubblicazione CRL  e per  Pubblica l'intervallo di pubblicazione Delta CRL , quindi fare clic su  Applica  OK . Nel pannello di sinistra, fare clic con il pulsante destro del mouse su  Certificati revocati , scegliere  Tutte le attività , quindi pubblicare il CRL  Nuovo . configurazione delle impostazioni Punto di distribuzione CRL configurazione delle impostazioni Accesso alle informazioni dell'autorità Punto di distribuzione CRL configurazione Accesso alle informazioni dell'autorità configurazione CDP configurazione AIA configurazione"},{"UUID":"91c7c0c4-d7bd-4450-bf8d-4a2c47118144","title":"Gestione dei certificati con l'autorità di certificazione Microsoft tramite SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Configurazione dell'accessibilità al CRL prima","descFull":"Configurazione dell'accessibilità al CRL prima di iniziare, assicurarsi che Gestione Internet Information Services (IIS) sia installato. In Gestione IIS, espandere la CA, quindi espandere  Siti . Fare clic con il pulsante destro del mouse su  Sito Web predefinito , quindi scegliere  Aggiungi directory virtuale . Nel campo  Alias  digitare  CertEnroll . Nel campo  Percorso fisico  digitare  C:Windows/System32/CertSrv/CertEnrol . Fare clic su  OK . Fare clic con il pulsante destro del mouse su  CertEnroll , quindi scegliere  Modifica autorizzazioni . Nella scheda  Protezione  rimuovere tutti gli accessi in scrittura, tranne che per il sistema. Fare clic su  OK . configurazione dell'accessibilità al CRL accessibilità al CRL configurazione"},{"UUID":"b4788132-1f15-470a-a80f-a68d32b23f7b","title":"Gestione dei certificati con l'autorità di certificazione Microsoft tramite SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Configurazione del server NDES Sul","descFull":"Configurazione del server NDES Sul server, accedere come utente di dominio  SCEPAdmin . In Server Manager, fare clic su  Gestisci  Aggiungi ruoli e funzionalità . Fare clic su  Ruoli server , selezionare  Servizi certificati Active Directory  e tutte le relative funzioni, quindi fare clic su  Avanti . Nella sezione  Servizi del ruolo Servizi certificati Active Directory  deselezionare  Autorità di certificazione . Selezionare  Servizio Registrazione dispositivi di rete  e tutte le relative funzioni, quindi fare clic su  Avanti . Nella sezione  Servizi ruolo server Web (IIS)  conservare le impostazioni predefinite. Dopo l'installazione, fare clic su  Configurare Servizi certificati Active Directory nel server di destinazione . Nella sezione  Servizi ruolo  selezionare  Servizio Registrazione dispositivi di rete , quindi fare clic su  Avanti . Selezionare l'account di servizio  SCEPSvc . Nella sezione  CA per NDES  selezionare  Nome CA  o  Nome computer , quindi fare clic su  Avanti . Nella sezione  Informazioni RA  specificare le informazioni, quindi fare clic su  Avanti . Nella sezione  Crittografia per NDES  effettuare le seguenti operazioni: Selezionare i provider di firma e chiave di crittografia appropriati. Nel menu  Lunghezza chiave  selezionare la stessa lunghezza chiave del server CA. Fare clic su  Avanti . Completare l'installazione. È ora possibile accedere al server NDES da un browser Web come utente SCEPSvc. Sul server NDES, è possibile visualizzare l'identificazione personale del certificato CA, la password di verifica di registrazione e il periodo di validità di tale password. Accesso al server NDES Aprire un browser Web e digitare  http:// NDESserverIP /certsrv/mscep_admin , dove  NDESserverIP  è l'indirizzo IP del server NDES. configurazione dei server NDES server NDES configurazione configurazione dei server del servizio Registrazione dispositivi di rete server del servizio Registrazione dispositivi di rete configurazione"},{"UUID":"8de5af46-1bdb-4ad9-837b-1961f7ee0b95","title":"Configurazione di NDES per MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Creazione di un modello di","descFull":"Creazione di un modello di certificato Sul server CA subordinata (certserv), aprire  Autorità di certificazione . Nel pannello di sinistra, espandere la CA, fare clic con il pulsante destro del mouse su  Modelli di certificato , quindi scegliere  Gestisci . In  Console dei modelli di certificato , creare una copia del  Server Web . Nella scheda  Impostazioni generali  digitare  MVEWebServer  come nome del modello. Nella scheda  Protezione  assegnare agli utenti  SCEPAdmin  e  SCEPSvc  le autorizzazioni appropriate. per ulteriori informazioni, vedere  . Nella scheda  Nome oggetto  selezionare  Inserisci nella richiesta . Sul server CA subordinata (certserv), aprire  Autorità di certificazione . Nella scheda  Estensioni  selezionare  Criteri di applicazione  Modifica . Fare clic su  Aggiungi  Autenticazione client  OK . Nel pannello di sinistra, espandere la CA, fare clic con il pulsante destro del mouse su  Modelli di certificato , quindi scegliere  Nuovo  Modello di certificato da rilasciare . Selezionare i certificati appena creati, quindi fare clic su  OK . È ora possibile accedere ai modelli utilizzando il portale di registrazione Web della CA. Accesso ai modelli Aprire un browser Web e digitare  http:// CAserverIP /certsrv/certrqxt.asp , dove  CAserverIP  è l'indirizzo IP del server CA. Nel menu  Modello certificato  visualizzare i modelli. creazione di modelli di certificato modelli di certificato creazione"},{"UUID":"2075c4e6-a961-4f50-81da-bf1bb29cd45c","title":"Configurazione di NDES per MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Impostazione dei modelli di certificato","descFull":"Impostazione dei modelli di certificato per il servizio Registrazione dispositivi di rete (NDES) Sul computer avviare l'editor del Registro di sistema. Accedere a  HKEY_LOCAL_MACHINE  SOFTWARE  Microsoft  Crittografia  MSCEP . Configurare le seguenti chiavi, quindi impostarle su  MVEWebServer : EncryptionTemplate GeneralPurposeTemplate SignatureTemplate Assegnare all'utente SCEPSvc le autorizzazioni complete per MSCEP. In Gestione IIS, espandere la CA, quindi fare clic su  Pool di applicazioni . Nel pannello di destra, fare clic su  Ricicla  per riavviare il pool di applicazioni SCEP. In Gestione IIS, espandere la CA, quindi espandere  Siti  Sito Web predefinito . Nel pannello di destra, fare clic su  Riavvia . impostazione dei modelli di certificato per il servizio Registrazione dispositivi di rete (NDES) modelli di certificato per il servizio Registrazione dispositivi di rete (NDES) impostazione"},{"UUID":"75eb84fa-a1a9-4180-aa80-06673a5d91bb","title":"Configurazione di NDES per MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Disabilitazione della  Password di","descFull":"Disabilitazione della  Password di verifica  nel server CA Microsoft Sul computer avviare l'editor del Registro di sistema. Accedere a  HKEY_LOCAL_MACHINE   SOFTWARE   Microsoft   Crittografia  MSCEP . Impostare  EnforcePassword  su  0 . In Gestione IIS, espandere la CA, fare clic su  Pool di applicazioni , quindi selezionare  SCEP . Nel pannello di destra, fare clic su  Impostazioni avanzate . Impostare  Carica profilo utente  su  True , quindi fare clic su  OK . Nel pannello di destra, fare clic su  Ricicla  per riavviare il pool di applicazioni SCEP. In Gestione IIS, espandere la CA, quindi espandere  Siti  Sito Web predefinito . Nel pannello di destra, fare clic su  Riavvia . Quando si apre il servizio Registrazione dispositivi di rete (NDES) dal browser Web, ora è possibile visualizzare solo l'identificazione personale della CA. disabilitazione della  Password di verifica  nel server CA Microsoft Password di verifica disabilitazione nel server CA Microsoft"},{"UUID":"f02ec493-642d-4db7-8ccc-086c5b87d6a8","title":"Gestione dei certificati con l'autorità di certificazione Microsoft tramite MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Requisiti di sistema In questa","descFull":"Requisiti di sistema In questa sezione, per tutte le impostazioni viene utilizzato il sistema operativo Windows Server 2012 R2 e versioni successive. I seguenti requisiti e funzionalità di installazione si applicano sia al server CEP che al server CES, a meno che non sia specificato diversamente. Creare i seguenti tipi di account nel controller di dominio: Amministratore del servizio: denominato  CEPAdmin  e  CESAdmin Questo utente deve far parte del  gruppo di amministrazione locale  nei rispettivi server CEP e CES. Questo utente deve essere un membro del gruppo  Enterprise Admin . Account di servizio: denominato  CEPSvc  e  CESSvc Questo utente deve far parte del gruppo  IIS_IUSRS locale . Richiede l'autorizzazione  Richiedi certificati  nella CA per i rispettivi  CEPSvc  e  CESSvc . requisiti sistema requisiti di sistema"},{"UUID":"674b32ae-e056-4cf1-9158-90a76083b9bc","title":"Gestione dei certificati con l'autorità di certificazione Microsoft tramite MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Requisiti di connettività di rete","descFull":"Requisiti di connettività di rete I requisiti di connettività di rete sono una parte fondamentale della pianificazione della distribuzione, in particolare nei casi in cui i server CEP e CES siano ospitati in una rete perimetrale. La connettività di tutti i client a entrambi i servizi avviene all'interno di una sessione HTTPS, pertanto è consentito solo il traffico HTTPS tra il client e i servizi Web. Il server CEP comunica con Servizi di dominio Active Directory (AD DS), utilizzando le porte standard LDAP (Lightweight Directory Access Protocol) e LDAPS (Secure LDAP) (TCP 389 e 636 rispettivamente). Il server CES comunica con l'autorità di certificazione tramite DCOM (Distributed Component Object Model). Per impostazione predefinita, DCOM utilizza porte temporanee casuali. L'autorità di certificazione può essere configurata in modo da riservare un intervallo di porte specifico per semplificare la configurazione del firewall. requisiti connettività di rete requisiti di connettività di rete requisiti di connettività"},{"UUID":"cb957d3c-ba0b-4eeb-8e9b-e55b768b7506","title":"Gestione dei certificati con l'autorità di certificazione Microsoft tramite MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Creazione di certificati SSL per","descFull":"Creazione di certificati SSL per i server CEP e CES I server CES e CEP devono utilizzare il protocollo SSL (Secure Sockets Layer) per la comunicazione con i client (tramite HTTPS). Ogni servizio deve disporre di un certificato valido dotato di un criterio EKU (Enhanced Key Usage) per l'autenticazione del server nell'archivio certificati del computer locale. Installare il servizio IIS nel server. Accedere al server CEP, quindi aggiungere il  Certificato CA radice  nell'archivio  Autorità di certificazione radice attendibile . Avviare  IIS Manager Console , quindi selezionare  Server Home . Nella sezione Visualizzazione principale, aprire  Certificati server . Fare clic su  Azioni Crea richiesta certificato . Nella finestra  Proprietà nome distinto , specificare le informazioni necessarie, quindi fare clic su  Avanti . Nella finestra  Proprietà provider di servizi crittografici , selezionare la lunghezza in bit, quindi fare clic su  Avanti . Salvare il file. Ottenere il file firmato dall'autorità di certificazione che si intende utilizzare per i server CEP e CES. Assicurarsi che  EKU autenticazione server  sia abilitato nel certificato firmato. Copiare nuovamente il file firmato nel server CEP. In  IIS Manager Console , selezionare  Server Home . Nella sezione  Visualizzazione principale , aprire  Certificati server . Fare clic su  Azioni Completa richiesta certificato . Nella finestra  Specifica risposta autorità di certificazione , selezionare il file firmato. Digitare un nome, quindi nel menu  Archivio certificati  selezionare  Personale . Completare l'installazione del certificato. In  IIS Manager Console , selezionare il sito Web predefinito. Fare clic su  Azioni Associazioni . Nella finestra di dialogo  Associazioni del sito , fare clic su  Aggiungi . Nella finestra di dialogo  Aggiungi associazione del sito , impostare  Tipo  su  https , quindi, dal certificato SSL, cercare il certificato appena creato. In  IIS Manager Console , selezionare  Sito Web predefinito , quindi aprire le impostazioni SSL. Abilitare  Richiedi SSL  e impostare  Certificati client  su  Ignora . Riavviare IIS. Seguire la stessa procedura per il server CES. server CEP e CES creazione di certificati SSL creazione di certificati SSL server CEP e CES certificati SSL creazione"},{"UUID":"541c2a87-be7a-4e26-a38d-83381d91b5d2","title":"Gestione dei certificati con l'autorità di certificazione Microsoft tramite MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Creazione di modelli di certificato","descFull":"Creazione di modelli di certificato L'utente deve creare un modello di certificato per la registrazione del certificato. Effettuare le seguenti operazioni per copiare da un modello di certificato esistente: Accedere alla CA Enterprise con le credenziali di amministratore CA. Espandere la CA, fare clic con il pulsante destro del mouse su  Modelli di certificato , quindi scegliere  Gestisci . In  Console dei modelli di certificato , fare clic con il pulsante destro del mouse su  Modello di certificato del server Web , quindi fare clic su  Duplica modello . Nella scheda  Generale  del modello, assegnare un nome al modello  MVEWebServer . Nella scheda  Protezione , concedere all'amministratore CA le autorizzazioni di  lettura ,  scrittura  e  registrazione . Assegnare le autorizzazioni di  lettura   e  registrazione  agli utenti autenticati. Nella scheda  Nome oggetto  selezionare  Inserisci  nella richiesta. Nella scheda  Generale , impostare il periodo di validità del certificato. Se si prevede di utilizzare questo modello di certificato per l'emissione di un  certificato 802.1X  per le stampanti, procedere come segue: Nella scheda  Estensioni , selezionare  Criteri di applicazione  dall'elenco delle estensioni incluse in questo modello. Fare clic su  Modifica Aggiungi . Nella finestra di dialogo  Aggiungi criterio applicazione , selezionare  Autenticazione client . Fare clic su  OK . Nella finestra di dialogo  Proprietà modello certificato , fare clic su  OK . Nella finestra CA, fare clic con il pulsante destro del mouse su  Modelli di certificato , quindi fare clic su  Nuovo modello di certificato . Selezionare  MVEWebServer , quindi fare clic su  OK . modelli di certificato creazione di modelli di certificato"},{"UUID":"949109cd-1932-40c6-9d40-5239a433d5d5","title":"Informazioni sui metodi di autenticazione","link":"managing-certificates-using-MSCEWS-group.html","desc":"I server CEP e CES","descFull":"I server CEP e CES supportano i seguenti metodi di autenticazione: Autenticazione integrata di Windows, nota anche come  autenticazione Kerberos Autenticazione certificato client, nota anche come  autenticazione del certificato X.509 Autenticazione tramite nome utente e password metodi di autenticazione"},{"UUID":"f09a5b46-b45c-45f0-8a86-84191c7a6ff1","title":"Informazioni sui metodi di autenticazione","link":"managing-certificates-using-MSCEWS-group.html","desc":"Autenticazione integrata di Windows L'autenticazione","descFull":"Autenticazione integrata di Windows L'autenticazione integrata di Windows utilizza Kerberos per fornire un flusso di autenticazione ininterrotto per i dispositivi connessi alla rete interna. Questo è il metodo preferito per le distribuzioni interne perché utilizza l'infrastruttura Kerberos esistente all'interno di AD DS. Richiede inoltre modifiche minime ai computer client dei certificati. Utilizzare questo metodo di autenticazione se sono necessari client per accedere  solo  al servizio Web mentre si è connessi direttamente alla rete interna. autenticazione integrata di Windows autenticazione integrata di Windows"},{"UUID":"2b27f9c2-d8b6-456f-9649-99a1ea549074","title":"Informazioni sui metodi di autenticazione","link":"managing-certificates-using-MSCEWS-group.html","desc":"Autenticazione certificato client Questo è","descFull":"Autenticazione certificato client Questo è il metodo preferito rispetto all'autenticazione con nome utente e password perché è più sicuro. Non richiede una connessione diretta alla rete aziendale. Utilizzare questo metodo di autenticazione se si intende fornire certificati X.509 digitali per l'autenticazione ai client. Questo metodo consente di abilitare i servizi Web disponibili su Internet. autenticazione certificato client autenticazione certificato client"},{"UUID":"40bffa3b-5adc-4f11-bbf0-0069e9e645ae","title":"Informazioni sui metodi di autenticazione","link":"managing-certificates-using-MSCEWS-group.html","desc":"Autenticazione nome utente e password","descFull":"Autenticazione nome utente e password Il metodo nome utente e password è la forma di autenticazione più semplice. Questo metodo viene in genere utilizzato per la manutenzione dei client che non direttamente connessi alla rete interna. Si tratta di un'opzione di autenticazione meno sicura rispetto all'autenticazione del certificato client, ma non richiede il provisioning di un certificato. Utilizzare questo metodo di autenticazione quando è possibile accedere al servizio Web sulla rete interna o su Internet. autenticazione nome utente e password autenticazione nome utente e password"},{"UUID":"2e9e5536-2dc2-4932-a3e4-531ad3a198c3","title":"Requisiti di delega","link":"managing-certificates-using-MSCEWS-group.html","desc":"La delega consente a un","descFull":"La delega consente a un servizio di impersonare l'account di un utente o un computer per accedere alle risorse in tutta la rete. La delega è necessaria per il server CES in tutti i seguenti casi: CA e CES non risiedono nello stesso computer. Il server CES è in grado di elaborare le richieste di registrazione iniziale anziché elaborare solo le richieste di rinnovo del certificato. Il tipo di autenticazione è impostato su  Autenticazione integrata di Windows  o  Autenticazione certificato client . La delega non è necessaria per il server CES nei seguenti casi: CA e CES risiedono nello stesso computer. Il nome utente e la password sono il metodo di autenticazione. Microsoft consiglia di eseguire CEP e CES come account utente di dominio. Gli utenti devono creare un nome principale servizio (SPN) appropriato prima di configurare la delega nell'account utente di dominio. delega requisiti requisiti di delega"},{"UUID":"d3d1bf90-9377-48bb-a21c-8da2142c6b68","title":"Requisiti di delega","link":"managing-certificates-using-MSCEWS-group.html","desc":"Abilitazione della delega Per creare","descFull":"Abilitazione della delega Per creare un SPN per un account utente di dominio, utilizzare il comando  setspn  come segue: setspn -s http/ces.msca.com msca\\CESSvc Il nome dell'account è CESSvc. Il server CES viene eseguito in un computer con un nome di dominio completo (FQDN) di  ces.msca.com  nel dominio msca.com. Aprire l'account utente di dominio CESSvc nel controller di dominio. Nella scheda  Delega , selezionare  Utente attendibile per la delega solo ai servizi specificati . Selezionare la delega appropriata in base al metodo di autenticazione. Se si seleziona l'autenticazione integrata di Windows, configurare la delega in modo da utilizzare  solo Kerberos . Se il servizio utilizza l'autenticazione del certificato client, configurare la delega in modo da utilizzare qualsiasi protocollo di autenticazione. Se si prevede di configurare più metodi di autenticazione, configurare la delega in modo da utilizzare qualsiasi protocollo di autenticazione. Fare clic su  Aggiungi . Nella finestra di dialogo  Aggiungi servizi , selezionare  Utenti  o  Computer . Digitare il nome host del server CA, quindi fare clic su  Controlla nomi . Nella finestra di dialogo  Aggiungi servizi , selezionare uno dei seguenti servizi da delegare: Servizio host (HOST) per il server CA specificato RPCSS (Remote procedure Call System Service) per il server CA specificato Chiudere la finestra di dialogo delle proprietà utente di dominio. Per gli utenti del dominio CEP che utilizzano l'autenticazione integrata di Windows, procedere come segue: Per creare un SPN per un account utente di dominio, utilizzare il comando  setspn  come segue: setspn -s http/cep.msca.com msca\\CEPSvc il nome dell'account è CESSvc. Aprire l'account utente di dominio CEPSvc nel controller di dominio. Nella scheda  Delega , selezionare  Non considerare questo utente attendibile per la delega . delega abilitazione"},{"UUID":"37d66a2c-b3b7-4ea1-b012-0e049b0b924a","title":"Configurazione dell'autenticazione integrata di Windows","link":"managing-certificates-using-MSCEWS-group.html","desc":"Per installare CEP e CES,","descFull":"Per installare CEP e CES, utilizzare Windows PowerShell. CEP installazione CES installazione"},{"UUID":"72af2429-5428-47cf-9378-e88428d402e5","title":"Configurazione dell'autenticazione integrata di Windows","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configurazione di CEP Il cmdlet","descFull":"Configurazione di CEP Il cmdlet  Install-AdcsEnrollmentPolicyWebService  configura il servizio Web dei criteri di registrazione certificato (CEP). Viene inoltre utilizzato per creare altre istanze del servizio all'interno di un'installazione esistente. Accedere al server CEP utilizzando il nome utente  CEPAdmin , quindi avviare PowerShell in modalità amministrativa. Eseguire il comando  Import-Module ServerManager . Eseguire il comando  Add-WindowsFeature ADC-Enroll-Web-Pol . Eseguire il comando  Install-AdcsEnrollmentPolicyWebService -AuthenticationType Kerberos -SSLCertThumbprint \"sslCertThumbPrint\" . Sostituire < sslCertThumbPrint > con l'identificazione personale del certificato SSL creato per il server CEP, dopo aver eliminato gli spazi tra i valori dell'identificazione personale. Completare l'installazione selezionando  Y  o  A . Avviare IIS Manager Console. Nel riquadro  Connessioni , espandere il server Web che ospita il server CEP. Espandere  Siti , espandere  Sito Web predefinito , quindi fare clic sul nome dell'applicazione virtuale di installazione appropriata,  ADPolicyProvider_CEP_Kerberos . Nell'applicazione virtuale denominata  Home , fare doppio clic sulle impostazioni dell'applicazione, quindi fare doppio clic su  FriendlyName . Digitare un nome in  Valore , quindi chiudere la finestra di dialogo. Fare doppio clic su  URI , quindi copiare il  Valore . Se si desidera configurare un altro metodo di autenticazione nello stesso server CEP, è necessario modificare l'ID. Questo URL viene utilizzato in MVE o in qualsiasi applicazione client. Nel riquadro a sinistra, fare clic su  Pool di applicazioni . Selezionare  WSEnrollmentPolicyServer , quindi, nel riquadro a destra, fare clic su  Azioni Impostazioni avanzate . Selezionare il campo dell'identità in  Modello processo . Nella finestra di dialogo  Identità pool di applicazioni , selezionare l'account personalizzato, quindi digitare  CEPSvc  come nome utente di dominio. Chiudere tutte le finestre di dialogo, quindi riciclare IIS nel riquadro a destra di  IIS Manager Console . In PowerShell, digitare  iisreset  per riavviare IIS. CEP configurazione configurazione di CEP"},{"UUID":"0c9f028c-8725-493e-8a0c-1c7264eba788","title":"Configurazione dell'autenticazione integrata di Windows","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configurazione di CES Il cmdlet","descFull":"Configurazione di CES Il cmdlet  Install-AdcsEnrollmentWebService  configura il servizio Web di registrazione certificati (CES). Viene inoltre utilizzato per creare altre istanze del servizio all'interno di un'installazione esistente. Accedere al server CES utilizzando  CESAdmin  come nome utente, quindi avviare PowerShell in modalità amministrativa. Eseguire il comando  Import-Module ServerManager . Eseguire il comando  Add-WindowsFeature Adcs-Enroll-Web-Svc . Eseguire il comando  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig \"CA1.contoso.com\\contoso-CA1-CA\" -SSLCertThumbprint \"sslCertThumbPrint\" -AuthenticationType Kerberos . Sostituire < sslCertThumbPrint > con l'identificazione personale del certificato SSL creato per il server CES, dopo aver eliminato gli spazi tra i valori dell'identificazione personale. Sostituire  CA1.contoso.com  con il nome del computer CA. Sostituire  contoso-CA1-CA  con il nome comune CA. Completare l'installazione selezionando  Y  o  A . Avviare IIS Manager Console. Nel riquadro  Connessioni , espandere il server Web che ospita il server CES. Espandere  Siti , espandere  Sito Web predefinito , quindi fare clic sul nome dell'applicazione virtuale di installazione appropriata:  contoso-CA1-CA _CES_Kerberos . Nel riquadro a sinistra, fare clic su  Pool di applicazioni . Selezionare  WSEnrollmentServer , quindi, nel riquadro a destra, fare clic su  Azioni Impostazioni avanzate . Selezionare il campo dell'identità in  Modello processo . Nella finestra di dialogo  Identità pool di applicazioni , selezionare l'account personalizzato, quindi digitare  CESSvc  come nome utente di dominio. Chiudere tutte le finestre di dialogo, quindi riciclare IIS nel riquadro a destra di  IIS Manager Console . In PowerShell, digitare  iisreset  per riavviare IIS. Per gli utenti del dominio CESSvc, abilitare la delega. Per ulteriori informazioni, vedere  . CES configurazione configurazione di CES"},{"UUID":"ad760e3e-4194-4d7a-9b74-3b827e3cf46d","title":"Configurazione dell'autenticazione con certificato client","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configurazione di CEP Il cmdlet","descFull":"Configurazione di CEP Il cmdlet  Install-AdcsEnrollmentPolicyWebService  configura il server CEP. Viene inoltre utilizzato per creare altre istanze del servizio all'interno di un'installazione esistente. Accedere al server CEP utilizzando il nome utente  CEPAdmin , quindi avviare PowerShell in modalità amministrativa. Eseguire il comando  Import-Module ServerManager . Eseguire il comando  Add-WindowsFeature ADC-Enroll-Web-Pol . Eseguire il comando  Install-AdcsEnrollmentPolicyWebService -AuthenticationType Certificate -SSLCertThumbprint “sslCertThumbPrint” . Sostituire < sslCertThumbPrint > con l'identificazione personale del certificato SSL creato per il server CEP, dopo aver eliminato gli spazi tra i valori dell'identificazione personale. Completare l'installazione selezionando  Y  o  A . Avviare IIS Manager Console. Nel riquadro  Connessioni , espandere il server Web che ospita il server CEP. Espandere  Siti , espandere  Sito Web predefinito , quindi fare clic sul nome dell'applicazione virtuale di installazione appropriata,  ADPolicyProvider_CEP_Certificate . Nell'applicazione virtuale denominata  Home , fare doppio clic sulle impostazioni dell'applicazione, quindi fare doppio clic su  FriendlyName . Digitare un nome in  Valore , quindi chiudere la finestra di dialogo. Fare doppio clic su  URI , quindi copiare il  Valore . Se si desidera configurare un altro metodo di autenticazione nello stesso server CEP, è necessario modificare l'ID. Questo URL viene utilizzato in MVE o in qualsiasi applicazione client. Nel riquadro a sinistra, fare clic su  Pool di applicazioni . Selezionare  WSEnrollmentPolicyServer , quindi, nel riquadro a destra, fare clic su  Azioni Impostazioni avanzate . Selezionare il campo dell'identità in  Modello processo . Nella finestra di dialogo  Identità pool di applicazioni , selezionare l'account personalizzato, quindi digitare  CEPSvc  come nome utente di dominio. Chiudere tutte le finestre di dialogo, quindi riciclare IIS nel riquadro a destra di  IIS Manager Console . In PowerShell, digitare  iisreset  per riavviare IIS. CEP configurazione configurazione di CEP"},{"UUID":"2485a8df-0ca2-44a7-a16e-6416ecdc40b1","title":"Configurazione dell'autenticazione con certificato client","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configurazione di CES Il cmdlet","descFull":"Configurazione di CES Il cmdlet  Install-AdcsEnrollmentWebService  configura il servizio Web di registrazione certificati (CES). Viene inoltre utilizzato per creare altre istanze del servizio all'interno di un'installazione esistente. Accedere al server CES utilizzando  CESAdmin  come nome utente, quindi avviare PowerShell in modalità amministrativa. Eseguire il comando  Import-Module ServerManager . Eseguire il comando  Add-WindowsFeature Adcs-Enroll-Web-Svc . Eseguire il comando  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig “CA1.contoso.com\\contoso-CA1-CA” -SSLCertThumbprint “sslCertThumbPrint” -AuthenticationType Certificate . Sostituire < sslCertThumbPrint > con l'identificazione personale del certificato SSL creato per il server CES, dopo aver eliminato gli spazi tra i valori dell'identificazione personale. Sostituire  CA1.contoso.com  con il nome del computer CA. Sostituire  contoso-CA1-CA  con il nome comune CA. Se è già stato configurato un metodo di autenticazione nell'host, rimuovere  ApplicationPoolIdentity  dal comando. Completare l'installazione selezionando  Y  o  A . Avviare IIS Manager Console. Nel riquadro  Connessioni , espandere il server Web che ospita il server CEP. Espandere  Siti , espandere  Sito Web predefinito , quindi fare clic sul nome dell'applicazione virtuale di installazione appropriata:  contoso-CA1-CA _CES_Certificate . Nel riquadro a sinistra, fare clic su  Pool di applicazioni . Selezionare  WSEnrollmentServer , quindi, nel riquadro a destra, fare clic su  Azioni Impostazioni avanzate . Selezionare il campo dell'identità in  Modello processo . Nella finestra di dialogo  Identità pool di applicazioni , selezionare l'account personalizzato, quindi digitare  CESSvc  come nome utente di dominio. Chiudere tutte le finestre di dialogo, quindi riciclare IIS nel riquadro a destra di  IIS Manager Console . In PowerShell, digitare  iisreset  per riavviare IIS. Per l'utente del dominio CESSvc, abilitare la delega. Per ulteriori informazioni, vedere  . CES configurazione configurazione di CES"},{"UUID":"c9009cec-4422-4e1b-bb16-c5ab832585c9","title":"Configurazione dell'autenticazione con certificato client","link":"managing-certificates-using-MSCEWS-group.html","desc":"Creazione di un certificato client","descFull":"Creazione di un certificato client Da qualsiasi account utente di dominio, aprire  certlm.msc . Fare clic su  Certificati Personali Certificati Tutte le attività Richiedi nuovo certificato . Fare clic su  Avanti . Fare clic su  Registrazione Active Directory Accesso client . se non si desidera utilizzare le opzioni Registrazione Active Directory , effettuare le seguenti operazioni: Fare clic su  Configurato da te Aggiungi nuovo . Immettere l'URI del server dei criteri di registrazione come indirizzo del server CEP per l'autenticazione Username_Password o Kerberos. Selezionare il tipo di autenticazione come  Integrata di Windows . Fare clic su  Convalida server . Dopo aver eseguito correttamente la convalida, fare clic su  Aggiungi . Fare clic su  Avanti . Selezionare un modello qualsiasi. Fare clic su  Dettagli Proprietà . Fare clic su  Registra . Nella scheda  Oggetto , fornire un nome di dominio completo (FQDN). Nella scheda  Chiave privata , selezionare  Consenti esportazione chiave privata . Fare clic su  Applica Registra . Dopo aver registrato il certificato client, procedere come segue per esportarlo in formato PFX. Fare clic su  Certificato Tutte le attività Esporta . Fare clic su  Avanti Sì, esporta la chiave privata . Fare clic su  Avanti . Digitare la password fornita dal client. Fare clic su  Avanti . Specificare il nome del file nella finestra di dialogo  Esportazione certificati . Fare clic su  Avanti Fine . certificato client creazione di un certificato client"},{"UUID":"34a9cfeb-61aa-4b18-8add-1c7d67f72430","title":"Configurazione dell'autenticazione con nome utente-password","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configurazione di CEP Il cmdlet","descFull":"Configurazione di CEP Il cmdlet  Install-AdcsEnrollmentPolicyWebService  configura il servizio Web dei criteri di registrazione certificato (CEP). Viene inoltre utilizzato per creare altre istanze del servizio all'interno di un'installazione esistente. Accedere al server CEP utilizzando il nome utente  CEPAdmin , quindi avviare PowerShell in modalità amministrativa. Eseguire il comando  Import-Module ServerManager . Eseguire il comando  Add-WindowsFeature ADC-Enroll-Web-Pol . Eseguire il comando  Install-AdcsEnrollmentPolicyWebService -AuthenticationType UserName -SSLCertThumbprint “sslCertThumbPrint” . Sostituire < sslCertThumbPrint > con l'identificazione personale del certificato SSL creato per il server CEP, dopo aver eliminato gli spazi tra i valori dell'identificazione personale. Completare l'installazione selezionando  Y  o  A . Avviare IIS Manager Console. Nel riquadro  Connessioni , espandere il server Web che ospita il server CEP. Espandere  Siti , espandere  Sito Web predefinito , quindi fare clic sul nome dell'applicazione virtuale di installazione appropriata:  ADPolicyProvider_CEP_UsernamePassword . Nell'applicazione virtuale denominata  Home , fare doppio clic sulle impostazioni dell'applicazione, quindi fare doppio clic su  FriendlyName . Digitare un nome in  Valore , quindi chiudere la finestra di dialogo. Fare doppio clic su  URI , quindi copiare il  Valore . Se si desidera configurare un altro metodo di autenticazione nello stesso server CEP, è necessario modificare l'ID. Questo URL viene utilizzato in MVE o in qualsiasi applicazione client. Nel riquadro a sinistra, fare clic su  Pool di applicazioni . Selezionare  WSEnrollmentPolicyServer , quindi, nel riquadro a destra, fare clic su  Azioni Impostazioni avanzate . Selezionare il campo dell'identità in  Modello processo . Nella finestra di dialogo  Identità pool di applicazioni , selezionare l'account personalizzato, quindi digitare  CEPSvc . Chiudere tutte le finestre di dialogo, quindi riciclare IIS nel riquadro a destra di  IIS Manager Console . In PowerShell, digitare  iisreset  per riavviare IIS. CEP configurazione configurazione di CEP"},{"UUID":"fbd0ef88-ef30-4383-ad41-14c93781e828","title":"Configurazione dell'autenticazione con nome utente-password","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configurazione di CES Il cmdlet","descFull":"Configurazione di CES Il cmdlet  Install-AdcsEnrollmentWebService  configura il servizio Web di registrazione certificati (CES). Viene inoltre utilizzato per creare altre istanze del servizio all'interno di un'installazione esistente. Accedere al server CES utilizzando  CESAdmin  come nome utente, quindi avviare PowerShell in modalità amministrativa. Eseguire il comando  Import-Module ServerManager . Eseguire il comando  Add-WindowsFeature Adcs-Enroll-Web-Svc . Eseguire il comando  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig “CA1.contoso.com\\contoso-CA1-CA” -SSLCertThumbprint “sslCertThumbPrint” -AuthenticationType UserName . Sostituire < sslCertThumbprint > con l'identificazione personale del certificato SSL creato per il server CES, dopo aver eliminato gli spazi tra i valori dell'identificazione personale. Sostituire  CA1.contoso.com  con il nome del computer CA. Sostituire  contoso-CA1-CA  con il nome comune CA. Se è già stato configurato un metodo di autenticazione nell'host, rimuovere  ApplicationPoolIdentity  dal comando. Completare l'installazione selezionando  Y  o  A . Avviare IIS Manager Console. Nel riquadro  Connessioni , espandere il server Web che ospita il server CES. Espandere  Siti , espandere  Sito Web predefinito , quindi fare clic sul nome dell'applicazione virtuale di installazione appropriata:  contoso-CA1-CA_CES_UsernamePassword . Nel riquadro a sinistra, fare clic su  Pool di applicazioni . Selezionare  WSEnrollmentServer , quindi, nel riquadro a destra, fare clic su  Azioni Impostazioni avanzate  sotto  Azioni . Selezionare il campo dell'identità in  Modello processo . Nella finestra di dialogo  Identità pool di applicazioni , selezionare l'account personalizzato, quindi digitare  CESSvc  come nome utente di dominio. Chiudere tutte le finestre di dialogo, quindi riciclare IIS nel riquadro a destra di  IIS Manager Console . In PowerShell, digitare  iisreset  per riavviare IIS. CES configurazione configurazione di CES"},{"UUID":"e4732d0d-a737-472f-8d8e-17a0fe7cf65c","title":"Configurazione di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Installazione di OpenXPKI CA Collegare","descFull":"Installazione di OpenXPKI CA Collegare il computer utilizzando PuTTY o un altro client. Dal client, eseguire il comando  sudo su -  per passare all'utente root. Immettere la password root. In  nano /etc/apt/sources.list , modificare l'origine per installare gli aggiornamenti. Aggiornare il file. Ad esempio: #\n\n# deb cdrom:[Debian GNU/Linux 8.11.1 _Jessie_ - Official amd64 CD Binary-1 20190211-02:10]/ jessie local main\n# deb cdrom:[Debian GNU/Linux 8.11.1 _Jessie_ - Official amd64 CD Binary-1 20190211-02:10]/ jessie local main\n\ndeb http://security.debian.org/ jessie/updates main\ndeb-src http://security.debian.org/ jessie/updates main\n\n# jessie-updates, previously known as 'volatile'\n# A network mirror was not selected during install.  The following entries\n# are provided as examples, but you should amend them as appropriate\n# for your mirror of choice.\n#\ndeb http://ftp.debian.org/debian/jessie-updates main\ndeb-src http://ftp.debian.org/debian/jessie-updates main\ndeb http://ftp.us.debian.org/debian/jessie main\n Salvare il file. Eseguire questi comandi: apt-get update apt-get upgrade Aggiornare gli elenchi dei certificati CA nel server utilizzando  apt-get install ca-certificates . Installare le  impostazioni locali en_US.utf8  utilizzando  dpkg-reconfigure locales . Selezionare le impostazioni locali  en_US.UTF-8 UTF-8 , quindi impostarle come predefinite per il sistema. utilizzare il tasto Tab e la barra spaziatrice per selezionare e navigare all'interno del menu. Controllare le impostazioni locali generate utilizzando  locale –a . Output di esempio C\nC.UTF-8\nen_IN\nen_IN.utf8\nen_US.utf8\nPOSIX Copiare l'impronta digitale del pacchetto OpenXPKI utilizzando  nano /home/Release.key . Per questo esempio, copiare la chiave in  /home . Digitare  9B156AD0 F0E6A6C7 86FABE7A D8363C4E 1611A2BE 2B251336 01D1CDB4 6C24BEF3  come valore. Eseguire questo comando: gpg --print-md sha256 /home/Release.key Aggiungere il pacchetto utilizzando il comando  wget https://packages.openxpki.org/v2/debian/Release.key -O - | apt-key add - . Aggiungere il repository all'elenco di origini (jessie) utilizzando  echo \"deb http://packages.openxpki.org/v2/debian/jessie release\" > /etc/apt/sources.list.d/openxpki.list , quindi  aptitude update . Installare l'associazione MySQL e Perl MySQL utilizzando  aptitude install mysql-server libdbd-mysql-perl . Installare apache2.2-common utilizzando  aptitude install apache2.2-common . In  nano /etc/apt/sources.list , installare il modulo fastcgi per velocizzare l'interfaccia utente. si consiglia di utilizzare  mod-fcgid . Aggiungere la riga  deb http://http.us.debian.org/debian/jessie main  nel file, quindi salvarlo. Eseguire questi comandi: apt-get update aptitude install libapache2-mod-fcgid Abilitare il modulo fastcgi utilizzando  a2enmod fcgid . Installare il pacchetto di base OpenXPKI utilizzando  aptitude install libopenxpki-perl openxpki-cgi-session-driver openxpki-i18n . Riavviare il server  Apache  utilizzando  service apache2 restart . Controllare se l'installazione è avvenuta correttamente utilizzando  openxpkiadm version . se l'installazione è riuscita, il sistema mostra la versione di OpenXPKI installata. Ad esempio,  Version (core): 2.5.5 . Creare il database vuoto, quindi assegnare l'utente del database utilizzando  mysql -u root –p . Questo comando deve essere digitato nel client. In caso contrario, non è possibile immettere la password. Digitare la password per MySQL. Per questo esempio,  root  è l'utente MySQL. openxpki  è l'utente su cui è installato OpenXPKI. CREATE DATABASE openxpki CHARSET utf8; \nCREATE USER 'openxpki'@'localhost' IDENTIFIED BY 'openxpki';\nGRANT ALL ON openxpki.* TO 'openxpki'@'localhost';\nflush privileges; Se il servizio MySQL non è in esecuzione, eseguire  /etc/init.d/mysql start  per avviarlo. Digitare  quit  per uscire da MySQL. Memorizzare le credenziali usate in  /etc/openxpki/config.d/system/database.yaml . Contenuto del file di esempio debug: 0\ntype: MySQL\nname: openxpki\nhost: localhost\nport: 3306\nuser: openxpki \npasswd: openxpki modificare  user  e  passwd  in modo che corrispondano al nome utente e alla password MySQL. Salvare il file. Per uno schema di database vuoto, eseguire  zcat /usr/share/doc/libopenxpki-perl/examples/schema-mysql.sql.gz | \\mysql -u root --password --database openxpki  dal file di schema fornito. Immettere la password per il database. installazione di OpenXPKI CA OpenXPKI CA installazione"},{"UUID":"4c01c6ef-4a6c-46fc-9da5-342fc50aab1d","title":"Configurazione di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Configurazione di OpenXPKI CA mediante","descFull":"Configurazione di OpenXPKI CA mediante lo script predefinito lo script predefinito configura solo l'area di autenticazione predefinita, ovvero  ca-one . CDP e CRL non sono configurati. Decomprimere lo script di esempio per installare il certificato utilizzando  gunzip -k /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh.gz . Eseguire lo script utilizzando  bash /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh . Confermare le impostazioni utilizzando  openxpkiadm alias --realm ca-one . Output di esempio === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set Controllare se l'installazione è avvenuta correttamente utilizzando  openxpkictl start . Output di esempio Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Effettuare le seguenti operazioni per accedere al server OpenXPKI: Nel browser Web, digitare  http://ipaddress/openxpki/ . Eseguire l'accesso come  Operatore . La password predefinita è  openxpki . l'accesso Operatore dispone di due account operatore preconfigurati:  raop  e  raop2 . Creare una richiesta di certificato, quindi testarla. configurazione di OpenXPKI CA mediante lo script predefinito OpenXPKI CA configurazione mediante lo script predefinito"},{"UUID":"4333e29e-ba3c-427c-a25c-39d9d8cdc3ac","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Panoramica prima di iniziare, assicurarsi","descFull":"Panoramica prima di iniziare, assicurarsi di disporre di una conoscenza di base sulla creazione di certificati OpenSSL. Per configurare manualmente OpenXPKI CA, creare i seguenti certificati: Certificato CA radice. Per ulteriori informazioni, vedere  . Certificato del firmatario CA, firmato dalla CA radice. Per ulteriori informazioni, vedere  . Certificato del vault di dati, autofirmato. Per ulteriori informazioni, vedere  . Certificato SCEP, firmato dal certificato del firmatario. Quando si seleziona l'hash della firma, utilizzare SHA256 o SHA512. La modifica della dimensione della chiave pubblica è opzionale. In questo esempio, utilizziamo la directory  /etc/certs/openxpki_ca-one/  per la generazione dei certificati. Tuttavia, è possibile utilizzare qualsiasi directory. configurazione manuale di OpenXPKI CA OpenXPKI CA configurazione manuale"},{"UUID":"e3066029-6b6a-4027-8057-1c816ea8d823","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creazione di un file di","descFull":"Creazione di un file di configurazione OpenSSL Eseguire questo comando: nano /etc/certs/openxpki_ca-one/openssl.conf Se il server è raggiungibile tramite il nome di dominio completo (FQDN), utilizzare il DNS del server anziché il suo indirizzo IP. File di esempio # x509_extensions               = v3_ca_extensions\n# x509_extensions               = v3_issuing_extensions\n# x509_extensions               = v3_datavault_extensions\n# x509_extensions               = v3_scep_extensions\n# x509_extensions               = v3_web_extensions\n# x509_extensions               = v3_ca_reqexts # not for root self-signed, only for issuing\n## x509_extensions              = v3_datavault_reqexts # not required self-signed\n# x509_extensions               = v3_scep_reqexts\n# x509_extensions               = v3_web_reqexts\n\n[ req ]\ndefault_bits            = 4096\ndistinguished_name      = req_distinguished_name\n\n[ req_distinguished_name ]\ndomainComponent         = Domain Component\ncommonName              = Common Name\n\n[ v3_ca_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\n\n[ v3_datavault_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\n\n[ v3_scep_reqexts ]\nsubjectKeyIdentifier    = hash\n\n[ v3_web_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\n\n[ v3_ca_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_issuing_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer:always\ncrlDistributionPoints   = URI:http://FQDN of the server/CertEnroll/MYOPENXPKI.crl\nauthorityInfoAccess     = caIssuers;URI:http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\n\n[ v3_datavault_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_scep_extensions ]\nsubjectKeyIdentifier    = hash\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid,issuer\n\n[ v3_web_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\nbasicConstraints        = critical,CA:FALSE\nsubjectAltName          = DNS:stlopenxpki.lexmark.com\ncrlDistributionPoints   = URI:http://FQDN of the server/CertEnroll/MYOPENXPKI_ISSUINGCA.crl\nauthorityInfoAccess     = caIssuers;URI:http://FQDN of the server/CertEnroll/MYOPENXPKI_ISSUINGCA.crt\n Modificare l'indirizzo IP e il nome del certificato CA in base alle informazioni delle proprie impostazioni. Salvare il file. creazione di file di configurazione OpenSSL file di configurazione OpenSSL creazione"},{"UUID":"1ef9008e-275a-4451-864e-68672ec0b60c","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creazione di un file di","descFull":"Creazione di un file di password per le chiavi dei certificati Eseguire questo comando: nano /etc/certs/openxpki_ca-one/pd.pass Digitare la propria password. Salvare il file. creazione di file di password per le chiavi dei certificati file di password per le chiavi dei certificati creazione chiavi dei certificati creazione di file di password"},{"UUID":"a34f38f2-a5a7-4417-8e25-6d70dbdbe76f","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creazione di un certificato CA","descFull":"Creazione di un certificato CA radice è possibile creare un‑certificato CA radice autofirmato o generare una richiesta di certificato e quindi ottenerne la firma dalla CA radice. Eseguire questi comandi: sostituire la lunghezza della chiave, l'algoritmo di firma e il nome del certificato con i valori appropriati. openssl genrsa -out /etc/certs/openxpki_ca-one/ca-root-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 openssl req -new -key /etc/certs/openxpki_ca-one/ca-root-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ROOTCA -out /etc/certs/openxpki_ca-one/ca-root-1.csr openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_ca_extensions -x509 -days 3560 -in /etc/certs/openxpki_ca-one/ca-root-1.csr -key /etc/certs/openxpki_ca-one/ca-root-1.key -out /etc/certs/openxpki_ca-one/ca-root-1.crt -sha256 creazione dei certificati CA radice certificati CA radice creazione"},{"UUID":"35eb5306-2e10-4136-bad4-4104d519a5f3","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creazione di un certificato del","descFull":"Creazione di un certificato del firmatario sostituire la lunghezza della chiave, l'algoritmo di firma e il nome del certificato con i valori appropriati. Eseguire questo comando: openssl genrsa -out /etc/certs/openxpki_ca-one/ca-signer-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 Modificare l'oggetto della richiesta con le informazioni della propria CA utilizzando  openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_ca_reqexts -new -key /etc/certs/openxpki_ca-one/ca-signer-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ISSUINGCA -out /etc/certs/openxpki_ca-one/ca-signer-1.csr . Ottenere il certificato firmato dalla CA radice utilizzando  openssl x509 -req -extfile /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_issuing_extensions -days 3650 -in /etc/certs/openxpki_ca-one/ca-signer-1.csr -CA /etc/certs/openxpki_ca-one/ca-root-1.crt -CAkey /etc/certs/openxpki_ca-one/ca-root-1.key -CAcreateserial -out /etc/certs/openxpki_ca-one/ca-signer-1.crt -sha256 . creazione dei certificati del firmatario certificati del firmatario creazione"},{"UUID":"7b9a50ff-b5f2-4c20-ac1b-244276fc20c7","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creazione di un certificato del","descFull":"Creazione di un certificato del vault Il certificato del vault è autofirmato. Sostituire la lunghezza della chiave, l'algoritmo di firma e il nome del certificato con i valori appropriati. Eseguire questo comando: openssl genrsa -out /etc/certs/openxpki_ca-one/vault-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 Modificare l'oggetto della richiesta con le informazioni della propria CA utilizzando  openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_datavault_reqexts -new -key /etc/certs/openxpki_ca-one/vault-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/DC=STLOPENXPKI_INTERNAL/CN=MYOPENXPKI_DATAVAULT -out /etc/certs/openxpki_ca-one/vault-1.csr . Eseguire questo comando: openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_datavault_extensions -x509 -days 3560 -in /etc/certs/openxpki_ca-one/vault-1.csr -key /etc/certs/openxpki_ca-one/vault-1.key -out /etc/certs/openxpki_ca-one/vault-1.crt creazione dei certificati del vault certificati del vault creazione"},{"UUID":"84095d1a-feeb-4a44-b4cd-eee26ed1c566","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creazione di un certificato SCEP","descFull":"Creazione di un certificato SCEP il certificato SCEP è firmato dal certificato del firmatario. Eseguire questi comandi: sostituire la lunghezza della chiave, l'algoritmo di firma e il nome del certificato con i valori appropriati. openssl genrsa -out /etc/certs/openxpki_ca-one/scep-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_scep_reqexts -new -key /etc/certs/openxpki_ca-one/scep-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_SCEPCA -out /etc/certs/openxpki_ca-one/scep-1.csr openssl x509 -req -extfile /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_scep_extensions -days 900 -in /etc/certs/openxpki_ca-one/scep-1.csr -CA /etc/certs/openxpki_ca-one/ca-signer-1.crt -CAkey /etc/certs/openxpki_ca-one/ca-signer-1.key -CAcreateserial -out /etc/certs/openxpki_ca-one/scep-1.crt -sha256 creazione di certificati SCEP certificati SCEP creazione"},{"UUID":"324e7378-9cd1-46e6-b9f8-6bfb67daefb1","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Copia del file di chiave","descFull":"Copia del file di chiave e creazione di un collegamento simbolico Copiare i file di chiave in  /etc/openxpki/ca/ca-one . i file di chiave devono essere leggibili da OpenXPKI. cp /etc/certs/openxpki_ca-one/ca-signer-1.key /etc/openxpki/ca/ca-one/\n\ncp /etc/certs/openxpki_ca-one/vault-1.key /etc/openxpki/ca/ca-one/\n\ncp /etc/certs/openxpki_ca-one/scep-1.key /etc/openxpki/ca/ca-one/ Creare il collegamento simbolico. i collegamenti simbolici sono alias utilizzati dalla configurazione predefinita. ln -s /etc/openxpki/ca/ca-one/ca-signer-1.key /etc/openxpki/ca/ca-one/ca-signer-1.pem\n\nln -s /etc/openxpki/ca/ca-one/scep-1.key /etc/openxpki/ca/ca-one/scep-1.pem\n\nln -s /etc/openxpki/ca/ca-one/vault-1.key /etc/openxpki/ca/ca-one/vault-1.pem copia dei file di chiave creazione dei collegamenti simbolici file di chiave copia collegamenti simbolici creazione"},{"UUID":"bbe9d381-173f-4384-96d4-f80e93f3486f","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Importazione dei certificati Importare il","descFull":"Importazione dei certificati Importare il certificato radice, il certificato del firmatario, il certificato del vault e il certificato SCEP nel database con i token appropriati. Eseguire questi comandi: openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/ca-root-1.crt openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/ca-signer-1.crt --realm ca-one --token certsign openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/scep-1.crt --realm ca-one --token scep openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/vault-1.crt --realm ca-one --token datasafe Controllare se l'importazione è avvenuta correttamente utilizzando  openxpkiadm alias --realm ca-one . Output di esempio === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set\n importazione dei certificati certificati importazione"},{"UUID":"98d601cb-cfa2-407e-a7fd-cae4ad60d1c8","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Avvio di OpenXPKI Eseguire il","descFull":"Avvio di OpenXPKI Eseguire il comando  openxpkictl start . Output di esempio Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Effettuare le seguenti operazioni per accedere al server OpenXPKI: Nel browser Web, digitare  http://ipaddress/openxpki/ . Invece di  ipaddress , è possibile utilizzare anche il nome di dominio completo (FQDN) del server. Eseguire l'accesso come  Operatore . La password predefinita è  openxpki . l'accesso Operatore dispone di due account operatore preconfigurati:  raop  e  raop2 . Creare una richiesta di certificato, quindi testarla. avvio di OpenXPKI OpenXPKI avvio"},{"UUID":"e0a342f9-9087-4a2b-8a2c-827e4e9391a2","title":"Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Generazione delle informazioni del CRL","descFull":"Generazione delle informazioni del CRL se il server è raggiungibile tramite il nome di dominio completo (FQDN), utilizzare il DNS del server anziché il suo indirizzo IP. Arrestare il servizio OpenXPKI utilizzando  Openxpkictl stop . In  nano /etc/openxpki/config.d/realm/ca-one/publishing.yaml , aggiornare la sezione  connectors: cdp  come segue: class: Connector::Builtin::File::Path\nLOCATION: /var/www/openxpki/CertEnroll/\nfile: \"[% ARGS.0 %].crl\"\ncontent: \"[% pem %]\" In  nano /etc/openxpki/config.d/realm/ca-one/profile/default.yaml , aggiornare quanto segue: Sezione crl_distribution_points:  sezione critical: 0\nuri:\n    - http://FQDN of the server/CertEnroll/[% ISSUER.CN.0 %].crl\n    - ldap://localhost/[% ISSUER.DN %] Sezione authority_info_access:  sezione critical: 0\nca_issuers: http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\nocsp: http://ocsp.openxpki.org/ Modificare l'indirizzo IP e il nome del certificato CA in base al proprio server CA. In  nano /etc/openxpki/config.d/realm/ca-one/crl/default.yaml , effettuare le seguenti operazioni: Se necessario, aggiornare  nextupdate  e  renewal . Aggiungere  ca_issuers  alla seguente sezione: extensions:\n    \t\tauthority_info_access:\n        \t\t\tcritical: 0\n        \t\t\t# ca_issuers and ocsp can be scalar or list\n        \t\t\tca_issuers: http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\n       \t\t\t#ocsp: http://ocsp.openxpki.org/\n Modificare l'indirizzo IP e il nome del certificato CA in base al proprio server CA. Avviare il servizio OpenXPKI utilizzando  Openxpkictl start . generazione delle informazioni del CRL informazioni CRL generazione"},{"UUID":"0e9676bd-c299-4b4b-943e-a8de51ec116a","title":"Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Configurazione dell'accessibilità al CRL Arrestare","descFull":"Configurazione dell'accessibilità al CRL Arrestare il servizio Apache utilizzando  service apache2 stop . Creare una directory  CertEnroll  per crl nella directory  /var/www/openxpki/ . Impostare  openxpki  come proprietario di questa directory, quindi configurare le autorizzazioni per consentire ad Apache la lettura e l'esecuzione e agli altri servizi la sola lettura. chown openxpki /var/www/openxpki/CertEnroll chmod 755 /var/www/openxpki/CertEnroll Aggiungere un riferimento al file Apache alias.conf utilizzando  nano /etc/apache2/mods-enabled/alias.conf . Dopo la sezione  <Directory \"/usr/share/apache2/icons\"> , aggiungere quanto segue:         \tAlias /CertEnroll/ \"/var/www/openxpki/CertEnroll/\"\n         \t<Directory \"/var/www/openxpki/CertEnroll\">\n               Options FollowSymlinks\n               AllowOverride None\n               Require all granted\n         \t</Directory> Aggiungere un riferimento nel file apache2.conf utilizzando  nano /etc/apache2/apache2.conf . Aggiungere quanto segue nella sezione  Apache2 HTTPD server :          \t<Directory /var/www/openxpki/CertEnroll>\n               Options FollowSymlinks\n               AllowOverride None\n               Allow from all\n         \t</Directory> Avviare il servizio Apache utilizzando  service apache2 start . configurazione dell'accessibilità al CRL accessibilità al CRL configurazione"},{"UUID":"cde993f7-93c0-4488-ab7c-36e1d9650a25","title":"Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Abilitazione del servizio SCEP Arrestare","descFull":"Abilitazione del servizio SCEP Arrestare il servizio OpenXPKI utilizzando  openxpkictl stop . Installare il pacchetto openca-tools utilizzando  aptitude install openca-tools . Avviare il servizio OpenXPKI utilizzando  openxpkictl start . Testare il servizio utilizzando un qualsiasi client, ad esempio certnanny con SSCEP. SSCEP è un client della riga di comando per SCEP. È possibile scaricare SSCEP da  https://github.com/certnanny/sscep . abilitazione del servizio SCEP servizio SCEP abilitazione Simple Certificate Enrollment Protocol abilitazione"},{"UUID":"f7bc1874-7edb-4d06-9154-330eacf3906c","title":"Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Abilitazione del certificato del \"firmatario","descFull":"Abilitazione del certificato del \"firmatario per conto di\" (agente di registrazione) Per le richieste automatiche di certificati, stiamo utilizzando la funzione del \"firmatario per conto di\" di OpenXPKI. Arrestare il servizio OpenXPKI utilizzando  openxpkictl stop . In  nano /etc/openxpki/config.d/realm/ca-one/scep/generic.yaml , nella sezione  authorized_signer: , aggiungere una regola per il nome dell'oggetto del certificato del firmatario. rule1:\n        \t\t# Full DN\n            \t\tsubject: CN=Markvision_.*\n In questa regola, qualsiasi CN di certificato che inizia con  Markvision_  è il certificato del \"firmatario per conto di\". Il nome dell'oggetto è impostato in MVE per generare il certificato del \"firmatario per conto di\". Esaminare lo spazio e il rientro nel file script. Se il CN viene modificato in MVE, aggiungere il CN aggiornato in OpenXPKI. È possibile specificare un solo certificato del \"firmatario per conto di\", quindi specificare il CN completo. Salvare il file. Avviare il servizio OpenXPKI utilizzando  openxpkictl start . abilitazione dei certificati del \"firmatario per conto di\" certificati del \"firmatario per conto di\" abilitazione"},{"UUID":"1af47e2f-66f5-40d2-abeb-cce1fb7d9f6d","title":"Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Abilitazione dell'approvazione automatica delle richieste","descFull":"Abilitazione dell'approvazione automatica delle richieste di certificato in OpenXPKI CA Arrestare il servizio OpenXPKI utilizzando  openxpkictl stop . In  nano /etc/openxpki/config.d/realm/ca-one/scep/generic.yaml , aggiornare la sezione  eligible:  come segue: Precedente contenuto eligible:\n\t\t\tinitial:\n\t\t\t\tvalue@: connector:scep.generic.connector.initial\n       \t\targs: '[% context.cert_subject_parts.CN.0 %]'\n       \t\texpect:\n       \t\t\t- Build\n       \t\t\t- New Nuovo contenuto eligible:\n\t\t\tinitial:\n\t\t\t\tvalue: 1\n\t\t\t\t# value@: connector:scep.generic.connector.initial\n\t\t\t\t# args: '[% context.cert_subject_parts.CN.0 %]'\n\t\t\t\t# expect:\n\t\t\t\t#\t- Build\n\t\t\t\t#\t- New Esaminare lo spazio e il rientro nel file script. Per approvare manualmente i certificati, inserire un commento per  value: 1 , quindi rimuovere il commento dalle altre righe in cui era stato in precedenza inserito. Salvare il file. Avviare il servizio OpenXPKI utilizzando  openxpkictl start . abilitazione dell'approvazione automatica delle richieste di certificato in OpenXPKI CA approvazione automatica delle richieste di certificato abilitazione in OpenXPKI CA richieste di certificato in OpenXPKI CA approvazione automatica"},{"UUID":"76cb0c93-d4ac-4170-8ba0-c3bac211683f","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Copia e impostazione della directory","descFull":"Copia e impostazione della directory Copiare la struttura di directory di esempio  /etc/openxpki/config.d/realm/ca-one  in una nuova directory ( cp -avr /etc/openxpki/config.d/realm/ca-one /etc/openxpki/config.d/realm/ca-two ) all'interno della directory dell'area di autenticazione. In  /etc/openxpki/config.d/system/realms.yaml , aggiornare la seguente sezione: Precedente contenuto # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\nca-one:\n    label: Verbose name of this realm\n    baseurl: https://pki.example.com/openxpki/\n\n#ca-two:\n#    label: Verbose name of this realm\n#    baseurl: https://pki.acme.org/openxpki/ Nuovo contenuto # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\nca-one:\n    label: CA-ONE\n    baseurl: https://pki.example.com/openxpki/\n\nca-two:\n    label: CA-TWO\n    baseurl: https://pki.example.com/openxpki/ Salvare il file. copia della directory impostazione della directory"},{"UUID":"413792b4-f9bb-49cd-b3fb-a6002b8ed5e0","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creazione dei certificati Le seguenti","descFull":"Creazione dei certificati Le seguenti istruzioni mostrano come generare il certificato del firmatario, il certificato del vault e il certificato SCEP. La CA radice firma il certificato del firmatario, quindi il certificato del firmatario firma il certificato SCEP. Il certificato del vault è autofirmato. Generare e quindi firmare i certificati. Per ulteriori informazioni, vedere  . modificare il nome comune del certificato in modo che l'utente possa distinguere facilmente tra i diversi certificati per le diverse aree di autenticazione. Si può modificare  DC=CA-ONE  in  DC=CA-TWO . I file di certificato vengono creati nella  /etc/certs/openxpki_ca-two/ . Copiare i file di chiave in  /etc/openxpki/ca/ca-two/ . i file di chiave devono essere leggibili da OpenXPKI. cp /etc/certs/openxpki_ca-two/ca-signer-1.key /etc/openxpki/ca/ca-two/\n\ncp /etc/certs/openxpki_ca-two/vault-1.key /etc/openxpki/ca/ca-two/\n\ncp /etc/certs/openxpki_ca-two/scep-1.key /etc/openxpki/ca/ca-two/ Creare il collegamento simbolico. Creare anche un collegamento simbolico per il certificato CA radice. i collegamenti simbolici sono alias utilizzati dalla configurazione predefinita. ln -s /etc/openxpki/ca/ca-one/ca-root-1.crt /etc/openxpki/ca/ca-two/ca-root-1.crt\n\nln -s /etc/openxpki/ca/ca-two/ca-signer-1.key /etc/openxpki/ca/ca-two/ca-signer-1.pem\n\nln -s /etc/openxpki/ca/ca-two/scep-1.key /etc/openxpki/ca/ca-two/scep-1.pem\n\nln -s /etc/openxpki/ca/ca-two/vault-1.key /etc/openxpki/ca/ca-two/vault-1.pem Importare il certificato del firmatario, il certificato del vault e il certificato SCEP nel database con i token appropriati per  ca-two . openxpkiadm certificate import --file /etc/certs/openxpki_ca-two/ca-signer-1.crt --realm ca-two –issuer /etc/openxpki/ca/ca-two/ca-one-1.crt --token certsign\n\nopenxpkiadm certificate import --file /etc/certs/openxpki_ca-two/scep-1.crt --realm ca-two --token scep\n\nopenxpkiadm certificate import --file /etc/certs/openxpki_ca-two/vault-1.crt --realm ca-two --token datasafe Controllare se l'importazione è avvenuta correttamente utilizzando  openxpkiadm alias --realm ca-two . Output di esempio === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set\n In questo caso, le informazioni relativa alla CA radice sono le stesse per  ca-one  e  ca-two . Se la password della chiave del certificato è stata modificata durante la creazione del certificato, aggiornare  nano /etc/openxpki/config.d/realm/ca-two/crypto.yaml . Generare i CRL per questa area di autenticazione. Per ulteriori informazioni, vedere  . Pubblicare i CRL per questa area di autenticazione. Per ulteriori informazioni, vedere  . Riavviare il servizio OpenXPKI utilizzando  openxpkictl restart . Output di esempio Stopping OpenXPKI\nStopping gracefully, 3 (sub)processes remaining...\nDONE.\nStarting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Effettuare le seguenti operazioni per accedere al server OpenXPKI: Nel browser Web, digitare  http://ipaddress/openxpki/ . Eseguire l'accesso come  Operatore . La password predefinita è  openxpki . l'accesso Operatore dispone di due account operatore preconfigurati:  raop  e  raop2 . creazione dei certificati certificati creazione"},{"UUID":"04687c4c-68d1-438e-994f-d676900c857f","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Configurazione dell'endpoint SCEP per più","descFull":"Configurazione dell'endpoint SCEP per più aree di autenticazione L'endpoint SCEP dell'area di autenticazione predefinita è  http://<ipaddress>/scep/scep . Se si dispone di più aree di autenticazione, configurare un endpoint SCEP univoco (file di configurazione diverso) per ogni area di autenticazione. Nelle seguenti istruzioni, utilizziamo due aree di autenticazione PKI, ovvero  ca-one  e  ca-two . Copiare il file di configurazione predefinito in  cp /etc/openxpki/scep/default.conf /etc/openxpki/scep/ca-one.conf . assegnare al file il nome  ca-one.conf . In  nano /etc/openxpki/scep/ca-one.conf , modificare il valore dell'area di autenticazione in  realm=ca-one . Creare un altro file di configurazione in  cp /etc/openxpki/scep/default.conf /etc/openxpki/scep/ca-two.conf . assegnare al file il nome  ca-two.conf . In  nano /etc/openxpki/scep/ca-two.conf , modificare il valore dell'area di autenticazione in  realm=ca-two . Riavviare il servizio OpenXPKI utilizzando  openxpkictl restart . Gli endpoint SCEP sono i seguenti: ca‑one :  http://ipaddress/scep/ca-one ca-two :  http://ipaddress/scep/ca-two Se si desidera differenziare tra le credenziali di accesso e i modelli di certificato predefiniti per aree di autenticazione PKI diverse, potrebbe essere necessaria una configurazione avanzata. configurazione degli endpoint SCEP per più aree di autenticazione endpoint SCEP configurazione per più aree di autenticazione"},{"UUID":"2a07692f-41f2-43ee-ba00-d510d508875a","title":"Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Abilitazione della presenza contemporanea di","descFull":"Abilitazione della presenza contemporanea di più certificati attivi Per impostazione predefinita, in OpenXPKI può essere attivo un solo certificato con lo stesso nome oggetto alla volta. Tuttavia, quando si applicano più certificati con nome, devono essere presenti più certificati attivi con lo stesso nome oggetto alla volta. In  etc/openxpki/config.d/realm/REALM NAME/scep/generic.yaml , nella sezione  policy , modificare il valore di  max_active_certs  da  1  a  0 . REAL NAME è il nome dell'area di autenticazione. Ad esempio,  ca‑one . Esaminare lo spazio e il rientro nel file script. Riavviare il servizio OpenXPKI utilizzando  openxpkictl restart . abilitazione di più certificati attivi stesso soggetto"},{"UUID":"278ff87e-d5d4-431c-92a2-8ebbd3b814da","title":"Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Impostazione del numero di porta","descFull":"Impostazione del numero di porta predefinito per OpenXPKI CA Per impostazione predefinita, Apache è in ascolto sulla porta numero 80. Impostare il numero di porta predefinito per OpenXPKI CA per evitare conflitti. In  /etc/apache2/ports.conf , aggiungere o modificare una porta. Ad esempio,  Listen 8080 . In  /etc/apache2/sites-enabled/000-default.conf , aggiungere o modificare la sezione  VirtualHost  per associare la nuova porta. Ad esempio,  <VirtualHost *:8080> . Riavviare il server Apache utilizzando  systemctl restart apache2 . Per verificare lo stato, eseguire  netstat -tlpn| grep apache . L'URL SCEP di OpenXPKI è ora  http://ipaddress:8080/scep/ca-one , mentre l'URL Web è  http://ip address:8080/openxpki . impostazione dei numeri di porta predefiniti per OpenXPKI CA numeri di porta predefiniti impostazione per OpenXPKI CA"},{"UUID":"abdfd8a7-9dd1-40c3-8c18-05753769ce35","title":"Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Rifiuto delle richieste di certificati","descFull":"Rifiuto delle richieste di certificati senza  password di verifica  in OpenXPKI CA Per impostazione predefinita, OpenXPKI accetta le richieste senza controllare la password di verifica. La richiesta di certificato non viene rifiutata e la CA e l'amministratore CA stabiliscono se approvare o rifiutare la richiesta. Per evitare potenziali problemi di sicurezza, disabilitare questa funzione in modo che tutte le richieste di certificato che contengono password non valide vengano rifiutate immediatamente. In MVE, la  Password di verifica  è obbligatoria solo quando viene generato il certificato agente di registrazione. In  etc/openxpki/config.d/realm/REALM NAME/scep/generic.yaml , nella sezione  policy , modificare il valore di  allow_man_authen  da  1  a  0 . REAL NAME è il nome dell'area di autenticazione. Ad esempio,  ca‑one . Esaminare lo spazio e il rientro nel file script. Riavviare il servizio OpenXPKI utilizzando  openxpkictl restart . rifiuto delle richieste di certificati senza  password di verifica  in OpenXPKI CA richieste di certificati senza  password di verifica rifiuto in OpenXPKI CA"},{"UUID":"6f459147-a94e-4b54-99dc-1582f8a1fedd","title":"Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Aggiunta dell'EKU di autenticazione client","descFull":"Aggiunta dell'EKU di autenticazione client nei certificati In  /etc/openxpki/config.d/realm/REALM NAME/profile/I18N_OPENXPKI_PROFILE_TLS_SERVER.yaml , nella sezione  extended_key_usage: , modificare il valore di  client_auth:  in  1 . REAL NAME è il nome dell'area di autenticazione. Ad esempio,  ca‑one . Esaminare lo spazio e il rientro nel file script. Riavviare il servizio OpenXPKI utilizzando  openxpkictl restart . aggiunta dell'EKU di autenticazione client nei certificati EKU di autenticazione client aggiunta nei certificati"},{"UUID":"a113d24c-4d14-45c8-ba15-4ff8c05a8940","title":"Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Recupero dell'oggetto del certificato completo","descFull":"Recupero dell'oggetto del certificato completo quando si effettua la richiesta tramite SCEP Per impostazione predefinita, OpenXPKI legge solo il nome comune CN dell'oggetto del certificato richiesto. Il resto delle informazioni, quali il paese, la località e dominio DC, è hardcoded. Ad esempio, se l'oggetto di un certificato è  C=US ,  ST=KY ,  L=Lexington ,  O=Lexmark ,  OU=ISS ,  CN=ET0021B7C34AEC.dhcp.dev.lexmark.com , dopo la firma del certificato tramite SCEP, l'oggetto viene modificato in  DC=Test Deployment ,  DC= OpenXPKI ,  CN=ET0021B7C34AEC.dhcp.dev.lexmark.com . REAL NAME è il nome dell'area di autenticazione. Ad esempio,  ca‑one . In  /etc/openxpki/config.d/realm/REALM NAME/profile/I18N_OPENXPKI_PROFILE_TLS_SERVER.yaml , nella sezione  enroll , modificare il valore di  dn  come segue: CN=[% CN.0 %][% IF OU %][% FOREACH entry = OU %],OU=[% entry %][% END %][% END %][% IF O %][% FOREACH entry = O %],O=[% entry %][% END %][% END %][% IF L %],L=[% L.0 %][% END %][% IF ST %],ST=[% ST.0 %][% END %][% IF C %],C=[% C.0 %][% END %][% IF DC %][% FOREACH entry = DC %],DC=[% entry %][% END %][% END %][% IF EMAIL %][% FOREACH entry = EMAIL %],EMAIL=[% entry %][% END %][% END %] Salvare il file. Creare un file denominato  l.yaml  nella directory  /etc/openxpki/config.d/realm/REALM NAME/profile/template . Aggiungere quanto segue: id: L\nlabel: L\ndescription: I18N_OPENXPKI_UI_PROFILE_L_DESC\npreset: L\ntype: freetext\nwidth: 60\nplaceholder: Kolkata Salvare il file. Creare un file denominato  st.yaml  nella directory  /etc/openxpki/config.d/realm/REALM NAME/profile/template . Aggiungere quanto segue: id: ST\nlabel: ST\ndescription: I18N_OPENXPKI_UI_PROFILE_ST_DESC\npreset: ST\ntype: freetext\nwidth: 60\nplaceholder: WB Salvare il file. OpenXPKI deve contenere entrambi i file e deve essere leggibile, scrivibile e eseguibile. Riavviare il servizio OpenXPKI utilizzando  openxpkictl restart . recupero degli oggetti dei certificati completi quando si effettua la richiesta tramite SCEP oggetti dei certificati completi richiesta tramite SCEP"},{"UUID":"75db2105-f02b-4166-96b3-e0a111c2a34a","title":"Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Revoca dei certificati e pubblicazione","descFull":"Revoca dei certificati e pubblicazione del CRL Accedere al server OpenXPKI. Nel browser Web, digitare  http://ipaddress/openxpki/ . Eseguire l'accesso come  Operatore . La password predefinita è  openxpki . l'accesso Operatore dispone di due account operatore preconfigurati:  raop  e  raop2 . Fare clic su  Cerca flusso di lavoro Cerca ora . Fare clic su un certificato da revocare, quindi sul collegamento del certificato. Nella sezione  Azione  fare clic su  richiesta di revoca . Digitare i valori appropriati, quindi fare clic su  Continua Invia richiesta . Nella pagina successiva approvare la richiesta. La revoca del certificato è in attesa della successiva pubblicazione del CRL. Nella sezione  Funzionamento PKI  fare clic su  Emettere un elenco di revoche di certificati (CRL) . Fare clic su  Applica creazione di elenchi di revoche Continua . Nella sezione  Funzionamento PKI  fare clic su  Pubblica CA/CRL . Fare clic su  Cerca flusso di lavoro Cerca ora . Fare clic sul certificato revocato con un tipo  certificate_revocation_request_v2 . Fare clic su  Applica riattivazione . Nel nuovo CRL è possibile trovare il numero di serie e il motivo di revoca del certificato revocato. revoca di certificati certificati revoca pubblicazione del CRL CRL pubblicazione"},{"UUID":"bdfbe5aa-eb1a-40f3-9b2b-b4413843362a","title":"Configurazione di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Installazione di OpenXPKI CA Collegare","descFull":"Installazione di OpenXPKI CA Collegare il computer utilizzando PuTTY o un altro client. Dal client, eseguire il comando  sudo su -  per passare all'utente root. Immettere la password root. In  nano /etc/apt/sources.list , modificare l'origine per installare gli aggiornamenti. Aggiornare il file. Ad esempio: #\n\n# deb cdrom:[Debian GNU/Linux testing _Buster_ - Official Snapshot amd64 DVD Binary-1 20190527-04:04]/ buster contrib main\n# deb cdrom:[Debian GNU/Linux testing _Buster_ - Official Snapshot amd64 DVD Binary-1 20190527-04:04]/ buster contrib main\n\ndeb http://security.debian.org/debian-security buster/updates main contrib\ndeb-src http://security.debian.org/debian-security buster/updates main contrib\n\n# buster-updates, previously known as 'volatile'\n# A network mirror was not selected during install. The following entries\n# are provided as examples, but you should amend them as appropriate\n# for your mirror of choice.\n#\ndeb http://ftp.debian.org/debian/ buster-updates main\ndeb-src http://ftp.debian.org/debian/ buster-updates main\ndeb http://ftp.us.debian.org/debian/ buster main\n Salvare il file. Eseguire questi comandi: apt-get update apt-get upgrade Aggiornare gli elenchi dei certificati CA nel server utilizzando  apt-get install ca-certificates . Installare le  impostazioni locali en_US.utf8  utilizzando  dpkg-reconfigure locales . Selezionare le impostazioni locali  en_US.UTF-8 UTF-8 , quindi impostarle come predefinite per il sistema. utilizzare il tasto Tab e la barra spaziatrice per selezionare e navigare all'interno del menu. Controllare le impostazioni locali generate utilizzando  locale –a . Output di esempio C\nC.UTF-8\nen_IN\nen_IN.utf8\nen_US.utf8\nPOSIX Copiare l'impronta digitale del pacchetto OpenXPKI utilizzando  nano /home/Release.key . Per questo esempio, copiare la chiave in  /home . Digitare  55D89776 006F632B E0196E3E D2495509 BAFDDC74 22FEAAD2 F055074E 0FE3A724  come valore. Eseguire questo comando: gpg --print-md sha256 /home/Release.key Aggiungere il pacchetto utilizzando il comando  wget https://packages.openxpki.org/v3/debian/Release.key -O - | apt-key add - . Aggiungere il repository all'elenco di origini (buster) utilizzando  echo \" deb http://packages.openxpki.org/v3/debian/ buster release\" > /etc/apt/sources.list.d/openxpki.list , quindi  apt update . Installare l'associazione MySQL e Perl MySQL utilizzando  apt install mariadb-server libdbd-mariadb-perl . Installare apache2.2-common utilizzando  apt install apache2 . In  nano /etc/apt/sources.list , installare il modulo fastcgi per velocizzare l'interfaccia utente. si consiglia di utilizzare  mod-fcgid . Aggiungere la riga  deb http://http.us.debian.org/debian/ buster main  nel file, quindi salvarlo. Eseguire questi comandi: apt-get update apt install libapache2-mod-fcgid Abilitare il modulo fastcgi utilizzando  a2enmod fcgid . Installare il pacchetto di base OpenXPKI utilizzando  apt install libopenxpki-perl openxpki-cgi-session-driver openxpki-i18n . Riavviare il server  Apache  utilizzando  service apache2 restart . Controllare se l'installazione è avvenuta correttamente utilizzando  openxpkiadm version . se l'installazione è riuscita, il sistema mostra la versione di OpenXPKI installata. Ad esempio,  Version (core): 3.18.2 . Creare il database vuoto, quindi assegnare l'utente del database utilizzando  mariadb -u root -p . Questo comando deve essere digitato nel client. In caso contrario, non è possibile immettere la password. Digitare la password per MySQL. Per questo esempio,  root  è l'utente MySQL. openxpki  è l'utente su cui è installato OpenXPKI. CREATE DATABASE openxpki CHARSET utf8; \nCREATE USER 'openxpki'@'localhost' IDENTIFIED BY 'openxpki';\nGRANT ALL ON openxpki.* TO 'openxpki'@'localhost';\nflush privileges; Se il servizio MySQL non è in esecuzione, eseguire  /etc/init.d/mysql start  per avviarlo. Digitare  quit  per uscire da MySQL. Memorizzare le credenziali usate in  /etc/openxpki/config.d/system/database.yaml . Contenuto del file di esempio main:\ndebug: 0\ntype: MariaDB\nname: openxpki\nhost: localhost\nport: 3306\nuser: openxpki \npasswd: openxpki modificare  user  e  passwd  in modo che corrispondano al nome utente e alla password per MariaDB. Salvare il file. Per uno schema di database vuoto, eseguire  zcat /usr/share/doc/libopenxpki-perl/examples/schema-mariadb.sql.gz | \\ mysql -u root --password --database openxpki  dal file di schema fornito. Digitare la password per il database. installazione di OpenXPKI CA OpenXPKI CA installazione"},{"UUID":"dfced5fb-53a9-4699-86a0-3dde47ef1cbb","title":"Configurazione di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Configurazione di OpenXPKI CA mediante","descFull":"Configurazione di OpenXPKI CA mediante lo script predefinito lo script predefinito configura solo l'area di autenticazione predefinita, ovvero  ca-one . CDP e CRL non sono configurati. Eseguire lo script utilizzando  bash /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh . Confermare le impostazioni utilizzando  openxpkiadm alias --realm democa . Output di esempio === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set Controllare se l'installazione è avvenuta correttamente utilizzando  openxpkictl start . Output di esempio Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Effettuare le seguenti operazioni per accedere al server OpenXPKI: Nel browser Web, digitare  http://ipaddress/openxpki/ . Aggiungere il nome utente e le password corrispondenti in un file  userdb.yaml . Per aggiungere il nome utente e la password, procedere come segue: Eseguire il check-out a  /home/pkiadm  e quindi  nano userdb.yaml . Incollare quanto segue: estRA:  \n       digest:\"{ssha256}somePassword”\n       role: RA Operator in questo caso estRA si riferisce al nome utente. Per generare la password, digitare  openxpkiadm hashpwd . Quando viene visualizzato un messaggio che richiede la password e appare una password crittografata ssha256, copiarla e incollarla nel digest di qualsiasi utente. i ruoli disponibili nell'accesso Operatore sono RA Operator CA Operator e User. Immettere il nome utente e la password. Creare una richiesta di certificato, quindi testarla. configurazione di OpenXPKI CA mediante lo script predefinito OpenXPKI CA configurazione mediante lo script predefinito"},{"UUID":"6280b45a-5770-403a-9b6d-62be79f590d3","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Panoramica prima di iniziare, assicurarsi","descFull":"Panoramica prima di iniziare, assicurarsi di disporre di una conoscenza di base sulla creazione di certificati OpenSSL. Per configurare manualmente OpenXPKI CA, creare i seguenti certificati: Certificato CA radice. Per ulteriori informazioni, vedere  . Certificato del firmatario CA, firmato dalla CA radice. Per ulteriori informazioni, vedere  . Certificato del vault di dati, autofirmato. Per ulteriori informazioni, vedere  . Certificato Web, firmato dal certificato del firmatario. Per ulteriori informazioni, vedere  . Quando si seleziona l'hash della firma, utilizzare SHA256 o SHA512. La modifica della dimensione della chiave pubblica è opzionale. Per la versione 3.10 o successiva, è possibile gestire le chiavi direttamente utilizzando il comando openxpkiadm alias: Eseguire  mkdir -p /etc/openxpki/local/key  per creare la directory. La posizione predefinita della directory è  /etc/openxpki/local/keys . Eseguire  openxpkictl start  per avviare il server. In questo esempio, utilizziamo la directory  /etc/certs/openxpki_democa/  per la generazione dei certificati. Tuttavia, è possibile utilizzare qualsiasi directory. configurazione manuale di OpenXPKI CA OpenXPKI CA configurazione manuale"},{"UUID":"8b66c19f-84bf-4501-9275-15417548a58a","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Creazione di un file di","descFull":"Creazione di un file di configurazione OpenSSL Il file di configurazione OpenSSL contiene le estensioni X.509 per la generazione e la firma delle richieste di certificato. Eseguire questo comando: nano /etc/certs/openxpki_democa/openssl.conf se il server è raggiungibile tramite il nome di dominio completo (FQDN), utilizzare il DNS del server anziché il suo indirizzo IP. File di esempio # x509_extensions               = v3_ca_extensions\n# x509_extensions               = v3_issuing_extensions\n# x509_extensions               = v3_datavault_extensions\n# x509_extensions               = v3_scep_extensions\n# x509_extensions               = v3_web_extensions\n# x509_extensions               = v3_ca_reqexts # not for root self-signed, only for issuing\n## x509_extensions              = v3_datavault_reqexts # not required self-signed\n# x509_extensions               = v3_scep_reqexts\n# x509_extensions               = v3_web_reqexts\n\n[ req ]\ndefault_bits            = 4096\ndistinguished_name      = req_distinguished_name\n\n[ req_distinguished_name ]\ndomainComponent         = Domain Component\ncommonName              = Common Name\n\n[ v3_ca_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\n\n[ v3_datavault_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\n\n[ v3_scep_reqexts ]\nsubjectKeyIdentifier    = hash\n\n[ v3_web_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\n\n[ v3_ca_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_issuing_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer:always\ncrlDistributionPoints   = URI:https://FQDN of your system/openxpki/CertEnroll/MYOPENXPKI.crl\nauthorityInfoAccess     = caIssuers;URI:https://FQDN of your system/download/MYOPENXPKI.crt\n\n[ v3_datavault_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_scep_extensions ]\nsubjectKeyIdentifier    = hash\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid,issuer\n\n[ v3_web_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\nbasicConstraints        = critical,CA:FALSE\nsubjectAltName          = DNS:FQDN of est server\ncrlDistributionPoints   = URI:https://FQDN of your system/openxpki/CertEnroll/MYOPENXPKI_ISSUINGCA.cr\nauthorityInfoAccess     = caIssuers;URI:https://FQDN of your system/download/MYOPENXPKI_ISSUINGCA.crt\n Sostituire l'indirizzo IP e il nome del certificato CA in base alle informazioni delle proprie impostazioni. Salvare il file. file di configurazione OpenSSL creazione"},{"UUID":"fe9131bc-bd50-4ff5-863b-97ee42c46a18","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Creazione di un file di","descFull":"Creazione di un file di password per le chiavi dei certificati Eseguire questo comando: nano /etc/certs/openxpki_democa/pd.pass Digitare la propria password. Salvare il file. file di password per le chiavi dei certificati creazione chiavi dei certificati creazione di file di password"},{"UUID":"cd301b56-619b-439c-bf1c-f9cb8c85d019","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Creazione di un certificato CA","descFull":"Creazione di un certificato CA radice È possibile creare un certificato CA radice autofirmato o generare una richiesta di certificato e quindi ottenerne la firma dalla CA radice. sostituire la lunghezza della chiave, l'algoritmo di firma e il nome del certificato con i valori appropriati. Eseguire questo comando: openssl genrsa -out /etc/certs/openxpki_democa/ca-root-1.key -passout file:/etc/certs/openxpki_democa/pd.pass 4096 Sostituire il soggetto della richiesta con le informazioni della propria CA utilizzando  openssl req -new -key /etc/certs/openxpki_democa/ca-root-1.key -out /etc/certs/openxpki_democa/ca-root-1.csr . Ottenere il certificato firmato dalla CA radice utilizzando  openssl req -config /etc/certs/openxpki_democa/openssl.conf -extensions v3_ca_extensions - x509 -days 3560 -in /etc/certs/openxpki_democa/ca-root-1.csr -key /etc/certs/openxpki_democa/ca-root-1.key -out /etc/certs/openxpki_democa/ca-root-1.crt - sha256 . Accedere a  /etc/certs/openxpki_democa/  in cui è salvato  ca-root-1.crt . Eseguire questo comando: openxpkiadm certificate import --file ca-root-1.crt certificati CA radice creazione"},{"UUID":"a0f8d3b6-e911-4709-b323-778f24e18dd2","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Creazione di un certificato del","descFull":"Creazione di un certificato del firmatario sostituire la lunghezza della chiave, l'algoritmo di firma e il nome del certificato con i valori appropriati. Eseguire questo comando: openssl genrsa -out /etc/certs/openxpki_democa/ca-signer-1.key -passout file:/etc/certs/openxpki_democa/pd.pass 4096 Modificare l'oggetto della richiesta con le informazioni della propria CA utilizzando  openssl req -config /etc/certs/openxpki_democa/openssl.conf -reqexts v3_ca_reqexts -new -key /etc/certs/openxpki_democa/ca-signer-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ISSUINGCA -out / etc/certs/openxpki_democa/ca-signer-1.csr . Ottenere il certificato firmato dalla CA radice utilizzando  openssl x509 -req -extfile /etc/certs/openxpki_democa/openssl.conf -extensions v3_issuing_extensions -days 3650 -in /etc/certs/openxpki_democa/ca-signer-1.csr -CA /etc/certs/openxpki_democa/ca-root-1.crt -CAkey /etc/certs/openxpki_democa/ca-root-1.key -CAcreateserial -out /etc/certs/openxpki_democa/ca-signer-1.crt -sha256 . Eseguire questo comando: openxpkiadm alias --realm democa --token certsign --file ca-signer-1.crt --key ca-signer-1.key certificati del firmatario creazione"},{"UUID":"f1f58e01-d22c-4d29-a477-8af02cbb634e","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Creazione di un certificato del","descFull":"Creazione di un certificato del vault Il certificato del vault è autofirmato. sostituire la lunghezza della chiave, l'algoritmo di firma e il nome del certificato con i valori appropriati. Eseguire questo comando: openssl req -new -x509 -keyout vault.key -out vault.crt -days 1100 -config /etc/certs/openxpki_democa/openssl.conf Modificare l'oggetto della richiesta con le informazioni della propria CA utilizzando  openxpkiadm certificate import --file vault.crt . Eseguire questo comando: openxpkiadm alias --realm democa --token datasafe --file vault.crt --key vault.key fornire i valori necessari, ma mantenere  /CN=DataVault  come oggetto. certificati del vault creazione"},{"UUID":"7de8bfc0-f0d7-44f3-a5d8-905fe531912b","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Creazione di un certificato Web","descFull":"Creazione di un certificato Web Eseguire questo comando: openssl genrsa -out /etc/certs/openxpki_democa/web-1.key -passout file:/etc/certs/openxpki_democa/pd.pass 4096 Modificare l'oggetto della richiesta con le informazioni della propria CA utilizzando  openssl req -config /etc/certs/openxpki_democa/openssl.conf -reqexts v3_web_reqexts -new -key /etc/certs/openxpki_democa/web-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=FQDN of your system -out /etc/certs/openxpki_democa/web-1.csr . Eseguire questo comando: openssl x509 -req -extfile /etc/certs/openxpki_democa/openssl.conf -extensions v3_web_extensions -days 900 -in /etc/certs/openxpki_democa/web-1.csr -CA /etc/certs/openxpki_democa/ca-signer-1.crt -CAkey /etc/certs/openxpki_democa/ca-signer-1.key -CAcreateserial -out /etc/certs/openxpki_democa/web-1.crt -sha256 certificato Web creazione"},{"UUID":"fcf1be7a-9050-4978-a0d4-4e8695ce7d0c","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Configurazione del server Web Eseguire","descFull":"Configurazione del server Web Eseguire questi comandi: a2enmod ssl rewrite headers a2ensite openxpki a2dissite 000-default default-ssl mkdir -m755 -p /etc/openxpki/tls/chain cp /etc/certs/openxpki_democa/ca-root-1.crt /etc/openxpki/tls/chain/ cp /etc/certs/openxpki_democa/ca-signer-1.crt /etc/openxpki/tls/chain/ c_rehash /etc/openxpki/tls/chain/ mkdir -m755 -p /etc/openxpki/tls/endentity mkdir -m700 -p /etc/openxpki/tls/private cp /etc/certs/openxpki_democa/web-1.crt /etc/openxpki/tls/endentity/openxpki.crt cat /etc/certs/openxpki_democa/ca-signer-1.crt >> /etc/openxpki/tls/endentity/openxpki.crt openssl rsa -in /etc/certs/openxpki_democa/web-1.key -passin file:/etc/certs/openxpki_democa/pd.pass -out /etc/openxpki/tls/private/openxpki.pem chmod 400 /etc/openxpki/tls/private/openxpki.pem Riavviare il servizio OpenXPKI utilizzando  apache2 restart . Eseguire questo comando per verificare che l'importazione dei file abbia avuto esito positivo: openxpkiadm alias --realm democa Output di esempio === functional token ===\nca-signer (certsign):\n  \t\tAlias     : ca-signer-2\n  \t\tIdentifier: XjC6MPbsnyfLZkI9Poi9vm4Z5rk\n \t\t NotBefore : 2022-04-06 10:03:01\n  \t\tNotAfter  : 2032-04-03 10:03:01\n\nvault (datasafe):\n  \t\tAlias     : vault-2\n  \t\tIdentifier: G8ekluAsskGVC0N-jZhB2n9kvdM\n  \t\tNotBefore : 2022-04-06 09:53:57\n  \t\tNotAfter  : 2025-04-10 09:53:57\n\nscep (scep):\n  \t\tnot set\n\nratoken (cmcra):\n  \t\tnot set\n\n=== root ca ===\ncurrent root ca:\n  \t\tAlias     : root-2\n  \t\tIdentifier: prTHU5vCfcJuCnQWyb5wUknvXQM\n  \t\tNotBefore : 2022-04-06 09:40:27\n  \t\tNotAfter  : 2032-01-04 09:40:27\n configurazione del server Web server Web impostazione"},{"UUID":"a35f8bfb-bae3-4bc4-87b6-e6f16f5fea53","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Rendere la password della chiave","descFull":"Rendere la password della chiave del certificato disponibile per OpenXPKI Modificare il valore nel file  nano /etc/openxpki/config.d/system/crypto.yaml . Rimuovere il commento dalla cache:  daemon under secret: default : secret:\n  default:\n    label: Global Secret group\n    export: 0\n    method: literal\n    value: root\n    cache: daemon password della chiave del certificato rendere disponibile per openXPKI"},{"UUID":"2c6368a8-a76a-4626-b02d-72d05136c9ea","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Avvio di OpenXPKI Eseguire il","descFull":"Avvio di OpenXPKI Eseguire il comando  openxpkictl start . Output di esempio Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Accedere al server OpenXPKI: Nel browser Web, digitare  http://ipaddress/openxpki/ . Aggiungere i nomi utente e le password corrispondenti in un file  userdb.yaml : Eseguire il check-out a /home/pkiadm  e quindi  nano userdb.yaml . Incollare quanto segue: estRA:  \n       digest:\"{ssha256}somePassword”\n       role: RA Operator qui  estRA  si riferisce al nome utente. Per generare la password, digitare  openxpkiadm hashpwd . Viene visualizzato un messaggio che mostra la password e una password crittografata ssha256. Copiare la password, quindi incollarla nel digest di qualsiasi utente. l'accesso Operatore ha due ruoli disponibili preconfigurati: RA Operator, CA Operator e User. Digitare il nome utente e la password. Creare una richiesta di certificato, quindi testarla. OpenXPKI avvio"},{"UUID":"0c95592c-3797-473a-a9cd-66412d74ffd4","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Generazione delle informazioni del CRL","descFull":"Generazione delle informazioni del CRL se il server è raggiungibile tramite il nome di dominio completo (FQDN), utilizzare il DNS del server anziché il suo indirizzo IP. Arrestare il servizio OpenXPKI utilizzando  openxpkictl stop . In  nano /etc/openxpki/config.d/realm/democa/publishing.yaml , aggiornare la sezione  connectors: cdp  come segue: class: Connector::Builtin::File::Path\nLOCATION: /var/www/openxpki/CertEnroll/\nfile: \"[% ARGS.0 %].crl\"\ncontent: \"[% pem %]\" In  nano /etc/openxpki/config.d/realm/democa/profile/default.yaml , aggiornare quanto segue: Sezione crl_distribution_points:  sezione critical: 0\nuri:\n    - https://FQDN of the est/openxkpi/CenrtEnroll/[% ISSUER.CN.0 %].crl\n    - ldap://localhost/[% ISSUER.DN %]\n Sezione authority_info_access:  sezione critical: 0\nca_issuers: http://FQDN of the est/download/MYOPENXPKI.crt\nocsp: http://ocsp.openxpki.org/ Modificare l'indirizzo IP e il nome del certificato CA in base al proprio server CA. il percorso authority_info_access (AIA) viene salvato nella cartella  Download , ma è possibile impostare la posizione in base alle proprie preferenze. In  nano /etc/openxpki/config.d/realm/democa/crl/default.yaml , effettuare le seguenti operazioni: Se necessario, aggiornare  nextupdate  e  renewal . Aggiungere  ca_issuers  alla seguente sezione: extensions:\n    \t\tauthority_info_access:\n        \t\t\tcritical: 0\n        \t\t\t# ca_issuers and ocsp can be scalar or list\n        \t\t\tca_issuers: https://FQDN of the est/download/MYOPENXPKI.crt\n       \t\t\t#ocsp: http://ocsp.openxpki.org/\n Modificare l'indirizzo IP e il nome del certificato CA in base al proprio server CA. Avviare il servizio OpenXPKI utilizzando  openxpkictl start . informazioni CRL generazione"},{"UUID":"39886ec2-9983-4f9a-9976-a95f82c46d8b","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Pubblicazione delle informazioni CRL Dopo","descFull":"Pubblicazione delle informazioni CRL Dopo aver creato i CRL, è necessario pubblicarli affinché tutti possano accedervi. Arrestare il servizio Apache utilizzando  service apache2 stop . Creare una directory  CertEnroll  per il CRL nella directory  /var/www/openxpki/ . Impostare  openxpki  come proprietario di questa directory, quindi configurare le autorizzazioni per consentire ad Apache la lettura e l'esecuzione e agli altri servizi la sola lettura. chown openxpki /var/www/openxpki/CertEnroll chmod 755 /var/www/openxpki/CertEnroll Aggiungere un riferimento al file Apache alias.conf utilizzando  nano /etc/apache2/mods-enabled/alias.conf . Dopo la sezione  <Directory \"/usr/share/apache2/icons\"> , aggiungere quanto segue:         \tAlias /CertEnroll/ \"/var/www/openxpki/CertEnroll/\"\n         \t<Directory \"/var/www/openxpki/CertEnroll\">\n               Options FollowSymlinks\n               AllowOverride None\n               Require all granted\n         \t</Directory> Aggiungere un riferimento nel file apache2.conf utilizzando  nano /etc/apache2/apache2.conf . Aggiungere quanto segue nella sezione  Apache2 HTTPD server :          \t<Directory /var/www/openxpki/CertEnroll>\n               Options FollowSymlinks\n               AllowOverride None\n               Allow from all\n         \t</Directory> Avviare il servizio Apache utilizzando  service apache2 start . informazioni CRL pubblicazione"},{"UUID":"a44e94ba-7920-41e1-bafe-6bd4f24a899b","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Abilitazione dell'approvazione automatica delle richieste","descFull":"Abilitazione dell'approvazione automatica delle richieste di certificato in OpenXPKI CA Arrestare il servizio OpenXPKI utilizzando  openxpkictl stop . In  /etc/openxpki/config.d/realm/democa/est/default.yaml , aggiornare la sezione  eligible:  come segue: Precedente contenuto eligible:\n\t\t\tinitial:\n\t\t\t\tvalue@: connector:scep.generic.connector.initial\n       \t\targs: '[% context.cert_subject_parts.CN.0 %]'\n       \t\texpect:\n       \t\t\t- Build\n       \t\t\t- New Nuovo contenuto eligible:\n\t\t\tinitial:\n\t\t\t\tvalue: 1\n\t\t\t\t# value@: connector:scep.generic.connector.initial\n\t\t\t\t# args: '[% context.cert_subject_parts.CN.0 %]'\n\t\t\t\t# expect:\n\t\t\t\t#\t- Build\n\t\t\t\t#\t- New Esaminare lo spazio e il rientro nel file script. Per approvare manualmente i certificati, inserire un commento per  value: 1 , quindi rimuovere il commento dalle altre righe in cui era stato in precedenza inserito. Salvare il file. Avviare il servizio OpenXPKI utilizzando  openxpkictl start . approvazione automatica delle richieste di certificato abilitazione in OpenXPKI CA richieste di certificato in OpenXPKI CA approvazione automatica"},{"UUID":"c6d438c5-f5fb-4487-9a17-12e3a5762949","title":"Configurazione manuale di OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Modifica dei dettagli per abilitare","descFull":"Modifica dei dettagli per abilitare il download di ca-certs Eseguire questo comando: nano /usr/lib/cgi-bin/est.fcgi Sostituire  my $mime = \"application/pkcs7-mime; smime-type=certs-only\";  con  my $mime = \"application/pkcs7-mime\"; . Avviare il servizio OpenXPKI utilizzando  openxpkictl . download di ca‑certs modifica dei dettagli per l'abilitazione"},{"UUID":"4b0d1c80-7a73-4faf-8c3f-393e435b2b08","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-EST-group.html","desc":"Copia e impostazione della directory","descFull":"Copia e impostazione della directory Creare una directory, ossia  democa2 , per la seconda area di autenticazione all'interno di  /etc/openxpki/config.d/realm . Copiare la struttura di directory di esempio  /etc/openxpki/config.d/realm/ca-one  in una nuova directory ( cp -r /etc/openxpki/config.d/realm.tpl/*/etc/openxpki/config.d/realm/democa2 ) all'interno della directory dell'area di autenticazione. In  /etc/openxpki/config.d/system/realms.yaml , aggiornare la seguente sezione: Precedente contenuto # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\ndemoca:\n    label: Verbose name of this realm\n    baseurl: https://pki.example.com/openxpki/\n\n#democa2:\n#    label: Verbose name of this realm\n#    baseurl: https://pki.acme.org/openxpki/ Nuovo contenuto # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\ndemoca:\n    label: Example.org Demo CA\n    baseurl: https://pki.example.com/openxpki/\n\ndemoca2:\n    label: Example.org Demo CA2\n    baseurl: https://pki.example.com/openxpki/ Salvare il file. copia della directory impostazione della directory directory copia e impostazione"},{"UUID":"55e7cf1e-ee4f-4b11-a8f3-58f6f88dcc8a","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-EST-group.html","desc":"Configurazione dell'endpoint EST per più","descFull":"Configurazione dell'endpoint EST per più aree di autenticazione È possibile configurare l'endpoint EST con una tupla composta dalla parte dell'URI relativa all'authority dall'etichetta opzionale (ad esempio www.example.com:80 e arbitraryLabel1). Nelle seguenti istruzioni utilizziamo due aree di autenticazione PKI, ovvero  democa  e  democa2 . Copiare il file di configurazione predefinito in  cp /etc/openxpki/est/default.conf /etc/openxpki/est/democa.conf . assegnare al file il nome  democa.conf . In  nano /etc/openxpki/est/democa.conf , modificare il valore dell'area di autenticazione in  realm=democa . In base alle esigenze, potrebbe essere necessario rimuovere i commenti dalle righe corrispondenti per le sezioni  simpleenroll ,  simplereenroll ,  csrattrs  e  cacerts . Mantenere i commenti delle sezioni relative all'ambiente. Eseguire la stessa operazione per  default.conf . Creare un altro file di configurazione in  cp /etc/openxpki/est/default.conf /etc/openxpki/est/democa2.conf . assegnare al file il nome  democa2.conf . In  nano /etc/openxpki/est/democa2.conf , modificare il valore dell'area di autenticazione in  realm=democa2 . In base alle esigenze, potrebbe essere necessario rimuovere i commenti dalle righe corrispondenti per le sezioni  simpleenroll ,  simplereenroll ,  csrattrs  e  cacerts . Mantenere i commenti delle sezioni relative all'ambiente. Copiare il file  default.yaml  nelle seguenti posizioni: cp /etc/openxpki/config.d/realm/democa/est/default.yaml /etc/openxpki/config.d/realm/democa/est/democa.yaml assegnare al file il nome  democa.yaml . Copiare il file  default.yaml  nelle seguenti posizioni: cp /etc/openxpki/config.d/realm/democa2/est/default.yaml /etc/openxpki/config.d/realm/democa2/est/democa2.yaml assegnare al file il nome  democa2.yaml . Riavviare il servizio OpenXPKI utilizzando  openxpkictl restart . Selezionare i seguenti URL per aprire il server EST corrispondente a un'area di autenticazione tramite un browser Web: democa :  http://ipaddress/est/democa democa2 :  http://ipaddress/est/democa2 Se si desidera differenziare tra le credenziali di accesso e i modelli di certificato predefiniti per aree di autenticazione PKI diverse, potrebbe essere necessaria una configurazione avanzata. configurazione degli endpoint EST per più aree di autenticazione endpoint EST configurazione per più aree di autenticazione"},{"UUID":"6887b4cf-ff7b-488e-a3ff-2bc999a7175c","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-EST-group.html","desc":"Creazione di un certificato del","descFull":"Creazione di un certificato del firmatario Le seguenti istruzioni mostrano come generare un certificato del firmatario nella seconda area di autenticazione. È possibile utilizzare gli stessi certificati radice e del vault presenti nella prima area di autenticazione. Creare un file di configurazione OpenSSL in  nano /etc/certs/openxpki_democa2/openssl.conf . modificare il nome comune del certificato in modo che l'utente possa distinguere facilmente tra i diversi certificati per le diverse aree di autenticazione. I file di certificato vengono creati nella directory  /etc/certs/openxpki_democa2/ . Accedere alla directory del certificato del vault nella prima area di autenticazione, quindi importare il certificato dalla prima area di autenticazione. Eseguire questo codice: openxpkiadm alias --realm democa2 --token datasafe --file vault.crt certificati creazione certificati del firmatario creazione"},{"UUID":"82b65129-417f-4bef-8b92-d9fc2f4f7879","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-EST-group.html","desc":"Creazione di un file di","descFull":"Creazione di un file di password per le chiavi dei certificati Eseguire questo comando: nano /etc/certs/openxpki_democa2/pd.pass Digitare la propria password. Creare un certificato del firmatario. Per ulteriori informazioni, vedere  . Controllare se l'importazione è avvenuta correttamente utilizzando  openxpkiadm alias --realm democa2 . se la password della chiave del certificato è stata modificata durante la creazione del certificato, aggiornare  nano /etc/openxpki/config.d/realm/democa2/crypto.yaml . Generare i CRL per la seconda area di autenticazione. Per ulteriori informazioni, vedere  . assicurarsi di utilizzare il nome del certificato CA corretto in base all'area di autenticazione. Pubblicare i CRL per questa area di autenticazione. Per ulteriori informazioni, vedere  . Riavviare il servizio OpenXPKI utilizzando  openxpkictl restart . Output di esempio Stopping OpenXPKI\nStopping gracefully, 3 (sub)processes remaining...\nDONE.\nStarting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. creazione di file di password per le chiavi dei certificati file di password per le chiavi dei certificati creazione chiavi dei certificati creazione di file di password"},{"UUID":"99f8c211-ce70-47f9-b293-ae9d51ca43d8","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-EST-group.html","desc":"Abilitazione della presenza contemporanea di","descFull":"Abilitazione della presenza contemporanea di più certificati attivi con lo stesso oggetto Per impostazione predefinita, in OpenXPKI può essere attivo un solo certificato con lo stesso nome oggetto alla volta. Tuttavia, quando si applicano più certificati con nome, devono essere presenti più certificati attivi con lo stesso nome oggetto alla volta. In  /etc/openxpki/config.d/realm/REALM NAME/est/< REALM NAME >.yaml , nella sezione  policy , modificare il valore di  max_active_certs  da  1  a  0 . REAL NAME è il nome dell'area di autenticazione. Ad esempio,  ca‑one . Esaminare lo spazio e il rientro nel file script. Riavviare il servizio OpenXPKI utilizzando  openxpkictl restart . più certificati attivi con lo stesso oggetto abilitazione certificati con lo stesso oggetto abilitazione"},{"UUID":"1a73226a-79a3-4b90-9b7e-b441b73e1e7c","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-EST-group.html","desc":"Impostazione del numero di porta","descFull":"Impostazione del numero di porta predefinito per OpenXPKI CA Per impostazione predefinita, Apache è in ascolto sulla porta numero 443 per https. Impostare il numero di porta predefinito per OpenXPKI CA per evitare conflitti. In  /etc/apache2/ports.conf , modificare la porta 443 impostando su una qualsiasi altra porta. Ad esempio: Precedente contenuto Listen 80\n\n<IfModule ssl_module>\n   Listen 443\n</IfModule>\n\n<IfModule mod_gnutls.c>\n  Listen 443\n</IfModule> Nuovo contenuto Listen 80\n\n<IfModule ssl_module>\n   Listen 9443\n</IfModule>\n\n<IfModule mod_gnutls.c>\n  Listen 9443\n</IfModule> In  /etc/apache2/sites-available/openxpki.conf , aggiungere o modificare la sezione  VirtualHost  per associare una nuova porta. Ad esempio,  <VirtualHost *:443>  in  <Virtualhost *:9443> . In   /etc/apache2/sites-available/default-ssl.conf , aggiungere o modificare la sezione  VirtualHost_default  per associare una nuova porta. Ad esempio, modificare  <VirtualHost *:443>  in  <Virtualhost *:9443> . Riavviare il server Apache utilizzando  systemctl restart apache2 . se viene richiesta la passphrase  SSL/TLS , digitare la password quando si aggiunge il certificato del server Web TLS nel server EST. In  tinddopenxpkiweb01.dhcp.dev.lexmark.com:9443 (RSA): , immettere la passphrase per le chiavi  SSL/TLS . Per verificare lo stato, eseguire  netstat -tlpn| grep apache . L'URL SCEP di OpenXPKI è ora  https://ipaddress , mentre l'URL Web è  FQDN:9443/openxpki . numeri di porta predefiniti per OpenXPKI CA modifica numeri di porta predefiniti modifica per OpenXPKI CA numeri di porta predefiniti per OpenXPKI CA modifica"},{"UUID":"36b1704f-b9d2-4eff-8090-f24471fa8164","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-EST-group.html","desc":"Abilitazione dell'autenticazione di base Eseguire","descFull":"Abilitazione dell'autenticazione di base Eseguire questo comando: apt -y install apache2-utils Creare un account utente che abbia accesso al server. Immettere i seguenti dettagli: htpasswd -c /etc/apache2/.htpasswd <username>\n                New password:     \n                Re-type new password:\n                Adding password for user <username> Passare alla directory  cd /etc/apache2/sites-enabled/ . In  nano openxpki.conf , aggiungere le seguenti righe in  <Virtualhost *: 443 block> : #HTTPS BASIC AUTH FOR LABELS\nLocation /.well-known/est/*/simpleenroll\n    AuthType Basic\n    AuthName \"estrealm\"\n    AuthUserFile /etc/apache2/.htpasswd\n    require valid-user\n    </Location>\n    #HTTPS BASIC AUTH FOR NO LABEL\n    <Location /.well-known/est/simpleenroll>\n    AuthType Basic\n    AuthName \"estrealm\"\n    AuthUserFile /etc/apache2/.htpasswd\n    require valid-user\n    </Location> Aggiungere   ErrorDocument 401%{unescape:%00}   prima di  SSLEngine  nello stesso blocco host virtuale. Esempio ServerAlias *\nDocumentRoot /var/www/\nErrorDocument 401 %{unescape:%00}\nSSLEngine On Riavviare il  servizio apache2  utilizzando  service apache2 restart . l'autenticazione di base funziona utilizzando il nome utente e la password indicati sopra. abilitazione dell'autenticazione di base autenticazione di base abilitazione"},{"UUID":"3b245844-b93f-4869-9b5f-b86622a9dbe2","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-EST-group.html","desc":"Abilitazione dell'autenticazione con certificato client","descFull":"Abilitazione dell'autenticazione con certificato client Passare alla seguente directory:  cd /etc/apache2/sites-enabled/ . Per l'host richiesto in  nano openxpki.conf , aggiungere  SSLVerifyClient require . Ad esempio, se si utilizza la porta 443, modificare la sezione  Virtualhost  in: <VirtualHost *:443>\nSSLVerifyClient require\n</VirtualHost> Rimuovere il comando  SSLVerifyClient opzional_no_ca . Salvare il file, quindi digitare  quit  per uscire da MySQL. Passare alla seguente directory:  cd /etc/openxpki/config.d/realm/democa/est . Aprire  default.yaml  e  democa.yaml . Se l'etichetta è diversa, modificare il file YAML. Eseguire questo comando: vi default.yaml Nella sezione  authorized_signer , aggiungere quanto segue: authorized_signer:\nrule2:\n\t\t\tsubject: CN=,. Ad esempio, se il nome dell'oggetto del certificato client è  test123 , aggiungere quanto segue nella sezione  authorized_signer : authorized_signer:\nrule1:\n\t\t# Full DN\t\n\t\tsubject: CN=.+:pkiclient,.\nrule2:\t\n\t\tsubject: CN=test123,.* Salvare il file, quindi digitare  quit  per uscire da MySQL. Riavviare il servizio OpenXPKI utilizzando  openxpkictl restart . Avviare il servizio Apache utilizzando  service apache2 restart . autenticazione di base abilitazione"},{"UUID":"66550323-8185-456f-95e0-e4a7ac1d6bba","title":"Creazione di una seconda area di autenticazione","link":"managing-certificates-using-EST-group.html","desc":"Che cosa causa dell'errore di","descFull":"Che cosa causa dell'errore di SAN non corrispondente che impedisce al sistema di recuperare il CRL? L'errore di SAN non corrispondente può verificarsi quando si abilitano le informazioni CRL. Questo errore indica che l'IP o il nome host non corrispondono al valore della SAN nel certificato Web. Per evitare di ricevere questo errore, utilizzare il nome di dominio completo (FQDN) nel percorso del CRL anziché l'IP. È anche possibile configurare il certificato Web e utilizzare l'FQDN del sistema nel campo SAN. Perché i token ca-signer-1 e vault-1 sono offline? Se nella pagina  Stato sistema  risulta che i token ca-signer-1 e vault-1 sono offline, procedere come segue: In  /etc/openxpki/config.d/realm/realm name/crypto.yaml , modificare il valore della chiave corrispondente. Riavviare il servizio OpenXPKI. domande frequenti FAQ"},{"UUID":"5f49f39c-e881-49e6-815d-8e6e2a818bca","title":"Gestione degli avvisi della stampante","link":"managing-printer-alerts-overview-topic.html","desc":"Panoramica Gli avvisi vengono attivati","descFull":"Panoramica Gli avvisi vengono attivati quando una stampante richiede un intervento. Le azioni consentono di inviare e-mail personalizzate o di eseguire script quando viene emesso un avviso. Gli eventi definiscono quali azioni vengono eseguite quando sono attivi avvisi specifici. Per effettuare la registrazione per gli avvisi da una stampante, creare azioni, quindi associarle a un evento. Assegnare l'evento alle stampanti da monitorare. questa funzione non è applicabile alle stampanti protette. gestione degli avvisi della stampante, panoramica panoramica gestione degli avvisi della stampante"},{"UUID":"199d646a-9363-40c4-9c94-409d403dcb45","title":"Gestione degli avvisi della stampante","link":"creating-action-topic.html","desc":"Creazione di un'azione Un'azione è","descFull":"Creazione di un'azione Un'azione è una notifica e-mail o un registro di visualizzazione eventi. Le azioni assegnate agli eventi vengono attivate quando viene emesso un avviso della stampante. Nel menu  Stampanti  fare clic su  Eventi e azioni Azioni Crea . Digitare un nome univoco per l'azione e la relativa descrizione. Selezionare un tipo di azione. E-mail prima di iniziare, accertarsi che le impostazioni e-mail siano configurate. Per ulteriori informazioni, vedere  . Nel menu  Tipo  selezionare  E‑mail . Immettere i valori appropriati nei relativi campi. È anche possibile utilizzare i segnaposto disponibili per una parte o per tutto il titolo dell'oggetto, o come parte di un messaggio e-mail. Per ulteriori informazioni, vedere  . Fare clic su  Crea azione . Registro eventi Nel menu  Tipo  selezionare  Registro eventi . Digitare i parametri dell'evento. È inoltre possibile utilizzare i segnaposto nel menu a discesa. Per ulteriori informazioni, vedere  . Fare clic su  Crea azione . azioni creazione creazione di un'azione segnaposto azione e-mail azione registro eventi"},{"UUID":"97bdc713-a117-4f44-9689-b269e300e51c","title":"Gestione degli avvisi della stampante","link":"understanding-action-placeholders-topic.html","desc":"Comprensione segnaposto azione Utilizzare i","descFull":"Comprensione segnaposto azione Utilizzare i segnaposto disponibili nel titolo dell'oggetto o nel messaggio e-mail. I segnaposto rappresentano degli elementi variabili e vengono sostituiti con i valori effettivi una volta utilizzati. ${eventHandler.timestamp} : la data e l'ora di elaborazione dell'evento in MVE. Ad esempio,  Mar 14, 2017 1:42:24 PM . ${eventHandler.name} : il nome dell'evento. ${configurationItem.name} : il nome del sistema della stampante che ha attivato l'avviso. ${configurationItem.address} : l'indirizzo MAC della stampante che ha attivato l'avviso. ${configurationItem.ipAddress} : l'indirizzo IP della stampante che ha attivato l'avviso. ${configurationItem.ipHostname} : il nome host della stampante che ha attivato l'avviso. ${configurationItem.model} : il nome del modello della stampante che ha attivato l'avviso. ${configurationItem.serialNumber} : il numero di serie della stampante che ha attivato l'avviso. ${configurationItem.propertyTag} : l'etichetta della proprietà della stampante che ha attivato l'avviso. ${configurationItem.contactName} : il nome del contatto della stampante che ha attivato l'avviso. ${configurationItem.contactLocation} : la posizione di contatto della stampante che ha attivato l'avviso. ${configurationItem.manufacturer} : il produttore della stampante che ha attivato l'avviso. ${alert.name} : il nome dell'avviso attivato. ${alert.state} : lo stato dell'avviso. Può essere attivo o cancellato. ${alert.location} : la posizione all'interno della stampante in cui si è verificato l'avviso attivato. ${alert.type} : la gravità dell'avviso attivato, ad esempio  Avvertenza  o  Intervento richiesto . comprensione segnaposto azione Segnaposto azione informazioni azione segnaposto"},{"UUID":"03451b26-df50-4e97-bd6a-d4c236ac8784","title":"Gestione degli avvisi della stampante","link":"managing-actions-topic.html","desc":"Gestione delle azioni Nel menu","descFull":"Gestione delle azioni Nel menu Stampanti, fare clic su  Eventi e azioni Azioni . Effettuare una delle seguenti operazioni: Modificare un'azione Selezionare un'azione, quindi fare clic su  Modifica . Configurare le impostazioni. Fare clic su  Salva modifiche . Eliminare le azioni Selezionare una o più azioni. Fare clic su  Elimina , quindi confermare l'eliminazione. Effettuare il test di un'azione Selezionare un'azione, quindi fare clic su  Test . Per verificare i risultati del test, vedere i registri delle attività. Per ulteriori informazioni, vedere  . Se si sta effettuando il test di un'azione e-mail, verificare se l'e-mail è stata inviata al destinatario. gestione delle azioni azioni gestione azioni modifica azioni eliminazione azioni test modifica delle azioni eliminazione delle azioni test delle azioni"},{"UUID":"6967678a-1c45-477c-91de-17b4c1f4b7cb","title":"Gestione degli avvisi della stampante","link":"creating-event-topic.html","desc":"Creazione di un evento È","descFull":"Creazione di un evento È possibile controllare gli avvisi nel parco periferiche. Creare un evento, quindi impostare l'esecuzione di un'azione quando si verificano gli avvisi specificati. Gli eventi non sono supportati sulle stampanti protette. Nel menu Stampanti, fare clic su  Eventi e azioni Eventi Crea . Digitare un nome univoco per l'evento e la relativa descrizione. Nella sezione Avvisi, selezionare uno o più eventi. Per ulteriori informazioni, vedere  . Nella sezione Azioni, selezionare una o più azioni da eseguire quando sono attivi gli avvisi selezionati. Per ulteriori informazioni, vedere  . Consentire al sistema di eseguire azioni specifiche quando vengono cancellati gli avvisi sulla stampante. Impostare un periodo di tolleranza prima dell'esecuzione delle azioni selezionate. Se l'avviso viene cancellato durante il periodo di tolleranza, l'azione non viene eseguita. Fare clic su  Crea evento . creazione di un evento evento creazione"},{"UUID":"7c42d5df-3093-4f27-baa5-a18f64a9426c","title":"Gestione degli avvisi della stampante","link":"understanding-printer-alerts-topic.html","desc":"Informazioni sugli avvisi della stampante","descFull":"Informazioni sugli avvisi della stampante Gli avvisi vengono attivati quando una stampante richiede un intervento. I seguenti avvisi possono essere associati a un evento in MVE: Inceppamento alimentatore automatico documenti (ADF) : un documento è inceppato nell'ADF e deve essere rimosso fisicamente. Scanner: Inceppamento uscita ADF Scanner: Inceppamento carta ADF Scanner: Inceppamento inversione ADF Scanner: Carta inceppata nell'ADF rimossa Scanner: Carta ADF mancante Scanner: Inceppamento preregistrazione ADF Scanner: Inceppamento registrazione ADF Avviso scanner: sostituire tutti gli originali in caso di riavvio del processo Sportello o coperchio aperto : uno sportello della stampante è aperto e deve essere chiuso. Controlla coperchio/sportello - Mailbox Sportello aperto Avviso coperchio Coperchio chiuso Coperchio aperto Coperchio aperto o cartuccia mancante Coperchio fronte/retro aperto Coperchio ADF scanner aperto Coperchio di accesso inceppamento scanner aperto Dimensione o tipo di supporto errato : un processo è in fase di stampa e richiede il caricamento di alcuni documenti in un vassoio. Dimensioni busta errate Alimentazione manuale errata Supporto errato Dimensioni supporto errate Carica supporti Memoria piena o errore : la memoria della stampante è quasi esaurita ed è necessario applicare delle modifiche. Pagina complessa I file verranno eliminati Memoria insufficiente per fascicolazione Memoria deframmentazione insufficiente Memoria fax insufficiente Memoria insufficiente Memoria insufficiente - Possibile perdita processi in attesa Memoria insufficiente per la funzione Salva risorse Memoria piena Memoria PS insufficiente Scanner: Troppe pagine. Scansione annullata Riduzione risoluzione Malfunzionamento opzione : un'opzione collegata alla stampante è in stato di errore. Le opzioni comprendono opzioni di input, opzioni di stampa, schede font, schede di memoria flash utente, dischi e fascicolatori. Verifica allineamento/connessione Verifica connessione unità fronte/retro Verifica installazione fascicolatore/mailbox Verifica alimentazione Opzione danneggiata Opzione difettosa Scollega periferica Avviso fronte/retro Vassoio fronte/retro mancante Adattatore di rete esterno assente Avviso fascicolatore Blocco o sportello fascicolatore aperto Pannello carta fascicolatore aperto Periferica fronte/retro non compatibile Periferica di alimentazione non compatibile Periferica di uscita non compatibile Periferica sconosciuta non compatibile Installazione opzione errata Avviso alimentazione Errore di configurazione alimentazione Avviso opzione Raccoglitore di uscita pieno Raccoglitore di uscita quasi pieno Errore di configurazione uscita Opzione piena Opzione mancante Meccanismo di alimentazione carta mancante Processi di stampa su opzione Ricollega periferica Ricollega periferica di uscita Troppi vassoi di alimentazione installati Troppe opzioni installate Troppi vassoi di uscita installati Vassoio mancante Vassoio mancante durante accensione Errore di rilevamento vassoio Vassoio di alimentazione non calibrato Opzione non formattata Opzione non supportata Ricollega periferica di alimentazione Inceppamento carta : un documento è inceppato nella stampane e deve essere rimosso fisicamente. Inceppamento carta interno Avviso inceppamento Inceppamento carta Errore scanner : problema relativo allo scanner. Scanner: Cavo posteriore non collegato Carrello scanner bloccato Scanner: Pulire striscia di supporto/vetro superficie piana Scanner: Disabilitato Scanner: Coperchio superficie piana aperto Scanner: Cavo anteriore non collegato Scanner: Registrazione scanner non valida Errore mat. consumo : problema relativo a un materiale di consumo della stampante. Materiale di consumo anomalo Regione cartuccia non corrispondente Materiale di consumo difettoso Rullo di patinatura o unità di fusione mancante Cartuccia sinistra non valida o mancante Cartuccia destra non valida o mancante Materiale di consumo non valido Attivazione non riuscita Avviso materiali di consumo Inceppamento materiale di consumo Materiale di consumo mancante Maniglia di espulsione cartuccia di toner tirata Cartuccia di toner non installata in modo corretto Materiale di consumo non calibrato Materiale di consumo senza licenza Materiale di consumo non supportato Materiali di consumo mancanti : un materiale di consumo della stampante deve essere sostituito. Alimentatore vuoto Esaurito Stampante pronta per manutenzione Manutenzione programmata Materiale di consumo vuoto Materiale di consumo pieno Materiale di consumo pieno o mancante La stampante invia l'avviso sotto forma di errore o avvertenza. Se viene attivato uno di questi avvisi, l'azione associata si verifica due volte. Materiali di consumo in esaurimento : un materiale di consumo della stampante è in esaurimento. Avviso preventivo Primo basso Alimentatore basso In esaurimento Quasi vuoto Quasi basso Materiale di consumo basso Materiale di consumo quasi pieno Condizione o avviso non classificato Errore di calibrazione colore Errore trasmissione dati Errore CRC motore Avviso esterno Connessione fax interrotta Ventola bloccata Esadecimale attivo Inserire pagina fronte/retro e premere Vai Avviso interno Assistenza richiesta su adattatore di rete interno Avviso unità logica Offline Prompt Fuori linea per avvertenza Operazione non riuscita Avviso intervento operatore Errore pagina Avviso porta Errore di comunicazione porta Porta disabilitata risparmio energia Spegnimento Timeout processo PS Timeout manuale PS Installazione richiesta Errore checksum SIMM Calibrazione materiali di consumo Rilevamento patch toner non riuscito Condizione di avviso sconosciuta Configurazione sconosciuta Condizione avviso scanner sconosciuta Utenti bloccati Notifica di avvertenza informazioni sugli avvisi della stampante avvisi della stampante informazioni"},{"UUID":"b8643fef-3159-4674-8964-a05b4265f7f3","title":"Gestione degli avvisi della stampante","link":"managing-events-topic.html","desc":"Gestione degli eventi Nel menu","descFull":"Gestione degli eventi Nel menu Stampanti, fare clic su  Eventi e azioni Eventi . Effettuare una delle seguenti operazioni: Modificare un evento Selezionare un evento, quindi fare clic su  Modifica . Configurare le impostazioni. Fare clic su  Salva modifiche . Elimina eventi Selezionare uno o più eventi. Fare clic su  Elimina , quindi confermare l'eliminazione. gestione degli eventi eventi gestione eventi modifica eventi eliminazione"},{"UUID":"c64d9140-6bd5-4095-9369-5f49cefb005f","title":"Visualizzazione della cronologia e dello stato delle attività","link":"viewing-task-status-history-overview-topic.html","desc":"Panoramica Le attività sono le","descFull":"Panoramica Le attività sono le attività di gestione delle stampanti eseguite in MVE, quali rilevamento delle stampanti, controllo e applicazione delle configurazioni. La pagina  Stato  mostra lo stato di tutte le attività attualmente in esecuzione e delle attività eseguite nelle ultime 72 ore. Le informazioni sulle attività attualmente in esecuzione sono inserite nel registro. Le attività anteriori a 72 ore si possono visualizzare solo come voci di registro singole nella pagina  Registro  e si possono ricercare utilizzando gli ID corrispondenti. visualizzazione della cronologia e dello stato delle attività, panoramica panoramica visualizzazione della cronologia e dello stato delle attività"},{"UUID":"cd04d782-9e0d-4ab6-b466-8985066c673a","title":"Visualizzazione della cronologia e dello stato delle attività","link":"viewing-task-status-topic.html","desc":"Visualizzazione dello stato delle attività","descFull":"Visualizzazione dello stato delle attività Nel menu Attività, fare clic su  Stato . Lo stato dell'attività viene aggiornato in tempo reale. visualizzazione dello stato delle attività stato dell'attività visualizzazione"},{"UUID":"45c518ac-b8ba-4b1c-a8bf-7ceb0ba13eee","title":"Visualizzazione della cronologia e dello stato delle attività","link":"stopping-tasks-topic.html","desc":"Interruzione delle attività Nel menu","descFull":"Interruzione delle attività Nel menu Attività, fare clic su  Stato . Nella sezione Attività attualmente in esecuzione, selezionare una o più attività. Fare clic su  Interrompi . interruzione delle attività attività interruzione"},{"UUID":"c11b8100-4bd8-4ef6-8cd2-b7603cb74e87","title":"Visualizzazione della cronologia e dello stato delle attività","link":"viewing-logs-topic.html","desc":"visualizzazione dei registri Nel menu","descFull":"visualizzazione dei registri Nel menu Attività, fare clic su  Registri . Selezionare le categorie e i tipo di attività o un intervallo di tempo. Utilizzare il campo di ricerca per cercare più ID attività. Utilizzare le virgole per separare più ID attività o un trattino per indicare un intervallo. Ad esempio,  11, 23, 30-35 . Per esportare i risultati di ricerca, fare clic su  Esporta su CSV . visualizzazione dei registri registri visualizzazione"},{"UUID":"6c9a7da3-a4a5-4f12-95e7-e22217b93717","title":"Visualizzazione della cronologia e dello stato delle attività","link":"clearing-logs-topic.html","desc":"Eliminazione dei registri Nel menu","descFull":"Eliminazione dei registri Nel menu Attività, fare clic su  Registro . Fare clic su  Elimina registro , quindi selezionare una data. Fare clic su  Elimina registro . eliminazione dei registri registri eliminazione"},{"UUID":"2a5e4a8e-bc8e-4bed-b10b-9426dbf51415","title":"Visualizzazione della cronologia e dello stato delle attività","link":"exporting-logs-topic.html","desc":"Esportazione dei registri Nella cartella","descFull":"Esportazione dei registri Nella cartella  Attività  , fare clic su  Registro . Selezionare le categorie e i tipo di attività o un intervallo di tempo. Fare clic su  Esporta a CSV . esportazione dei registri registri esportazione"},{"UUID":"6cb1bfcc-ae3f-448d-a534-6fa8bb753b0b","title":"Programmazione delle attività","link":"creating-schedule-topic.html","desc":"Creazione di un programma Nel","descFull":"Creazione di un programma Nel menu  Attività  fare clic su  Programma Crea . Nella sezione  Impostazioni generali  digitare un nome univoco per le attività programmate e la relativa descrizione. Nella sezione  Attività  effettuare una delle seguenti operazioni: Programmare un controllo Selezionare  Controllo . Selezionare una ricerca salvata. Programmare un controllo di conformità Selezionare  Conformità . Selezionare una ricerca salvata. Programmare un controllo dello stato della stampante Selezionare  Stato attuale . Selezionare una ricerca salvata. Selezionare un'azione. Programmare una distribuzione di configurazione Selezionare  Distribuisci file . Selezionare una ricerca salvata. Selezionare il file, quindi scegliere il tipo di file. Se necessario, selezionare un protocollo o metodo di distribuzione. Pianificare un rilevamento Selezionare  Ricerca . Selezionare un profilo di ricerca. Programmare un'applicazione della configurazione Selezionare  Applicazione . Selezionare una ricerca salvata. Pianificare una convalida del certificato Selezionare  Convalida certificato . durante la convalida, MVE comunica con il server CA per scaricare la catena di certificati e l'elenco di revoche di certificati (CRL). Viene generato anche il certificato agente di registrazione. Questo certificato consente al server CA di considerare attendibile MVE. Programmare un'esportazione di visualizzazione Selezionare  Esporta visualizzazione . Selezionare una ricerca salvata. Selezionare un modello di visualizzazione. Digitare l'elenco di indirizzi e-mail in cui vengono inviati i file esportati. Nella sezione  Programma  impostare la data, l'ora e la frequenza dell'attività. Fare clic su  Crea attività programmata . creazione di un programma programma creazione"},{"UUID":"1d634c64-b9c9-4789-86ea-e4277da3bcae","title":"Programmazione delle attività","link":"managing-schedules-topic.html","desc":"Gestione delle attività programmate Nella","descFull":"Gestione delle attività programmate Nella cartella  Attività  , fare clic su  Pianifica . Effettuare una delle seguenti operazioni: Modificare un'attività programmata Selezionare un'attività, quindi fare clic su  Modifica . Configurare le impostazioni. Fare clic su  Modifica attività programmata . Le informazioni su Ultima esecuzione vengono rimosse quando viene modificata un'attività programmata. Eliminare un'attività programmata Selezionare un'attività, quindi fare clic su  Elimina . Fare clic su  Elimina attività programmata . gestione delle programmazioni programmazioni gestione modifica programmazioni eliminazione programmazioni programmazioni modifica programmazioni eliminazione"},{"UUID":"8e61d38e-13a3-4e3e-bbf1-719f3d7f00d0","title":"Esecuzione di altre attività amministrative","link":"configuring-system-settings-topic.html","desc":"Configurazione delle impostazioni generali Fare","descFull":"Configurazione delle impostazioni generali Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  Generale , quindi selezionare un'origine di nome host. Stampante : il sistema recupera il nome host dalla stampante. Ricerca DNS inversa : il sistema recupera il nome host dalla tabella DNS utilizzando l'indirizzo IP. Impostare la frequenza delle nuove registrazioni degli avvisi. Quando si effettuano modifiche, come il riavvio o l'aggiornamento del firmware, le stampanti possono perdere lo stato di registrazione degli avvisi. MVE tenta di ripristinare automaticamente lo stato sull'intervallo successivo impostato nella frequenza della nuova registrazione degli avvisi. Configurare le seguenti impostazioni del registro di sistema: Ora di inizio pulizia registro di sistema : l'ora in cui ha inizio la pulizia del registro di sistema o delle attività. Periodo di conservazione dei registri di sistema (settimane) : il numero di settimane durante le quali i registri di sistema sono memorizzati nel database. Le voci memorizzate nel database per più di 52 settimane vengono rimosse. Archivio dei registri di sistema : consente di archiviare i registri di sistema e le voci codificate nel file system. La destinazione e il formato dei file di archivio sono definiti nel file log4j2.xml. Fare clic su  Salva modifiche . configurazione delle impostazioni generali impostazioni generali configurazione"},{"UUID":"f3a1c090-fc7c-4fcb-a08f-813e616a92ed","title":"Esecuzione di altre attività amministrative","link":"configuring-email-settings-topic.html","desc":"Configurazione delle impostazioni e-mail Abilitare","descFull":"Configurazione delle impostazioni e-mail Abilitare la configurazione SMTP per consentire a MVE di inviare tramite e-mail i file di esportazione dei dati e le notifiche degli eventi. Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  E-mail , quindi selezionare  Abilita configurazione SMTP e-mail . Digitare la porta e il server di posta SMTP. Selezionare la crittografia appropriata. Per la crittografia SSL, selezionare la porta 465. Per la crittografia TLS/STARTTLS, selezionare la porta 587. Digitare l'indirizzo e-mail del mittente. Se un utente deve effettuare l'accesso prima della comunicazione e-mail, selezionare  Connessione richiesta , quindi digitare le credenziali dell'utente. Fare clic su  Salva modifiche . configurazione delle impostazioni e-mail impostazioni e-mail configurazione"},{"UUID":"3485563c-3759-4bea-9cce-3d4d8ff6e4a4","title":"Esecuzione di altre attività amministrative","link":"adding-login-disclaimer-topic.html","desc":"Aggiunta di una declinazione di","descFull":"Aggiunta di una declinazione di responsabilità prima dell'accesso È possibile configurare una declinazione di responsabilità per l'accesso che verrà visualizzata all'accesso degli utenti a una nuova sessione. Gli utenti devono accettare la declinazione di responsabilità per poter accedere a MVE. Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  Declinazione di responsabilità , quindi selezionare  Abilita declinazione di responsabilità prima dell'accesso . Digitare il testo della declinazione di responsabilità. Fare clic su  Salva modifiche . aggiunta di una declinazione di responsabilità prima dell'accesso declinazione di responsabilità per l'accesso aggiunta"},{"UUID":"104f4187-3f92-4a91-862d-adbf77b38e56","title":"Esecuzione di altre attività amministrative","link":"signing-mve-certificate-topic.html","desc":"Firma del certificato MVE SSL","descFull":"Firma del certificato MVE SSL (Secure Socket Layer) o TLS (Transport Layer Security) è un protocollo di sicurezza che utilizza la crittografia e l'autenticazione del certificato per proteggere la comunicazione tra server e client. In MVE, viene utilizzato il protocollo TLS per proteggere le informazioni riservate condivise tra il server MVE e il browser Web. Le informazioni protette possono essere password della stampante, criteri di sicurezza, credenziali utente MVE o informazioni di autenticazione della stampante, come LDAP o Kerberos. TLS permette al server MVE e al browser Web di crittografare i dati prima dell'invio, quindi di decrittografarli dopo la ricezione. SSL richiede inoltre al server di inviare al browser Web un certificato che dimostri l'identità del server. Questo certificato è autofirmato o firmato mediante un'autorità di certificazione (CA) attendibile di terze parti. Per impostazione predefinita, MVE è configurato per l'uso di un certificato autofirmato. Scaricare la richiesta di firma del certificato. Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  TLS Download . Selezionare  Richiesta di firma certificato . la richiesta di firma del certificato include il nome soggetto alternativo (SAN). Utilizzare un'autorità di certificazione (CA) attendibile per firmare la richiesta di firma del certificato. Installare il certificato firmato tramite CA. Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  TLS Installa certificato firmato . Caricare il certificato firmato tramite CA, quindi fare clic su  Installa certificato . Fare clic su  Riavvia servizio MVE . il riavvio del servizio MVE determina il riavvio del sistema, per cui il server potrebbe non essere disponibile per alcuni minuti. Prima di riavviare il servizio, assicurarsi che non vi siano attività in esecuzione. firma del certificato MVE certificato MVE firma"},{"UUID":"c19f8ee0-74c3-4b05-94e8-e2b49819f6db","title":"Esecuzione di altre attività amministrative","link":"removing-user-information-topic.html","desc":"Rimozione di informazioni e riferimenti","descFull":"Rimozione di informazioni e riferimenti dell'utente MVE è conforme alle normative sulla protezione dei dati enunciate nel Regolamento generale sulla protezione dei dati (General Data Protection Regulation, GDPR). MVE si può configurare in modo da applicare il diritto di essere dimenticati e rimuovere i dati personali dell'utente dal sistema. Rimozione di utenti Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  Utente , quindi selezionare uno o più utenti. Fare clic su  Elimina Elimina utenti . Rimozione dei riferimenti dell'utente in LDAP Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  LDAP . Rimuovere le informazioni relative all'utente nei filtri di ricerca e nelle impostazioni di binding. Rimozione dei riferimenti dell'utente dal server e-mail Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  E-mail . Rimuovere le eventuali informazioni relative all'utente, ad esempio le credenziali utilizzate dall'utente per l'autenticazione sul server e-mail. Rimozione dei riferimenti dell'utente dai registri delle attività Per ulteriori informazioni, vedere  . Rimozione dei riferimenti di un utente da una configurazione Nel menu  Configurazioni  fare clic su  Tutte le configurazioni . Fare clic sul nome della configurazione. Nella scheda  Di base  rimuovere eventuali valori correlati all'utente dalle impostazioni della stampante, con il nome del contatto e la posizione del contatto. Rimozione dei riferimenti dell'utente in un componente di protezione avanzata Nel menu  Configurazioni  fare clic su  Tutti i componenti di protezione avanzata . Fare clic sul nome del componente. Nella sezione  Impostazioni di protezione avanzate , rimuovere i valori relativi all'utente. Rimozione dei riferimenti dell'utente dalle ricerche salvate Nel menu  Stampanti  fare clic su  Ricerche salvate . Fare clic su una ricerca salvata. Rimuovere le eventuali regole di ricerca che utilizzano valori relativi all'utente, come il nome del contatto e la posizione del contatto. Rimozione dei riferimenti dell'utente nelle parole chiave Nel menu  Stampanti  fare clic su  Elenco stampanti . Annullamento dell'assegnazione di parole chiave correlate all'utente dalle stampanti. Nel menu  Stampanti  fare clic su  Parole chiave . Rimuovere le parole chiave che utilizzano informazioni relative all'utente. Rimozione dei riferimenti dell'utente in eventi e azioni Nel menu  Stampanti  fare clic su  Eventi e azioni . Rimuovere le eventuali azioni che contengono riferimenti e-mail agli utenti. rimozione di informazioni e riferimenti dell'utente informazioni dell'utente rimozione"},{"UUID":"bede7256-ab38-4df3-a84c-c94ecbc0b27e","title":"Gestione SSO","link":"mve-configuration-workflow-adfs-overview-topic.html","desc":"Panoramica Active Directory Federation Services","descFull":"Panoramica Active Directory Federation Services (ADFS) è una soluzione di accesso alle identità che fornisce ai computer client l'accesso Single Sign-on (SSO) ad applicazioni o servizi protetti. Gli utenti possono accedere a tali applicazioni o servizi anche quando i loro account e le loro applicazioni si trovano in organizzazioni o reti completamente diverse. ADFS utilizza l'autenticazione SAML (Security Assertion Markup Language) e l'autorizzazione CBAC (Claims-based Access Control) per garantire la protezione tra le applicazioni tramite l'identità federativa. È necessario stabilire una comunicazione crittografata tra i server MVE e ADFS. A tale scopo, ADFS deve considerare attendibile il server MVE. ADFS contiene anche gruppi di utenti del server Active Directory (AD) i cui ruoli devono corrispondere ai ruoli utente MVE richiesti. Quando si configura il server ADFS, l'applicazione MVE richiede le seguenti informazioni: Identificatore dell'attendibilità componente - https://mve-host/mve/saml Componente URL o endpoint del servizio SAML 2.0 SSO - https://mve-host/mve/adfs/saml Negli URL,  mve-host  corrisponde all'indirizzo IP o all'FQDN del server MVE. Flusso di lavoro di configurazione MVE per ADFS panoramica"},{"UUID":"8c674b9e-78b5-4f82-a59c-89a69240ab0d","title":"Gestione SSO","link":"setting-claim-issuance-policy-grouprule-topic.html","desc":"Impostazione dei criteri di rilascio","descFull":"Impostazione dei criteri di rilascio delle attestazioni per GroupRule Nella finestra  AD FS , fare clic su  Attendibilità componente , quindi fare clic con il pulsante destro del mouse sull'attendibilità del componente applicabile. Fare clic su  Modifica criteri di rilascio attestazioni , quindi su  Aggiungi regola . Nell'elenco  Modello di regola attestazione , selezionare  Invia attributi LDAP come attestazioni . Nel campo  Nome regola attestazione , digitare  GroupRule . Nell'elenco  Archivio attributi , selezionare  Active Directory . Impostare  Attributo LDAP  su  Token-Groups - Nomi non qualificati , quindi impostare  Tipo di attestazione in uscita  su  MVEGroup . Fare clic su  Fine . impostazione dei criteri di rilascio delle attestazioni GroupRule criteri di rilascio delle attestazioni per GroupRule impostazione"},{"UUID":"9de672ce-2fc2-4985-b096-230233a66134","title":"Gestione SSO","link":"setting-claim-issuance-policy-name-id-topic.html","desc":"Impostazione dei criteri di rilascio","descFull":"Impostazione dei criteri di rilascio delle attestazioni per ID nome Nella finestra  AD FS , fare clic su  Attendibilità componente , quindi fare clic con il pulsante destro del mouse sull'attendibilità del componente applicabile. Fare clic su  Modifica criteri di rilascio attestazioni , quindi su  Aggiungi regola . Nell'elenco  Modello di regola attestazione , selezionare  Invia attributi LDAP come attestazioni . Nel campo  Nome regola attestazione , digitare  ID nome . Nell'elenco  Archivio attributi , selezionare  Active Directory . Impostare  Attributo LDAP  su  SAM - Account - Name , quindi impostare  Tipo di attestazione in uscita  su  ID nome . Fare clic su  Fine . impostazione dei criteri di rilascio delle attestazioni ID nome criteri di rilascio delle attestazioni per ID nome impostazione"},{"UUID":"a2ef7fd8-1570-43d6-9a98-c1bd97704175","title":"Gestione SSO","link":"enabling-adfs-server-authentication-topic.html","desc":"Abilitazione dell'autenticazione tramite server ADFS","descFull":"Abilitazione dell'autenticazione tramite server ADFS Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  ADFS , quindi selezionare  Abilita ADFS per autenticazione . Nel campo  URL SSO (obbligatorio) , digitare l'URL SSO pubblicato dal server ADFS come provider di identità. Nella sezione  Mapping gruppi ADFS a ruoli MVE , inserire i nomi dei gruppi ADFS che corrispondono ai ruoli MVE. Fare clic su  Salva modifiche . server ADFS abilitazione dell'autenticazione abilitazione dell'autenticazione tramite server ADFS"},{"UUID":"045cf85a-7127-435e-903c-8f1f5c6a38ad","title":"Gestione SSO","link":"accessing-mve-adfs-topic.html","desc":"Accesso a MVE tramite ADFS","descFull":"Accesso a MVE tramite ADFS Quando si accede a MVE dopo aver abilitato ADFS, si apre automaticamente la pagina di accesso di ADFS. Eseguire l'autenticazione nella pagina ADFS prima di essere reindirizzati alla pagina iniziale di MVE. Aprire un browser Web e digitare  https:// MVE_SERVER /mve/ , in cui  MVE_SERVER  corrisponde al nome host o all'indirizzo IP del server che ospita MVE. Quando la pagina di accesso di ADFS si apre, immettere le credenziali ADFS, quindi fare clic su  Accedi . Se gli utenti riscontrano problemi durante l'accesso a MVE tramite ADFS, gli amministratori possono accedere a MVE utilizzando le proprie credenziali localhost e risolvere il problema. Se ADFS non è configurato nel server MVE, viene visualizzata la pagina di accesso predefinita di MVE per gli utenti localhost e non-localhost. In questo caso, gli utenti devono accedere a MVE utilizzando gli account configurati nel server MVE. MVE tramite ADFS ADSF"},{"UUID":"b88b5571-0fc3-4b16-ae89-9152440e7eb3","title":"Gestione SSO","link":"logging-out-mve-adfs-topic.html","desc":"Disconnessione da MVE Se si","descFull":"Disconnessione da MVE Se si accede a MVE tramite ADFS, il pulsante  Disconnetti  non viene visualizzato nella pagina iniziale di MVE. La sessione MVE termina solo se si chiude la pagina MVE o se la sessione resta inattiva per più di 30 minuti. Se si tenta di accedere all'URL MVE dopo 30 minuti di inattività, si viene reindirizzati alla pagina di accesso di ADFS. Se l'accesso a MVE viene eseguito utilizzando le credenziali MVE localhost, il pulsante  Disconnetti  viene comunque visualizzato nella pagina iniziale di MVE. disconnessione da MVE tramite ADFS"},{"UUID":"cd9b638b-63b1-415e-a0ac-bf9cfb5927a1","title":"Domande frequenti","link":"faq-chapter.html","desc":"Domande frequenti su Markvision Enterprise","descFull":"Domande frequenti su Markvision Enterprise Perché non è possibile selezionare più stampanti nell'elenco dei modelli supportati durante la creazione di una configurazione? Le impostazioni e i comandi di configurazione variano a seconda del modello di stampante. Altri utenti possono accedere alle mie ricerche salvate? Sì. Tutti gli utenti possono accedere alle ricerche salvate. Dove è possibile trovare i file di registro? I file del registro di installazione sono nella directory nascosta dell'utente che ha installato MVE. Ad esempio,  C:\\Utenti\\Administrator\\AppData\\Local\\Temp\\mveLexmark-install.log . È possibile trovare i file del registro dell'applicazione  *.log  nella cartella  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\logs , dove  installation_dir  indica la cartella di installazione di MVE. Qual è la differenza tra ricerca DNS inversa e nome host? Un nome host è un nome univoco assegnato a una stampante in rete. A ciascun nome host corrisponde un indirizzo IP. La ricerca DNS inversa viene usata per determinare il nome host e il nome di dominio designato di un determinato indirizzo IP. Dove è disponibile la ricerca DNS inversa in MVE? La ricerca DNS inversa si trova nelle impostazioni generali. Per ulteriori informazioni, vedere  . In che modo è possibile aggiungere manualmente regole a Windows Firewall? Eseguire il prompt dei comandi come amministratore, quindi digitare quanto segue: firewall add allowedprogram \" installation_dir /Lexmark/Markvision Enterprise/tomcat/bin/tomcat9.exe\" \"Markvision Enterprise Tomcat\" firewall add portopening UDP 9187 \"Markvision Enterprise NPA UDP\" firewall add portopening UDP 6100 \"Markvision Enterprise LST UDP\" Dove  installation_dir  indica la cartella di installazione di MVE. In che modo è possibile configurare MVE per utilizzare una porta diversa dalla 443? Arrestare il servizio Markvision Enterprise. Aprire la finestra di dialogo  Esegui , quindi digitare  services.msc . Fare clic con il pulsante destro del mouse su  Markvision Enterprise , quindi fare clic su  Arresta . Aprire il file  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml. Dove  installation_dir  indica la cartella di installazione di MVE. Modificare il valore  Connector port  con quello di un'altra porta inutilizzata. <Connector port=\"443\" protocol=\"org.apache.coyote.http11.Http11NioProtocol\" \nsslImplementationName=\"org.apache.tomcat.util.net.jsse.JSSEImplementation\" \nSSLEnabled=\"true\" scheme=\"https\" secure=\"true\" clientAuth=\"false\" \ncompression=\"on\" compressableMimeType=\"text/html,text/xml,text/plain,text/css,\ntext/javascript,application/javascript,application/json\" maxThreads=\"150\" \nmaxHttpHeaderSize=\"16384\" minSpareThreads=\"25\" enableLookups=\"false\" \nacceptCount=\"100\" connectionTimeout=\"120000\" disableUploadTimeout=\"true\" \nURIEncoding=\"UTF-8\" server=\"Apache\" sslEnabledProtocols=\"TLSv1,TLSv1.1,TLSv1.2\" \nsslProtocol=\"TLS\" keystoreFile=\"C:/Program Files/Lexmark/Markvision Enterprise/\n../mve_truststore.p12\" keystorePass=\"markvision\" keyAlias=\"mve\" keyPass=\"markvision\" \nkeystoreType=\"PKCS12\" ciphers=\"TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA256,\nTLS_ECDHE_RSA_WITH_AES_128_CBC_SHA,TLS_RSA_WITH_AES_128_CBC_SHA256,\nTLS_RSA_WITH_AES_128_CBC_SHA\"/> Modificare il valore  redirectPort  sullo stesso numero di porta utilizzato come porta del connettore. <Connector port=\"9788\" maxHttpHeaderSize=\"16384\" maxThreads=\"150\" minSpareThreads=\"25\" \nenableLookups=\"false\" redirectPort=\"443\" acceptCount=\"100\" connectionTimeout=\"120000\" \ndisableUploadTimeout=\"true\" compression=\"on\" compressableMimeType=\"text/html,text/xml,\ntext/plain,text/css,text/javascript,application/javascript,application/json\" \nURIEncoding=\"UTF-8\" server=\"Apache\"/> Riavviare il servizio Markvision Enterprise. Aprire la finestra di dialogo  Esegui , quindi digitare  services.msc . Fare clic con il pulsante destro del mouse su  Markvision Enterprise , quindi fare clic su  Riavvia . Accedere a MVE utilizzando la nuova porta. Ad esempio, aprire un browser Web e digitare  https:// MVE_SERVER : port /mve . Dove  MVE_SERVER  è il nome host o l'indirizzo IP del server su cui è installato MVE e  port  è il numero di porta del connettore. In che modo è possibile personalizzare le crittografie e le versioni TLS utilizzate da MVE? Arrestare il servizio Markvision Enterprise. Aprire la finestra di dialogo  Esegui , quindi digitare  services.msc . Fare clic con il pulsante destro del mouse su  Markvision Enterprise , quindi fare clic su  Arresta . Aprire il file  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml. Dove  installation_dir  indica la cartella di installazione di MVE. Configurare le crittografie e le versioni TLS. Per ulteriori informazioni sulla configurazione, vedere le  istruzioni di configurazione di Apache Tomcat SSL/TLS . Per ulteriori informazioni sui protocolli e i valori delle crittografie, vedere la  documentazione relativa alle informazioni di supporto di Apache Tomcat SSL . Riavviare il servizio Markvision Enterprise. Aprire la finestra di dialogo  Esegui , quindi digitare  services.msc . Fare clic con il pulsante destro del mouse su  Markvision Enterprise , quindi fare clic su  Riavvia . Come si gestiscono i file CRL quando si utilizza una CA Microsoft Enterprise? Ottenere il file CRL dal server CA. Per la CA Microsoft Enterprise, il CRL non viene scaricato automaticamente tramite SCEP. Per ulteriori informazioni, vedere la  Guida alla configurazione dell'autorità di certificazione Microsoft . Salvare il file CRL nella cartella   installation_dir Lexmark/Markvision Enterprise/apps/library/crl, dove  installation_dir  è la cartella di installazione di MVE. Configurare l'autorità di certificazione in MVE. Questo processo è applicabile solo al protocollo SCEP. modelli supportati configurazione ricerca DNS inversa ricerca nome host ricerca inversa file di registro individuazione file di registro dell'applicazione individuazione file di registro di installazione individuazione ricerche salvate accesso Windows Firewall aggiunta di regole crittografia AES256 configurazione porte configurazione crittografie personalizzazione versioni TLS personalizzazione CA Microsoft Enterprise configurazione"},{"UUID":"33d99492-ebec-4704-b5bf-18886a22d794","title":"Risoluzione dei problemi","link":"trb-forgotten-password-mve-topic.html","desc":"L'utente ha dimenticato la password","descFull":"L'utente ha dimenticato la password Reimpostare la password utente È necessario disporre dei privilegi di amministratore per reimpostare la password. Fare clic su   nell'angolo superiore destro della pagina. Fare clic su  Utente , quindi selezionare un utente. Fare clic su  Modifica , quindi modificare la password. Fare clic su  Salva modifiche . Se si è dimenticata la password, effettuare una delle seguenti operazioni: Contattare un altro utente amministratore per reimpostare la password. Contattare il Centro di assistenza clienti Lexmark. l'utente ha dimenticato la password risoluzione dei problemi l'utente ha dimenticato la password password ripristino"},{"UUID":"b1349ba0-9e2c-4806-89b0-d1a49e8e197d","title":"Risoluzione dei problemi","link":"trb-admin-forgotten-password-mve-topic.html","desc":"L'utente amministratore ha dimenticato la","descFull":"L'utente amministratore ha dimenticato la password Creare un altro utente amministratore, quindi eliminare l'account precedente È possibile utilizzare Markvision Enterprise Password Utility per creare un altro utente amministratore. Selezionare la cartella in cui è installato Markvision Enterprise. Ad esempio,  C:\\Programmi\\ Avviare il file  mvepwdutility-windows.exe  nella cartella Lexmark\\Markvision Enterprise\\. Selezionare una lingua, quindi fare clic su  OK Avanti . Selezionare  Aggiungi account utente Avanti . Immettere le credenziali utente. Fare clic su  Avanti . Accedere a MVE, quindi eliminare il precedente utente amministratore. Per ulteriori informazioni, vedere  . l'utente amministratore ha dimenticato la password risoluzione dei problemi l'utente amministratore ha dimenticato la password"},{"UUID":"787e0fc6-6413-4c13-b714-d52ebf2106be","title":"Risoluzione dei problemi","link":"trb-page-loading-infinitely-topic.html","desc":"La pagina non viene caricata","descFull":"La pagina non viene caricata Questo problema può verificarsi se il browser Web è stato chiuso senza disconnettersi. Provare una o più di una delle seguenti soluzioni: Cancellare la cache ed eliminare i cookie nel browser Web Andare alla pagina di accesso a MVE, quindi effettuare l'accesso utilizzando le proprie credenziali Aprire un browser Web e digitare  https:// MVE_SERVER /mve/login , in cui  MVE_SERVER  corrisponde al nome host o all'indirizzo IP del server che ospita MVE. caricamento pagina continuo risoluzione dei problemi caricamento pagina continuo"},{"UUID":"b0b3a111-acc9-4521-b2c5-e16818fa4279","title":"Risoluzione dei problemi","link":"trb-cannot-discover-network-device-topic.html","desc":"Impossibile rilevare una stampante di","descFull":"Impossibile rilevare una stampante di rete Provare una o più delle seguenti soluzioni: Verificare che la stampante sia accesa. Assicurarsi che il cavo di alimentazione sia collegato saldamente alla stampante e a una presa elettrica dotata di messa a terra. Verificare che la stampante sia collegata alla rete Riavviare la stampante Accertarsi che il protocollo TCP/IP sia abilitato sulla stampante Accertarsi che le porte utilizzate da MVE siano aperte e che i protocolli SNMP e mDNS siano abilitati Per ulteriori informazioni, vedere  . Contattare il rappresentante Lexmark risoluzione dei problemi impossibile rilevare una stampante di rete impossibile rilevare una stampante di rete"},{"UUID":"c718b09e-5fdc-48c5-a78a-a3d5cc3dae7a","title":"Risoluzione dei problemi","link":"trb-incorrect-device-information-topic.html","desc":"Informazioni stampante errate Eseguire un","descFull":"Informazioni stampante errate Eseguire un controllo Per ulteriori informazioni, vedere  . informazioni stampante errate risoluzione dei problemi informazioni stampante errate"},{"UUID":"0c4e2492-9917-4653-9322-20ab4539d274","title":"Risoluzione dei problemi","link":"trb-mve-does-not-recognize-secured-printer-topic.html","desc":"MVE non riconosce una stampante","descFull":"MVE non riconosce una stampante come stampante protetta Come verificare che la stampante sia protetta Come accertarsi che mDNS sia attivato e che non si sia bloccato Come eliminare la stampante, quindi eseguire di nuovo la ricerca della stampante Per ulteriori informazioni, vedere  . MVE non riconosce una stampante come stampante protetta risoluzione dei problemi MVE non riconosce una stampante come stampante protetta"},{"UUID":"490cac05-0639-4139-909a-854959a85fd4","title":"Risoluzione dei problemi","link":"trb-config-enforcement-fails-topic.html","desc":"L'applicazione di configurazioni con più","descFull":"L'applicazione di configurazioni con più applicazioni non riesce al primo tentativo ma riesce con i tentativi successivi Aumentare il timeout Selezionare la cartella in cui è installato Markvision Enterprise. Ad esempio,  C:\\Programmi\\ Passare alla cartella Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes. Utilizzando un editor di testo, aprire il file  platform.properties . Modificare il valore  cdcl.ws.readTimeout . Il valore è espresso in millisecondi. Ad esempio, 90000 millisecondi è pari a 90 secondi. Utilizzando un editor di testo, aprire il file  devCom.properties . Modificare i valori  lst.responseTimeoutsRetries . Il valore è espresso in millisecondi. Ad esempio, 10000 millisecondi è pari a 10 secondi. Ad esempio,  lst.responseTimeoutsRetries=10000 15000 20000 . Il primo tentativo di riconnessione avviene dopo 10 secondi, il secondo tentativo di riconnessione avviene dopo 15 secondi e il terzo dopo 20 secondi. Se necessario, quando si utilizza LDAP GSSAPI, creare un file  parameters.properties . Aggiungere l'impostazione seguente:  lst.negotiation.timeout=400 Il valore è espresso in secondi. Salvare le modifiche. l'applicazione di configurazioni con più applicazioni non riesce al primo tentativo ma riesce con i tentativi successivi risoluzione dei problemi l'applicazione di configurazioni con più applicazioni non riesce al primo tentativo ma riesce con i tentativi successivi"},{"UUID":"02aa8be5-360c-4e07-8989-a8125cf3fa78","title":"Risoluzione dei problemi","link":"trb-enforcement-printer-cert-fails-topic.html","desc":"L'applicazione di configurazioni con il","descFull":"L'applicazione di configurazioni con il certificato della stampante non riesce A volte non viene rilasciato alcun nuovo certificato durante l'applicazione. Aumentare il numero di tentativi di registrazione Aggiungere la seguente chiave nel file  platform.properties : enrol.maxEnrolmentRetry=10 Il valore dei tentativi deve essere maggiore di cinque. l'applicazione di configurazioni con il certificato della stampante non riesce risoluzione dei problemi l'applicazione di configurazioni con il certificato della stampante non riesce"},{"UUID":"e71b6ba3-71e3-4f5e-b6eb-c0b76033c5c4","title":"Autorità di certificazione OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Rilascio del certificato non riuscito","descFull":"Rilascio del certificato non riuscito con il server OpenXPKI CA Assicurarsi che la chiave del \"firmatario per conto di\" in MVE corrisponda alla chiave del firmatario autorizzato nel server CA Ad esempio: Se la seguente è la chiave  ca.onBehalf.cn  nel file  platform.properties  in MVE, ca.onBehalf.cn=Markvision_SQA-2012-23AB.lrdc.lexmark.ds la seguente deve essere la chiave  authorized_signer  nel file  generic.yaml  nel server CA. rule1:\n\t\t\t# Full DN\n\t\t\t\t\tSubject: CN=Markvision_SQA-2012-23AB.lrdc.lexmark.ds Per ulteriori informazioni sulla configurazione del server OpenXPKI CA, consultare la  Guida alla configurazione dell'autorità di certificazione OpenXPKI . rilascio del certificato non riuscito con il server OpenXPKI CA risoluzione dei problemi rilascio del certificato non riuscito con il server OpenXPKI CA"},{"UUID":"ed6c46b1-1abd-4044-aef8-dad50489b43e","title":"Autorità di certificazione OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Si verifica un errore interno","descFull":"Si verifica un errore interno del server Installare le impostazioni locali en_US.utf8 Eseguire il comando  dpkg-reconfigure locales . Installare le impostazioni locali  en_US.utf8  (locale -a | grep en_US). risoluzione dei problemi errore interno del server errore interno del server"},{"UUID":"063c58c8-7efe-440f-b3fd-f9c5d3704799","title":"Autorità di certificazione OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"La richiesta di accesso non","descFull":"La richiesta di accesso non viene visualizzata Quando si accede a  http://yourhost/openxpki/ , viene visualizzato solo il banner Open Source TrustCenter, senza una richiesta di accesso. Abilitare  fcgid Eseguire questi comandi: a2enmod fcgid service apache2 restart risoluzione dei problemi la richiesta di accesso non viene visualizzata la richiesta di accesso non viene visualizzata"},{"UUID":"045a2d18-bb68-4be3-9401-71e7f3a81109","title":"Autorità di certificazione OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Si verifica un errore di","descFull":"Si verifica un errore di connettore nidificato senza classe Viene visualizzato un errore  EXCEPTION: Nested connector without class (scep.scep-server-1.connector.initial)  alla riga 201 di /usr/share/perl5/Connector/Multi.pm. Aggiornare  scep.scep-server-1 In  /etc/openxpki/config.d/realm/REALM/scep/general.yaml , sostituire  scep.scep-server-1  con  scep.generic . sostituire  REALM  con il nome dell'area di autenticazione. Ad esempio, quando si utilizza l'area di autenticazione predefinita, utilizzare  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial risoluzione dei problemi errore di connettore nidificato senza classe errore di connettore nidificato senza classe"},{"UUID":"c61ca8bc-258e-410b-928a-55a36a63420b","title":"Autorità di certificazione OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Impossibile approvare manualmente i certificati","descFull":"Impossibile approvare manualmente i certificati Il pulsante  Approvazione manuale  non viene visualizzato quando si approvano manualmente i certificati. Aggiornare  scep.scep-server-1 In  /etc/openxpki/config.d/realm/REALM/scep/general.yaml , sostituire  scep.scep-server-1  con  scep.generic . sostituire  REALM  con il nome dell'area di autenticazione. Ad esempio, quando si utilizza l'area di autenticazione predefinita, utilizzare  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial risoluzione dei problemi impossibile approvare manualmente i certificati impossibile approvare manualmente i certificati"},{"UUID":"d9f658a6-5c6f-4852-a246-8cf93f96da96","title":"Autorità di certificazione OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Si verifica un errore Perl","descFull":"Si verifica un errore Perl durante l'approvazione delle richieste di registrazione Aggiornare  scep.scep-server-1 In  /etc/openxpki/config.d/realm/REALM/scep/general.yaml , sostituire  scep.scep-server-1  con  scep.generic . sostituire  REALM  con il nome dell'area di autenticazione. Ad esempio, quando si utilizza l'area di autenticazione predefinita, utilizzare  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial risoluzione dei problemi errore Perl errore Perl"},{"UUID":"deb7776f-ec78-439c-b110-0ce7f80b5d51","title":"Autorità di certificazione OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"I token  ca-signer-1 ","descFull":"I token  ca-signer-1  e  vault-1  sono offline Nella pagina  Stato sistema  risulta che i token  ca-signer-1  e  vault-1  sono offline. Provare una o più delle soluzioni seguenti Modificare la password della chiave del certificato In  /etc/openxpki/config.d/realm/ca-one/crypto.yaml , modificare la password della chiave del certificato. Creare collegamenti simbolici corretti e copiare il file della chiave Per ulteriori informazioni, vedere  . Assicurarsi che il file della chiave sia leggibile per OpenXPKI risoluzione dei problemi ca-signer-1 è offline risoluzione dei problemi vault-1 è offline ca-signer-1 è offline risoluzione dei problemi vault-1 è offline risoluzione dei problemi"},{"UUID":"9a182a04-113c-41e3-a7aa-bfe84537822e","title":"Accesso al database","link":"differences-supported-databases-data-types-topic.html","desc":"Differenze tra i tipi di","descFull":"Differenze tra i tipi di dati dei database supportati MVE supporta Firebird e Microsoft SQL Server. La tabella seguente mostra i tipi di dati Firebird utilizzati in MVE e i tipi di dati corrispondenti in Microsoft SQL Server. Tipi di dati Firebird Tipi di dati Microsoft SQL Server * Questo tipo di dati è obbligatorio per Microsoft SQL Server. BIGINT Bigint VARCHAR(x) varchar(x) TIMESTAMP Datetime INTEGER Int SMALLINT/TINYINT * Bit BLOB SUB_TYPE 0 varbinary(1024) differenze tra i tipi di dati dei database supportati tipi di dati dei database supportati differenze"},{"UUID":"9f228c90-530e-428c-84ae-e1b8610eddd7","title":"Stampante","link":"config-item-topic.html","desc":"CONFIG_ITEM La tabella CONFIG_ITEM mostra","descFull":"CONFIG_ITEM La tabella CONFIG_ITEM mostra gli elementi di configurazione (CI) ITIL della stampante. Mostra lo stato del CI, la data e l'ora della sua creazione, la gestione iniziale, l'ultimo rilevamento e altre azioni. La tabella non mostra alcuna parte fisica di una stampante; è semplicemente una rappresentazione astratta della periferica. CONFIG_ITEM Nome campo Tipo di dati Per CI_ID BIGINT Chiave primaria. CI_STATE VARCHAR(255) Lo stato corrente del CI. Le opzioni sono NEW, MANAGED, MISSING, FOUND, CHANGED, UNMANAGED e RETIRED. CREATION_DATE TIMESTAMP La data in cui il CI è stato inserito per la prima volta nel sistema. INITIAL_MANAGEMENT_DATE TIMESTAMP La data in cui il CI è stato inserito per la prima volta nello stato o nello stato secondario MANAGED. DATA_ULTIMA_VE TIMESTAMP La data dell'ultima verifica tentata sul CI (indipendentemente dall'esito). PRINTER_ID BIGINT La chiave esterna per NETWORK_PRINTER.PRINTER_ID. LAST_DISCOVERY_DATE TIMESTAMP La data in cui è stato eseguito l'ultimo tentativo di rilevamento sul CI (indipendentemente dall'esito). LAST_SUCCESSFUL_AUDIT_DATE TIMESTAMP La data dell'ultima verifica del CI con esito positivo. LAST_SUCCESSFUL_DISCOVERY_ DATE TIMESTAMP La data dell'ultimo rilevamento del CI con esito positivo. DEFAULT_CERT_COMMON_NAME VARCHAR(255) Il nome del certificato predefinito. DEFAULT_CERT_ISSUER_NAME VARCHAR(255) Il nome dell'autorità di certificazione. DEFAULT_CERT_SIGNING_STATUS VARCHAR(255) Lo stato di firma del certificato della stampante. Le opzioni sono SIGNED, INVALID_CERT, NO_CA e UNKNOWN. DEFAULT_CERT_VALID_FROM TIMESTAMP La data di inizio di validità del certificato. DEFAULT_CERT_VALID_TO TIMESTAMP L'ultima data di validità del certificato. DEFAULT_CERTIFICATE VARCHAR(8190) Il certificato predefinito. DEFAULT_CERT_SERIAL_NUMBER VARCHAR(255) Il numero di serie del certificato predefinito. CONFIG_ITEM"},{"UUID":"d03f5c87-b885-47c8-a553-9317269cce47","title":"Stampante","link":"config-item-topic.html","desc":"NETWORK_ADAPTER Questa tabella mostra la","descFull":"NETWORK_ADAPTER Questa tabella mostra la scheda di rete (nota anche come server di stampa) di una stampante fisica. NETWORK_ADAPTER Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. ADAPTER_TYPE VARCHAR(31) Sempre INA (internal network adapter, scheda di rete interna). ADAPTER_ID BIGINT La chiave primaria. FIRMWARE_REVISION VARCHAR(255) La revisione del firmware di rete corrente. MANUFACTURER VARCHAR(255) N/D MODEL_NAME VARCHAR(255) N/D SERIAL_NUMBER VARCHAR(50) N/D SYSTEM_NAME VARCHAR(255) N/D RETRIES INTEGER Il numero di tentativi di comunicazione con una stampante. SNMP_READ_COMMUNITY_NAME VARCHAR(255) Il nome della community SNMP per la lettura. TIMEOUT BIGINT Il numero di millisecondi da attendere affinché un tentativo di comunicazione con una stampante vada a buon fine. CONTACT_LOCATION VARCHAR(255) N/D CONTACT_NAME VARCHAR(255) N/D DOMAIN_NAME_SUFFIX VARCHAR(191) Il suffisso del nome di dominio associato alla scheda di rete in uso (ad esempio, foo.lexmark.com). In combinazione con HOSTNAME, restituisce il nome di dominio completo (FQDN). HOSTNAME VARCHAR(63) Il nome host associato alla scheda di rete in uso. MVE può essere configurato per recuperare il nome host dal DNS o dalla scheda di rete stessa. In combinazione con DOMAIN_NAME_SUFFIX, restituisce il nome di dominio completo (FQDN). IP_ADDRESS VARCHAR(15) La rappresentazione sotto forma di numero intero dell'indirizzo IP della scheda di rete in uso. Obsoleto. IP_ADDRESS_INT INTEGER La rappresentazione sotto forma di numero intero dell'indirizzo IP della scheda di rete in uso. IP_ADDRESS_SUBNET INTEGER La rappresentazione sotto forma di numero intero della subnet su cui risiede la scheda di rete in uso. MAC_CANONICAL VARCHAR(12) L'indirizzo MAC della scheda di rete in formato canonico. PORTS INTEGER Il numero di porte supportate dalla scheda di rete. Sempre 1. RAND_MAC SMALLINT/TINYINT * Il flag che indica se il valore corrente di MAC_CANONICAL è stato generato in modo casuale. CREDENTIAL_REQUIRED SMALLINT/TINYINT * Il flag che indica se è necessario specificare le credenziali per comunicare con la stampante associata. CREDENTIAL_PASSWORD BLOB SUB_TYPE 0 Questo valore è crittografato e non è utilizzabile al di fuori di MVE. CREDENTIAL_PIN BLOB SUB_TYPE 0 Questo valore è crittografato e non è utilizzabile al di fuori di MVE. CREDENTIAL_REALM VARCHAR(64) L'area di autenticazione delle credenziali, se impostata. CREDENTIAL_USERNAME VARCHAR(255) Il nome utente delle credenziali, se impostato. PORT_CONFIG_LST_TCP_OPEN SMALLINT/TINYINT * Il flag che indica se la porta sulla stampante associata è aperta. PORT_CONFIG_LST_UDP_OPEN SMALLINT/TINYINT * Il flag che indica se la porta sulla stampante associata è aperta. PORT_CONFIG_MDNS_OPEN SMALLINT/TINYINT * Il flag che indica se la porta sulla stampante associata è aperta. PORT_CONFIG_NPA_TCP_OPEN SMALLINT/TINYINT * Il flag che indica se la porta sulla stampante associata è aperta. PORT_CONFIG_NPA_UDP_OPEN SMALLINT/TINYINT * Il flag che indica se la porta sulla stampante associata è aperta. PORT_CONFIG_RAW_PRINT_OPEN SMALLINT/TINYINT * Il flag che indica se la porta sulla stampante associata è aperta. PORT_CONFIG_SNMP_OPEN SMALLINT/TINYINT * Il flag che indica se la porta sulla stampante associata è aperta. PORT_CONFIG_XML_TCP_OPEN SMALLINT/TINYINT * Il flag che indica se la porta sulla stampante associata è aperta. PORT_CONFIG_XML_UDP_OPEN SMALLINT/TINYINT * Il flag che indica se la porta sulla stampante associata è aperta. SECURE_COMMUNICATION_STATE VARCHAR(255) Lo stato della comunicazione. Le opzioni sono UNSECURED, MISSING_CREDENTIALS e SECURED. USER_PASSWORD Blob sub_type 0 La parte del nome utente delle credenziali. SNMP_USERNAME VARCHAR(32) Il nome utente utilizzato per le comunicazioni SNMPv3. SNMP_PASSWORD VARCHAR(255) Questo valore è crittografato e non è utilizzabile al di fuori di MVE. SNMP_MIN_AUTHENTICATION_LEVEL Varchar(50) Il livello minimo di autenticazione utilizzato per le comunicazioni SNMPv3. SNMP_AUTHENTICATION_HASH VARCHAR(50) L'autenticazione con hash utilizzata per le comunicazioni SNMPv3. SNMP_PRIVACY_ALGORITHM VARCHAR(50) L'algoritmo di privacy utilizzato per le comunicazioni SNMPv3. LOGIN_METHOD VARCHAR(256) Il metodo di autenticazione utilizzato per accedere alla stampante. LOGIN_METHOD_NAME VARCHAR(256) Se LOGIN_METHOD è LDAP o LDAP+GSSAPI, questo campo mostra il nome del metodo di autenticazione. TRACING_SERIAL_NUMBER VARCHAR(64) Il metodo di autenticazione utilizzato per tracciare il numero di serie. NETWORK_ADAPTER"},{"UUID":"fd077b9b-f4a2-4503-87ed-304706f052d5","title":"Stampante","link":"config-item-topic.html","desc":"NETWORK_PRINTER Questa tabella mostra la","descFull":"NETWORK_PRINTER Questa tabella mostra la parte della stampante fisica preposta alla stampa. NETWORK_PRINTER Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. PRINTER_ID BIGINT La chiave primaria. MANUFACTURER VARCHAR(255) L'azienda che ha prodotto la stampante. Può differire da DISPLAY_MANUFACTURER. MODEL_NAME VARCHAR(255) Il nome del modello della stampante. SERIAL_NUMBER VARCHAR(50) Il numero di serie della stampante. SYSTEM_NAME VARCHAR(255) Il nome utilizzato per identificare la periferica. COPY SMALLINT/TINYINT * Il flag che indica se la stampante supporta la copia. DUPLEX SMALLINT/TINYINT * Il flag che indica se la stampante supporta la stampa su due lati. ESF SMALLINT/TINYINT * Il flag che indica se la stampante supporta le applicazioni eSF. MARKING_TECHNOLOGY VARCHAR(255) Il tipo di tecnologia di contrassegno utilizzata dalla stampante (ad esempio, elettrofotografica). MEMORY BIGINT La quantità di memoria in byte. PROFILE SMALLINT/TINYINT * Il flag che indica se la stampante in uso supporta i profili. RECEIVE_FAX SMALLINT/TINYINT * Il flag che indica se la stampante in uso supporta la ricezione dei fax. SCAN_TO_EMAIL SMALLINT/TINYINT * Il flag che indica se la stampante in uso supporta l'acquisizione su e-mail. SCAN_TO_FAX SMALLINT/TINYINT * Il flag che indica se la stampante in uso supporta l'acquisizione su fax. SCAN_TO_NETWORK SMALLINT/TINYINT * Il flag che indica se la stampante in uso supporta l'acquisizione in rete. SPEED VARCHAR(255) Il numero di fogli al minuto stampabili dalla stampante. DISPLAY_MANUFACTURER VARCHAR(255) Il nome visualizzato sulla parte esterna della stampante. Ad esempio, MANUFACTURER potrebbe essere LEXMARK, ma DISPLAY_MANUFACTURER potrebbe essere Dell. FAMILY_ID INTEGER L'ID famiglia NPA. INITIAL_DISCOVERY_TIMESTAMP TIMESTAMP Indica quando la stampante è stata rilevata per la prima volta. LIFETIME_PAGE_COUNT BIGINT Il conteggio delle pagine complessive MAINTENANCE_COUNTER BIGINT Il contatore di manutenzione. ADAPTER_PORT INTEGER La porta su cui la stampante in uso è collegata alla scheda di rete associata. Al momento è sempre 1. PROPERTY_TAG VARCHAR(255) L'etichetta della risorsa o della proprietà o la targhetta in ottone. ADAPTER_ID BIGINT La chiave esterna per NETWORK_ADAPTER.ADAPTER_ID. RAND_SN SMALLINT/TINYINT * Il flag che indica se il valore corrente di SERIAL_NUMBER è stato generato in modo casuale. DEV_STATUS_REG_COUNTER INTEGER Il numero di registrazioni dello stato della periferica. SCANNER_SERIAL_NUMBER VARCHAR(12) Per le MFP modulari, il numero di serie della testina di acquisizione. DISK_ENCRYPTION VARCHAR(8) La frequenza di abilitazione della crittografia del disco. DISK_WIPING VARCHAR(8) La frequenza di abilitazione della pulizia del disco. COLOR SMALLINT/TINYINT * Il flag che indica se la stampante esegue la stampa a colori. PRINTER_STATUS_SUMMARY SMALLINT/TINYINT * L'indicatore del messaggio di stato più grave presente sulla stampante. SUPPLY_STATUS_SUMMARY SMALLINT/TINYINT * L'indicatore del messaggio più grave sullo stato dei materiali di consumo presente sulla stampante. TLI VARCHAR(255) L'indicatore di livello superiore (TLI) del modello di stampante. FAX_STATION_NAME VARCHAR(255) Il valore dell'impostazione del nome fax sulla stampante. FAX_STATION_NUMBER VARCHAR(255) Il valore dell'impostazione del numero fax sulla stampante. SCANNER_SERIAL_NUMBER VARCHAR(50) Il numero di serie dello scanner della stampante. TIME_ZONE VARCHAR(255) L'ID dei diversi fusi orari supportati dalla stampante. MODULAR_SERIAL_NUMBER VARCHAR(255) Il numero di serie modulare. TRACING_SERIAL_NUMBER VARCHAR(64) Il metodo di autenticazione utilizzato per tracciare il numero di serie. NETWORK_PRINTER"},{"UUID":"6d03bc51-1047-4ca5-8b72-3bcba508b1f7","title":"Stampante","link":"config-item-topic.html","desc":"PRINTER_CURRENT_STATUS Questa tabella mostra lo","descFull":"PRINTER_CURRENT_STATUS Questa tabella mostra lo stato della stampante al momento della raccolta dei dati. In questa tabella è presente una riga per ogni stato di una determinata stampante; tutte le righe fanno riferimento allo stesso PRINTER_ID. PRINTER_CURRENT_STATUS Nome campo Tipo di dati Per STATUS_ID BIGINT La chiave primaria. STATUS_MESSAGE VARCHAR(255) Il testo dello stato (ad esempio, Vassoio 1 in esaurimento). STATUS_SEVERITY VARCHAR(255) La gravità dello stato (ad esempio, Avvertenza). STATUS_TYPE VARCHAR(255) Il tipo di stato (ad esempio, Stampante o Materiale di consumo). PRINTER_ID BIGINT La chiave esterna per NETWORK_PRINTER.PRINTER_ID. PRINTER_CURRENT_STATUS"},{"UUID":"eea10591-61b2-49b7-820f-989581f0edf9","title":"Stampante","link":"config-item-topic.html","desc":"PRINTER_ESF_APPS Questa tabella mostra le","descFull":"PRINTER_ESF_APPS Questa tabella mostra le applicazioni eSF installate sulle stampanti al momento della raccolta dei dati. In questa tabella è presente una riga per ogni applicazione eSF attualmente installata su una determinata stampante; tutte le righe fanno riferimento allo stesso PRINTER_ID. PRINTER_ESF_APPS Nome campo Tipo di dati Per APPLICATION_ID BIGINT La chiave primaria. NAME VARCHAR(255) Il nome dell'applicazione. STATE VARCHAR(255) Lo stato corrente. VERSION VARCHAR(255) La versione corrente. PRINTER_ID BIGINT La chiave esterna per NETWORK_PRINTER.PRINTER_ID. PRINTER_ESF_APPS"},{"UUID":"740b74b1-539e-4985-b2ee-9bdc32664f43","title":"Stampante","link":"config-item-topic.html","desc":"PRINTER_INPUT_OPTIONS Questa tabella mostra le","descFull":"PRINTER_INPUT_OPTIONS Questa tabella mostra le opzioni di alimentazione installate sulle stampanti al momento della raccolta dei dati. In questa tabella è presente una riga per ogni opzione di alimentazione attualmente installata su una determinata stampante; tutte le righe fanno riferimento allo stesso PRINTER_ID. PRINTER_INPUT_OPTIONS Nome campo Tipo di dati Per INPUT_OPTION_ID BIGINT La chiave primaria. NAME VARCHAR(255) Il nome dell'opzione di alimentazione (ad esempio, Vassoio multifunzione). PRINTER_ID BIGINT La chiave esterna per NETWORK_PRINTER.PRINTER_ID. PRINTER_INPUT_OPTIONS"},{"UUID":"440b842f-1f2a-4870-a193-163fa438619a","title":"Stampante","link":"config-item-topic.html","desc":"PRINTER_INPUT_TRAYS Questa tabella mostra i","descFull":"PRINTER_INPUT_TRAYS Questa tabella mostra i vassoi di alimentazione associati a un'opzione di alimentazione. In questa tabella è presente una riga per ogni vassoio di alimentazione associato a una determinata opzione di alimentazione; tutte le righe fanno riferimento allo stesso INPUT_OPTION_ID. PRINTER_INPUT_TRAYS Nome campo Tipo di dati Per INPUT_OPTION_ID BIGINT La chiave esterna per PRINTER_INPUT_OPTIONS.INPUT_OPTION_ID. CAPACITY BIGINT Il numero massimo di fogli che il vassoio può contenere. FEED_TYPE VARCHAR(255) Manuale o Automatica. FORM_SIZE VARCHAR(255) Il formato carta corrente (ad esempio Letter). FORM_TYPE VARCHAR(255) Il tipo di carta corrente (ad esempio Carta normale). TYPE VARCHAR(255) Il tipo di vassoio di alimentazione (ad esempio, Alimentatore multiuso). PRINTER_INPUT_TRAYS"},{"UUID":"9405cd71-6bd2-4736-ba41-f19f6955e6f4","title":"Stampante","link":"config-item-topic.html","desc":"PRINTER_OPTIONS Questa tabella mostra le","descFull":"PRINTER_OPTIONS Questa tabella mostra le opzioni installate sulle stampanti al momento della raccolta dei dati. In questa tabella è presente una riga per ogni opzione attualmente installata su una determinata stampante; tutte le righe fanno riferimento allo stesso PRINTER_ID. In genere, l'opzione è una periferica di memorizzazione. PRINTER_OPTIONS Nome campo Tipo di dati Per OPTION_ID BIGINT La chiave primaria. FREESPACE_ BIGINT Lo spazio libero rimanente sulla periferica di memorizzazione. NAME VARCHAR(255) Il nome dell'opzione della stampante (ad esempio, DISK). SIZE_ BIGINT La quantità totale di spazio. PRINTER_ID BIGINT La chiave esterna per NETWORK_PRINTER.PRINTER_ID. PRINTER_OPTIONS"},{"UUID":"bb915a76-76eb-43b2-8d71-01592c56d305","title":"Stampante","link":"config-item-topic.html","desc":"PRINTER_OUTPUT_BINS Questa tabella mostra i","descFull":"PRINTER_OUTPUT_BINS Questa tabella mostra i raccoglitori di uscita associati a un'opzione di uscita. In questa tabella è presente una riga per ogni raccoglitore di uscita associato a una determinata opzione di uscita; tutte le righe fanno riferimento allo stesso OUTPUT_OPTION_ID. PRINTER_OUTPUT_BINS Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. OUTPUT_OPTION_ID BIGINT La chiave esterna per PRINTER_OUTPUT_OPTIONS.OUTPU T_OPTION_ID. BINDING SMALLINT/TINYINT * Il flag che indica se il raccoglitore in uso supporta la rilegatura. BURSTING SMALLINT/TINYINT * Il flag che indica se il raccoglitore in uso supporta il bursting. CAPACITY BIGINT Il numero massimo di fogli che il raccoglitore può contenere. COLLATION SMALLINT/TINYINT * Il flag che indica se il raccoglitore in uso supporta la fascicolazione. FACE_DOWN SMALLINT/TINYINT * Il flag che indica se la carta è caricata con il lato di stampa rivolto verso il basso nel raccoglitore in uso. FACE_UP SMALLINT/TINYINT * Il flag che indica se la carta è caricata con il lato di stampa rivolto verso l'alto nel raccoglitore in uso. LEVEL_SENSING SMALLINT/TINYINT * Il flag che indica se il raccoglitore in uso supporta il rilevamento del livello della carta. PUNCHING SMALLINT/TINYINT * Il flag che indica se il raccoglitore in uso supporta la perforazione. SECURITY SMALLINT/TINYINT * Il flag che indica se il raccoglitore in uso supporta la protezione. SEPARATION SMALLINT/TINYINT * Il flag che indica se il raccoglitore in uso supporta la separazione. STITICHING SMALLINT/TINYINT * Il flag che indica se il raccoglitore in uso supporta la cucitura. TYPE VARCHAR(255) Il tipo di raccoglitore di uscita della stampante (ad esempio, Raccoglitore standard, Raccoglitore 5, ecc.) PRINTER_OUTPUT_BINS"},{"UUID":"5d1120ec-ea8d-490d-976e-a5e154cfc92e","title":"Stampante","link":"config-item-topic.html","desc":"PRINTER_OUTPUT_OPTIONS Questa tabella mostra le","descFull":"PRINTER_OUTPUT_OPTIONS Questa tabella mostra le opzioni di uscita installate sulle stampanti. In questa tabella è presente una riga per ogni opzione di uscita attualmente installata su una determinata stampante; tutte le righe fanno riferimento allo stesso PRINTER_ID. PRINTER_OUTPUT_OPTIONS Nome campo Tipo di dati Per OUTPUT_OPTION_ID BIGINT La chiave primaria. NAME VARCHAR(255) Il nome dell'opzione (ad esempio, Raccoglitore integrato, Mailbox e Fascicolatore). PRINTER_ID BIGINT La chiave esterna per NETWORK_PRINTER.PRINTER_ID. PRINTER_OUTPUT_OPTIONS"},{"UUID":"9a778f61-c3b2-42d9-a95d-a86b305c0a78","title":"Stampante","link":"config-item-topic.html","desc":"PRINTER_STATISTICS Questa tabella contiene le","descFull":"PRINTER_STATISTICS Questa tabella contiene le informazioni raccolte dai dati dei contatori della stampante. Ogni riga mostra i dati di una singola stampante. Le colonne applicabili variano a seconda del modello di stampante a cui è associato il record. PRINTER_STATISTICS Nome campo Tipo di dati Per STATISTICS_ID BIGINT La chiave primaria. COVG_LAST_JOB_BLACK BIGINT La copertura del toner nero dell'ultimo processo di stampa. COVG_LIFETIME_BLACK BIGINT La copertura del toner nero di tutti i processi di stampa. CART_PAGES_PRINT_BLACK BIGINT Il numero di pagine stampate utilizzando la cartuccia di toner nero. BLACK_TONER_LEVEL VARCHAR(255) Il livello corrente della cartuccia di toner nero. PHOTO_COND_LEVEL_K VARCHAR(255) Il livello corrente del fotoconduttore (nero). BLANK_SAFE_SIDE_COPY BIGINT Il numero di lati di una copia che possono essere lasciati vuoti. BLANK_SAFE_SIDE_FAX BIGINT Il numero di lati di un fax che possono essere lasciati vuoti. BLANK_SAFE_SIDE_PRINT BIGINT Il numero di lati di una stampa che possono essere lasciati vuoti. PAPER_CHANGE BIGINT Il numero di eventi di cambio carta. COVER_OPEN BIGINT Il numero di eventi di apertura del coperchio. COVG_LAST_JOB_CYAN BIGINT La copertura del toner ciano dell'ultimo processo di stampa. COVG_LIFETIME_CYAN BIGINT La copertura del toner ciano di tutti i processi di stampa. CART_PAGES_PRINT_CYAN BIGINT Il numero di pagine stampate utilizzando la cartuccia di toner ciano. CYAN_TONER_LEVEL VARCHAR(255) Il livello corrente della cartuccia di toner ciano. CYAN_TONER_STATUS VARCHAR(255) Il livello della cartuccia ciano (ad esempio, Intermedio). YELLOW_TONER_STATUS VARCHAR(255) Il livello della cartuccia giallo (ad esempio, Intermedio). MAGENTA_TONER_STATUS VARCHAR(255) Il livello della cartuccia magenta (ad esempio, Intermedio). BLACK_TONER_STATUS VARCHAR(255) Il livello della cartuccia nero (ad esempio, Intermedio). PHOTO_COND_LEVEL_C VARCHAR(255) Il livello corrente del fotoconduttore (ciano). DEVICE_INSTALL_DATE TIMESTAMP La data e l'ora della prima installazione della stampante. FUSER_CURRENT_LEVEL VARCHAR(255) Il livello corrente del fusore. IMG_SAFE_SIDE_COPY BIGINT Il numero di lati con immagini stampate di un processo di copia. IMG_SAFE_SIDE_FAX BIGINT Il numero di lati con immagini stampate di un processo fax. IMG_SAFE_SIDE_PRINT BIGINT Il numero di lati con immagini stampate di un processo di stampa. LAST_FAX_JOB_DATE TIMESTAMP La data e l'ora dell'ultimo processo fax. LAST_PRINTED_JOB_DATE TIMESTAMP La data e l'ora dell'ultimo processo di stampa. LAST_SCAN_JOB_DATE TIMESTAMP La data e l'ora dell'ultimo processo di acquisizione. COVG_LAST_JOB_MAGENTA BIGINT La copertura del toner magenta dell'ultimo processo. COVG_LIFETIME_MAGENTA BIGINT La copertura del toner magenta di tutti i processi. CART_PAGES_PRINT_MAGENTA BIGINT Il numero di pagine stampate utilizzando la cartuccia di toner magenta. MAGENTA_TONER_LEVEL VARCHAR(255) Il livello corrente della cartuccia di toner magenta. PHOTO_COND_LEVEL_M VARCHAR(255) Il livello corrente del fotoconduttore (magenta). MAINT_KIT_LEVEL VARCHAR(255) Il livello corrente del kit di manutenzione. MEDIA_SIZE_TYPE_MONO_SIDE_ SAFE BIGINT I lati stampati in bianco e nero (sicuri). MEDIA_SIZE_TYPE_COLOR_SIDE_ SAFE BIGINT I lati stampati a colori (sicuri). SUPPLY_EVENTS BIGINT Il numero di altri eventi relativi ai materiali di consumo. PAPER_JAMS BIGINT Il numero di eventi di inceppamento carta. PAPER_LOAD BIGINT Il numero di eventi di caricamento della carta. PRINT_SHEET_USE_PICKED BIGINT I fogli stampati (prelevati). PRINT_SIDE_USE_PICKED BIGINT I lati stampati (prelevati). POR BIGINT Il numero di reset all'accensione. PRINT_AND_HOLD_JOB BIGINT Il numero di processi di tipo Stampa e mantieni. SAFE_SHT_COPY BIGINT I fogli stampati (sicuri) dei processi di copia. SAFE_SHT_FAX BIGINT I fogli stampati (sicuri) dei processi fax. SAFE_SHT_PRINT BIGINT I fogli stampati (sicuri) dei processi di stampa. SCAN_PAPER_JAMS BIGINT Il numero di inceppamenti dello scanner. PRINTED_FROM_PRINT_AND_HOLD BIGINT Il numero di processi di tipo Stampa e mantieni stampati. PRINTED_FROM_USB BIGINT Il numero di stampe da USB. TRANS_BELT_LEVEL VARCHAR(255) Il livello corrente del materiale di consumo del nastro di trasferimento. USB_DIRECT_JOB BIGINT Il numero di inserimenti di periferiche USB. WASTE_TONER_LEVEL VARCHAR(255) Il livello corrente del contenitore del toner di scarto. COVG_LAST_JOB_YELLOW BIGINT La copertura del toner giallo dell'ultimo processo. COVG_LIFETIME_YELLOW BIGINT La copertura del toner giallo di tutti i processi. CART_PAGES_PRINT_YELLOW BIGINT Il numero di pagine stampate utilizzando la cartuccia di toner giallo. YELLOW_TONER_LEVEL VARCHAR(255) Il livello corrente della cartuccia di toner giallo. PHOTO_COND_LEVEL_Y VARCHAR(255) Il livello corrente del fotoconduttore (giallo). IMG_SAFE_SIDE_PRINT_MONO BIGINT Il numero di lati in bianco e nero con immagini stampate (sicuri) dei processi di stampa. IMG_SAFE_SIDE_PRINT_COLOR BIGINT Il numero di lati a colori con immagini stampate (sicuri) dei processi di stampa. IMG_SAFE_SIDE_COPY_MONO BIGINT Il numero di lati in bianco e nero con immagini stampate (sicuri) dei processi di copia. IMG_SAFE_SIDE_COPY_COLOR BIGINT Il numero di lati a colori con immagini stampate (sicuri) dei processi di copia. IMG_SAFE_SIDE_FAX_MONO BIGINT Il numero di lati in bianco e nero con immagini stampate (sicuri) dei processi fax. IMG_SAFE_SIDE_FAX_COLOR BIGINT Il numero di lati a colori con immagini stampate (sicuri) dei processi fax. FAX_JOB_RECV BIGINT Il numero di processi fax ricevuti. FAX_JOB_SENT BIGINT Il numero di processi fax inviati. FAX_PAGE_RECV BIGINT Il numero di pagine fax ricevute. FAX_PAGE_SENT BIGINT Il numero di pagine fax inviate. SCAN_COPY BIGINT Il numero di acquisizioni dei processi di copia. SCAN_FAX BIGINT Il numero di acquisizioni del fax. SCAN_LOCAL BIGINT Il numero di acquisizioni locali. SCAN_NET BIGINT Il numero di acquisizioni in rete. SCAN_FLAT BIGINT Il numero di acquisizioni della superficie piana del vetro dello scanner. SCAN_ADF_SIMPLEX BIGINT Il numero di acquisizioni dell'ADF (una facciata). SCAN_ADF_DUPLEX BIGINT Il numero di acquisizioni dell'ADF (fronte/retro). SCAN_USB_DIRECT BIGINT Il numero di acquisizioni dirette su USB. USB_DIRECT_INSERT BIGINT Il numero di inserimenti di periferiche USB. CART_INST_DATE_CYAN TIMESTAMP La data e l'ora di installazione della cartuccia ciano. CART_INST_DATE_YELLOW TIMESTAMP La data e l'ora di installazione della cartuccia giallo. CART_INST_DATE_MAGENTA TIMESTAMP La data e l'ora di installazione della cartuccia magenta. CART_INST_DATE_BLACK TIMESTAMP La data e l'ora di installazione della cartuccia nero. PRINTER_ID BIGINT La chiave esterna per NETWORK_PRINTER.PRINTER_ID. MAINT_KIT_STATUS_100K VARCHAR(255) Livello del kit di manutenzione 100K. MAINT_KIT_STATUS_160K VARCHAR(255) Livello del kit di manutenzione 160K. MAINT_KIT_STATUS_200K VARCHAR(255) Livello del kit di manutenzione 200K. MAINT_KIT_STATUS_300K VARCHAR(255) Livello del kit di manutenzione 300K. MAINT_KIT_STATUS_320K VARCHAR(255) Livello del kit di manutenzione 320K. MAINT_KIT_STATUS_480K VARCHAR(255) Livello del kit di manutenzione 480K. MAINT_KIT_STATUS_600K VARCHAR(255) Livello del kit di manutenzione 600K. PRINTER_STATISTICS"},{"UUID":"0bd3f134-a061-4325-8e58-9c74a8e504d5","title":"Stampante","link":"config-item-topic.html","desc":"PRINTER_SUPPLIES Questa tabella mostra i","descFull":"PRINTER_SUPPLIES Questa tabella mostra i materiali di consumo nelle stampanti. In questa tabella è presente una riga per ogni materiale di consumo di una determinata stampante; tutte le righe fanno riferimento allo stesso PRINTER_ID. Le colonne applicabili variano a seconda del tipo. PRINTER_SUPPLIES Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. SUPPLY_ID BIGINT La chiave primaria. CAPACITY BIGINT La capacità massima del materiale di consumo in termini di fogli. COLOR VARCHAR(255) Il colore del materiale di consumo (ad esempio nero, ciano o NULLO). NAME VARCHAR(255) Il nome del materiale di consumo (ad esempio Toner nero, Fusore e Contenitore scarti). SMART_CARTRIDGE_PREBATE SMALLINT/TINYINT * Il flag che indica se il materiale di consumo è una cartuccia intelligente Prebate. SMART_CARTRIDGE_REFILLED SMALLINT/TINYINT * Il flag che indica se il materiale di consumo è la ricarica di una cartucce intelligente. SMART_CARTRIDGE_SERIAL_NUM BER VARCHAR(255) Il numero di serie della cartuccia intelligente. TYPE VARCHAR(255) Il tipo di materiale di consumo (ad esempio, Toner, Nastro di trasferimento, Fusore, Contenitore o Unità immagini). PRINTER_ID BIGINT La chiave esterna per NETWORK_PRINTER.PRINTER_ID. PERCENT_FULL BIGINT La percentuale rimanente calcolata del materiale di consumo. PRINTER_SUPPLIES"},{"UUID":"abbafb3a-5451-4683-bc57-e0f5ed206f5d","title":"Stampante","link":"config-item-topic.html","desc":"CHANGED_SETTINGS Questa tabella contiene informazioni","descFull":"CHANGED_SETTINGS Questa tabella contiene informazioni sulle impostazioni che sono state modificate tra le ultime due verifiche. CHANGED_SETTINGS Nome campo Tipo di dati Per ID BIGINT La chiave primaria. CI_ID BIGINT Si riferisce a CONFIG_ITEM.ID. SETTING_NAME VARCHAR(255) Il nome dell'impostazione modificata. CHANGE_TYPE VARCHAR(255) Il tipo di modifica. Le opzioni sono ADD, UPDATE e REMOVE. CHANGED_SETTINGS"},{"UUID":"8cea974c-556e-4eb9-8295-3bafce0ed106","title":"Stampante","link":"config-item-topic.html","desc":"PRINTER_PORTS Questa tabella contiene informazioni","descFull":"PRINTER_PORTS Questa tabella contiene informazioni sullo stato delle porte TCP/UDP della stampante. PRINTER_PORTS Nome campo Tipo di dati Per PRINTER_PORTS_ID BIGINT La chiave primaria. PRINTER_ID BIGINT Si riferisce a PRINTER.ID. TCP21 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. UDP69 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP79 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP80 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. UDP137 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. UDP161 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. UDP162 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP515 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP631 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP5001 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. UDP5353 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP8000 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP9100 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP9200 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. UDP9200 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. UDP9300 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. UDP9301 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. UDP9302 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP9400 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP9500 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP9501 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP9600 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. UDP9700 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP9000 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP5000 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP443 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP4000 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. UDP6100 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP6100 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP65002 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP65004 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP65004 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP65001 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TCP65003 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. PRINTER_PORTS"},{"UUID":"f3710ac9-296a-46e0-afb7-42a9791b6d96","title":"Stampante","link":"config-item-topic.html","desc":"PRINTER_SECURITY-OPTIONS Questa tabella contiene informazioni","descFull":"PRINTER_SECURITY-OPTIONS Questa tabella contiene informazioni relative ai dettagli di protezione della stampante. PRINTER_SECURITY-OPTIONS Nome campo Tipo di dati Per PRINTER_SECURITY_ID BIGINT La chiave primaria. PRINTER_ID BIGINT Si riferisce a PRINTER.ID. OWASP_CIPHER_CATEGORY VARCHAR(500) L'elenco delle categorie di crittografia supportate dalla periferica. TLS10 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. TLS11 VARCHAR(255) Le opzioni sono OFF, ON, UNKNOWN e NONE. PRINTER_SECURITY-OPTIONS"},{"UUID":"4d393669-1788-4d37-ade4-3b4ddbeda469","title":"Parole chiave","link":"config-item-topic.html","desc":"ASSIGNED_KEYWORDS Questa tabella mostra le","descFull":"ASSIGNED_KEYWORDS Questa tabella mostra le parole chiave assegnate ai rispettivi CI e stampanti. ASSIGNED_KEYWORDS Nome campo Tipo di dati Per KEYWORD_ID BIGINT La chiave primaria composta e la chiave esterna per KEYWORD.KEYWORD_ID. CI_ID BIGINT La chiave primaria composta e la chiave esterna per CONFIGURATION_ITEM.CI_ID. ASSIGNED_KEYWORDS"},{"UUID":"b2c754e9-be5d-4a29-b0fa-3e437d96c841","title":"Parole chiave","link":"config-item-topic.html","desc":"KEYWORD Questa tabella mostra tutte","descFull":"KEYWORD Questa tabella mostra tutte le parole chiave definite nel sistema. KEYWORD Nome campo Tipo di dati Per KEYWORD_ID BIGINT La chiave primaria. KEYWORD_VALUE VARCHAR(255) Il nome della parola chiave. CATEGORY_ID BIGINT La chiave esterna per KEYWORD_CATEGORY.CATEGORY_ID. KEYWORD"},{"UUID":"fbf37afb-a6de-4c7e-9f90-53bfa8a0e088","title":"Parole chiave","link":"config-item-topic.html","desc":"KEYWORD_CATEGORY Questa tabella elenca tutte","descFull":"KEYWORD_CATEGORY Questa tabella elenca tutte le categorie definite nel sistema ed è utilizzata per raggruppare le parole chiave. KEYWORD_CATEGORY Nome campo Tipo di dati Per CATEGORY_ID BIGINT La chiave primaria. CATEGORY_VALUE VARCHAR(255) Il nome della categoria. KEYWORD_CATEGORY"},{"UUID":"90d0d3d7-6235-4dab-9678-b42a912a4439","title":"Configurazioni","link":"config-item-topic.html","desc":"CONFIGURATION Questa tabella mostra il","descFull":"CONFIGURATION Questa tabella mostra il livello più alto di configurazione di una stampante, inclusi nome e modello della stampante e se può essere assegnata. CONFIGURATION Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. CONFIGURATION_ID BIGINT La chiave primaria. CONFIGURATION_NAME VARCHAR(255) Il nome della configurazione. ASSIGNABLE SMALLINT/TINYINT * Il flag che indica se la configurazione è assegnabile. DESCRIPTION VARCHAR(4000) Una descrizione della configurazione immessa dall'utente. LAST_MODIFIED TIMESTAMP La data e l'ora dell'ultima modifica della configurazione. MANAGING_DEV_CERTIFICATE BOOLEAN Il valore booleano predefinito. Questo campo indica se la configurazione gestisce automaticamente il certificato della periferica. CONFIGURATION"},{"UUID":"130e1e02-3c54-428e-a81a-3298e4d72bd0","title":"Configurazioni","link":"config-item-topic.html","desc":"CONFIGURATION_COMPONENT Questa tabella mostra un","descFull":"CONFIGURATION_COMPONENT Questa tabella mostra un componente di una configurazione. CONFIGURATION_COMPONENT Nome campo Tipo di dati Per CONFIGURATION_COMPONENT_ID BIGINT La chiave primaria. COMPONENT_TYPE VARCHAR(255) Il tipo di componente. Le opzioni sono DEVICE_SETTINGS, SECURITY_CAESAR1, SECURITY_CAESAR2, ESF e FIRMWARE. CREDENTIAL_PASSWORD BLOB SUB_TYPE 0 La password delle credenziali crittografata, se impostata. CREDENTIAL_PIN BLOB SUB_TYPE 0 Il PIN delle credenziali crittografato, se impostato. CREDENTIAL_REALM VARCHAR(255) L'area di autenticazione delle credenziali, se impostata. CREDENTIAL_USERNAME VARCHAR(255) Il nome utente delle credenziali, se impostato. COMPONENT_NAME VARCHAR(255) Il nome del componente. LICENSE_TYPE VARCHAR(255) Il tipo di licenza del componente di configurazione. Le opzioni sono PRODUCTION, TRIAL e FACTORY. LOGIN_METHOD VARCHAR(256) Il metodo di autenticazione utilizzato per accedere alla stampante. MERGE_DATA_PATH VARCHAR(255) La posizione di un file delle impostazioni delle variabili. FLASH_FILE_SHA1 VARCHAR(255) L'hash SHA1 del file flash per un componente firmware. LOGIN_METHOD_NAME VARCHAR(256) Se LOGIN_METHOD è LDAP o LDAP+GSSAPI, questo campo mostra il nome del metodo di accesso specifico. DESCRIPTION VARCHAR(4000) Questo campo mostra la descrizione, se viene aggiunta in un componente. LAST_MODIFIED TIMESTAMP La data e l'ora dell'ultima modifica. ASSIGNABLE Booleano Il valore è true se il componente è assegnato a una stampante. In caso contrario, è false. PRE_POPULATED Booleano Aggiunto per identificare i componenti di protezione avanzata precompilati. CONFIGURATION_COMPONENT"},{"UUID":"f49770fd-a44a-48d2-98fb-2467ba055a13","title":"Configurazioni","link":"config-item-topic.html","desc":"CONFIGURATION_COMPONENTS Questa tabella contiene informazioni","descFull":"CONFIGURATION_COMPONENTS Questa tabella contiene informazioni sui vari componenti correlati alle diverse configurazioni, se selezionati. CONFIGURATION_COMPONENTS Nome campo Tipo di dati Per CONFIGURATION_ID BIGINT La chiave esterna per CONFIGURATION.CONFIGURATION_ID. CONFIGURATION_COMPONENT_ID BIGINT La chiave esterna per CONFIGURATION_COMPONENT. CONFIGURATION_COMPONENT_ID. COMPONENT_TYPE VARCHAR(255) Aggiunto per distinguere tra il componente di impostazione della periferica e altri otto componenti. CONFIGURATION_COMPONENTS"},{"UUID":"78f6d0d9-cbe0-4791-a58a-d8373db90249","title":"Configurazioni","link":"config-item-topic.html","desc":"ASSIGNED_CONFIGURATIONS Questa tabella mostra le","descFull":"ASSIGNED_CONFIGURATIONS Questa tabella mostra le configurazioni assegnate ai singoli CI e alle singole stampanti. ASSIGNED_CONFIGURATIONS Nome campo Tipo di dati Per CI_ID BIGINT La chiave primaria composta e la chiave esterna reimpostate su CONFIGURATION_ITEM.CI_ID. CONFIGURATION_ID BIGINT La chiave primaria composta e la chiave esterna reimpostate su CONFIGURATION.CONFIGURATION_ID. COMPLIANCE_STATE VARCHAR(255) Lo stato di conformità corrente per la configurazione. LAST_COMPLIANCE_CHECK TIMESTAMP La data e l'ora dell'ultimo controllo di conformità. ASSIGNED_CONFIGURATIONS"},{"UUID":"2d9dd8e9-b234-4707-85f7-b54376ff8b0e","title":"Configurazioni","link":"config-item-topic.html","desc":"FAILED_COMPONENT Questa tabella include tutti","descFull":"FAILED_COMPONENT Questa tabella include tutti i componenti che presentano un'impostazione non conforme. FAILED_COMPONENT Nome campo Tipo di dati Per FAILED_COMPONENT_ID BIGINT La chiave primaria. CI_ID BIGINT La chiave esterna reimpostata su ASSIGNED_CONFIGURATIONS.CI_ID. CONFIGURATION_ID BIGINT (non nullo) La chiave esterna reimpostata su ASSIGNED_CONFIGURATIONS.CONFIGURATION_ID. COMPONENT_TYPE VARCHAR(255) Il tipo di componente in errore. COMPONENT_NAME VARCHAR(255) Il nome del componente in errore. FAILED_COMPONENT"},{"UUID":"5e1a88b2-5c4c-4489-809b-32e850d4e5a4","title":"Configurazioni","link":"config-item-topic.html","desc":"FAILED_COMPONENT_SETTINGS Questa tabella include tutte","descFull":"FAILED_COMPONENT_SETTINGS Questa tabella include tutte le impostazioni non conformi e i relativi valori. FAILED_COMPONENT_SETTINGS Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. TYPE SMALLINT/ TINYINT * , valore predefinito 0 Aggiunto per distinguere le cause degli errori di conformità tra Discrepanza, Inapplicabile, Non supportato, Risorsa non nella libreria e Impossibile unire le impostazioni del token. FAILED_COMPONENT_ID BIGINT (non nullo) La chiave esterna reimpostata su FAILED_COMPONENT.FAILED_COMPONENT_ID. SETTING_NAME VARCHAR(255) Il nome dell'impostazione in errore. PRINTER_VALUE dropNotNullConstraint Può essere un valore nullo. COMPONENT_VALUE dropNotNullConstraint Può essere un valore nullo. FAILED_COMPONENT_SETTINGS"},{"UUID":"48db8361-3879-4d3c-9d4d-68e8e451e99f","title":"Configurazioni","link":"config-item-topic.html","desc":"FLASHFILE Questa tabella mostra informazioni","descFull":"FLASHFILE Questa tabella mostra informazioni sulle risorse della libreria del firmware MVE. FLASHFILE Nome campo Tipo di dati Per ID BIGINT La chiave primaria. FILENAME VARCHAR(256) Il nome e la posizione del file all'interno dell'archivio MVE. SHA1 VARCHAR(255) L'hash SHA1 del file flash. DISPLAY_NAME VARCHAR(255) Un identificatore della versione del file flash. DATE_IMPORTED TIMESTAMP La data di importazione del file flash. DESCRIPTION VARCHAR(255) La descrizione del file flash. FLASHFILE"},{"UUID":"5f4e0e1c-8e4b-4b39-b06a-a98249af7994","title":"Configurazioni","link":"config-item-topic.html","desc":"FLASH_NET_IDS Questa tabella memorizza l'ID","descFull":"FLASH_NET_IDS Questa tabella memorizza l'ID NETFLASH riportato in alto in ciascun file flash nella libreria delle risorse. FLASH_NET_IDS Nome campo Tipo di dati Per FLASHNETID BIGINT La chiave primaria. NET_ID VARCHAR(255) L'ID NETFLASH. FLASH_NET_IDS"},{"UUID":"7ae3deca-7378-4ba6-88dd-4296cf5b0c59","title":"Configurazioni","link":"config-item-topic.html","desc":"CERTIFICATES Questa tabella mostra informazioni","descFull":"CERTIFICATES Questa tabella mostra informazioni sulle risorse della libreria dei certificati CA di MVE. CERTIFICATES Nome campo Tipo di dati Per CERTIFICATE_ID BIGINT La chiave primaria. NAME VARCHAR(255) Il nome descrittivo di un certificato CA. PEM_CERTIFICATE BLOB La rappresentazione PEM di un certificato CA. DATE_IMPORTED TIMESTAMP La data di importazione del certificato CA in MVE. PEM_CERTIFICATE_SHA2 VARCHAR (64) Hash SHA2 del certificato CA. DESCRIPTION VARCHAR (255) Descrizione del certificato CA. CERTIFICATES"},{"UUID":"2f49109b-5003-4b48-a26c-36d8f3457a7f","title":"Configurazioni","link":"config-item-topic.html","desc":"CERTIFICATE_COMP_CERTIFICATES Questa tabella mostra il","descFull":"CERTIFICATE_COMP_CERTIFICATES Questa tabella mostra il collegamento del certificato nella libreria delle risorse a un componente di configurazione e quindi a una configurazione. CERTIFICATE_COMP_CERTIFICATES Nome campo Tipo di dati Per CONFIGURATION_COMP ONENT_ID BIGINT La chiave esterna reimpostata su CONFIGURATION_COMPONENT.CONFIGURATION_ COMPONENT_ID. CERTIFICATE_ID BIGINT La chiave esterna reimpostata su CERTIFICATES.CERTIFICATE_ID. CERTIFICATE_COMP_CERTIFICATES"},{"UUID":"c816352a-412a-42fb-a708-08ffd2776ec1","title":"Configurazioni","link":"config-item-topic.html","desc":"COMPONENT_SETTINGS Questa tabella mostra le","descFull":"COMPONENT_SETTINGS Questa tabella mostra le impostazioni di un determinato componente di configurazione. In questa tabella è presente una riga per ogni impostazione associata al componente di configurazione; tutte le righe fanno riferimento allo stesso CONFIGURATION_COMPONENT.CONFIGURATION_COMPONENT_ID. I valori sono crittografati e non sono disponibili al di fuori di MVE. COMPONENT_SETTINGS Nome campo Tipo di dati Per SETTING_ID BIGINT La chiave primaria. SETTING_NAME VARCHAR(255) Il nome dell'impostazione. SETTING_VALUE VARCHAR(1280) Il valore dell'impostazione crittografata. CONFIGURATION_COMPONENT_ID BIGINT La chiave esterna per CONFIGURATION_COMPONENT.CONFIG URATION_COMPONENT_ID. DISCRIMINATOR VARCHAR(255) Le opzioni sono SSIMPLE_SETTING e TABULAR_SETTING. TABULAR_SETTING_VALUE_ID BIGINT La chiave esterna per COMPONENT_TAB_SETTING_VALUE.TA BULAR_SETTING_VALUE_ID. COMPONENT_SETTINGS"},{"UUID":"cd47211c-1b97-470a-817c-70a69a2ab7e5","title":"Configurazioni","link":"config-item-topic.html","desc":"COMPONENT_TAB_TABLE Questa tabella mostra le","descFull":"COMPONENT_TAB_TABLE Questa tabella mostra le tabelle Autorizzazione stampa a colori incluse nelle configurazioni. COMPONENT_TAB_TABLE Nome campo Tipo di dati Per TABLE_ID BIGINT La chiave primaria. TABLE_TYPE VARCHAR(255) Le opzioni sono HOST_TABLE e USER_TABLE. COMPONENT_TAB_TABLE"},{"UUID":"15ed7318-359d-4276-8384-fb2b06dd4508","title":"Configurazioni","link":"config-item-topic.html","desc":"COMPONENT_TAB_ROW Questa tabella mostra una","descFull":"COMPONENT_TAB_ROW Questa tabella mostra una riga delle tabelle Autorizzazioni stampa a colori. I valori sono crittografati e non sono utilizzabili al di fuori di MVE. COMPONENT_TAB_ROW Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. TABLE_ID BIGINT La chiave esterna per COMPONENT_TAB_TABLE.TABLE_ID. HOST_NAME VARCHAR(255) Il valore dell'impostazione  Nome host  nella tabella host. USER_NAME VARCHAR(255) Il valore dell'impostazione  Nome utente  nella tabella utenti. ALLOWED_TO_PRINT_COLOR SMALLINT/TINYINT * Il valore dell'impostazione  Consenti stampa a colori  per le tabelle host e utenti. USER_PERMISSION_OV ERRIDDEN SMALLINT/TINYINT * Il valore dell'impostazione  Ignora autorizzazione utente  nella tabella host. COMPONENT_TAB_ROW"},{"UUID":"4e56ff93-b000-4211-a385-df557c78db5f","title":"Configurazioni","link":"config-item-topic.html","desc":"COMPONENT_TAB_SETTING_VALUE Questa tabella mostra la","descFull":"COMPONENT_TAB_SETTING_VALUE Questa tabella mostra la correlazione tra le tabelle Autorizzazioni stampa a colori e i componenti e, di conseguenza, le configurazioni. COMPONENT_TAB_SETTING_VALUE Nome campo Tipo di dati Per TABULAR_SETTING_VALUE_ID BIGINT La chiave esterna per COMPONENT_SETTINGS.TABULAR_SETTING_VALUE_ID. TABLE_ID BIGINT La chiave esterna per COMPONENT_TAB_TABLE.TABLE_ID. COMPONENT_TAB_SETTING_VALUE"},{"UUID":"2e668ae7-0c91-41f7-833d-5f93a35bc22a","title":"Configurazioni","link":"config-item-topic.html","desc":"CC_SUPPORTED_MODEL_BACKUP CC_SUPPORTED_MODEL_BACKUP Nome campo Tipo","descFull":"CC_SUPPORTED_MODEL_BACKUP CC_SUPPORTED_MODEL_BACKUP Nome campo Tipo di dati Per ID BIGINT La chiave primaria. SUPPORTED_MODEL VARCHAR(255) Utilizzato per creare un backup per i  componenti per l'impostazione della periferica  da CONFIGURATION e CONFIGURATION_COMPONENT. CC_SUPPORTED_MODEL_BACKUP"},{"UUID":"f1b09bc4-6321-418b-86f5-33f4895f64e2","title":"Configurazioni","link":"config-item-topic.html","desc":"ESF_COMP_PRODUCTS ESF_COMP_PRODUCTS Nome campo Tipo","descFull":"ESF_COMP_PRODUCTS ESF_COMP_PRODUCTS Nome campo Tipo di dati Per CONFIGURATION_COMPONENT_ID BIGINT I riferimenti alla chiave esterna. Tabella: CONFIGURATION_COMPONENT Colonna: CONFIGURATION_COMPONENT_ID PART_NUMBER VARCHAR(255) Il numero di parte del prodotto del componente della soluzione. ESF_COMP_PRODUCTS"},{"UUID":"5eb4dcb7-6e1c-4944-b52a-037ca887a400","title":"Configurazioni","link":"config-item-topic.html","desc":"VCCFILE VCCFILE Nome campo Tipo","descFull":"VCCFILE VCCFILE Nome campo Tipo di dati Per ID BIGINT La chiave primaria. FILENAME VARCHAR(255) Il nome del file caricato. DISPLAY_NAME VARCHAR(255) Il nome del file VCC visualizzato in MVE. DATE_IMPORTED TIMESTAMP La data e l'ora di caricamento del file. SHA1 VARCHAR(255) L'hash del contenuto del file. DESCRIPTION VARCHAR(255) La descrizione del file VCC. VCCFILE"},{"UUID":"725232c0-ba83-4b5c-9571-3181285ba3a6","title":"Configurazioni","link":"config-item-topic.html","desc":"UCFFILE UCFFILE Nome campo Tipo","descFull":"UCFFILE UCFFILE Nome campo Tipo di dati Per ID BIGINT La chiave primaria. FILENAME VARCHAR(255) Il nome del file caricato. DISPLAY_NAME VARCHAR(255) Il nome del file UCF visualizzato in MVE. DATE_IMPORTED TIMESTAMP La data e l'ora di caricamento del file. SHA1 VARCHAR(255) L'hash del contenuto del file. DESCRIPTION VARCHAR(255) La descrizione del file UCF. UCFFILE"},{"UUID":"a5241579-0700-4372-a917-5f91673d2741","title":"Configurazioni","link":"config-item-topic.html","desc":"UCF_VCC_RESOURCE_FILES Questa tabella contiene informazioni","descFull":"UCF_VCC_RESOURCE_FILES Questa tabella contiene informazioni sullo stato delle porte TCP/UDP della stampante. UCF_VCC_RESOURCE_FILES Nome campo Tipo di dati Per RESOURCE_ID BIGINT La chiave primaria. SHA1 VARCHAR(255) L'hash del contenuto del file. RESOURCE_TYPE VARCHAR(255) Il tipo di file di risorse. Le opzioni sono UCF_FILE, VCC_FILE e APP_FLS. CONFIGURATION_COMPONENT_ID VARCHAR(255) La chiave esterna dell'ID della tabella CONFIGURATION_COMPONENT. UCF_VCC_RESOURCE_FILES"},{"UUID":"8eb4ffc5-e259-4890-9c7b-65e3e5a0ad63","title":"Tabelle di FRAMEWORK e nomi dei campi","link":"config-item-topic.html","desc":"Profili di rilevamento Le seguenti","descFull":"Profili di rilevamento Le seguenti tabelle vengono utilizzate per monitorare i profili di rilevamento di MVE. DISCOVERY_PROFILE DISCOVERY_PROFILE Nome campo Tipo di dati Per ID BIGINT La chiave primaria. NAME VARCHAR(255) Il nome del profilo fornito dall'utente. RETRIES INTEGER Il numero di tentativi di comunicazione con una stampante. SNMP_READ_COMMUNITY_NAME VARCHAR(255) Il nome della community SNMP da usare durante la lettura. TIMEOUT BIGINT Il numero di millisecondi da attendere affinché un tentativo di comunicazione con una stampante vada a buon fine. SNMP_USERNAME VARCHAR(32) Il nome utente per la comunicazione SNMP. SNMP_PASSWORD VARCHAR(32) La password per la comunicazione SNMP. SNMP_MIN_AUTHENTICATION_LEVEL VARCHAR(255) Il livello minimo di autenticazione per SNMP. SNMP_AUTHENTICATION_HASH VARCHAR(50) L'hash utilizzato per l'autenticazione SNMP. SNMP_PRIVACY_ALGORITHM VARCHAR(50) L'algoritmo utilizzato per la privacy SNMP. DISCOVERY_PROFILE_CI Questa tabella contiene i componenti CI del profilo di rilevamento. DISCOVERY_PROFILE_CI Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. CI_DP_ID BIGINT La chiave primaria e la chiave esterna per DISCOVERY_PROFILE.ID. AUTOMANAGE SMALLINT/TINYINT * Il flag che indica se gli elementi di configurazione rilevati con questo profilo devono essere gestiti automaticamente. DESCRIPTION VARCHAR(4000) La descrizione del profilo di rilevamento fornita dall'utente. LAST_RUN TIMESTAMP La data e l'ora dell'ultima esecuzione del profilo. CREDENTIAL_USERNAME VARCHAR(255) Il nome utente delle credenziali, se impostato. CREDENTIAL_REALM VARCHAR(64) L'area di autenticazione delle credenziali, se impostata. LOGIN_METHOD VARCHAR(256) Il metodo di autenticazione utilizzato per accedere alla stampante. LOGIN_METHOD_NAME VARCHAR(256) Il nome del metodo di autenticazione se LOGIN_METHOD è LDAP o LDAP+GSSAPI. CREDENTIAL_PASSWORD BLOB Questo valore è crittografato e non è utilizzabile al di fuori di MVE. CREDENTIAL_PIN BLOB Questo valore è crittografato e non è utilizzabile al di fuori di MVE. ASSIGN_KEYWORD_IDS VARCHAR(512) Le parole chiave assegnate in un profilo di rilevamento. EXCLUDE_PROFILE_ITEM Questa tabella mostra l'elenco  di esclusione  per un profilo. Ogni elemento escluso ha una riga in questa tabella. EXCLUDE_PROFILE_ITEM Nome campo Tipo di dati Per DISCOVERY_PROFILE_ID BIGINT La chiave primaria composta e la chiave esterna per DISCOVERY_PROFILE.ID. VALUE_ VARCHAR(255) La chiave primaria composta. Questo campo definisce gli elementi da escludere. INCLUDE_PROFILE_ITEM Questa tabella mostra l'elenco  di inclusione  per un profilo. Ogni elemento incluso ha una riga in questa tabella. INCLUDE_PROFILE_ITEM Nome campo Tipo di dati Per DISCOVERY_PROFILE_ID BIGINT La chiave primaria composta e la chiave esterna per DISCOVERY_PROFILE.ID. VALUE_ VARCHAR(255) La chiave primaria composta. Questo campo definisce gli elementi da includere. DISCOVERY_PROFILE_MODEL_CONFIG Questa tabella mostra la sezione  Assegna configurazioni  di un profilo di rilevamento. DISCOVERY_PROFILE_MODEL_CONFIG Nome campo Tipo di dati Per ID BIGINT La chiave primaria. MODEL VARCHAR(255) Il nome del modello delle stampanti a cui è assegnata la configurazione. DISCOVERY_PROFILE_ID BIGINT La chiave esterna per DISCOVERY_PROFILE.ID. CI_CONFIGURATION_ID BIGINT La chiave esterna per CONFIGURATION.CONFIGURATION_ID. Profili di rilevamento"},{"UUID":"3561408a-1007-4f93-bc95-27cc6e156f73","title":"Tabelle di FRAMEWORK e nomi dei campi","link":"config-item-topic.html","desc":"ESF ESF_APPLICATION Questa tabella contiene","descFull":"ESF ESF_APPLICATION Questa tabella contiene tutte le applicazioni eSF in tutti i pacchetti eSF distribuibili. Ogni pacchetto distribuibile può includere numerose applicazioni eSF. ESF_APPLICATION Nome campo Tipo di dati Per ESF_APP_ID BIGINT La chiave primaria. ESF_DP_ID BIGINT La chiave esterna reimpostata su ESF_DEPLOYABLE_PACKAGE.ESF_DP_ID. APP_ID VARCHAR(255) L'ID applicazione delle applicazioni eSF. VERSION VARCHAR(255) La versione dell'applicazione eSF. DESCRIPTION_URI VARCHAR(255) La descrizione URI dell'applicazione eSF. FLS_URI VARCHAR(255) L'URI del file flash. ESF_APPLICATION_LOCALE Questa tabella contiene il nome e la descrizione di ciascuna applicazione eSF in tutte le lingue supportate da MVE. ESF_APPLICATION_LOCALE Nome campo Tipo di dati Per ESF_APP_LOCALE_ID BIGINT La chiave primaria. ESF_APP_ID BIGINT La chiave esterna per ESF_APPLICATION.ESF_APP_ID. LOCALE VARCHAR(255) Il codice della lingua a due caratteri. NAME VARCHAR(255) Il nome dell'applicazione eSF nella lingua indicata da LOCALE. DESCRIPTION VARCHAR(510) La descrizione dell'applicazione eSF nella lingua indicata da LOCALE. ESF_COMP_DEPLOYABLE_PACKAGE Questa tabella contiene una riga per ciascun pacchetto distribuibile in uso da una configurazione MVE. ESF_COMP_DEPLOYABLE_PACKAGE Nome campo Tipo di dati Per ESF_COMPONENT_ID BIGINT La chiave esterna per CONFIGURATION_COMPONENT.CONFIGURATION_COMPONENT_ID. ESF_DP_ID VARCHAR(255) La chiave esterna per ESF_DEPLOYABLE_PACKAGE.ESF_DP_ID. ESF_DEPLOYABLE_PACKAGE Questa tabella mostra tutti i pacchetti distribuibili caricati nella libreria MVE. ESF_DEPLOYABLE_PACKAGE Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. ESF_DP_ID BIGINT La chiave primaria. NAME VARCHAR(255) Il nome del pacchetto distribuibile. PART_NUMBER VARCHAR(255) Il numero di parte del pacchetto distribuibile. PART_REVISION VARCHAR(255) La revisione del componente del pacchetto distribuibile. LICENSE_REQUIRED SMALLINT/TINYINT * Il flag che indica se è necessaria una licenza per il pacchetto distribuibile. URI VARCHAR(255) L'URI del pacchetto distribuibile. DATE_IMPORTED TIMESTAMP La data di importazione del pacchetto distribuibile. VERSION VARCHAR(255) La versione del pacchetto distribuibile. DESCRIPTION VARCHAR(255) La descrizione del pacchetto distribuibile. ESF_DEPLOYABLE_PACKAGE_LOCALE Questa tabella contiene il nome e la descrizione di ciascun pacchetto distribuibile in tutte le lingue supportate da MVE. ESF_DEPLOYABLE_PACKAGE_LOCALE Nome campo Tipo di dati Per ESF_DP_LOCALE_ID BIGINT La chiave primaria. ESF_DP_ID BIGINT La chiave esterna per ESF_DEPLOYABLE_PACKAGE.ESF_ DP_ID. LOCALE VARCHAR(255) Il codice della lingua a due caratteri. NAME VARCHAR(255) Il nome del pacchetto distribuibile nella lingua indicata da LOCALE. DESCRIPTION VARCHAR(2048) La lunghezza della descrizione aumentata, da 510 a 2048 caratteri. ESF_DP_SUPPORTED MODELS Questa tabella contiene una riga per ciascun modello supportato da un pacchetto distribuibile nella libreria MVE. ESF_DP_SUPPORTED MODELS Nome campo Tipo di dati Per ESF_DP_ID BIGINT La chiave esterna reimpostata su ESF_DEPLOYABLE_PACKA GE.ESF_DP_ID. SUPPORTED_MODEL VARCHAR(255) Il nome del modello della stampante supportata dal pacchetto distribuibile. ESF_LICENSE Questa tabella mostra le licenze per le applicazioni eSF disponibili nella libreria MVE. ESF_LICENSE Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. ESF_LICENSE_ID BIGINT La chiave primaria. PRINTER_SERIAL VARCHAR(255) Il numero di serie della stampante a cui è associata la licenza. PART_NUMBER VARCHAR(255) Il numero di parte del pacchetto a cui è associata la licenza. PART_REVISION VARCHAR(255) La revisione del componente del pacchetto a cui è associata la licenza. LICENSE_TYPE VARCHAR(255) Le opzioni sono TRIAL e PRODUCTION. FILE_NAME VARCHAR(255) Il nome del file binario della licenza. DEPLOYED SMALLINT/TINYINT * Il flag che indica se la licenza è stata distribuita. RAWESFAPPFILE Questa tabella mostra i dettagli del file raw dell'applicazione eSF disponibili nella libreria MVE. RAWESFAPPFILE Nome campo Tipo di dati Per ID BIGINT La chiave primaria. FILENAME VARCHAR(255) Il nome del file del pacchetto. DISPLAY_NAME VARCHAR(255) Il nome visualizzato del file del pacchetto. DATE_IMPORTED TIMESTAMP La data e l'ora di importazione del pacchetto. SHA1 VARCHAR(255) L'hash SHA1 del pacchetto. DESCRIPTION VARCHAR(255) La descrizione del pacchetto. APP_ID VARCHAR(255) L'ID applicazione del pacchetto. VERSION VARCHAR(255) La versione del pacchetto. APP_FLS_RESOURCE_FILES Questa tabella mostra l'associazione del file delle applicazioni eSF disponibile nella libreria MVE con la configurazione. APP_FLS_RESOURCE_FILES Nome campo Tipo di dati Per RESOURCE_ID BIGINT La chiave primaria. SHA1 VARCHAR(255) L'hash SHA1 del pacchetto. RESOURCE_TYPE VARCHAR(255) Il tipo di file di risorse. Le opzioni sono UCF_FILE, VCC_FILE e APP_FLS. CONFIGURATION_COMPONENT_ID BIGINT La chiave esterna con la colonna ID di CONFIGURATION_COMPONENT. ESF"},{"UUID":"43ca641d-d5ff-4d3f-b074-dd36f9d9ea0c","title":"Tabelle di FRAMEWORK e nomi dei campi","link":"config-item-topic.html","desc":"Gestione certificati Di seguito è","descFull":"Gestione certificati Di seguito è riportato l'elenco delle certificazioni da verificare. ENROLLMENT_STATUS La seguente tabella elenca i certificati emessi. ENROLLMENT_STATUS Nome campo Tipo di dati Per ENROLLMENT_STATUS_ID BIGINT La chiave primaria. CERTIFICATE_ENROL_STATUS VARCHAR(255) Lo stato di registrazione del certificato. Le opzioni sono Emesso, In attesa e Non riuscito. CERT_ENROL_TRANSACTION_ID VARCHAR(2048) La risposta del certificato in attesa per EST. A volte questo campo mostra l'ID della transazione per la registrazione del certificato. CERT_SUBJECT_IDENTITY VARCHAR(255) L'identità del soggetto del certificato. CERT_SERIAL_NUMBER VARCHAR(255) Il numero di serie del certificato emesso. PRINTER_ID BIGINT La stampante di riferimento. DEFAULT_CERT_REVISION_NO VARCHAR(255) Il numero di revisione del certificato rinnovato. DEFAULT_CERT_RENEWAL_DATE VARCHAR(255) La data di rinnovo del certificato. CERTIFICATE_FRIENDLY_NAME VARCHAR(255) Il nome descrittivo del certificato. CERTIFICATE_USED_FOR VARCHAR(255) L'associazione del certificato con nome. Le opzioni sono DEFAULT, HTTPS, WIRELESS, IPSEC e UNASSIGNED. CA_CERT_REVOCATION_COMP_LIST La seguente tabella elenca le informazioni sui certificati revocati. CA_CERT_REVOCATION_COMP_LIST Nome campo Tipo di dati Per ID BIGINT L'identificatore univoco. SERIAL_NUMBER VARCHAR(255) Il numero di serie del certificato presente nella chiave primaria dell'elenco di revoche. CERTIFICATE_SUBJECT VARCHAR(255) Il soggetto del certificato revocato. REVOCATION_DATE TIMESTAMP La data della revoca del certificato. ISSUER VARCHAR(255) L'emittente del certificato revocato. REVOCATION_REASON VARCHAR(255) Il motivo della revoca. NAMED_CERTIFICATE_SETTINGS La seguente tabella elenca il nome e l'associazione del certificato con nome. NAMED_CERTIFICATE_SETTINGS Nome campo Tipo di dati Per CERT_SETTING_ID BIGINT L'identificatore univoco. FRIENDLY_NAME VARCHAR(255) Il nome descrittivo del certificato con nome. CERT_USED_FOR VARCHAR(255) L'associazione del certificato con nome. Le opzioni sono DEFAULT, HTTPS, WIRELESS, IPSEC e UNASSIGNED. CONFIGURATION_COMPONENT_ID BIGINT La chiave esterna associata all'ID della tabella CONFIGURATION_COMPONENT. TEMPLATE_ID BIGINT L'ID del modello associato. PRINTER_CERTIFICATE La seguente tabella mostra i dettagli del certificato con nome. PRINTER_CERTIFICATE Nome campo Tipo di dati Per CERTIFICATE_ID BIGINT L'identificatore univoco. CERTIFICATE_FRIENDLY_NAME VARCHAR(255) Il nome descrittivo del certificato. CERTIFICATE_COMMON_NAME VARCHAR(255) Il nome comune del certificato. CERTIFICATE_ISSUER_NAME VARCHAR(255) Il nome dell'autorità di certificazione. CERTIFICATE_SIGNING_STATUS VARCHAR(255) Lo stato di registrazione del certificato. Le opzioni sono SIGNED, INVALID_CERT, NO_CA, REVOKED e UNKNOWN. CERTIFICATE_VALID_FROM TIMESTAMP L'ora di inizio della validità del certificato. CERTIFICATE_VALID_TO TIMESTAMP L'ora di fine della validità del certificato. CERTIFICATE_SIGNATURE VARCHAR(8190) La firma del certificato. CERTIFICATE_SERIAL_NUMBER VARCHAR(255) Il numero di serie del certificato. TYPE VARCHAR(255) Il tipo di certificato. Le opzioni sono DEFAULT, HTTPS, WIRELESS, IPSEC e UNASSIGNED. PRINTER_ID BIGINT La chiave esterna associata all'ID della tabella CONFIGURATION_COMPONENT. ENROLLED_CERTIFICATE_TYPE La tabella seguente mostra la relazione tra il certificato e lo stato di registrazione. ENROLLED_CERTIFICATE_TYPE Nome campo Tipo di dati Per TYPE_ID BIGINT L'identificatore univoco. ENROLLMENT_STATUS_ID BIGINT La chiave esterna della colonna ID della tabella ENROLLMENT_STATUS. TYPE VARCHAR(255) Il tipo di certificato. Le opzioni sono DEFAULT, HTTPS, WIRELESS, IPSEC e UNASSIGNED. CA_TEMPLATE La tabella seguente mostra i dettagli dei modelli selezionati durante la configurazione del server MSCA utilizzando il protocollo MSCEWS. CA_TEMPLATE Nome campo Tipo di dati Per TEMPLATE_ID BIGINT L'identificatore univoco dei modelli per il server MSCA con MSCEWS (non può essere nullo). TEMPLATE_NAME VARCHAR(255) Il nome dei modelli nel server CEP. TEMPLATE_OID VARCHAR(255) Il percorso MIB SNMP corrispondente. Gestione certificati"},{"UUID":"b5c41b01-ae8f-4ccc-a730-5ff0dc95bb9c","title":"Tabelle di FRAMEWORK e nomi dei campi","link":"config-item-topic.html","desc":"Autenticazione e autorizzazione Le seguenti","descFull":"Autenticazione e autorizzazione Le seguenti tabelle vengono utilizzate per il meccanismo di autenticazione e autorizzazione utente di MVE. MASTER_ROLE Questa tabella contiene tutti i ruoli supportati da MVE. MASTER_ROLE Nome campo Tipo di dati Per ID BIGINT La chiave primaria. ROLE_NAME VARCHAR(255) Il nome del ruolo. USERS Questa tabella elenca tutti gli account utente interni di MVE. USERS Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. ID BIGINT La chiave primaria. USER_NAME VARCHAR(15) Il nome utente fornito dall'utente. USER_PASS VARCHAR(1024) La password fornita dall'utente. ENABLED SMALLINT/TINYINT * Il flag che indica se l'account è abilitato. NAME VARCHAR(255) Il nome dell'utente. LAST_LOGIN TIMESTAMP La data e l'ora dell'ultimo tentativo di accesso. LOGIN_ATTEMPT BIGINT L'attuale numero di tentativi eseguiti per effettuare l'accesso. REFRESH_TOKEN VARCHAR(1024) Il token di autenticazione per l'accesso dell'utente. USER_ROLE Questa tabella descrive l'associazione degli utenti ai ruoli. USER_ROLE Nome campo Tipo di dati Per ID BIGINT La chiave primaria. USER_NAME VARCHAR(15) La chiave esterna reimpostata su USERS.USER_NAME. ROLE_NAME VARCHAR(30) La chiave esterna reimpostata su MASTER_ROLE.ROLE_NAME. autenticazione e autorizzazione"},{"UUID":"a4180984-10d4-4c3b-8986-d4f24e157f59","title":"Tabelle di FRAMEWORK e nomi dei campi","link":"config-item-topic.html","desc":"Impostazioni di protezione Le seguenti","descFull":"Impostazioni di protezione Le seguenti tabelle descrivono le impostazioni di protezione in una configurazione. Le informazioni relative alla configurazione di protezione sono crittografate per garantire la sicurezza dei dati, non sono disponibili al di fuori di MVE e non sono utili nell'ambito di questo documento. Pertanto, i dettagli delle seguenti tabelle vengono omessi. SEC_ACCESS_CONTROL SEC_AUTH_GROUP SEC_BUILDING_BLOCK SEC_BUILDING_BLOCK_SETTINGS SEC_COMPONENT_MISC_SETTINGS SEC_INTERNAL_ACCOUNT SEC_INTERNAL_ACCOUNT_GROUPS SEC_INTERNAL_ACCOUNT_SETTINGS SEC_SECURITY_TEMPLATE SEC_SECURTY_TEMPLATE_BBS SEC_SECURITY_TEMPLATE_GROUPS CAESAR2_LOCAL_ACCOUNTS CAESAR2_MISC_SETTINGS CAESAR2_KRB_SETUP CAESAR2_COMP_LOCAL_ACCTS CAESAR2_LOCAL_ACCOUNT_GROUPS CAESAR2_GROUPS CAESAR2_COMP_GROUPS CAESAR2_GROUP_PERMISSIONS CAESAR2_KRB_SETUP_PERMISSIONS CAESAR2_COMP_PUBLIC_PERMS CAESAR2_LDAP_SETUPS CAESAR2_COMP_LDAP_SETUPS CAESAR2_LDAP_SEARCH_OBJECTS CAESAR2_LDAP_SETUP_GROUPS CAESAR2_LDAP_SERVER_INFO CAESAR2_LDAP_DEVICE_CREDS CAESAR2_SOLUTION_ACCTS CAESAR2_LDAP_ADDRESS_BOOKS CAESAR2_LDAP_SEARCH_ATTRS CAESAR2_COMP_SOLN_ACCTS CAESAR2_SOLUTION_ACCT_GROUPS CAESAR2_MISC_SETTINGS CAESAR2_MISC_SETTINGS Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. MINIMUM_PASSWORD_LENGTH SMALLINT/TINYINT * Aggiunta nuova impostazione Varie nel componente Protezione avanzata. PROTECTED_FEATURES VARCHAR(255) PRINT_PERMISSION_PRINT VARCHAR(255) PRINT_PERMISSION_BROWSER VARCHAR(255) PRINT_PERMISSION_CONTROL_PAN EL VARCHAR(255) Impostazioni di protezione"},{"UUID":"da01481a-ee68-4b4b-868b-382b3cc4c394","title":"Tabelle di FRAMEWORK e nomi dei campi","link":"config-item-topic.html","desc":"Visualizzazioni ed esportazione dei dati","descFull":"Visualizzazioni ed esportazione dei dati Le tabelle seguenti forniscono informazioni sulle visualizzazioni in MVE e sui relativi campi. DATA_EXPORT_TEMPLATE Questa tabella contiene informazioni sulle visualizzazioni in MVE. DATA_EXPORT_TEMPLATE Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. DATA_EXPORT_ID BIGINT La chiave primaria. NAME VARCHAR(255) Il nome della visualizzazione. DEFAULT_TEMPLATE SMALLINT/TINYINT * Se il modello corrisponde a quello predefinito da mostrare quando si esegue l'accesso, questo valore può essere impostato su  True  in una sola visualizzazione. LANGUAGE_CODE VARCHAR(255) Obsoleto. INCLUDE_HEADER SMALLINT/TINYINT * Obsoleto. WRAP_FIELDS SMALLINT/TINYINT * Obsoleto. DESCRIPTION VARCHAR(4000) La descrizione della visualizzazione. IS_SYSTEM SMALLINT/TINYINT * Questo campo indica se il modello è nella visualizzazione di sistema, che non può essere modificata o eliminata. IDENTIFIER_FIELD VARCHAR(255) Il campo dell'identificatore scelto per la visualizzazione. DATA_EXPORT_FIELDS Questa tabella contiene i campi inclusi in ogni visualizzazione. DATA_EXPORT_FIELDS Nome campo Tipo di dati Per FIELD_INDEX Numero intero La chiave primaria. FIELD VARCHAR(255) Il nome del campo da includere nella visualizzazione. DATA_EXPORT_ID BIGINT La chiave esterna per DATA_EXPORT_TEMPLATE.DATA_EXP ORT_ID. Visualizzazioni ed esportazione dei dati"},{"UUID":"6ac77938-50a8-40e0-a959-68dee7141535","title":"Tabelle di FRAMEWORK e nomi dei campi","link":"config-item-topic.html","desc":"Gestione eventi Le seguenti tabelle","descFull":"Gestione eventi Le seguenti tabelle illustrano informazioni relative alla creazione e alla gestione degli eventi. ALERT Questa tabella contiene tutti gli avvisi supportati da MVE. ALERT Nome campo Tipo di dati Per ID BIGINT La chiave primaria NAME VARCHAR(255) Il nome in formato testo dell'avviso. Ad esempio, \"Avviso materiali di consumo\". SEVERITY VARCHAR(255) Ad esempio, \"ERROR\". CATEGORY VARCHAR(255) Ad esempio, \"SUPPLIES\". ASSIGNED_EVENTS Questa tabella collega gli eventi con i relativi elementi di configurazione assegnati. ASSIGNED_EVENTS Nome campo Tipo di dati Per CI_ID BIGINT La chiave primaria composta. Si riferisce a CONFIG_ITEM.CI_ID. EVENT_ID BIGINT La chiave primaria composta. Si riferisce a EVENT.EVENT_ID. EVENT_REGISTRATION_STATE VARCHAR(255) Le opzioni sono REGISTERED e NOT_REGISTERED. DESTINATION Questa tabella mostra un'azione all'interno del modulo Gestione eventi. DESTINATION Nome campo Tipo di dati Per ID BIGINT La chiave primaria. DESTINATION_TYPE VARCHAR(31) Il tipo di destinazione, attualmente comando shell o e-mail. Le colonne applicabili variano a seconda del tipo. NAME VARCHAR(255) Il nome della destinazione fornito dall'utente. EMAIL_BODY VARCHAR(255) Il testo del corpo dell'e-mail. EMAIL_CC VARCHAR(255) L'elenco Cc dell'e-mail. EMAIL_FROM VARCHAR(255) Il mittente dell'e-mail. EMAIL_SUBJECT VARCHAR(255) Il testo dell'oggetto dell'e-mail. EMAIL_TO VARCHAR(255) Il destinatario dell'e-mail. COMMAND_PATH VARCHAR(255) Il percorso completo del comando. COMMAND_PARAMS VARCHAR(255) Qualsiasi parametro da inviare al comando. DESCRIPTION VARCHAR(4000) Una descrizione opzionale dell'azione fornita dall'utente. LAST_MODIFIED Timestamp La data dell'ultima modifica dell'azione. EVENT Questa tabella contiene gli eventi creati dall'utente, che comprendono un nome, una descrizione e una raccolta di avvisi da includere. EVENT Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. NAME VARCHAR(255) Il nome dell'evento fornito dall'utente. DESCRIPTION VARCHAR(255) La descrizione dell'evento fornita dall'utente. EVENT_ID BIGINT La chiave primaria. TRIGGER_DESTINATIONS VARCHAR(255) Le destinazioni di attivazione dell'evento. Le opzioni sono on_active_only e on_active_and_clear. GRACE_PERIOD_ENABLED SMALLINT/TINYINT * Il flag che indica se è abilitato un periodo di tolleranza. GRACE_PERIOD_MINUTES INTEGER La durata del periodo di tolleranza in minuti. LAST_MODIFIED TIMESTAMP L'ora dell'ultima modifica dell'evento. EVENT_ALERTS Questa tabella collega un evento alla raccolta degli avvisi che include. EVENT_ALERTS Nome campo Tipo di dati Per EVENT_ID BIGINT La chiave primaria composta. Si riferisce a EVENT.EVENT_ID. ALERT_ID BIGINT La chiave primaria composta. Si riferisce ad ALERT.ALERT_ID. EVENT_DESTINATIONS Questa tabella collega un evento a un'azione associata. EVENT_DESTINATIONS Nome campo Tipo di dati Per EVENT_ID BIGINT La chiave primaria composta. Si riferisce a EVENT.EVENT_ID. DESTINATION_ID BIGINT La chiave primaria composta. Si riferisce a DESTINATION.DESTINATION_ID. PRINTER_EVENT_ACTIVE_CONDITIONS Questa tabella mostra le condizioni o gli avvisi attivi per le stampanti con eventi che attivano la condizione o l'avviso in questione. Le varie condizioni hanno le proprie righe corrispondenti; tutte le righe fanno riferimento allo stesso PRINTER_ID. PRINTER_EVENT_ACTIVE_CONDITIONS Nome campo Tipo di dati Per ACTIVE_CONDITION_ID BIGINT La chiave primaria. LOCATION VARCHAR(255) Ad esempio, \"Vassoio 1\". MESSAGE VARCHAR(255) Ad esempio, \"Vassoio mancante\". TYPE VARCHAR(255) Ad esempio, \"Intervento richiesto\". CI_ID BIGINT Si riferisce a CONFIG_ITEM.ID. DESTINATION_TASK_ID VARCHAR(80) La chiave esterna reimpostata su SYSTEM_LOG.TASK_ID. Gestione eventi"},{"UUID":"63883c5e-75e1-4b65-97af-9ad92d907a11","title":"Tabelle di FRAMEWORK e nomi dei campi","link":"config-item-topic.html","desc":"Varie Le seguenti tabelle forniscono","descFull":"Varie Le seguenti tabelle forniscono dati utili ma non rientrano in nessuna delle categorie precedenti. APPLICATION_SETTINGS Questa tabella al momento include tutte le impostazioni di sistema di MVE. I valori sono crittografati e non sono disponibili al di fuori di MVE. APPLICATION_SETTINGS Nome campo Tipo di dati Per ID BIGINT La chiave primaria. SETTING_KEY VARCHAR(255) Il nome della preferenza. SETTING_VALUE VARCHAR(8190) Il valore della preferenza. BOOKMARK Questa tabella contiene tutte le ricerche salvate di MVE. Attualmente tali ricerche sono memorizzate come BLOB, pertanto non possono essere modificate al di fuori di MVE. BOOKMARK Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. ID BIGINT La chiave primaria. DEFAULT_SEARCH SMALLINT/TINYINT * Il flag che indica se il segnalibro corrente è uno degli elementi predefiniti forniti con MVE. NAME VARCHAR(255) Il nome del segnalibro fornito dall'utente. SEARCH_CRITERIA BLOB SUB_TYPE 0 La rappresentazione binaria del segnalibro. DESERIALIZABLE SMALLINT/TINYINT * Indica se la ricerca salvata è deserializzabile. DESCRIPTION VARCHAR(4000) Una descrizione opzionale della ricerca salvata fornita dall'utente. Tabelle Liquibase e Hibernate Liquibase e Hibernate solo librerie di terze parti utilizzate da MVE per gestire il database. Le seguenti tabelle sono utilizzate da queste librerie. Queste tabelle non contengono dati significativi relativi alla stampante, pertanto il loro contenuto non è descritto qui. DATABASECHANGELOG DATABASECHANGELOGLOCK Tutte le tabelle i cui nomi iniziano con  HT_ . HIBERNATESEQUENCE SMTP_CONFIGURATION Questa tabella contiene la configurazione del protocollo SMTP (Simple Mail Transfer Protocol), che consente agli utenti di MVE di inviare le e-mail. SMTP_CONFIGURATION Nome campo Tipo di dati Per * Questo tipo di dati è obbligatorio per Microsoft SQL Server. ID BIGINT La chiave primaria. FROM_ADDRESS VARCHAR(255) L'indirizzo e-mail del mittente. LOGIN_ID VARCHAR(255) L'ID utente per il server SMTP. LOGIN_PASSWORD VARCHAR(255) La password associata all'ID utente per il server SMTP. LOGIN_REQ SMALLINT/TINYINT * Il flag che indica se il server SMTP richiede l'accesso. SMTP_PORT BIGINT La porta del server SMTP. SMTP_SERVER VARCHAR(255) Il nome host o l'indirizzo IP del server SMTP. SMTP_ENABLE SMALLINT/TINYINT * Il flag che indica se SMTP è abilitato. EMAIL_ENCRYPTION VARCHAR(64) Si riferisce ai tipi di crittografia supportati; il valore predefinito è nullo. SYSTEM_LOG Questa tabella contiene tutti i messaggi del registro di sistema che vengono prodotti man mano che MVE esegue le attività. Questa tabella può diventare molto grande. SYSTEM_LOG Nome campo Tipo di dati Per LOG_ID BIGINT La chiave primaria. TIMESTAMP_ TIMESTAMP L'ora in cui è stato registrato il messaggio. TASKID BIGINT L'istanza dell'attività che ha generato il messaggio. TASKNAME VARCHAR(50) L'attività che ha generato il messaggio. LEVEL_ INTEGER Le opzioni sono DEBUG, INFO, ecc. MESSAGE_ VARCHAR(8000) Il messaggio del registro effettivo. USER_NAME VARCHAR(255) Il nome dell'utente che ha eseguito l'azione. IP_ADDRESS VARCHAR(50) L'indirizzo IP del client. Varie"},{"UUID":"2a9f80ae-4444-446c-94f1-1ea18104b576","title":"Tabelle di FRAMEWORK e nomi dei campi","link":"config-item-topic.html","desc":"Quartz DB QRTZ_FIRED_TRIGGERS Nome campo","descFull":"Quartz DB QRTZ_FIRED_TRIGGERS Nome campo Tipo di dati Per SCHED_TIME BIGINT Una nuova colonna aggiunta per l'ora programmata. Quartz DB"},{"UUID":"7169fdcb-eb3d-4b14-bcf0-0eb37d16b86a","title":"Appendice","link":"understanding-ports-and-protocols-topic.html","desc":"Informazioni su porte e protocolli","descFull":"Informazioni su porte e protocolli MVE utilizza diversi protocolli e porte per i vari tipi di comunicazione di rete, come mostrato nel diagramma seguente: Le porte sono bidirezionali e devono essere aperte o attive affinché MVE funzioni correttamente. Assicurarsi che tutte le porte della stampante siano attivate. Alcune comunicazioni richiedono una porta temporanea, cioè un intervallo assegnato delle porte disponibili sul server. Quando un client richiede una sessione di comunicazione temporanea, il server assegna una porta dinamica al client. La porta è valida solo per una durata breve e può diventare disponibile per il riutilizzo alla scadenza della sessione precedente. Comunicazione da server a stampante Protocolli e porte utilizzati per le comunicazioni dal server MVE alle stampanti di rete Protocollo Server MVE Stampante Utilizzato per NPAP (Network Printing Alliance Protocol) UDP 9187 UDP 9300 Comunicazioni con le stampanti di rete Lexmark. Comunicazioni con le stampanti di rete. XMLNT (XML Network Transport) UDP 9187 UDP 6000 Comunicazioni con alcune stampanti di rete Lexmark. Comunicazioni con alcune stampanti di rete. LST (Lexmark Secure Transport) UDP 6100 Porta TCP (Transmission Control Protocol) temporanea (handshaking) UDP 6100 TCP 6110 (handshaking) Comunicazioni protette con alcune stampanti di rete Lexmark. Comunicazioni protette con alcune stampanti di rete. mDNS (Multicast Domain Name System) Porta UDP (User Datagram Protocol) temporanea UDP 5353 Rilevamento delle stampanti di rete Lexmark e identificazione delle funzionalità di protezione delle stampanti. Rilevamento di alcune stampanti di rete e identificazione delle funzionalità di protezione delle stampanti. Questa porta è richiesta per consentire la comunicazione di MVE con le stampanti protette. SNMP (Simple Network Management Protocol) Porta UDP temporanea UDP 161 Rilevamento e comunicazione con le stampanti di rete Lexmark e di terze parti. Rilevamento e comunicazione con le stampanti di rete. FTP (File Transfer Protocol) Porta TCP temporanea TCP 21 TCP 20 Distribuzione dei file. HTTP (Hypertext Transfer Protocol) Porta TCP temporanea TCP 80 Distribuzione dei file o applicazione delle configurazioni. TCP 443 Distribuzione dei file o applicazione delle configurazioni. HTTPS (Hypertext Transfer Protocol over SSL) Porta TCP temporanea TCP 161 TCP 443 Distribuzione dei file o applicazione delle configurazioni. RAW Porta TCP temporanea TCP 9100 Distribuzione dei file o applicazione delle configurazioni. Comunicazione da stampante a server La porta e il protocollo utilizzati per le comunicazioni dalle stampanti di rete al server MVE Protocollo Stampante Server MVE Utilizzato per NPAP UDP 9300 UDP 9187 Creazione e ricezione di avvisi Comunicazioni da server a database Porte utilizzate durante la comunicazione dal server MVE ai database Server MVE Database Utilizzato per Porta TCP temporanea Porta definita dall'utente. La porta predefinita è TCP 1433. Comunicazioni con un database SQL Server. Porta TCP temporanea TCP 3050 Comunicazioni con un database Firebird. Comunicazioni da client a server La porta e il protocollo utilizzati per le comunicazioni dal client del browser al server MVE Protocollo Client browser Server MVE HTTPs (Hypertext Transfer Protocol over SSL) Porta TCP TCP 443 Comunicazione da server a server di posta Porta e protocollo utilizzati per le comunicazioni dal server MVE a un server di posta Protocollo Server MVE Server SMTP Utilizzato per SMTP (Simple Mail Transfer Protocol) Porta TCP temporanea Porta definita dall'utente. La porta predefinita è TCP 25. Fornire la funzionalità e-mail utilizzata per ricevere gli avvisi dalle stampanti. Comunicazione da server a server LDAP Le porte e i protocolli utilizzati per le comunicazioni dal server MVE a un server LDAP che interessano i gruppi utente e la funzionalità di autenticazione Protocollo Server MVE Server LDAP Utilizzato per LDAP (Lightweight Directory Access Protocol) Porta TCP temporanea Porta definita dall'utente. La porta predefinita è TCP 389. Autenticazione degli utenti MVE tramite un server LDAP. LDAPS (Lightweight Directory Access Protocol over TLS) Porta TCP temporanea Porta definita dall'utente. La porta predefinita è TCP 636. Autenticazione degli utenti MVE tramite un server LDAP su TLS. Kerberos Porta UDP temporanea Porta definita dall'utente. La porta predefinita è UDP 88. Autenticazione degli utenti MVE tramite Kerberos. porte informazioni protocolli informazioni"},{"UUID":"83b240fe-e7c6-4776-87fa-62396a7fc200","title":"Appendice","link":"enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html","desc":"Abilitazione dell'approvazione automatica delle richieste","descFull":"Abilitazione dell'approvazione automatica delle richieste di certificato in CA Microsoft Per impostazione predefinita, tutti i server CA sono in modalità di attesa ed è necessario approvare manualmente ogni richiesta di certificato firmato. Poiché questo metodo non è pratico per le richieste in blocco, abilitare l'approvazione automatica dei certificati firmati. In Server Manager fare clic su  Strumenti  Autorità di certificazione . Nel pannello di sinistra, fare clic con il pulsante destro del mouse sulla CA, quindi scegliere  Proprietà  Modulo criterio . Nella scheda  gestione delle richieste  fare clic su  Utilizza le impostazioni contenute nel modello di certificato. , quindi fare clic su  OK . se l'opzione  Imposta lo stato della richiesta certificato in modo che risulti in sospeso  è selezionata, è necessario approvare manualmente il certificato. Riavviare il servizio CA. abilitazione dell'approvazione automatica delle richieste di certificato in CA Microsoft approvazione automatica delle richieste di certificato abilitazione in CA Microsoft richieste di certificato in CA Microsoft approvazione automatica"},{"UUID":"93eeae2b-d0ee-40ba-a81a-c478b54c4db8","title":"Appendice","link":"revoking-certificates-topic.html","desc":"Revoca di certificati prima di","descFull":"Revoca di certificati prima di iniziare, assicurarsi che il server CA sia configurato per i CRL e che questi siano disponibili. Sul server CA, aprire  Autorità di certificazione . Nel pannello di sinistra, espandere la CA, quindi fare clic su  Certificati emessi . Fare clic con il pulsante destro del mouse su un certificato da revocare, quindi scegliere  Tutte le attività  Revoca certificato . Selezionare un codice motivo e la data e l'ora della revoca, quindi fare clic su  Sì . Nel pannello di sinistra, fare clic con il pulsante destro del mouse su  Certificati revocati , quindi scegliere  Tutte le attività  Pubblica . assicurarsi che il certificato revocato si trovi in  Certificati revocati . Il numero di serie del certificato revocato è riportato nel CRL. revoca di certificati certificati revoca"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"divd0e8"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_vm._m(32),_vm._v(" "),_vm._m(33),_vm._v(" "),_vm._m(34),_vm._v(" "),_vm._m(35),_vm._v(" "),_vm._m(36),_vm._v(" "),_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_vm._m(39),_vm._v(" "),_vm._m(40),_vm._v(" "),_vm._m(41),_vm._v(" "),_vm._m(42),_vm._v(" "),_vm._m(43),_vm._v(" "),_vm._m(44),_vm._v(" "),_c('div',{attrs:{"id":"divd0e18169"}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"Markvision Enterprise"}},[_vm._v("\n    Markvision Enterprise\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"change-history.html#change-history_it","title":"Cronologia delle modifiche"}},[_vm._v("\n    Cronologia delle modifiche\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"overview-chapter.html#overview-chapter_it","title":"Panoramica"}},[_vm._v("\n    Panoramica\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e260"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"overview-chapter.html#overview-markvision-enterprise_it","title":"Informazioni su Markvision Enterprise"}},[_vm._v("\n     Informazioni su Markvision Enterprise\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"getting-started-chapter.html#getting-started-chapter_it","title":"Introduzione"}},[_vm._v("\n    Introduzione\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e289"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"best-practices-topic.html#best-practices_it","title":"Best practice"}},[_vm._v("\n     Best practice\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"system-requirements-topic.html#system-requirements_it","title":"Requisiti di sistema"}},[_vm._v("\n     Requisiti di sistema\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-languages-topic.html#supported-languages_it","title":"Lingue supportate"}},[_vm._v("\n     Lingue supportate\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-printer-models-topic.html#supported-printer-models_it","title":"Modelli di stampante supportati"}},[_vm._v("\n     Modelli di stampante supportati\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-database-topic.html#setting-up-database_it","title":"Configurazione del database"}},[_vm._v("\n     Configurazione del database\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-mve-run-as-user-topic.html#d0e1132","title":"Impostazione di Esegui come utente"}},[_vm._v("\n     Impostazione di Esegui come utente\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-markvision-topic.html#installing-markvision_it","title":"Installazione di MVE"}},[_vm._v("\n     Installazione di MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-mve-silently-topic.html#installing-mve-silently_it","title":"Installazione di MVE invisibile all'utente"}},[_vm._v("\n     Installazione di MVE invisibile all'utente\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-mve-topic.html#accessing-mve_it","title":"Accesso a MVE"}},[_vm._v("\n     Accesso a MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-language-topic.html#changing-language_it","title":"Modifica della lingua"}},[_vm._v("\n     Modifica della lingua\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-your-password-topic.html#changing-your-password_it","title":"Modifica della password"}},[_vm._v("\n     Modifica della password\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintaining-application-chapter.html#maintaining-application-chapter_it","title":"Manutenzione dell'applicazione"}},[_vm._v("\n    Manutenzione dell'applicazione\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1715"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"upgrading-to-latest-version-topic.html#upgrading-to-latest-version_it","title":"Aggiornamento a MVE 4.3"}},[_vm._v("\n     Aggiornamento a MVE 4.3\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"backing-up-and-restoring-database-topic.html#backing-up-and-restoring-database_it","title":"Backup e ripristino del database"}},[_vm._v("\n     Backup e ripristino del database\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-installer-settings-topic.html#changing-installer-settings_it","title":"Aggiornamento delle impostazioni del programma di installazione dopo l'installazione"}},[_vm._v("\n     Aggiornamento delle impostazioni del programma di installazione dopo l'installazione\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-user-access-chapter.html#setting-user-access-chapter_it","title":"Configurazione dell'accesso utente"}},[_vm._v("\n    Configurazione dell'accesso utente\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1987"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-user-access-overview-topic.html#setting-up-user-access-overview_it","title":"Panoramica"}},[_vm._v("\n     Panoramica\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-user-roles-topic.html#understanding-user-roles_it","title":"Informazioni sui ruoli utente"}},[_vm._v("\n     Informazioni sui ruoli utente\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-users-topic.html#managing-users_it","title":"Gestione degli utenti"}},[_vm._v("\n     Gestione degli utenti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-ldap-server-authentication-topic.html#enabling-ldap-server-authentication_it","title":"Abilitazione dell'autenticazione tramite server LDAP"}},[_vm._v("\n     Abilitazione dell'autenticazione tramite server LDAP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-ldap-server-certificates-topic.html#installing-ldap-server-certificates_it","title":"Installazione dei certificati del server LDAP"}},[_vm._v("\n     Installazione dei certificati del server LDAP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adding-root-ca-certificate-java-truststore-topic.html#adding-root-ca-certificate-java-truststore_it","title":"Aggiunta di un certificato CA radice al truststore Java"}},[_vm._v("\n     Aggiunta di un certificato CA radice al truststore Java\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"discovering-devices-chapter.html#discovering-devices-chapter_it","title":"Rilevamento delle stampanti"}},[_vm._v("\n    Rilevamento delle stampanti\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2401"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-discovery-profile-topic.html#creating-discovery-profile_it","title":"Creazione di un profilo di ricerca"}},[_vm._v("\n     Creazione di un profilo di ricerca\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-discovery-profiles-topic.html#managing-discovery-profiles_it","title":"Gestione dei profili di ricerca"}},[_vm._v("\n     Gestione dei profili di ricerca\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-discovering-printers-topic.html#sample-scenario-discovering-printers_it","title":"Scenario di esempio: rilevamento delle stampanti"}},[_vm._v("\n     Scenario di esempio: rilevamento delle stampanti\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintaining-dashboard-chapter.html#maintaining-dashboard-chapter_it","title":"Gestione della dashboard di protezione"}},[_vm._v("\n    Gestione della dashboard di protezione\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2657"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"overview-security-dashboard-topic.html#overview-security-dashboard_it","title":"Panoramica"}},[_vm._v("\n     Panoramica\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-dashboard-topic.html#accessing-dashboard_it","title":"Accesso al dashboard di protezione"}},[_vm._v("\n     Accesso al dashboard di protezione\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-device-security-information-topic.html#managing-device-security-information_it","title":"Gestione di Informazioni sulla protezione della periferica"}},[_vm._v("\n     Gestione di Informazioni sulla protezione della periferica\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-device-conformance-check-topic.html#managing-device-conformance-check_it","title":"Gestione di Controllo conformit&agrave; periferica"}},[_vm._v("\n     Gestione di Controllo conformità periferica\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"finding-devices-chapter.html#finding-devices-chapter_it","title":"Visualizzazione delle stampanti"}},[_vm._v("\n    Visualizzazione delle stampanti\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2766"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-printer-list-topic.html#viewing-printer-list_it","title":"Visualizzazione dell'elenco stampanti"}},[_vm._v("\n     Visualizzazione dell'elenco stampanti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-device-information-topic.html#viewing-device-information_it","title":"Visualizzazione delle informazioni della stampante"}},[_vm._v("\n     Visualizzazione delle informazioni della stampante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"exporting-data-topic.html#exporting-data_it","title":"Esportazione dei dati della stampante"}},[_vm._v("\n     Esportazione dei dati della stampante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-views-topic.html#managing-views_it","title":"Gestione delle visualizzazioni"}},[_vm._v("\n     Gestione delle visualizzazioni\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-printer-listing-view-topic.html#changing-printer-listing-view_it","title":"Modifica della visualizzazione dell'elenco stampanti"}},[_vm._v("\n     Modifica della visualizzazione dell'elenco stampanti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"filtering-printers-using-search-bar-topic.html#filtering-printers-using-search-bar_it","title":"Filtraggio delle stampanti dalla barra di ricerca"}},[_vm._v("\n     Filtraggio delle stampanti dalla barra di ricerca\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-keywords-topic.html#managing-keywords_it","title":"Gestione delle parole chiave"}},[_vm._v("\n     Gestione delle parole chiave\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-device-life-cycle-states-topic.html#d0e3226","title":"Uso delle ricerche salvate"}},[_vm._v("\n     Uso delle ricerche salvate\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-monitor-fleet-topic.html#sample-scenario-monitor-fleet_it","title":"Scenario di esempio: monitoraggio dei livelli di toner del parco stampanti"}},[_vm._v("\n     Scenario di esempio: monitoraggio dei livelli di toner del parco stampanti\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-devices-chapter.html#securing-devices-chapter_it","title":"Protezione delle comunicazioni della stampante"}},[_vm._v("\n    Protezione delle comunicazioni della stampante\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e4163"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-security-status-topic.html#understanding-security-status_it","title":"Informazioni sugli stati di protezione della stampante"}},[_vm._v("\n     Informazioni sugli stati di protezione della stampante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printers-using-default-config-topic.html#securing-printers-using-default-config_it","title":"Protezione delle stampanti mediante le configurazioni predefinite"}},[_vm._v("\n     Protezione delle stampanti mediante le configurazioni predefinite\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-fac-permissions-topic.html#understanding-fac-permissions_it","title":"Informazioni sulle autorizzazioni e i controlli di accesso alle funzioni"}},[_vm._v("\n     Informazioni sulle autorizzazioni e i controlli di accesso alle funzioni\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-device-security-topic.html#configuring-device-security_it","title":"Configurazione della protezione della stampante"}},[_vm._v("\n     Configurazione della protezione della stampante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printer-communications-on-your-fleet-topic.html#securing-printer-communications-on-your-fleet_it","title":"Protezione delle comunicazioni della stampante nel parco stampanti"}},[_vm._v("\n     Protezione delle comunicazioni della stampante nel parco stampanti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printers-topic.html#securing-printers_it","title":"Altri modi per proteggere le stampanti"}},[_vm._v("\n     Altri modi per proteggere le stampanti\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-assets-chapter.html#managing-assets-chapter_it","title":"Gestione delle stampanti"}},[_vm._v("\n    Gestione delle stampanti\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e4527"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restarting-printer-topic.html#restarting-printer_it","title":"Riavvio della stampante"}},[_vm._v("\n     Riavvio della stampante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-ews-topic.html#viewing-ews_it","title":"Visualizzazione di Embedded Web Server della stampante"}},[_vm._v("\n     Visualizzazione di Embedded Web Server della stampante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"auditing-devices-topic.html#auditing-devices_it","title":"Controllo delle stampanti"}},[_vm._v("\n     Controllo delle stampanti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"updating-printer-status-topic.html#updating-printer-status_it","title":"Aggiornamento dello stato della stampante"}},[_vm._v("\n     Aggiornamento dello stato della stampante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-device-state-topic.html#setting-device-state_it","title":"Impostazione dello stato della stampante"}},[_vm._v("\n     Impostazione dello stato della stampante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-configurations-to-devices-topic.html#assigning-configurations-to-devices_it","title":"Assegnazione di configurazioni alle stampanti"}},[_vm._v("\n     Assegnazione di configurazioni alle stampanti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"unassigning-configurations-topic.html#unassigning-configurations_it","title":"Annullamento dell'assegnazione delle configurazioni"}},[_vm._v("\n     Annullamento dell'assegnazione delle configurazioni\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enforcing-configurations-topic.html#enforcing-configurations_it","title":"Applicazione delle configurazioni"}},[_vm._v("\n     Applicazione delle configurazioni\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-device-conformance-topic.html#checking-device-conformance_it","title":"Controllo della conformit&agrave; di una stampante con una configurazione"}},[_vm._v("\n     Controllo della conformità di una stampante con una configurazione\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"deploying-files-to-printers-topic.html#deploying-files-to-printers_it","title":"Distribuzione dei file alle stampanti"}},[_vm._v("\n     Distribuzione dei file alle stampanti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"updating-printer-firmware-topic.html#updating-printer-firmware_it","title":"Aggiornamento del firmware delle stampanti"}},[_vm._v("\n     Aggiornamento del firmware delle stampanti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"uninstalling-applications-from-devices-topic.html#uninstalling-applications-from-devices_it","title":"Disinstallazione delle applicazioni dalle stampanti"}},[_vm._v("\n     Disinstallazione delle applicazioni dalle stampanti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-events-to-device-topic.html#assigning-events-to-device_it","title":"Assegnazione di eventi alle stampanti"}},[_vm._v("\n     Assegnazione di eventi alle stampanti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-keyword-topic.html#assigning-keyword_it","title":"Assegnazione di parole chiave alle stampanti"}},[_vm._v("\n     Assegnazione di parole chiave alle stampanti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"entering-credentials-secured-printers-topic.html#entering-credentials-secured-printers_it","title":"Immissione delle credenziali per le stampanti protette"}},[_vm._v("\n     Immissione delle credenziali per le stampanti protette\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-printer-certificates-manually-topic.html#configuring-printer-certificates-manually_it","title":"Configurazione manuale dei certificati predefiniti delle stampanti"}},[_vm._v("\n     Configurazione manuale dei certificati predefiniti delle stampanti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"removing-printers-topic.html#removing-printers_it","title":"Rimozione di stampanti"}},[_vm._v("\n     Rimozione di stampanti\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-configurations-chapter.html#managing-configurations-chapter_it","title":"Gestione delle configurazioni"}},[_vm._v("\n    Gestione delle configurazioni\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5133"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-configurations-overview-topic.html#managing-configurations-overview_it","title":"Panoramica"}},[_vm._v("\n     Panoramica\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-configuration-topic.html#creating-configuration_it","title":"Creazione di una configurazione"}},[_vm._v("\n     Creazione di una configurazione\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-configuration-from-printer-topic.html#creating-configuration-from-printer_it","title":"Creazione di una configurazione da una stampante"}},[_vm._v("\n     Creazione di una configurazione da una stampante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-cloning-configurations-topic.html#sample-scenario-cloning-configurations_it","title":"Scenario di esempio: clonazione di una configurazione"}},[_vm._v("\n     Scenario di esempio: clonazione di una configurazione\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-advanced-security-component-topic.html#creating-advanced-security-component_it","title":"Creazione di un componente di protezione avanzata da una stampante"}},[_vm._v("\n     Creazione di un componente di protezione avanzata da una stampante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"generating-printable-version-topic.html#generating-printable-version_it","title":"Generazione di una versione stampabile delle impostazioni di configurazione"}},[_vm._v("\n     Generazione di una versione stampabile delle impostazioni di configurazione\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-dynamic-settings-topic.html#understanding-dynamic-settings_it","title":"Informazioni sulle impostazioni dinamiche"}},[_vm._v("\n     Informazioni sulle impostazioni dinamiche\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-variable-settings-topic.html#understanding-variable-settings_it","title":"Informazioni sulle impostazioni delle variabili"}},[_vm._v("\n     Informazioni sulle impostazioni delle variabili\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-color-permissions-topic.html#configuring-color-permissions_it","title":"Configurazione delle autorizzazioni per la stampa a colori"}},[_vm._v("\n     Configurazione delle autorizzazioni per la stampa a colori\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-applications-package-topic.html#creating-applications-package_it","title":"Creazione di un pacchetto di applicazioni"}},[_vm._v("\n     Creazione di un pacchetto di applicazioni\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"importing-exporting-configuration-file-topic.html#importing-exporting-configuration-file_it","title":"Importazione o esportazione di una configurazione"}},[_vm._v("\n     Importazione o esportazione di una configurazione\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"importing-files-to-resource-library-topic.html#importing-files-to-resource-library_it","title":"Importazione di file nella libreria delle risorse"}},[_vm._v("\n     Importazione di file nella libreria delle risorse\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-cert-auto-manage-chapter.html#setting-up-cert-auto-manage-chapter_it","title":"Gestione dei certificati"}},[_vm._v("\n    Gestione dei certificati\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5644"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-MVE-manage-certificates-automatically-group.html#d0e5647","title":"Configurazione di MVE per la gestione automatica dei certificati"}},[_vm._v("\n     Configurazione di MVE per la gestione automatica dei certificati\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-SCEP-group.html#d0e5973","title":"Gestione dei certificati con l'autorit&agrave; di certificazione Microsoft tramite SCEP"}},[_vm._v("\n     Gestione dei certificati con l'autorità di certificazione Microsoft tramite SCEP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-MSCEWS-group.html#d0e6695","title":"Gestione dei certificati con l'autorit&agrave; di certificazione Microsoft tramite MSCEWS"}},[_vm._v("\n     Gestione dei certificati con l'autorità di certificazione Microsoft tramite MSCEWS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-OpenXPKI-CA-group.html#d0e7680","title":"Gestione dei certificati con l'autorit&agrave; di certificazione OpenXPKI tramite SCEP"}},[_vm._v("\n     Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite SCEP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-EST-group.html#d0e8747","title":"Gestione dei certificati con l'autorit&agrave; di certificazione OpenXPKI tramite EST"}},[_vm._v("\n     Gestione dei certificati con l'autorità di certificazione OpenXPKI tramite EST\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-device-alerts-chapter.html#managing-device-alerts-chapter_it","title":"Gestione degli avvisi della stampante"}},[_vm._v("\n    Gestione degli avvisi della stampante\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9832"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-printer-alerts-overview-topic.html#managing-printer-alerts-overview_it","title":"Panoramica"}},[_vm._v("\n     Panoramica\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-action-topic.html#creating-action_it","title":"Creazione di un'azione"}},[_vm._v("\n     Creazione di un'azione\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-action-placeholders-topic.html#understanding-action-placeholders_it","title":"Comprensione segnaposto azione"}},[_vm._v("\n     Comprensione segnaposto azione\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-actions-topic.html#managing-actions_it","title":"Gestione delle azioni"}},[_vm._v("\n     Gestione delle azioni\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-event-topic.html#creating-event_it","title":"Creazione di un evento"}},[_vm._v("\n     Creazione di un evento\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-printer-alerts-topic.html#understanding-printer-alerts_it","title":"Informazioni sugli avvisi della stampante"}},[_vm._v("\n     Informazioni sugli avvisi della stampante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-events-topic.html#managing-events_it","title":"Gestione degli eventi"}},[_vm._v("\n     Gestione degli eventi\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"viewing-tasks-chapter.html#viewing-tasks-chapter_it","title":"Visualizzazione della cronologia e dello stato delle attivit&agrave;"}},[_vm._v("\n    Visualizzazione della cronologia e dello stato delle attività\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10464"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-task-status-history-overview-topic.html#viewing-task-status-history-overview_it","title":"Panoramica"}},[_vm._v("\n     Panoramica\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-task-status-topic.html#viewing-task-status_it","title":"Visualizzazione dello stato delle attivit&agrave;"}},[_vm._v("\n     Visualizzazione dello stato delle attività\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stopping-tasks-topic.html#stopping-tasks_it","title":"Interruzione delle attivit&agrave;"}},[_vm._v("\n     Interruzione delle attività\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-logs-topic.html#viewing-logs_it","title":"visualizzazione dei registri"}},[_vm._v("\n     visualizzazione dei registri\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-logs-topic.html#clearing-logs_it","title":"Eliminazione dei registri"}},[_vm._v("\n     Eliminazione dei registri\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"exporting-logs-topic.html#exporting-logs_it","title":"Esportazione dei registri"}},[_vm._v("\n     Esportazione dei registri\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"scheduling-tasks.html#scheduling-tasks_it","title":"Programmazione delle attivit&agrave;"}},[_vm._v("\n    Programmazione delle attività\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10572"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-schedule-topic.html#creating-schedule_it","title":"Creazione di un programma"}},[_vm._v("\n     Creazione di un programma\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-schedules-topic.html#managing-schedules_it","title":"Gestione delle attivit&agrave; programmate"}},[_vm._v("\n     Gestione delle attività programmate\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"admin-tasks-chapter.html#admin-tasks-chapter_it","title":"Esecuzione di altre attivit&agrave; amministrative"}},[_vm._v("\n    Esecuzione di altre attività amministrative\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10714"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-system-settings-topic.html#configuring-system-settings_it","title":"Configurazione delle impostazioni generali"}},[_vm._v("\n     Configurazione delle impostazioni generali\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-email-settings-topic.html#configuring-email-settings_it","title":"Configurazione delle impostazioni e-mail"}},[_vm._v("\n     Configurazione delle impostazioni e-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adding-login-disclaimer-topic.html#adding-login-disclaimer_it","title":"Aggiunta di una declinazione di responsabilit&agrave; prima dell'accesso"}},[_vm._v("\n     Aggiunta di una declinazione di responsabilità prima dell'accesso\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"signing-mve-certificate-topic.html#signing-mve-certificate_it","title":"Firma del certificato MVE"}},[_vm._v("\n     Firma del certificato MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"removing-user-information-topic.html#removing-user-information_it","title":"Rimozione di informazioni e riferimenti dell'utente"}},[_vm._v("\n     Rimozione di informazioni e riferimenti dell'utente\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-SSO-chapter.html#managing-SSO-chapter_it","title":"Gestione SSO"}},[_vm._v("\n    Gestione SSO\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10972"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"mve-configuration-workflow-adfs-overview-topic.html#d0e10977","title":"Panoramica"}},[_vm._v("\n     Panoramica\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-claim-issuance-policy-grouprule-topic.html#setting-claim-issuance-policy-grouprule_it","title":"Impostazione dei criteri di rilascio delle attestazioni per GroupRule"}},[_vm._v("\n     Impostazione dei criteri di rilascio delle attestazioni per GroupRule\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-claim-issuance-policy-name-id-topic.html#setting-claim-issuance-policy-name-id_it","title":"Impostazione dei criteri di rilascio delle attestazioni per ID nome"}},[_vm._v("\n     Impostazione dei criteri di rilascio delle attestazioni per ID nome\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-adfs-server-authentication-topic.html#enabling-adfs-server-authentication_it","title":"Abilitazione dell'autenticazione tramite server ADFS"}},[_vm._v("\n     Abilitazione dell'autenticazione tramite server ADFS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-mve-adfs-topic.html#accessing-mve-adfs_it","title":"Accesso a MVE tramite ADFS"}},[_vm._v("\n     Accesso a MVE tramite ADFS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"logging-out-mve-adfs-topic.html#logging-out-mve-adfs_it","title":"Disconnessione da MVE"}},[_vm._v("\n     Disconnessione da MVE\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"faq-chapter.html#faq-chapter_it","title":"Domande frequenti"}},[_vm._v("\n    Domande frequenti\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11142"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"faq-chapter.html#frequently-asked-questions_it","title":"Domande frequenti su Markvision Enterprise"}},[_vm._v("\n     Domande frequenti su Markvision Enterprise\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_it","title":"Risoluzione dei problemi"}},[_vm._v("\n    Risoluzione dei problemi\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11336"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-forgotten-password-mve-topic.html#trb-forgotten-password-mve_it","title":"L'utente ha dimenticato la password"}},[_vm._v("\n     L'utente ha dimenticato la password\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-admin-forgotten-password-mve-topic.html#trb-admin-forgotten-password-mve_it","title":"L'utente amministratore ha dimenticato la password"}},[_vm._v("\n     L'utente amministratore ha dimenticato la password\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-page-loading-infinitely-topic.html#trb-page-loading-infinitely_it","title":"La pagina non viene caricata"}},[_vm._v("\n     La pagina non viene caricata\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-discover-network-device-topic.html#trb-cannot-discover-network-device_it","title":"Impossibile rilevare una stampante di rete"}},[_vm._v("\n     Impossibile rilevare una stampante di rete\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-incorrect-device-information-topic.html#trb-incorrect-device-information_it","title":"Informazioni stampante errate"}},[_vm._v("\n     Informazioni stampante errate\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-mve-does-not-recognize-secured-printer-topic.html#trb-mve-does-not-recognize-secured-printer_it","title":"MVE non riconosce una stampante come stampante protetta"}},[_vm._v("\n     MVE non riconosce una stampante come stampante protetta\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-config-enforcement-fails-topic.html#trb-config-enforcement-fails_it","title":"L'applicazione di configurazioni con pi&ugrave; applicazioni non riesce al primo tentativo ma riesce con i tentativi successivi"}},[_vm._v("\n     L'applicazione di configurazioni con più applicazioni non riesce al primo tentativo ma riesce con i tentativi successivi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-enforcement-printer-cert-fails-topic.html#trb-enforcement-printer-cert-fails_it","title":"L'applicazione di configurazioni con il certificato della stampante non riesce"}},[_vm._v("\n     L'applicazione di configurazioni con il certificato della stampante non riesce\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-openxpki-ca-group.html#d0e11553","title":"Autorit&agrave; di certificazione OpenXPKI"}},[_vm._v("\n     Autorità di certificazione OpenXPKI\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"database-access-chapter.html#database-access-chapter_it","title":"Accesso al database"}},[_vm._v("\n    Accesso al database\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11723"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"differences-supported-databases-data-types-topic.html#differences-supported-databases-data-types_it","title":"Differenze tra i tipi di dati dei database supportati"}},[_vm._v("\n     Differenze tra i tipi di dati dei database supportati\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"config-item-topic.html#d0e11784","title":"Tabelle di FRAMEWORK e nomi dei campi"}},[_vm._v("\n     Tabelle di FRAMEWORK e nomi dei campi\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"appendix-chapter.html#appendix-chapter_it","title":"Appendice"}},[_vm._v("\n    Appendice\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17724"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-ports-and-protocols-topic.html#understanding-ports-and-protocols_it","title":"Informazioni su porte e protocolli"}},[_vm._v("\n     Informazioni su porte e protocolli\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html#enabling-automatic-approval-certificate-requests-microsoft-ca_it","title":"Abilitazione dell'approvazione automatica delle richieste di certificato in CA Microsoft"}},[_vm._v("\n     Abilitazione dell'approvazione automatica delle richieste di certificato in CA Microsoft\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"revoking-certificates-topic.html#revoking-certificates_it","title":"Revoca di certificati"}},[_vm._v("\n     Revoca di certificati\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"leap_notices.html#leap_notices_it","title":"Avvertenze"}},[_vm._v("\n    Avvertenze\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18100"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#d0e18103","title":"Nota sull'edizione"}},[_vm._v("\n     Nota sull'edizione\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#d0e18139","title":"Marchi"}},[_vm._v("\n     Marchi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#us-government-rights_it","title":"GOVERNMENT END USERS"}},[_vm._v("\n     GOVERNMENT END USERS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#jmdns-license_it","title":"JmDNS License"}},[_vm._v("\n     JmDNS License\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#licensing-notices-program-folder_it","title":"Informazioni sulla licenza"}},[_vm._v("\n     Informazioni sulla licenza\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"glossary.html#glossary_it","title":"Glossario"}},[_vm._v("\n    Glossario\n   ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js